/*
 * SonarQube
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

/* eslint-disable camelcase */

export const defaultMessages = {
  //------------------------------------------------------------------------------
  //
  // GENERIC WORDS, sorted alphabetically
  //
  //------------------------------------------------------------------------------

  about: 'About',
  about_x: 'About {x}',
  action: 'Action',
  actions: 'Actions',
  active: 'Active',
  activate: 'Activate',
  add_verb: 'Add',
  admin: 'Admin',
  after: 'After',
  ai_code: 'AI Code',
  ai_code_assurance: 'AI CODE ASSURANCE',
  alpha: 'Alpha',
  apply: 'Apply',
  all: 'All',
  and: 'And',
  anonymous: 'Anonymous',
  any: 'Any',
  ascending: 'Ascending',
  assignee: 'Assignee',
  author: 'Author',
  billion: 'Billion',
  bitbucket: 'Bitbucket',
  back: 'Back',
  backup: 'Backup',
  backup_verb: 'Back up',
  best: 'Best',
  beta: 'Beta',
  blocker: 'Blocker',
  bold: 'Bold',
  branch: 'Branch',
  'branch.small': 'branch',
  branches: 'Branches',
  breadcrumbs: 'Breadcrumbs',
  expand_breadcrumbs: 'Expand breadcrumbs',
  by_: 'by',
  calendar: 'Calendar',
  cancel: 'Cancel',
  category: 'Category',
  connect: 'Connect',
  attribute: 'Attribute',
  see_changelog: 'See Changelog',
  changelog: 'Changelog',
  change_verb: 'Change',
  check_all: 'Check all',
  choose_file: 'Choose file',
  class: 'Class',
  classes: 'Classes',
  clear_file: 'Clear file',
  close: 'Close',
  closed: 'Closed',
  code: 'Code',
  color: 'Color',
  collapse: 'Collapse',
  collapse_all: 'Collapse all',
  compare: 'Compare',
  complete: 'Complete',
  component: 'Component',
  contains_ai_code: 'Contains AI code',
  configure: 'Configure',
  confirm: 'Confirm',
  continue: 'Continue',
  copy: 'Copy',
  create: 'Create',
  create_new_element: 'Create new element',
  created: 'Created',
  created_on: 'Created on',
  criteria: 'Criteria',
  critical: 'Critical',
  csv: 'CSV',
  current: 'current',
  current_noun: 'Current',
  customize: 'Customize',
  date: 'Date',
  days: 'Days',
  default: 'Default',
  delete: 'Delete',
  delete_x: 'Delete {0}',
  deprecated: 'Deprecated',
  descending: 'Descending',
  description: 'Description',
  directories: 'Directories',
  directory: 'Directory',
  disabled_: 'disabled',
  dismiss: 'Dismiss',
  dismiss_permanently: 'Dismiss permanently',
  display: 'Display',
  documentation: 'documentation',
  done: 'Done',
  download_verb: 'Download',
  duplications: 'Duplications',
  end_date: 'End Date',
  edit: 'Edit',
  enabled_: 'enabled',
  error: 'Error',
  events: 'Events',
  example: 'Example',
  expand: 'Expand',
  expand_all: 'Expand all',
  explore: 'Explore',
  extend: 'Extend',
  false: 'False',
  favorite: 'Favorite',
  field_required: 'This field is required',
  fields_marked_with_x_required: 'All fields marked with {star} are required',
  file: 'File',
  files: 'Files',
  filters: 'Filters',
  folder: 'Folder',
  follow: 'Follow',
  format: 'Format',
  from: 'From',
  global: 'Global',
  github: 'GitHub',
  go_back: 'Go back',
  got_it: 'Got it',
  help: 'Help',
  here: 'here',
  hide: 'Hide',
  ide: 'IDE',
  inactive: 'Inactive',
  info: 'Info',
  issue: 'Issue',
  issues: 'Issues',
  inheritance: 'Inheritance',
  internal: 'internal',
  inventory: 'Inventory',
  json: 'JSON',
  key: 'Key',
  later: 'Later',
  language: 'Language',
  last_analysis: 'Last Analysis',
  learn_more: 'Learn More',
  learn_more_x: 'Learn More: {link}',
  learn_more_in_doc: 'Learn more in documentation',
  lets_go: "Let's go",
  library: 'Library',
  line_number: 'Line Number',
  links: 'Links',
  list_of_issues: 'List of issues',
  list_of_projects: 'List of projects',
  list_of_rules: 'List of rules',
  load_more: 'Load more',
  load_verb: 'Load',
  loading: 'Loading',
  login: 'Login',
  major: 'Major',
  manual: 'Manual',
  max: 'Max',
  max_results_reached: 'Only the first {0} results are displayed',
  me: 'Me',
  member: 'Member',
  members: 'Members',
  menu: 'Menu',
  min: 'Min',
  minor: 'Minor',
  more: 'More',
  more_x: '{0} more',
  more_actions: 'More Actions',
  move: 'Move',
  my_issues: 'My Issues',
  my_favorite: 'My Favorite',
  my_favorites: 'My Favorites',
  my_projects: 'My Projects',
  name: 'Name',
  navigation: 'Navigation',
  never: 'Never',
  new: 'New',
  next: 'Next',
  next_month_x: 'next month {month}',
  new_name: 'New name',
  next_: 'next',
  none: 'None',
  no_file_selected: 'No file selected',
  no_tags: 'No tags',
  not_now: 'Not now',
  not_impacted: 'Not impacted',
  off: 'off',
  on: 'on',
  or: 'Or',
  open: 'Open',
  open_in_ide: 'Open in IDE',
  'open_in_ide.safari.not_supported': 'Not supported',
  'open_in_ide.safari.not_supported.title': 'Feature not supported in Safari',
  'open_in_ide.safari.not_supported.description':
    'The "Open in IDE" feature is not supported in Safari. This is due to Safari\'s strict security policies regarding custom protocol links which are required to open files directly in your IDE. Please use Chrome or Firefox for this functionality.',
  open_issues: 'Open issues',
  optional: 'Optional',
  order: 'Order',
  owner: 'Owner',
  parameters: 'Parameters',
  password: 'Password',
  confirm_password: 'Confirm Password',
  main: 'Main',
  path: 'Path',
  permalink: 'Permanent Link',
  plugin: 'Plugin',
  preview: 'Preview',
  previous: 'Previous',
  previous_: 'previous',
  previous_month_x: 'previous month {month}',
  prioritized: 'Prioritized',
  profile_name: 'Profile name',
  project: 'Project',
  project_x: 'Project: {0}',
  projects: 'Projects',
  projects_: 'project(s)',
  x_projects_: '{count} project(s)',
  project_plural: 'projects',
  projects_management: 'Projects Management',
  'pull_request.small': 'pull request',
  pull_requests: 'Pull Requests',
  quality_gate: 'Quality Gate',
  quality_profile: 'Quality Profile',
  raw: 'Raw',
  recent_history: 'Recent History',
  recently_browsed: 'Recently Browsed',
  recommended: 'Recommended',
  references: 'References',
  refresh: 'Refresh',
  reload: 'Reload',
  remove: 'Remove',
  remove_x: 'Remove {0}',
  rename: 'Rename',
  replaces: 'Replaces',
  required: 'Required',
  reset_verb: 'Reset',
  reset_to_default: 'Reset To Default',
  reset_date: 'Reset dates',
  resolution: 'Resolution',
  resolve: 'Resolve',
  restart: 'Restart',
  restore: 'Restore',
  result: 'Result',
  results: 'Results',
  x_results: '{0} results',
  review: 'Review',
  rule: 'Rule',
  rules: 'Rules',
  save: 'Save',
  search_results: 'Search results',
  search_verb: 'Search',
  secondary: 'Secondary',
  see_all: 'See all',
  see_x: 'See {0}',
  select_verb: 'Select',
  selected: 'Selected',
  select_tags: 'Add or remove tags',
  set: 'Set',
  set_up: 'Set Up',
  setup: 'Setup',
  settings: 'Settings',
  severity: 'Severity',
  severity_deprecated: 'Severity (deprecated)',
  shared: 'Shared',
  start_date: 'Start Date',
  x_show: '{0} shown',
  x_selected: '{0} selected',
  x_of_y_shown: '{0} of {1} shown',
  size: 'Size',
  skip: 'Skip',
  skip_to_content: 'Skip to main content',
  status: 'Status',
  submit: 'Submit',
  support: 'Support',
  success: 'Success',
  table: 'Table',
  tags: 'Tags',
  tags_list_x: 'Tags list: {0}',
  technical_debt: 'Technical Debt',
  template: 'Template',
  title: 'Title',
  to: 'To',
  to_: 'to',
  total: 'Total',
  tours: 'Tours',
  treemap: 'Treemap',
  true: 'True',
  troubleshooting_steps: 'Troubleshooting steps',
  type: 'Type',
  unassigned: 'Not assigned',
  uncheck_all: 'Uncheck all',
  unit_test: 'Unit test',
  unit_tests: 'Unit tests',
  unknown: 'Unknown',
  unresolved: 'Unresolved',
  update: 'Update',
  updated: 'Updated',
  updated_: 'updated',
  updated_on: 'Updated on',
  updates: 'Updates',
  update_verb: 'Update',
  updating: 'Updating',
  unselected: 'Unselected',
  user: 'User',
  username: 'Username',
  value: 'Value',
  variation: 'Variation',
  version: 'Version',
  version_x: 'Version {0}',
  view: 'View',
  views: 'Views',
  violations: 'Violations',
  visibility: 'Visibility',
  warnings: 'Warnings',
  with: 'With',
  worst: 'Worst',
  yes: 'Yes',
  no: 'No',
  valid_input: 'Valid input',

  //------------------------------------------------------------------------------
  //
  // GENERIC EXPRESSIONS, sorted alphabetically
  //
  //------------------------------------------------------------------------------

  '404_not_found': '404 Not found',
  address_mistyped_or_page_moved: 'You may have mistyped the address or the page may have moved.',
  and_worse: 'and worse',
  are_you_sure: 'Are you sure?',
  as_explained_here: 'as explained here',
  assigned_to: 'Assigned to',
  bulk_change: 'Bulk Change',
  bulleted_point: 'Bulleted point',
  clear: 'Clear',
  clear_x_filter: 'Clear {0} Filters',
  clear_all_filters: 'Clear All Filters',
  coding_rules: 'Rules',
  copy_permalink: 'Copy permalink',
  copy_to_clipboard: 'Click to copy to clipboard',
  copied_action: 'Copied to clipboard',
  created_by: 'Created by',
  default_error_message: 'The request cannot be processed. Try again later.',
  default_component_error_message: 'The component cannot be loaded. Try again later.',
  default_save_field_error_message: 'This field cannot be saved. Try again later.',
  default_severity: 'Default severity',
  edit_permissions: 'Edit Permissions',
  show_permissions: 'Show Permissions',
  facet_might_have_more_results:
    'There might be more results, try another set of filters to see them.',
  false_positive: 'False positive',
  go_back_to_homepage: 'Go back to the homepage',
  hidden_for_security: 'Hidden for security',
  last_analysis_before: 'Last analysis before',
  less_than_1_hour_ago: '< 1 hour ago',
  local: 'Local',
  logging_out: "You're logging out, please wait...",
  manage: 'Manage',
  managed: 'From {source}',
  'managed.github': 'GitHub',
  'managed.gitlab': 'GitLab',
  'managed.SCIM': 'IdP',
  management: 'Management',
  more_information: 'More information',
  new_violations: 'New violations',
  new_window: 'New window',
  no_data: 'No data',
  no_measure_value_x: 'No measure value for {0}',
  results_shown_x: '{count} results shown',
  no_results: 'No results',
  no_results_for_x: 'No results for "{0}"',
  no_results_search: "We couldn't find any results matching selected criteria.",
  'no_results_search.favorites':
    "We couldn't find any results matching selected criteria in your favorites.",
  'no_results_search.2': 'Try to change filters to get some results.',
  'no_results_search.favorites.2': 'Would you like to search among {url} projects?',
  opens_in_new_window: 'Opens in a new window',
  page_extension_failed: 'Page extension failed.',
  page_not_found: 'The page you were looking for does not exist.',
  please_contact_administrator: 'Please contact the instance administrator.',
  set_as_default: 'Set as Default',
  'short_number_suffix.g': 'G',
  'short_number_suffix.k': 'k',
  'short_number_suffix.m': 'M',
  show_less: 'Show Less',
  show_less_filter_x: 'Show less results for "{0}" filter',
  show_x_more: 'Show {x} more',
  show_more: 'Show More',
  show_more_filter_x: 'Show more results for "{0}" filter',
  show_all: 'Show All',
  show_them: 'Show Them',
  should_be_unique: 'Should be unique',
  since_x: 'since {0}',
  since_version: 'since version {0}',
  'since_version.short': '{0}',
  since_version_detailed: 'since version {0} ({1})',
  'since_version_detailed.short': '{0} ({1})',
  since_previous_version: 'since previous version',
  'since_previous_version.short': '\u0394 version',
  since_previous_version_detailed: 'since previous version ({0} - {1})',
  since_previous_version_with_only_date: 'since previous version ({0})',
  'since_previous_version_detailed.short': '\u0394 version ({0})',
  this_name_is_already_taken: 'This name is already taken.',
  tooltip_is_interactive:
    'This is a tooltip with interactive elements. Use the TAB key to cycle through the interactive elements.',
  unexpected_error: 'An unexpected error occurred.',
  update_details: 'Update details',
  update_scm: 'Update SCM details',
  'work_duration.x_days': '{0}d',
  'work_duration.x_hours': '{0}h',
  'work_duration.x_minutes': '{0}min',
  'work_duration.about': '~ {0}',

  //------------------------------------------------------------------------------
  //
  // Open Fix in ide
  //
  //------------------------------------------------------------------------------
  view_fix_in_ide: 'View fix in IDE',
  'fix_in_ide.report_success': 'Success. Switch to your IDE to see the fix.',
  'fix_in_ide.report_error': 'Unable to open the fix in the IDE.',
  'unable_to_find_ide_with_fix.error':
    'Unable to find IDE with capabilities to show fix suggestions',

  //------------------------------------------------------------------------------
  //
  // DAY PICKER
  //
  //------------------------------------------------------------------------------

  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  Jan: 'Jan',
  Feb: 'Feb',
  Mar: 'Mar',
  Apr: 'Apr',
  Jun: 'Jun',
  Jul: 'Jul',
  Aug: 'Aug',
  Sep: 'Sep',
  Oct: 'Oct',
  Nov: 'Nov',
  Dec: 'Dec',
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sun: 'Sun',
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  Sat: 'Sat',
  Su: 'Su',
  Mo: 'Mo',
  Tu: 'Tu',
  We: 'We',
  Th: 'Th',
  Fr: 'Fr',
  Sa: 'Sa',

  'clear.start': 'Clear start date',
  'clear.end': 'Clear end date',

  //------------------------------------------------------------------------------
  //
  // ALM
  //
  //------------------------------------------------------------------------------

  'alm.azure': 'Azure DevOps',
  'alm.azure.short': 'Azure DevOps',
  'alm.bitbucket': 'Bitbucket',
  'alm.bitbucket.short': 'Bitbucket',
  'alm.bitbucket.long': 'Bitbucket Server',
  'alm.bitbucketcloud': 'Bitbucket',
  'alm.bitbucketcloud.short': 'Bitbucket',
  'alm.bitbucketcloud.long': 'Bitbucket Cloud',
  'alm.github': 'GitHub',
  'alm.github.short': 'GitHub',
  'alm.github.organization': 'organization',
  'alm.gitlab': 'GitLab',
  'alm.gitlab.short': 'GitLab',
  'alm.configuration.selector.label': '{0} configuration',
  'alm.configuration.selector.placeholder': 'Select a configuration',

  //------------------------------------------------------------------------------
  //
  // RESOURCE QUALIFIERS
  //
  //------------------------------------------------------------------------------

  'qualifier.TRK': 'Project',
  'qualifier.DIR': 'Directory',
  'qualifier.PAC': 'Package',
  'qualifier.VW': 'Portfolio',
  'qualifier.SVW': 'Portfolio',
  'qualifier.APP': 'Application',
  'qualifier.FIL': 'File',
  'qualifier.CLA': 'File',
  'qualifier.UTS': 'Test File',

  'qualifier.configuration.TRK': 'Project Configuration',
  'qualifier.configuration.VW': 'Portfolio Configuration',
  'qualifier.configuration.SVW': 'Portfolio Configuration',
  'qualifier.configuration.APP': 'Application Configuration',

  'qualifiers.TRK': 'Projects',
  'qualifiers.DIR': 'Directories',
  'qualifiers.PAC': 'Packages',
  'qualifiers.VW': 'Portfolios',
  'qualifiers.SVW': 'Portfolios',
  'qualifiers.APP': 'Applications',
  'qualifiers.FIL': 'Files',
  'qualifiers.CLA': 'Files',
  'qualifiers.UTS': 'Test Files',

  'qualifiers.all.TRK': 'All Projects',
  'qualifiers.all.VW': 'All Portfolios',
  'qualifiers.all.APP': 'All Applications',

  'qualifiers.new.TRK': 'New Project',
  'qualifiers.new.VW': 'New Portfolio',
  'qualifiers.new.APP': 'New Application',

  'qualifier.delete.TRK': 'Delete Project',
  'qualifier.delete.VW': 'Delete Portfolio',
  'qualifier.delete.APP': 'Delete Application',

  'qualifiers.delete.TRK': 'Delete Projects',
  'qualifiers.delete.VW': 'Delete Portfolios',
  'qualifiers.delete.APP': 'Delete Applications',

  'qualifier.delete_confirm.TRK': 'Do you want to delete this project?',
  'qualifier.delete_confirm.VW': 'Do you want to delete this portfolio?',
  'qualifier.delete_confirm.APP': 'Do you want to delete this application?',

  'qualifiers.delete_confirm.TRK': 'Do you want to delete these projects?',
  'qualifiers.delete_confirm.VW': 'Do you want to delete these portfolios?',
  'qualifiers.delete_confirm.APP': 'Do you want to delete these applications?',

  'qualifiers.create.TRK': 'Create Project',
  'qualifiers.create.VW': 'Create Portfolio',
  'qualifiers.create.APP': 'Create Application',

  'qualifiers.update.VW': 'Update Portfolio',
  'qualifiers.update.APP': 'Update Application',

  'qualifier.description.VW': 'Potentially multi-level, management-oriented overview aggregation.',
  'qualifier.description.SVW': 'Potentially multi-level, management-oriented overview aggregation.',
  'qualifier.description.APP':
    'Single-level aggregation with a technical focus and a project-like homepage.',

  //------------------------------------------------------------------------------
  //
  // Admin notification
  //
  //------------------------------------------------------------------------------
  'admin_notification.update.new_patch':
    'There’s an update available for your {productName} instance. Please update to make sure you benefit from the latest security and bug fixes.',
  'admin_notification.update.new_version':
    'There’s a new version of {productName} available. Update to the latest version to access new updates and features.',
  'admin_notification.update.current_version_inactive':
    'You’re running a version of {productName} that is no longer active. Please update to an active version as soon as possible.',
  'admin_notification.update.new_sqcb_version':
    'Keep your instance current and get the {link}, available now.',
  'admin_notification.update.latest': 'latest {productName}',
  'admin_notification.update.new_sqs_version_when_running_sqcb.banner':
    'There’s a new version of SonarQube Server available.',
  'admin_notification.update.new_sqs_version_when_running_sqcb.modal':
    'New SonarQube Server version available',
  'admin_notification.update.new_sqs_version_when_running_sqcb.upgrade':
    'Upgrade to SonarQube Server and get access to enterprise features',
  'admin_notification.bitbucket_cloud_app_deprecation.title':
    'Bitbucket API tokens have replaced app passwords',
  'admin_notification.bitbucket_cloud_app_deprecation.body':
    'Bitbucket Cloud app is deprecated and will be removed in the future. Please migrate to the new Bitbucket app.',
  'admin_notification.bitbucket_cloud_app_deprecation.link': 'Create API token on Bitbucket',

  //------------------------------------------------------------------------------
  //
  // PROJECT LINKS
  //
  //------------------------------------------------------------------------------

  'project_links.homepage': "Project's Website",
  'project_links.ci': 'Continuous integration',
  'project_links.issue': 'Bug Tracker',
  'project_links.scm': 'Sources',
  'project_links.scm_ro': 'Read-only connection',
  'project_links.scm_dev': 'Developer connection',

  'project_links.create_new_project_link': 'Create New Project Link',
  'project_links.delete_project_link': 'Delete Project Link',
  'project_links.are_you_sure_to_delete_x_link': 'Are you sure you want to delete the "{0}" link?',
  'project_links.delete_x_link': 'Delete "{0}" link',
  'project_links.name': 'Name',
  'project_links.url': 'URL',
  'project_links.no_results': 'No links yet. Click "Create" to add one.',

  //------------------------------------------------------------------------------
  //
  // EVENT CATEGORIES
  //
  //------------------------------------------------------------------------------

  'event.category.All': 'All',
  'event.category.VERSION': 'Version',
  'event.category.QUALITY_GATE': 'Quality Gate',
  'event.category.QUALITY_PROFILE': 'Quality Profile',
  'event.category.SQ_UPGRADE': '{productName} upgrade',
  'event.category.DEFINITION_CHANGE': 'Definition Change',
  'event.category.ISSUE_DETECTION': 'Issue Detection',
  'event.category.OTHER': 'Other',
  'event.quality_gate.still_x': 'Still {status}',
  'event.quality_gate.ERROR': 'Failed',
  'event.quality_gate.OK': 'Passed',
  'event.definition_change.added': '{project} added',
  'event.definition_change.removed': '{project} removed',
  'event.definition_change.branch_added': '{project} {branch} added',
  'event.definition_change.branch_removed': '{project} {branch} removed',
  'event.definition_change.branch_replaced': '{project} {oldBranch} replaced with {newBranch}',
  'event.failed_conditions': 'Failed Conditions:',
  'event.sqUpgrade': 'First analysis since updating to {productName} {sqVersion}',

  //------------------------------------------------------------------------------
  //
  // GLOBAL NAVIGATION
  //
  //------------------------------------------------------------------------------

  'global_nav.account.tooltip': 'Account',
  'global_nav.news.tooltip': 'Product news',

  //------------------------------------------------------------------------------
  //
  // LAYOUT
  //
  //------------------------------------------------------------------------------

  'layout.home': 'Home',
  'layout.login': 'Log in',
  'layout.logout': 'Log out',
  'layout.measures': 'Measures',
  'layout.settings': 'Administration',
  'layout.architecture': 'Architecture',
  'layout.security_hotspots': 'Security Hotspots',
  'layout.settings.TRK': 'Project Settings',
  'layout.settings.APP': 'Application Settings',
  'layout.settings.VW': 'Portfolio Settings',
  'layout.settings.SVW': 'Portfolio Settings',
  'layout.security_reports': 'Security Reports',
  'layout.nav.home_logo_alt': 'Logo, link to homepage',
  'layout.nav.home_sonarqube_logo_alt': '{productName} logo, link to homepage',
  'layout.must_be_configured':
    'This will be available once your project is configured and analyzed.',
  'layout.all_project_must_be_accessible':
    'You need access to all projects within this {qualifier} to access it.',

  'sidebar.projects': 'Projects',
  'sidebar.project_settings': 'Configuration',
  'sidebar.security': 'Security',
  'sidebar.system': 'System',
  'sidebar.tools': 'Tools',

  //------------------------------------------------------------------------------
  //
  // VISIBILITY
  //
  //------------------------------------------------------------------------------

  'visibility.both': 'Public, Private',
  'visibility.public': 'Public',
  'visibility.public.description.TRK':
    'This project is public. Anyone can browse and see the source code.',
  'visibility.public.description.VW': 'This portfolio is public. Anyone can browse it.',
  'visibility.public.description.APP': 'This application is public. Anyone can browse it.',
  'visibility.public.description.short': 'Anyone can browse and see the source code.',
  'visibility.public.description.long':
    'Anyone will be able to browse your source code and see the result of your analysis.',
  'visibility.private': 'Private',
  'visibility.private.description.TRK':
    'This project is private. Only authorized users can browse and see the source code.',
  'visibility.private.description.VW':
    'This portfolio is private. Only authorized users can browse it.',
  'visibility.private.description.APP':
    'This application is private. Only authorized users can browse it.',
  'visibility.private.description.short':
    'Only authorized users can browse and see the source code.',
  'visibility.private.description.long':
    'Only members of the organization will be able to browse your source code and see the result of your analysis.',

  //------------------------------------------------------------------------------
  //
  // ADMIN PAGE TITLES and descriptions
  //
  //------------------------------------------------------------------------------

  'coding_rules.page': 'Rules',
  'coding_rule.page': '{0} rule: {1}',
  'global_permissions.page': 'Global Permissions',
  'global_permissions.page.description':
    'Grant and revoke permissions to make changes at the global level. These permissions include editing Quality Profiles, executing analysis, and performing global system administration.',
  'roles.page': 'Project Permissions',
  'roles.page.description2':
    'Grant and revoke project-level permissions. Permissions can be granted to groups or individual users.',
  'roles.page.description_portfolio':
    'Grant and revoke portfolio-level permissions. Permissions can be granted to groups or individual users.',
  'roles.page.description_application':
    'Grant and revoke application-level permissions. Permissions can be granted to groups or individual users.',
  'roles.page.description.github':
    'Project permissions are read-only for users provisioned from GitHub. For non-GitHub users, permissions can only be removed.',
  'roles.page.description.gitlab':
    'Project permissions are read-only for users provisioned from GitLab. For non-GitLab users, permissions can only be removed.',
  'roles.page.change_visibility': 'Change project visibility',
  'project_permission.managed': 'Provisioned from {0}',
  'project_permission.local_project_with_github_provisioning':
    'Please note that this project is not linked to GitHub. Bind it to GitHub to benefit from permission provisioning.',
  'project_permission.local_project_with_gitlab_provisioning':
    'Please note that this project is not linked to GitLab. Bind it to GitLab to benefit from permission provisioning.',
  'project_permission.remove_only_confirmation':
    'Are you sure you want to remove the permission {permission} from {holder}? The permission can not be added back.',
  'project_permission.remove_only_confirmation_title': 'Remove permission',
  'project_settings.page': 'General Settings',
  'project_settings.page.description': 'Edit project settings.',
  'project_links.page': 'Links',
  'project_links.page.description': 'Edit some links associated with this project.',
  'projects_management.page.description':
    'Use this page to delete multiple projects at once, or to provision projects if you would like to configure them before the first analysis. Note that once a project is provisioned, you have access to perform all project configurations on it.',
  'settings.page': 'General Settings',
  'settings.page.description': 'Edit global settings for this {instance} instance.',
  'system_info.page': 'System Info',

  'project_quality_gate.page': 'Quality Gate',
  'project_quality_gate.page.description':
    'Choose which quality gate is associated with this project.',

  'update_key.page': 'Update Key',
  'update_key.page.description':
    'Edit the key of a project. Key changes must be made here BEFORE analyzing the project with the new keys, otherwise the analysis will simply create another project with the new key, rather than updating the existing project.',
  'deletion.page': 'Deletion',
  'project_deletion.page.description': 'Delete this project. The operation cannot be undone.',
  'portfolio_deletion.page.description':
    'This portfolio and its sub-portfolios will be deleted. If this portfolio is referenced by other entities, it will be removed from them. Independent entities referenced by this portfolio, such as projects and other top-level portfolios will not be deleted. This operation cannot be undone.',
  'application_deletion.page.description':
    'Delete this application. Application projects will not be deleted. Projects referenced by this application will not be deleted. This operation cannot be undone.',
  'application.branches.help':
    'Easily create Application branches composed of the branches of projects in your application.',
  'application.branches.link': 'Create Branch',
  'project_branch_pull_request.page': 'Branches & Pull Requests',
  'project_branch_pull_request.lifetime_information':
    'Branches and Pull Requests are permanently deleted after {days} days without analysis.',
  'project_branch_pull_request.lifetime_information.admin':
    'You can adjust this value globally in {settings}.',
  'project_branch_pull_request.branch.rename': 'Rename branch',
  'project_branch_pull_request.branch.set_main': 'Set as main branch',
  'project_branch_pull_request.branch.set_x_as_main': 'Set "{branch}" as the main branch',
  'project_branch_pull_request.branch.delete': 'Delete branch',
  'project_branch_pull_request.branch.actions_label': 'Update {0}',
  'project_branch_pull_request.branch.delete.are_you_sure':
    'Are you sure you want to delete branch "{name}"?',
  'project_branch_pull_request.branch.main_branch.are_you_sure':
    'Are you sure you want to set branch "{branch}" as the main branch of this project?',
  'project_branch_pull_request.branch.main_branch.requires_reindex':
    'Changing the main branch of your project will trigger a project re-indexing and may impact the level of information that is available until re-indexing is complete.',
  'project_branch_pull_request.branch.main_branch.learn_more':
    'Please refer to the {documentation} to understand the impacts of changing the main branch.',
  'project_branch_pull_request.branch.auto_deletion.keep_when_inactive': 'Keep when inactive',
  'project_branch_pull_request.branch.auto_deletion.keep_when_inactive.tooltip':
    'When turned on, the branch will not be automatically deleted when inactive.',
  'project_branch_pull_request.branch.auto_deletion.main_branch_tooltip':
    'The main branch is always excluded from automatic deletion.',
  'project_branch_pull_request.pull_request.delete': 'Delete Pull Request',
  'project_branch_pull_request.pull_request.delete.are_you_sure':
    'Are you sure you want to delete Pull Request "{name}"?',
  'project_branch_pull_request.tabs.branches': 'Branches',
  'project_branch_pull_request.tabs.pull_requests': 'Pull Requests',
  'project_branch_pull_request.table.branch': 'Branch',
  'project_branch_pull_request.table.pull_request': 'Pull Request',
  'project_branch_pull_request.last_analysis_date': 'Last Analysis Date',

  'project_baseline.page': 'New Code',
  'project_baseline.page.description':
    "The new code definition sets the criteria for what's considered new code, allowing you to focus on the most recent changes in your project.",
  'project_baseline.page.description2':
    'This setting allows project administrators to customize the new code definition for their project.',
  'project_baseline.page.description3':
    "The instance's default new code definition can be adjusted in the <link>general settings.</link>",
  'project_baseline.page.selection.label': 'Project definition of new code',
  'project_baseline.global_setting': 'Follows the instance’s default',
  'project_baseline.global_setting.description': 'Current default: {default}',
  'project_baseline.specific_setting': 'Is custom',
  'project_baseline.specific_setting.description':
    'Choose whether it should be the <b>previous version</b>, a <b>number of days</b> or a <b>reference branch</b>',
  'project_baseline.configure_branches': 'Set a specific setting for a branch',
  'project_baseline.compliance.warning.title.project':
    'Your project new code definition is not recommended by Sonar',
  'project_baseline.update_success': 'New code definition has been updated',

  'baseline.specific_analysis': 'Specific analysis',
  'baseline.specific_analysis.description': 'Choose an analysis as the baseline for the new code.',
  'baseline.reference_branch': 'Reference branch',

  'baseline.reference_branch.description': 'Choose a branch as the baseline for the new code.',
  'baseline.reference_branch.usecase': 'Recommended for projects using feature branches.',
  'baseline.reference_branch.description2':
    'The branch you select as the reference branch will need its own new code definition to prevent it from using itself as a reference.',

  'baseline.last_analysis_before': 'Last analysis before',
  'baseline.next_analysis_notice': 'Changes will take effect after the next analysis',

  'baseline.reference_branch.does_not_exist':
    'Branch {branch} could not be found in {productName}.',
  'baseline.reference_branch.invalid_branch_setting':
    'Branch {0} cannot use itself as a reference. Define a specific setting instead of using the project-level setting.',
  'baseline.edit_branch_setting': "Edit the branch's setting",

  'branch_list.branch': 'Branch',
  'branch_list.current_setting': 'Setting',
  'branch_list.current_baseline': 'Current Baseline',
  'branch_list.actions': 'Actions',
  'branch_list.show_actions_for_x': 'Show actions for branch {0}',
  'branch_list.edit_for_x': 'Edit {0}',
  'branch_list.default_setting': 'Project setting',

  'baseline.new_code_period_for_branch_x': 'New Code for {0}',
  'baseline.new_code_period_for_branch_x.question':
    'Choose the baseline for new code for this branch',

  'regulatory_report.page': 'Regulatory Report',
  'regulatory_report.description1':
    'The <link>Regulatory report</link> is a .zip file that contains a detailed snapshot of a selected project branch. {br} It is comprised of a selection of .txt, .csv, and .pdf files containing:',
  'regulatory_report.bullet_point1': 'An overview of the selected branch of the project.',
  'regulatory_report.bullet_point2':
    "The configuration items relevant to the project's quality (quality profile, quality gate, and analysis exclusions).",
  'regulatory_report.bullet_point3':
    'Lists of findings for both new and overall code on the selected branch.',
  'regulatory_report.description2':
    'Report generation and download may take a few minutes depending on the project size.',
  'regulatory_page.download_button': 'Download report',
  'regulatory_page.download_start.sentence':
    'Your download should start shortly. This may take some time.',
  'regulatory_page.select_branch': 'Choose project branch',
  'regulatory_page.no_available_branch':
    'No branch has been analyzed yet, no report can be generated.',
  'regulatory_page.available_branches_info.only_keep_when_inactive':
    'Only branches marked as "Keep when inactive" are available.',
  'regulatory_page.available_branches_info.more_info':
    'For further details, please check the {doc_link}.',
  'regulatory_page.available_branches_info.more_info.doc_link': 'related documentation',

  //------------------------------------------------------------------------------
  //
  // OTHER PAGE TITLES
  //
  //------------------------------------------------------------------------------

  'page_title.template.default': '%s - {productName}',
  'page_title.template.with_category': '%s - {page} - {productName}',
  'page_title.template.with_instance': '{project} - %s - {productName}',
  'overview.page': 'Overview',
  'code.page': 'Code',
  'permissions.page': 'Permissions',
  'quality_profiles.page': 'Quality Profiles',
  'quality_gates.page': 'Quality Gates',
  'issues.page': 'Issues',
  'issues.skip_to_filters': 'Skip to issue filters',
  'issues.skip_to_list': 'Skip to issues list',
  'view_projects.page': 'Projects',
  'portfolios.page': 'Portfolios',
  'portfolio_breakdown.page': 'Portfolio Breakdown',
  'project_activity.page': 'Activity',

  //------------------------------------------------------------------------------
  //
  // ASYNC PROCESS
  //
  //------------------------------------------------------------------------------

  'process.still_working': 'Still Working...',
  'process.fail': 'Failed',

  //------------------------------------------------------------------------------
  //
  // SESSION
  //
  //------------------------------------------------------------------------------

  'sessions.log_in': 'Log in',
  //------------------------------------------------------------------------------
  //
  // Audit Logs
  //
  //------------------------------------------------------------------------------

  'audit_logs.page': 'Audit Logs',
  'audit_logs.page.description.1':
    'Audit Logs help Administrators keep control and traceability of security related changes performed on the platform.',
  'audit_logs.page.description.2':
    'Your instance is set to keep audit logs for {housekeeping}. You can change the number of days by updating your {link}.',
  'audit_logs.page.description.link': 'housekeeping policy',

  'audit_logs.housekeeping_policy.Weekly': '7 days',
  'audit_logs.housekeeping_policy.Monthly': '30 days',
  'audit_logs.housekeeping_policy.Trimestrial': '90 days',
  'audit_logs.housekeeping_policy.Yearly': 'one year',

  'audit_logs.download': 'Download Audit Logs',
  'audit_logs.download_start.try_again': 'Try Again',
  'audit_logs.download_start.sentence.1':
    'Your download should start shortly. For longer periods this might take some time.',
  'audit_logs.download_start.sentence.2':
    'If the download doesn’t start after a few seconds, try to reduce the period for which you are fetching audit logs.',
  'audit_logs.download_start.sentence.3':
    'Change your selection above to download additional audit logs.',

  'audit_logs.range_option.today': 'Today',
  'audit_logs.range_option.7days': '7 days',
  'audit_logs.range_option.30days': '30 days',
  'audit_logs.range_option.90days': '90 days',
  'audit_logs.range_option.custom': 'Custom',

  //------------------------------------------------------------------------------
  //
  // HOTSPOTS
  //
  //------------------------------------------------------------------------------

  'risk_exposure.HIGH': 'High',
  'risk_exposure.MEDIUM': 'Medium',
  'risk_exposure.LOW': 'Low',

  'hotspots.page': 'Security Hotspots',
  'hotspots.no_hotspots.title': 'There are no Security Hotspots to review.',
  'hotspots.no_hotspots.description':
    'Next time you analyze a piece of code that contains a potential security risk, it will show up here.',
  'hotspots.no_hotspots_for_file.title': 'The selected file contains no hotspots.',
  'hotspots.no_hotspots_for_file.description':
    'Go back and select another file, or click "Show all hotspots".',
  'hotspots.no_hotspots_for_filters.title':
    "We couldn't find any results matching the selected criteria.",
  'hotspots.no_hotspots_for_filters.description': 'Try changing the filters to get some results.',
  'hotspots.no_hotspots_for_keys.title': 'The requested hotspots no longer exist.',
  'hotspots.no_hotspots_for_keys.description':
    'They have been closed because the code involved has been changed or removed.',
  'hotspots.learn_more': 'Learn more about Security Hotspots',
  'hotspots.list': 'List of Security Hotspots',
  'hotspots.list_title': '{0} Security Hotspots',
  'hotspots.list_title.TO_REVIEW': '{0} Security Hotspots to review',
  'hotspots.list_title.ACKNOWLEDGED': '{0} Security Hotspots reviewed as acknowledged',
  'hotspots.list_title.FIXED': '{0} Security Hotspots reviewed as fixed',
  'hotspots.list_title.SAFE': '{0} Security Hotspots reviewed as safe',
  'hotspots.risk_exposure': 'Review priority',
  'hotspots.permalink_copy': 'Copy permalink to current hotspot: "{title}"',

  'hotspots.tabs.code': 'Where is the risk?',
  'hotspots.tabs.risk_description': "What's the risk?",
  'hotspots.tabs.vulnerability_description': 'Assess the risk',
  'hotspots.tabs.fix_recommendations': 'How can I fix it?',
  'hotspots.tabs.activity': 'Activity',
  'hotspots.tabs.code.short': 'Where',
  'hotspots.tabs.risk_description.short': 'What',
  'hotspots.tabs.vulnerability_description.short': 'Assess',
  'hotspots.tabs.fix_recommendations.short': 'How',
  'hotspots.tabs.activity.short': 'Activity',
  'hotspots.review_history.created': 'created Security Hotspot',
  'hotspots.review_history.comment_added': 'added a comment',
  'hotspots.comment.field': 'Comment:',
  'hotspots.comment.open': 'Comment',
  'hotspots.comment.submit': 'Comment',
  'hotspots.open_in_ide.success': 'Success. Switch to your IDE to see the security hotspot.',
  'hotspots.open_in_ide.failure':
    "Unable to connect to your IDE to open the Security Hotspot. Please make sure you're running the latest version of SonarQube for IDE.",

  'hotspots.assignee.select_user': 'Select a user...',
  'hotspots.assignee.change_user': 'Click to change assignee',
  'hotspots.status.cannot_change_status': "Changing a hotspot's status requires permission.",
  'hotspots.status.review': 'Review',
  'hotspots.status.review_title': 'Review Security Hotspot',
  'hotspots.status.select': 'Select a status',
  'hotspots.status.add_comment': 'Add a comment',
  'hotspots.status.add_comment_optional': 'Add a comment (Optional)',
  'hotspots.status.change_status': 'Change status',

  'hotspots.status_option.TO_REVIEW': 'To review',
  'hotspots.status_option.TO_REVIEW.description':
    'This security hotspot needs to be reviewed to assess whether the code poses a risk.',
  'hotspots.status_option.ACKNOWLEDGED': 'Acknowledged',
  'hotspots.status_option.ACKNOWLEDGED.description':
    'The code has been reviewed and does pose a risk. A fix is required.',
  'hotspots.status_option.FIXED': 'Fixed',
  'hotspots.status_option.FIXED.description':
    'The code has been reviewed and modified to follow the recommended secure coding practices.',
  'hotspots.status_option.SAFE': 'Safe',
  'hotspots.status_option.SAFE.description':
    'The code has been reviewed and does not pose a risk. It does not need to be modified.',
  'hotspots.get_permalink': 'Get Permalink',
  'hotspots.no_associated_lines':
    'This Security Hotspot is not associated with any specific lines of code.',
  'hotspots.congratulations': 'Congratulations!',
  'hotspots.find_in_status_filter_x':
    ' You can find it again by setting the status filter to {status_label}.',
  'hotspots.successful_status_change_to_x': 'The Security Hotspot was successfully changed to {0}.',
  'hotspots.x_done_keep_going': '{percentage} of the Security Hotspots have been reviewed.',
  'hotspots.see_x_hotspots': 'See "{0}" Security Hotspots',
  'hotspots.continue_to_next_hotspot': 'Continue Reviewing',

  'hotspot.label': 'Security hotspot on file {file} - {issue},',
  'hotspot.label_with_line': 'Security hotspot on file {file} and line {line} - {issue},',
  'hotspot.filters.title': 'Filters',
  'hotspot.filters.title_x': 'Apply filters to security hotspots; currently applied: {count}',
  'hotspot.filters.assignee.assigned_to_me': 'Assigned to me',
  'hotspot.filters.assignee.all': 'All',
  'hotspot.filters.clear': 'Clear filters',
  'hotspot.filters.status': 'Status filter',
  'hotspot.filters.status.to_review': 'To review',
  'hotspot.filters.status.acknowledged': 'Acknowledged',
  'hotspot.filters.status.fixed': 'Fixed',
  'hotspot.filters.period': 'Period filter',
  'hotspot.filters.period.since_leak_period': 'New Code',
  'hotspot.filters.period.overall': 'Overall code',
  'hotspot.filters.status.safe': 'Safe',
  'hotspot.filters.by_file_or_list_x': 'Your hotspots are currently filtered, {show_all_link}',
  'hotspot.filters.show_all': 'show all hotspots',
  'hotspot.section.activity': 'Activity',
  'hotspot.location.count': '{number} extra location',
  'hotspot.location.count.plural': '{number} extra locations',

  'hotspots.reviewed.tooltip':
    'Percentage of open Security Hotspots that have been reviewed (Acknowledged, Fixed or Safe)',
  'hotspots.review_hotspot': 'Review Hotspot',

  'hotspots.assign.success': 'Security Hotspot was successfully assigned to {0}',
  'hotspots.assign.unassign.success': 'Security Hotspot was successfully unassigned',
  'hotspots.update.success': 'Update successful',
  'hotspots.success_dialog.do_not_show': "Don't show this dialog next time",

  //------------------------------------------------------------------------------
  //
  // ISSUES
  //
  //------------------------------------------------------------------------------

  'issues.on_file_x': 'Issues on file {file}',
  'issue.add_tags': 'Add Tags',
  'issue.remove_tags': 'Remove Tags',
  'issue.no_tag': 'No tags',
  'issue.create_tag': 'Create Tag',
  'issue.create_tag_x': 'Create Tag "{0}"',
  'issue.tags': 'Tags',
  'issue.permalink_copy': 'Copy permalink to current issue: "{title}"',
  'issue.assign.assigned_to_x_click_to_change': 'Assigned to {0}, click to change',
  'issue.assign.unassigned_click_to_assign': 'Unassigned, click to assign issue',
  'issue.assign.formlink': 'Assign',
  'issue.assign.to_me': 'to me',
  'issue.quick_fix': 'Quick fix',
  'issue.quick_fix_available_with_sonarlint': 'Quick fix available in {link}',
  'issue.quick_fix_available_with_sonarlint_no_link': 'Quick fix available in SonarQube for IDE',
  'issue.comment.add_comment': 'Add Comment',
  'issue.comment.add_comment.cancel': 'Cancel adding comment',
  'issue.comment.enter_comment': 'Enter Comment',
  'issue.comment.formlink': 'Comment',
  'issue.comment.formlink.total': 'comment',
  'issue.comment.formlink.total.plural': 'comments',
  'issue.comment.explain_why': 'Consider explaining why',
  'issue.comment.posted_on': 'Comment posted on',
  'issue.comment.edit': 'Edit comment',
  'issue.comment.edit.cancel': 'Cancel editing comment',
  'issue.comment.delete': 'Delete comment',
  'issue.comment.delete_confirm_message': 'Do you want to delete this comment?',
  'issue.comment.empty.list': 'There are no comments yet on this issue.',
  'issue.rule_details': 'Rule Details',
  'issue.send_notifications': 'Send Notifications',
  'issue.label': 'Issue on file {file} and line {line} - {issue},',
  'issue.why_this_issue': 'Why is this an issue?',
  'issue.why_this_issue.long':
    "Why is this an issue? Open the rule's details at the bottom of the page.",
  'issue.severity.updated_notification.link.standard': "This {type}'s",
  'issue.severity.updated_notification.link.mqr': "This issue's",
  'issue.severity.updated_notification':
    '{issueLink, select, other { {issueLink} }} {quality, select, other { {quality} }} severity was changed from {before} to {after}',
  'issue.change_status': 'Change Status',

  'issue.transition.title': 'Change issue status',
  'issue.transition.status': 'Issue status',
  'issue.transition.status_deprecated': 'Deprecated issue status',
  'issue.transition.status_in_sandbox':
    "Issues that don't affect the quality gate or measures, but should be triaged to avoid technical debt accumulation",
  'issue.transition.in_sandbox_helptext':
    'If "In sandbox" status is changed, it can\'t be assigned again',
  'issue.transition': 'Transition',
  'issue.transition.accept': 'Accept',
  'issue.transition.accept.description':
    "Won't fix immediately, but will no longer affect the quality gate",
  'issue.transition.confirm': 'Confirm',
  'issue.transition.confirm.description':
    'Confirmation that the issue is valid. Issue impacts the quality gate',
  'issue.transition.unconfirm': 'Open',
  'issue.transition.unconfirm.description': 'Issue impacts the quality gate',
  'issue.transition.resolve': 'Fixed',
  'issue.transition.resolve.description':
    'Marked manually as fixed, but will reopen after the next analysis',
  'issue.transition.falsepositive': 'False Positive',
  'issue.transition.falsepositive.description': 'Analysis is incorrect',
  'issue.transition.reopen': 'Open',
  'issue.transition.reopen.description': 'Issue impacts the quality gate',
  'issue.transition.wontfix': "Won't Fix",
  'issue.transition.wontfix.description': 'Deprecated',
  'issue.transition.openasvulnerability': 'Open as Vulnerability',
  'issue.transition.openasvulnerability.description':
    "There's a Vulnerability in the code that must be fixed",
  'issue.transition.resolveasreviewed': 'Resolve as Reviewed',
  'issue.transition.resolveasreviewed.description': 'There is no Vulnerability in the code',
  'issue.transition.resetastoreview': 'Reset as To Review',
  'issue.transition.resetastoreview.description': 'The Security Hotspot should be analyzed again',
  'issue.transition.status_change': 'Status change',
  'issue.transition.go_back_change_status': 'Go back to status change',
  'issue.transition.change_status': 'Change status',

  // StatusTransition
  'status_transition.status_x_click_to_change': 'Status: {0}, click to change',
  'status_transition.transition': 'Transition',
  'status_transition.accept': 'Accept',
  'status_transition.accept.to_status': 'Accepted',
  'status_transition.accept.description':
    "Won't fix immediately, but will no longer affect the quality gate",
  'status_transition.confirm': 'Confirm',
  'status_transition.confirm.description':
    'Confirmation that the issue is valid. Issue impacts the quality gate',
  'status_transition.confirm.to_status': 'Confirmed',
  'status_transition.unconfirm': 'Open',
  'status_transition.unconfirm.description': 'Issue impacts the quality gate',
  'status_transition.unconfirm.to_status': 'Open',
  'status_transition.resolve': 'Fixed',
  'status_transition.resolve.description':
    'Marked manually as fixed, but will reopen after the next analysis',
  'status_transition.resolve.to_status': 'Fixed',
  'status_transition.falsepositive': 'False Positive',
  'status_transition.falsepositive.description': 'Analysis is incorrect',
  'status_transition.falsepositive.to_status': 'False Positive',
  'status_transition.reopen': 'Open',
  'status_transition.reopen.description': 'Issue impacts the quality gate',
  'status_transition.reopen.to_status': 'Open',
  'status_transition.wontfix': "Won't Fix",
  'status_transition.wontfix.description': 'Deprecated',
  'status_transition.wontfix.to_status': "Won't Fix",
  'status_transition.comment.title': 'Add status change comment (optional)',
  'status_transition.comment.label': 'Why should the current status be changed to "{status}"?',
  'status_transition.comment.placeholder': 'Add the comment',
  'status_transition.comment.share': 'Share this comment with Sonar to help us improve analyzers',
  'status_transition.change_status': 'Change status',

  'issue.sandbox.title': 'Issue sandbox',
  'issue.sandbox.description':
    'Issues that don’t affect the quality gate or measures, but should be triaged to avoid technical debt accumulation. Change their status and bring them back to the workflow.',
  'issue.sandbox.includes_blockers': 'Includes blocker issues',
  'issue.sandbox.see_x_sandboxed_issues':
    'See the list of {count} {quality} issues in sandbox. {hasBlockers, select, true {Includes blocker issues.} other {}}',

  'issue.tabs.code': 'Where is the issue?',
  'issue.location_x': 'Location {0}',
  'issue.closed.file_level':
    'This issue is {status}. It was detected in the file below and is no longer being detected.',
  'issue.closed.project_level':
    'This issue is {status}. It was detected in the project below and is no longer being detected.',
  'issues.assignee.change_user': 'Click to change assignee',
  'issue.prioritized_rule.description':
    'The associated rule has been designated as a priority in the Quality Profile, indicating that all corresponding issues in Overall Code should be fixed.',

  'issues.action_select': 'Select issue',
  'issues.action_select.label': 'Select issue {0}',
  'issue.set_severity': 'Change Severity',
  'issue.set_type': 'Change Type',

  'issue.type.CODE_SMELL': 'Code Smell',
  'issue.type.BUG': 'Bug',
  'issue.type.VULNERABILITY': 'Vulnerability',
  'issue.type.SECURITY_HOTSPOT': 'Security Hotspot',
  'issue.type.SECURITY_HOTSPOT.plural': 'Security Hotspots',
  'issue.type.CODE_SMELL.plural': 'Code Smells',
  'issue.type.BUG.plural': 'Bugs',
  'issue.type.VULNERABILITY.plural': 'Vulnerabilities',
  'issue.type.tooltip': '{severity} severity.',
  'issue.type.tooltip_with_change': '{severity} severity. Click to change.',
  'issue.type.deprecation.title': 'Issue types are deprecated and can no longer be modified.',
  'issue.type.deprecation.filter_by': 'You can now filter issues by:',
  'issue.type.deprecation.documentation': 'Documentation',

  'issue.type.severity.button.popover':
    '{type} of {severity} severity . Click for more information.',
  'issue.type.severity.button.change':
    '{type} of {severity} severity . Click to change the severity.',

  'issue.severity.deprecation.title':
    'Severities are now directly tied to the software quality impacted. This old severity is deprecated and can no longer be modified.',
  'issue.severity.deprecation.filter_by': 'You can now filter issues by:',
  'issue.severity.deprecation.documentation': 'Documentation',
  'issue.severity.new': 'The new severities',

  'issue.cct_attribute.label': 'Code attribute',
  'issue.software_qualities.label': 'Software qualities impacted',
  'issue.impact.severity.tooltip':
    'This issue has a {severity} impact on the {quality} of your software.',

  'issue.clean_code_attribute_category.CONSISTENT': 'Consistency',
  'issue.clean_code_attribute_category.CONSISTENT.title': 'This is a consistency issue.',
  'issue.clean_code_attribute_category.CONSISTENT.advice':
    'To be consistent, the code needs to be written in a uniform and conventional way.',
  'issue.clean_code_attribute_category.INTENTIONAL': 'Intentionality',
  'issue.clean_code_attribute_category.INTENTIONAL.title': 'This is an intentionality issue.',
  'issue.clean_code_attribute_category.INTENTIONAL.advice':
    'To be intentional, the code content needs to be precise and purposeful.',
  'issue.clean_code_attribute_category.ADAPTABLE': 'Adaptability',
  'issue.clean_code_attribute_category.ADAPTABLE.title': 'This is an adaptability issue.',
  'issue.clean_code_attribute_category.ADAPTABLE.advice':
    'To be adaptable, the code needs to be structured to be easy to evolve and develop with confidence.',
  'issue.clean_code_attribute_category.RESPONSIBLE': 'Responsibility',
  'issue.clean_code_attribute_category.RESPONSIBLE.title': 'This is a responsibility issue.',
  'issue.clean_code_attribute_category.RESPONSIBLE.advice':
    'To be responsible, the code must take into account its ethical obligations on data and potential impact of societal norms.',

  'issue.clean_code_attribute': 'Code attribute',
  'issue.clean_code_attribute.CLEAR': 'Not clear',
  'issue.clean_code_attribute.CLEAR.title':
    'This is an intentionality issue, the code is not clear enough.',
  'issue.clean_code_attribute.CLEAR.advice':
    'To be clear, the code needs to be self-explanatory and transparently communicate its functionality.',
  'issue.clean_code_attribute.COMPLETE': 'Not complete',
  'issue.clean_code_attribute.COMPLETE.title':
    'This is an intentionality issue, the code is not complete enough.',
  'issue.clean_code_attribute.COMPLETE.advice':
    'To be complete, the code must be functional and achieve its implied goals through comprehensive, adequate, and thorough code constructs.',
  'issue.clean_code_attribute.CONVENTIONAL': 'Not conventional',
  'issue.clean_code_attribute.CONVENTIONAL.title':
    'This is a consistency issue, the code is not conventional enough.',
  'issue.clean_code_attribute.CONVENTIONAL.advice':
    'To be conventional, the code needs to perform tasks with expected instructions, and adhere to a single choice across all instances when faced with equally good options.',
  'issue.clean_code_attribute.DISTINCT': 'Not distinct',
  'issue.clean_code_attribute.DISTINCT.title':
    'This is an adaptability issue, the code is not distinct enough.',
  'issue.clean_code_attribute.DISTINCT.advice':
    'To be distinct, the code needs to have procedures and data that are unique and distinctive, without unnecessary duplication.',
  'issue.clean_code_attribute.EFFICIENT': 'Not efficient',
  'issue.clean_code_attribute.EFFICIENT.title':
    'This is an intentionality issue, the code is not efficient enough.',
  'issue.clean_code_attribute.EFFICIENT.advice':
    'To be efficient, the code needs to use resources without needless waste, and prioritize economical options when available.',
  'issue.clean_code_attribute.FOCUSED': 'Not focused',
  'issue.clean_code_attribute.FOCUSED.title':
    'This is an adaptability issue, the code is not focused enough.',
  'issue.clean_code_attribute.FOCUSED.advice':
    'To be focused, the code needs to have a single, narrow, and specific scope. Each of its units should have only one concise purpose.',
  'issue.clean_code_attribute.FORMATTED': 'Not formatted',
  'issue.clean_code_attribute.FORMATTED.title':
    'This is a consistency issue, the code is not formatted enough.',
  'issue.clean_code_attribute.FORMATTED.advice':
    'To be formatted, the code needs to be presented in a systematic and regular way, with the same non-semantic choices used over all the codebase.',
  'issue.clean_code_attribute.IDENTIFIABLE': 'Not identifiable',
  'issue.clean_code_attribute.IDENTIFIABLE.title':
    'This is a consistency issue, the code is not identifiable enough.',
  'issue.clean_code_attribute.IDENTIFIABLE.advice':
    'To be identifiable, the code needs to include names and identifiers with a regular structure based on language conventions.',
  'issue.clean_code_attribute.LAWFUL': 'Not lawful',
  'issue.clean_code_attribute.LAWFUL.title':
    'This is a responsibility issue, the code is not lawful enough.',
  'issue.clean_code_attribute.LAWFUL.advice':
    'To be lawful, the code needs to respect licensing and copyright regulation.',
  'issue.clean_code_attribute.LOGICAL': 'Not logical',
  'issue.clean_code_attribute.LOGICAL.title':
    'This is an intentionality issue, the code is not logical enough.',
  'issue.clean_code_attribute.LOGICAL.advice':
    'To be logical, the code needs to have well-formed and sound instructions that work together, and be free of explicit errors.',
  'issue.clean_code_attribute.MODULAR': 'Not modular',
  'issue.clean_code_attribute.MODULAR.title':
    'This is an adaptability issue, the code is not modular enough.',
  'issue.clean_code_attribute.MODULAR.advice':
    'To be modular, the code needs to be organized and distributed to emphasize the separation between its parts.',
  'issue.clean_code_attribute.RESPECTFUL': 'Not respectful',
  'issue.clean_code_attribute.RESPECTFUL.title':
    'This is a responsibility issue, the code is not respectful enough.',
  'issue.clean_code_attribute.RESPECTFUL.advice':
    'To be respectful, the code needs to refrain from using discriminatory and offensive language.',
  'issue.clean_code_attribute.TESTED': 'Not tested',
  'issue.clean_code_attribute.TESTED.title':
    'This is an adaptability issue, the code is not tested enough.',
  'issue.clean_code_attribute.TESTED.advice':
    'To be tested, the code needs to have automated functional tests that provide confidence in the functionality.',
  'issue.clean_code_attribute.TRUSTWORTHY': 'Not trustworthy',
  'issue.clean_code_attribute.TRUSTWORTHY.title':
    'This is a responsibility issue, the code is not trustworthy enough.',
  'issue.clean_code_attribute.TRUSTWORTHY.advice':
    'To be trustworthy, the code needs to abstain from revealing or hard-coding private information.',

  'issue.issue_status.OPEN': 'Open',
  'issue.issue_status.ACCEPTED': 'Accepted',
  'issue.issue_status.CONFIRMED': 'Confirmed',
  'issue.issue_status.FIXED': 'Fixed',
  'issue.issue_status.FALSE_POSITIVE': 'False Positive',
  'issue.issue_status.IN_SANDBOX': 'In sandbox',

  'issue.status.ACCEPTED': 'Accepted',
  'issue.status.REOPENED': 'Reopened',
  'issue.status.RESOLVED': 'Resolved',
  'issue.status.OPEN': 'Open',
  'issue.status.CONFIRMED': 'Confirmed',
  'issue.status.CLOSED': 'Closed',
  'issue.status.TO_REVIEW': 'To Review',
  'issue.status.IN_REVIEW': 'In Review',
  'issue.status.REVIEWED': 'Reviewed',

  'issue.scope.MAIN': 'Main code',
  'issue.scope.TEST': 'Test code',

  'issue.resolution.FALSE-POSITIVE': 'False Positive',
  'issue.resolution.FALSE-POSITIVE.description':
    'Issues that manual review determined were False Positives. Effort from these issues is ignored.',
  'issue.resolution.FIXED': 'Fixed',
  'issue.resolution.FIXED.description': 'Issues that were corrected in code and reanalyzed.',
  'issue.resolution.WONTFIX': "Won't Fix",
  'issue.resolution.WONTFIX.description':
    'Issues that are accepted in this context. They and their effort will be ignored.',
  'issue.resolution.REMOVED': 'Removed',
  'issue.resolution.REMOVED.description':
    'Either the rule or the resource was changed (removed, relocated, parameters changed, etc.) so that analysis no longer finds these issues.',
  'issue.unresolved.description': 'Unresolved issues have not been addressed in any way.',

  'issue.preview.jupyter_notebook.error':
    'Error while loading the Jupyter notebook. Use the Code tab to see issue details.',

  'issue.action.permalink': 'Get permalink',
  'issue.line_affected': 'Line affected:',
  'issue.introduced': 'Introduced:',
  'issue.code_variants': 'Variants:',
  'issue.rule_status': 'Rule status',
  'issue.effort': 'Effort:',
  'issue.x_effort': '{0} effort',
  'issue.ncloc_x.short': 'L{0}',
  'issue.1_code_variant': '1 variant',
  'issue.x_code_variants': '{0} variants',
  'issue.filter_similar_issues': 'Filter Similar Issues',
  'issue.this_issue_involves_x_code_locations': 'This issue involves {0} code location(s)',
  'issue.this_flow_involves_x_code_locations': 'This flow involves {0} code location(s)',
  'issue.from_external_rule_engine': 'Issue detected by an external rule engine: {0}',
  'issue.external_issue_description': 'This is external rule {0}. No details are available.',
  'issues.loading_issues': 'Loading issues',
  'issues.return_to_list': 'Return to List',
  'issues.bulk_change_X_issues': 'Bulk Change {0} Issue(s)',
  'issues.select_all_issues': 'Select all Issues',
  'issues.issues': 'issues',
  'issues.to_select_issues': 'Select issues',
  'issues.to_navigate': 'Navigate to issue',
  'issues.to_navigate_back': 'to navigate back',
  'issues.to_navigate_issue_locations': 'to navigate issue locations',
  'issues.to_switch_flows': 'to switch flows',
  'issues.new_code': 'Issues in new code',
  'issues.new_code_period': 'New Code Period',
  'issues.max_new_code_period': 'Max New Code Period',
  'issues.my_issues': 'My Issues',
  'issues.no_my_issues': 'There are no issues assigned to you.',
  'issues.no_issues': 'No Issues. Hooray!',
  'issues.fixed_issues': 'Fixed issues',
  'issues.fixed_issues.description': 'List of issues that will be fixed by {pullRequest}',
  'issues.x_more_locations': '+ {0} more locations',
  'issues.not_all_issue_show': 'Not all issues are included',
  'issues.not_all_issue_show_why': 'You do not have access to all projects in this portfolio',
  'issues.qg_mismatch.title': 'Mode metrics mismatch',
  'issues.qg_mismatch.description':
    'Your project contains metrics from {isStandardMode, select, true {Multi-Quality Rule (MQR) Mode} other {Standard Experience}}. While your instance remains in the {isStandardMode, select, true {Standard Experience} other {Multi-Quality Rule mode}}, some additional filters will be visible for these {isStandardMode, select, true {MQR} other {Standard Experience}} metrics.',
  'issues.qg_mismatch.link': 'Learn more about both modes in documentation',
  'issues.open_in_ide.success': 'Success. Switch to your IDE to see the issue.',
  'issues.open_in_ide.failure': 'Unable to open the issue in the IDE. Please check the {link}.',

  'issue.activity.review_history.created': 'Created Issue',
  'issue.activity.review_history.comment_added': 'added a comment',
  'issue.activity.add_comment': 'Add a comment',

  // ISSUES SUBNAVIGATION
  'issue.hint.navigate': 'Navigate locations',
  'issues.x_execution_flows':
    '{flowsCount, plural, one {{flows} execution flow} other {{flows} execution flows}}',
  'issues.execution_flow': 'execution flow',
  'issues.x_data_flows': '{flowsCount, plural, one {{flows} data flow} other {{flows} data flows}}',
  'issues.x_data_and_execution_flows':
    '{dataFlowsCount, plural, one {{dataFlows} data flow} other {{dataFlows} data flows}} and {executionFlowsCount, plural, one {{executionFlows} execution flow} other {{executionFlows} execution flows}}',
  'issues.x_locations':
    '{locationsCount, plural, one {{locations} location} other {{locations} locations}}',
  'issues.show_x_more_locations': 'Show {0} more location(s)',
  'issue.flow.1_step': '1 step',
  'issue.flow.x_steps': '{0} steps',
  'issue.unnamed_location': 'Other location',
  'issue.show_full_execution_flow': 'See the whole {0} step execution flow',

  // Issues code fix
  'issues.code_fix.get_fix_suggestion': 'Generate AI Fix',
  'issues.code_fix.see_fix_suggestion': 'See AI Fix',
  'issues.code_fix.let_us_suggest_fix': 'Let us suggest a fix for this issue',
  'issues.code_fix.fix_is_being_generated': 'A fix is being generated...',
  'issues.code_fix.something_went_wrong': 'Something went wrong.',
  'issues.code_fix.not_available': 'Fix generation is currently unavailable',
  'issues.code_fix.reached_usage_limit':
    'Your organization has reached the monthly usage limit for AI CodeFix.',
  'issues.code_fix.not_able_to_generate_fix': 'We are not able to generate a fix for this issue.',
  'issues.code_fix.check_how_to_fix':
    'Try again later, or visit the other sections above to learn how to fix this issue.',

  //------------------------------------------------------------------------------
  //
  // ISSUE CHANGELOG
  //
  //------------------------------------------------------------------------------
  'issue.changelog.found_on_x_show_more': 'Found on {0}; click to see changelog',
  'issue.changelog.changed_to': '{0} changed to {1}',
  'issue.changelog.was': 'was {0}',
  'issue.changelog.webhook_source': ' (change triggered by a {0} webhook)',
  'issue.change.file_move': 'The file has been moved from {0} to {1}',
  'issue.change.from_branch':
    'The issue has been copied from branch "{branchA}" to branch "{branchB}"',
  'issue.change.from_non_branch': 'The issue has been merged from "{branchA}"into "{branchB}"',
  'issue.changelog.removed': '{0} removed',
  'issue.changelog.line_removed_X': 'Line number removed from issue (was {0})',
  'issue.changelog.field.severity': 'Severity',
  'issue.changelog.field.originalSeverity': 'Calculated Severity',
  'issue.changelog.field.actionPlan': 'Action Plan',
  'issue.changelog.field.assignee': 'Assignee',
  'issue.changelog.field.assigneeName': 'Assignee',
  'issue.changelog.field.author': 'Author',
  'issue.changelog.field.resolution': 'Resolution',
  'issue.changelog.field.effort': 'Effort',
  'issue.changelog.field.status': 'Status',
  'issue.changelog.field.issueStatus': 'Status',
  'issue.changelog.field.tags': 'Tags',
  'issue.changelog.field.code_variants': 'Code Variants',
  'issue.changelog.field.type': 'Type',
  'issue.changelog.field.file': 'File',
  'issue.changelog.field.cleanCodeAttribute': 'Code attribute',
  'issue.changelog.impactSeverity': '{0} severity changed to {1} (was {2})',

  //------------------------------------------------------------------------------
  //
  // ISSUES FACETS
  //
  //------------------------------------------------------------------------------
  'issues.facet.period': 'Period',
  'issues.facet.types': 'Type',
  'issues.facet.severities': 'Severity',
  'issues.facet.scopes': 'Scope',
  'issues.facet.projects': 'Project',
  'issues.facet.issueStatuses': 'Status',
  'issues.facet.issueStatuses.help.title': 'Issue lifecycle',
  'issues.facet.issueStatuses.help.description':
    'There are {hasSandboxIssues, select, true {six} other {five}} possible statuses in the issue lifecycle. Some of them can be assigned manually, others can only be assigned by SonarQube after the scan.',
  'issues.facet.issueStatuses.help.description.ACCEPTED': "Accepted: won't fix immediately",
  'issues.facet.issueStatuses.help.description.FALSE_POSITIVE':
    'False positive: analysis is incorrect',
  'issues.facet.issueStatuses.help.description.CONFIRMED':
    'Confirmed: a confirmation that the issue is valid',
  'issues.facet.issueStatuses.help.description.IN_SANDBOX':
    'In sandbox: filtered issues that temporarily don’t affect the quality gate',
  'issues.facet.issueStatuses.help.description.FIXED': 'Fixed: issue has been resolved',
  'issues.facet.issueStatuses.help.link': 'Learn more about the issue lifecycle in documentation',
  'issues.facet.hotspotStatuses': 'Hotspot Status',
  'issues.facet.assignees': 'Assignee',
  'issues.facet.files': 'File',
  'issues.facet.modules': 'Module',
  'issues.facet.directories': 'Directory',
  'issues.facet.tags': 'Tag',
  'issues.facet.rules': 'Rule',
  'issues.facet.languages': 'Language',
  'issues.facet.cleanCodeAttributeCategories': 'Code attribute',
  'issues.facet.cleanCodeAttributeCategories.help.title':
    'Attributes group together conceptually similar issues.',
  'issues.facet.cleanCodeAttributeCategories.help.link': 'Learn more about code attributes',
  'issues.facet.impactSoftwareQualities': 'Software Quality',
  'issues.facet.impactSoftwareQualities.help.title': 'What are software qualities?',
  'issues.facet.impactSoftwareQualities.help.description':
    '<p1>Security is the protection of your software from unauthorized access, use, or destruction.</p1><p>Reliability is a measure of how your software is capable of maintaining its level of performance under stated conditions for a stated period of time.</p><p>Maintainability refers to the ease with which you can repair, improve and understand software code.</p>',
  'issues.facet.impactSoftwareQualities.help.link': 'Learn more about software qualities',
  'issues.facet.codeVariants': 'Code Variant',
  'issues.facet.createdAt': 'Creation Date',
  'issues.facet.createdAt.all': 'All',
  'issues.facet.createdAt.last_week': 'Last week',
  'issues.facet.createdAt.last_month': 'Last month',
  'issues.facet.createdAt.last_year': 'Last year',
  'issues.facet.createdAt.bar_description': '{0} issues from {1} to {2}',
  'issues.facet.authors': 'Author',
  'issues.facet.impactSeverities': 'Severity',
  'issues.facet.issues': 'Issue Key',
  'issues.facet.mode': 'Display Mode',
  'issues.facet.mode.count': 'Issues',
  'issues.facet.mode.effort': 'Effort',
  'issues.facet.standards': 'Security Category',
  'issues.facet.casa': 'CASA',
  'issues.facet.owaspTop10': 'OWASP Top 10 2017',
  'issues.facet.owaspTop10_2021': 'OWASP Top 10 2021',
  'issues.facet.owaspTop10_2025': 'OWASP Top 10 2025',
  'issues.facet.owaspLlmTop10_2025': 'OWASP Top 10 for LLM',
  'issues.facet.owaspAsvs_4.0': 'OWASP ASVS 4.0',
  'issues.facet.owaspAsvs_5.0': 'OWASP ASVS 5.0',
  'issues.facet.owaspMasvs_v2': 'OWASP MASVS',
  'issues.facet.owaspMobileTop10_2024': 'OWASP Mobile Top 10 2024',
  'issues.facet.sonarsourceSecurity': 'SonarSource',
  'issues.facet.stigAsd_v5r3': 'STIG ASD V5R3',
  'issues.facet.stigAsd_v6': 'STIG ASD V6',
  'issues.facet.pciDss_3.2': 'PCI DSS 3.2',
  'issues.facet.pciDss_4.0': 'PCI DSS 4.0',
  'issues.facet.cwe': 'CWE',
  'issues.facet.sonarsource.show_more': 'Show more SonarSource categories',
  'issues.facet.stigAsd_v5r3.show_more': 'Show more STIG ASD V5R3 categories',
  'issues.facet.stigAsd_v5r3.show_less': 'Show less STIG ASD V5R3 categories',
  'issues.facet.stigAsd_v6.show_more': 'Show more STIG ASD V6 categories',
  'issues.facet.stigAsd_v6.show_less': 'Show less STIG ASD V6 categories',
  'issues.facet.prioritized_rule.category': 'Prioritized rules',
  'issues.facet.prioritized_rule': 'Issues from prioritized rules',
  'issues.facet.detection_cause': 'Detection cause',
  'issues.facet.detection_cause.help':
    'New SonarQube issues arise either because of user actions (such as code changes or modification of custom quality profiles) or because of SonarQube updates (such as analyzer/rule improvements or built-in profile adjustments).',
  'issues.facet.detection_cause.help.aria_label': 'Detection cause information',
  'issues.facet.detection_cause.sonarqube_update': 'SonarQube update',
  'issues.facet.detection_cause.other_causes': 'All other causes',
  'issues.facet.second_line.mode.standard': 'Standard Experience',
  'issues.facet.second_line.mode.mqr': 'MQR mode',
  'issues.facet.linkedTicketStatus': 'Jira',
  'issues.facet.linkedTicketStatus.LINKED': 'Pushed to Jira',
  'issues.facet.linkedTicketStatus.NOT_LINKED': 'Not created',

  //------------------------------------------------------------------------------
  //
  // ISSUE BULK CHANGE
  //
  //------------------------------------------------------------------------------

  'issue_bulk_change.form.title': 'Change {0} issues',
  'issue_bulk_change.selected': '{0} issues selected',
  'issue_bulk_change.max_issues_reached':
    'There are more issues available than can be treated by a single bulk action. Your changes will only be applied to the first {max} issues.',
  'issue_bulk_change.x_issues': '{0} issues',
  'issue_bulk_change.no_match': 'There is no issue matching your filter selection',
  'issue_bulk_change.assignee.change': 'Assign the selected issues to a user',
  'issue_bulk_change.select_tags': 'Select tags',
  'issue_bulk_change.selected_tags': 'Selected tags',
  'issue_bulk_change.resolution_comment': 'Resolution comment',

  //------------------------------------------------------------------------------
  //
  // DEPENDENCIES, BILL OF MATERIALS, SCA
  //
  //------------------------------------------------------------------------------

  'dependencies.analysis.failed': 'Dependency analysis failed',
  'dependencies.analysis.outdated': 'Latest dependency analysis attempt failed',
  'dependencies.analysis.completed': 'There were errors in the dependency analysis',
  'dependencies.analysis.callout_body':
    'The results shown in this view may be incomplete due to errors in the dependency analysis.',
  'dependencies.analysis.callout_view_errors': 'View errors',
  'dependencies.analysis.dependency_files_analyzed':
    '<highlighted>{count}</highlighted> dependency {count, plural, one {file} other {files}} were analyzed.',
  'dependencies.list.title':
    '<highlighted>{count}</highlighted> {count, plural, one {dependency} other {dependencies}}',
  'dependencies.list.name_search.title':
    '<highlighted>{count}</highlighted> matching {count, plural, one {dependency} other {dependencies}}',
  'dependencies.learn_more_link': 'Learn more about dependency analysis',
  'dependencies.empty_state.title':
    'No {branchType, select, pullRequest {new dependencies in this pull request} other {dependencies found in this branch}}',
  'dependencies.empty_state.body':
    'We analyzed the manifest/lock files we found but no {branchType, select, pullRequest {new } other {}}dependencies were found.',
  'dependencies.no_result_state.title': "We couldn't find any results matching selected criteria",
  'dependencies.no_result_state.body': 'Try to change filters to get some results.',
  'dependencies.risks.project.no_analysis.title':
    'The next project analysis will start populating the list of dependency risks',
  'dependencies.risks.project.no_analysis.body':
    'For a complete list of dependency risks, make sure each project in this application has been analyzed at least once since the SCA feature was enabled.',
  'dependencies.project.no_analysis.title':
    'The next project analysis will start populating the list of dependencies',
  'dependencies.project.no_analysis.body':
    'For a complete list of dependencies, make sure each project in this application has been analyzed at least once since the SCA feature was enabled.',
  'dependencies.no_analysis.learn_more_link': 'Configuring your projects for SCA analysis',
  'dependencies.project.dependencies.error_loading_analysis':
    'Error loading analysis data: {error}',
  'dependencies.error_state.title': 'Something went wrong',
  'dependencies.error_state.body.1': 'We had trouble loading the bill of materials.',
  'dependencies.error_state.body.2': 'Try to analyze the branch again later.',
  'dependencies.expandable_text.link.full_text': 'Show more',
  'dependencies.expandable_text.link.less_text': 'Show less',
  'dependencies.skip_to_filters': 'Skip to filters page',
  'dependencies.filters.clear_all': 'Clear filters',
  'dependencies.list.new_code_show': 'Show',
  'dependencies.list.export_as_sbom.dropdown.button': 'Export SBOM',
  'dependencies.list.export_as_sbom.dropdown.header.label': 'Software Bill Of Materials (SBOM)',
  'dependencies.list.export_as_sbom.dropdown.header.helptext':
    ' This will export a SBOM for all of your dependencies.',
  'dependencies.list.export_as_sbom.type.cyclonedx': 'CycloneDX',
  'dependencies.list.export_as_sbom.type.spdx_23': 'SPDX v2.3',
  'dependencies.list.export_as_sbom.type.spdx_30': 'SPDX v3.0',
  'dependencies.list.export_as_sbom.format.xml': 'XML',
  'dependencies.risk.fixed_release_missing':
    'Information about where it was introduced is no longer available.',
  'dependencies.risk.header.risk_severity': 'Severity of impact',
  'dependencies.risk.header.risk_severity.intro': 'How is the severity impact calculated?',
  'dependencies.risk.header.first_detected': 'First detected',
  'dependencies.risk.header.what_is_the_risk': "What's the risk?",
  'dependencies.risk.header.how_can_i_fix_it': 'How can I fix it?',
  'dependencies.risk.header.activity': 'Activity',
  'dependencies.risk.what.basicInfo.published': 'Published on {date}',
  'dependencies.risk.what.basicInfo.updated': 'Updated on {date}',
  'dependencies.risk.what.basicInfo.withdrawnAt': 'Report withdrawn {date}',
  'dependencies.risk.what.basicInfo.severity': 'CVSS score',
  'dependencies.risk.what.basicInfo.no_severity': 'Unscored',
  'dependencies.risk.what.basicInfo.severity.tooltip':
    'CVSS (Common Vulnerability Scoring System) is a standardized metric that assesses the severity of software vulnerabilities on a scale of 0-10.',
  'dependencies.risk.what.basicInfo.severity.tooltip.link': 'Learn more about CVSS',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation': 'Chance of future exploitation',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss': '(EPSS)',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss.probabilityRankings.highSeverity':
    'High risk severity threshold',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss.probabilityRankings.mediumSeverity':
    'Medium risk severity threshold',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss.probabilityRankings.medianVulnerability':
    'Median vulnerability',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss.probabilityRankings.thisVulnerability':
    'This vulnerability',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss.tooltip.epss_description':
    'EPSS (Exploit Prediction Scoring System) v{version} estimates the percentage likelihood of a software vulnerability being exploited in the wild over the next 30 days, from 0 to 100%, and a percentile rank of how that likelihood compares to all other assessed vulnerabilities.',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss.tooltip.risk_calculation_description':
    'Sonar uses EPSS score alongside other factors to calculate risk severity. For medium severity risks, EPSS must be >=0.5% and CVSS must be >= 4.0, for high severity risks, EPSS must be >=5% and CVSS must be >=7.0.',
  'dependencies.risk.what.basicInfo.chanceOfFutureExploitation.epss.tooltip.link':
    'Learn more about EPSS v{version}',
  'dependencies.risk.what.basicInfo.cwe.weaknesses': 'Weaknesses',
  'dependencies.risk.what.basicInfo.knownExploited': 'Known exploited',
  'dependencies.risk.what.basicInfo.knownExploited.kev': '(KEV)',
  'dependencies.risk.what.basicInfo.knownExploited.kev.tooltip':
    'KEV (Known Exploited Vulnerabilities) is a list of vulnerabilities that have been confirmed to be actively exploited in the wild',
  'dependencies.risk.what.basicInfo.knownExploited.kev.tooltip.link': 'Learn more about KEV',
  'dependencies.risk.what.basicInfo.reportType.cve': 'NVD',
  'dependencies.risk.what.basicInfo.reportType.epss': 'EPSS',
  'dependencies.risk.what.basicInfo.reportType.ghsa': 'GHSA',
  'dependencies.risk.what.insights.insights_from_maintainer': 'Insights from the maintainer',
  'dependencies.risk.what.insights.insights_from_maintainer.body':
    'Sonar works with the maintainer of this dependency to uphold secure development practices and provide first-party insights on vulnerabilities that are identified.',
  'dependencies.risk.what.insights.provided_by_maintainer': 'Provided by the maintainer of {purl}',
  'dependencies.risk.what.insights.likelihood_to_be_affected': 'Likelihood to be affected',
  'dependencies.risk.what.insights.build_tool_dev_dependency_usage':
    'Build tool / dev dependency usage',
  'dependencies.risk.what.insights.build_tool_dev_dependency_usage.vulnerable': 'Vulnerable',
  'dependencies.risk.what.insights.build_tool_dev_dependency_usage.not_vulnerable':
    'Not vulnerable',
  'dependencies.risk.what.insights.workaround_available': 'Workaround available',
  'dependencies.risk.what.insights.faq.real_false_positive':
    'Is this a real vulnerability or a false positive?',
  'dependencies.risk.what.insights.faq.real_false_positive.real':
    'This is a real vulnerability that may affect users.',
  'dependencies.risk.what.insights.faq.real_false_positive.false_positive':
    'This is a false positive.',
  'dependencies.risk.what.insights.faq.vulnerability_exploitable':
    'Is this vulnerability exploitable when the package is used as a build tool or dev/test dependency?',
  'dependencies.risk.what.insights.faq.workaround_available':
    'For users who are unable to upgrade to a supported release, is there a workaround available?',
  'dependencies.risk.what.insights.faq.only_if_certain_methods_in_use':
    'Does this vulnerability apply only if certain methods, classes, or functionality are in use?',
  'dependencies.risk.what.insights.faq.how_likely_to_be_affected':
    'When using an affected version of this package as intended, how likely are users to be affected?',
  'dependencies.risk.what.insights.faq.other_conditions':
    'Are there any other conditions that users should check for to determine if they are vulnerable?',
  'dependencies.risks.affected_dependency.number_of_risks': 'Risks ({count})',
  'dependencies.risks.affected_dependency.view_all_risks':
    'View all {count} risks for this dependency',
  'dependencies.risk.what.license.category_prohibited':
    '{license} is considered a {category} license which is prohibited by the {profile} license profile.',
  'dependencies.risk.what.license.license_prohibited':
    '{license} is prohibited by the {profile} license profile.',
  'dependencies.risk.what.license.more': 'More about copyleft licenses',
  'dependencies.risk.comment.explain_why': 'Explain your decision',

  'dependencies.bill_of_materials': 'Dependencies',
  'dependencies.labels.severity_dependency_license.description':
    'Sonar marks all license violations as high severity. The actual risk to your organization may vary based on your policy, and how this application is distributed and deployed.',
  'dependencies.properties.import_type': 'Dependency type',
  'dependencies.properties.import_type.direct': 'Direct',
  'dependencies.properties.import_type.transitive': 'Transitive',
  'dependencies.properties.scope': 'Dependency scope',
  'dependencies.properties.scope.development': 'Development',
  'dependencies.properties.scope.production': 'Production',
  'dependencies.properties.status': 'Status',
  'dependencies.properties.license': 'License',
  'dependencies.properties.license.label.nonstandard':
    'This is a nonstandard license not tracked by SPDX.',
  'dependencies.properties.license.label.nonstandard_link': 'Learn more about SPDX licenses',
  'dependencies.properties.license.label.none':
    "This software has no declared license, and should be treated as 'All rights reserved'.",
  'dependencies.properties.newly_introduced': 'New dependencies',
  'dependencies.properties.newly_introduced.inverse': 'All dependencies',
  'dependencies.properties.newly_introduced.title': 'Risks in',
  'dependencies.properties.risks': 'Risks',
  'dependencies.properties.identified_using': 'Identified using',
  'dependencies.properties.identified_using.plural':
    '{file} and {count} {count, plural, one {other} other {others}}',
  'dependencies.properties.identified_using.tooltip': 'View files used to identify this dependency',
  'dependencies.properties.identified_using.description':
    'This dependency was identified using references found in the following files:',
  'dependencies.properties.package_manager': 'Package manager',
  'dependencies.properties.project': 'Project',
  'dependencies.details.not_found.title': 'Dependency not found',
  'dependencies.details.not_found.body':
    'The dependency you are trying to view may not exist anymore, or there may be a problem with its identifier. Try to locate it again in the bill of materials.',
  'dependencies.details.not_found.go_back_text': 'Go back to bill of materials',
  'dependencies.details.chain.title': 'How is {dependency} brought into {projectBranchLabel}?',
  'dependencies.details.chain.transitive_label':
    'Dependency chains resolved using <b>{lockfile}</b>',
  'dependencies.details.chain.paths_label': '{count} {count, plural, one {path} other {paths}}',
  'dependencies.details.chain_group_label': 'Dependency Group',
  'dependencies.details.chains_none_label':
    'No dependency chains were found. For more details view {link}.',
  'dependencies.details.chains_none_missing_lockfile_label':
    'A lockfile is required for complete dependency details and accurate analysis. As a best practice, Sonar recommends committing the lockfile to your source control system to ensure it is present when analysis is run. For more details view {link}',
  'dependencies.details.chains_none_missing_lockfile_link': 'analyzing projects for dependencies.',
  'dependencies.details.other_versions': '{count} other releases in use',
  'dependencies.details.other_versions.description':
    '{count} other releases of this package are used in {branchName}',
  'dependencies.package_managers.CARGO': 'Cargo',
  'dependencies.package_managers.COCOAPODS': 'CocoaPods',
  'dependencies.package_managers.COMPOSER': 'Packagist', // Composer is the tool, packagist is the package manager
  'dependencies.package_managers.CONAN': 'Conan',
  'dependencies.package_managers.GOLANG': 'Go',
  'dependencies.package_managers.MAVEN': 'Maven',
  'dependencies.package_managers.NPM': 'npm',
  'dependencies.package_managers.NUGET': 'NuGet',
  'dependencies.package_managers.PYPI': 'PyPI',
  'dependencies.package_managers.GEM': 'Gem',
  'dependencies.package_managers.UNKNOWN': 'Unknown',
  'dependencies.package_managers.VCPKG': 'vcpkg',

  'dependencies.risks.sort_by': 'Sort by',
  'dependencies.risks.sort_by.severity': 'Risk severity',
  'dependencies.risks.sort_by.cvss_score': 'CVSS score',
  'dependencies.risks.no_dependencies_risks': 'No dependency risks',
  'dependencies.risks.header.number_of_risks.risks_in':
    '{risksCount} {risksCount, plural, one {risk} other {risks}} in',
  'dependencies.risks.header.number_of_risks.releases_count':
    '{releasesCount} {newlyIntroduced, select, true {new } other {}}{releasesCount, plural, one {dependency} other {dependencies}}',
  'dependencies.risks.sort_by.sort_order': 'Sort order {order}',
  'dependencies.risks.sort_by.sort_order.asc': 'ascending',
  'dependencies.risks.sort_by.sort_order.desc': 'descending',
  'dependencies.risks.number_of_risks':
    '{count} {count, plural, one {dependency risk} other {dependency risks}}',
  'dependencies.risks.number_of_severities': '{count} {severity}',
  'dependencies.risks.unknown': 'Unknown dependency risk',
  'dependencies.risks.unknown.tooltip':
    'Dependency risk cannot be calculated for packages from unknown origin.',
  'dependencies.risks.unknown_package.description':
    '{name} is not a package known by an upstream package manager. Unrecognized packages might not have undergone necessary security checks, or might be malicious.',
  'dependencies.risks.unknown_release.description':
    '{release} is not a release of {name} that is known by an upstream package manager. Unrecognized releases might not have undergone necessary security checks, or might be malicious.',

  'dependencies.risks.status.accept': 'Accepted',
  'dependencies.risks.status.accept.description':
    'This finding is valid, but it may not be fixed for a while.',
  'dependencies.risks.status.confirm': 'Confirmed',
  'dependencies.risks.status.confirm.description':
    'This finding has been reviewed and the risk is valid.',
  'dependencies.risks.status.fixed': 'Fixed',
  'dependencies.risks.status.fixed.description':
    'This previously unfixed dependency risk is no longer being detected.',
  'dependencies.risks.status.open': 'Open',
  'dependencies.risks.status.open.description': 'This finding has not yet been reviewed.',
  'dependencies.risks.status.safe': 'Safe',
  'dependencies.risks.status.safe.description':
    'This finding does not pose a risk. No fix is needed.',
  'dependencies.risks.status.comment.placeholder.optional': 'Share why (optional)',
  'dependencies.risks.status.comment.placeholder.required': 'Please share (required)',
  'dependencies.risks.status_x_click_to_change':
    'Dependency risk status: {status}, click to change',

  'dependencies.risks.all': 'All risks',
  'dependencies.risks.type': 'Risk type',
  'dependencies.risks.type.license': 'Prohibited license',
  'dependencies.risks.type.license_prohibited_description':
    'Dependencies with license {license} should not be used',
  'dependencies.risks.type.vulnerability': 'Vulnerability',
  'dependencies.risks.type.malware': 'Malicious package',
  'dependencies.risk': 'Dependency Risk',
  'dependencies.risks': 'Dependency Risks',
  'dependencies.risks.empty_state.title':
    'No {branchType, select, pullRequest {new } other {}}dependency risks were found',
  'dependencies.risks.empty_state.body':
    'This may be because your project has no {branchType, select, pullRequest {new } other {}}dependencies, all dependencies are risk-free, or an error occurred during analysis.',
  'dependencies.risks.details.not_found.title': 'Dependency risk not found',
  'dependencies.risks.details.not_found.body':
    'The dependency risk you are trying to view may not exist anymore, or there may be a problem with its identifier.',
  'dependencies.risks.details.not_found.go_back_text': 'Go back to all risks',
  'dependencies.risks.details.license_profile_missing.title': 'License profile not found',
  'dependencies.risks.details.license_profile_missing.body':
    'The license profile associated with this dependency risk is no longer available. Please ensure that a valid license profile is assigned to the project and rescan.',
  'dependencies.risks.affected_dependency': 'Affected dependency',
  'dependencies.risks.more': '+{count} more',
  'dependencies.risks.activity.initial_activity': 'Dependency risk first detected',
  'dependencies.risks.severity': 'Risk severity',
  'dependencies.risks.severity.help.icon': 'More information about risk severity',
  'dependencies.risks.severity.help.intro':
    'Sonar assesses a severity for dependency risks based on the type of risk.',
  'dependencies.risks.severity.help.license.heading': 'Prohibited licenses',
  'dependencies.risks.severity.help.license.body':
    'All prohibited license risks are defined as HIGH severity.',
  'dependencies.risks.severity.help.vulnerability.heading': 'Vulnerabilities',
  'dependencies.risks.severity.help.vulnerability.body':
    'Vulnerabilities are given a holistic severity rating based on the vulnerability severity (as defined by CVSS), known exploitation (as defined by CISA KEV), and probable future exploitation (as defined by EPSS).',
  'dependencies.risks.severity.help.malware.body':
    'Malware is always given a BLOCKER severity rating by default.',
  'dependencies.risks.severity.help.manual_update':
    "This risk's severity was manually changed to {severity}. To see the history of severity changes for this risk, view the <link>activity tab.</link>",
  'dependencies.risks.severity.help.warning_title': 'Severity review recommended',
  'dependencies.risks.severity.help.warning_msg':
    "This risk's severity was manually changed to {manualSeverity}, but new data shows its calculated severity has now increased to {originalSeverity}. We recommend reviewing the risk to confirm if the prior override to {manualSeverity} is still appropriate. To see the history of severity changes for this risk, view the <link>activity tab</link>.",
  'dependencies.risks.severity.help.warning_dismiss': 'Mark as reviewed',
  'dependencies.risks.severity.calculated': 'Calculated',
  'dependencies.risks.severity.overridden': 'Overridden',
  'dependencies.risks.severity.user_override': 'User override',
  'dependencies.risks.severity.picker_header':
    'Please note: If the severity rating for this risk is manually changed, it will no longer be updated automatically by Sonar, even if the data used in our severity calculation changes.',
  'dependencies.risks.severity.quality.button.static': '{severity} severity impact on {quality}.',
  'dependencies.risks.severity.BLOCKER.description': 'Known as exploited (KEV)',
  'dependencies.risks.severity.LOW.description': 'All other non-withdrawn vulnerabilities',
  'dependencies.risks.severity.INFO.description': 'Confirmed false positive or withdrawn',
  'dependencies.risks.cvss_score': 'CVSS: {score}',
  'dependencies.risks.cvss_withdrawn': 'CVSS: N/A (withdrawn)',
  'dependencies.risks.no_cvss_score': 'CVSS: Unscored (pending)',
  'dependencies.risks.cvss_title': 'CVSS score',
  'dependencies.risks.cvss_severity_critical': 'Critical',
  'dependencies.risks.cvss_severity_high': 'High',
  'dependencies.risks.cvss_severity_medium': 'Medium',
  'dependencies.risks.cvss_severity_low': 'Low',
  'dependencies.risks.cvss_severity_none': 'None',
  'dependencies.risks.epss_title': 'EPSS probability',
  'dependencies.risks.epss.awaiting': 'Awaiting EPSS score',
  'dependencies.risks.epss.awaiting_details':
    'Risk severity may change once EPSS is available (typically 24 hours after CVE is published)',
  'dependencies.risks.epss.withdrawn': 'N/A (withdrawn)',
  'dependencies.risks.quality': 'Software Quality',
  'dependencies.risks.quality.SECURITY': 'Security',
  'dependencies.risks.quality.SECURITY.description': 'Security quality description',
  'dependencies.risks.quality.MAINTAINABILITY': 'Maintainability',
  'dependencies.risks.quality.MAINTAINABILITY.description': 'Maintainability quality description',
  'dependencies.risks.status.help':
    'Dependency risks can be confirmed (marked as problems that need fixed), accepted (technical debt to fix later), or marked safe (not a risk based on other factors).',
  'dependencies.risks.status.help.icon': 'More information about risk statuses',
  'dependencies.risks.status.learn_more': 'Learn more about managing dependency risks.',
  'dependencies.risk.how.title': 'Update the dependency',
  'dependencies.risk.how.body':
    'If an updated version of the dependency that fixes the vulnerability is available, update to that version. Always test your application thoroughly after updating a dependency to ensure nothing breaks.',
  'dependencies.risk.how_introduced_link': 'How is this dependency introduced?',
  'dependencies.risk.how_introduced_tab': 'Where is it?',
  'dependencies.risk.how.find_alternative': 'Find an alternative',
  'dependencies.risk.how.find_alternative.vulnerability_body':
    'If no update is available, consider switching to an alternative dependency that provides the same functionality but without the vulnerability.',
  'dependencies.risk.how.find_alternative.license_body':
    'Because this dependency’s license is prohibited by the {profile} license profile, you will need to find a different dependency to meet your needs.',
  'dependencies.risk.how.license.view_allowed': 'View licenses allowed for this project',
  'dependencies.risk.how.fix.complete': 'Complete fix',
  'dependencies.risk.how.fix.partial': 'Partial fix',
  'dependencies.risk.how.fix.none': 'Affected version',
  'dependencies.risk.how.wait_for_fix': 'Wait for a fix',
  'dependencies.risk.how.wait_for_fix.body':
    'You are using the latest version of this dependency, and no newer version is available to address the vulnerability. If you trust that the dependency is actively maintained and expect a fix to be released soon, it may be reasonable to wait for the update.',

  'dependencies.risk.how.fix_body.version_in_use.complete':
    "This is the version of the dependency you're using, but it is not affected.",
  'dependencies.risk.how.fix_body.version_in_use.unknown':
    "This is the version of the dependency you're using, but we have no data on it. It may or may not be affected.",
  'dependencies.risk.how.fix_body.version_in_use.default':
    "This is the affected version of the dependency you're using.",

  'dependencies.risk.how.fix_body.nearest_partial':
    'This is the nearest version that fixes this vulnerability, but it has {vulnerabilityIdCount} other {vulnerabilityIdCount, plural, one {vulnerability} other {vulnerabilities}}.',
  'dependencies.risk.how.fix_body.nearest_complete':
    'This is the nearest version without any known vulnerabilities.',

  'dependencies.risk.how.fix_body.latest_partial':
    'This is the latest version that fixes this vulnerability, but it has {vulnerabilityIdCount} other {vulnerabilityIdCount, plural, one {vulnerability} other {vulnerabilities}}.',
  'dependencies.risk.how.fix_body.latest_complete':
    'This is the latest version without any known vulnerabilities.',

  'dependencies.risk.how.fix_body.latest_stable.complete':
    'This is the latest non-prerelease version without any known vulnerabilities.',
  'dependencies.risk.how.fix_body.latest_stable.partial':
    'This is the latest non-prerelease version that fixes this vulnerability, but it has {vulnerabilityIdCount} other {vulnerabilityIdCount, plural, one {vulnerability} other {vulnerabilities}}.',
  'dependencies.risk.how.fix_body.latest_stable.default':
    'This is the latest non-prerelease version but it does not fix this vulnerability{vulnerabilityIdCount, plural, =1 {.} other { and has # other vulnerabilities.}}',

  'dependencies.risk.how.fix_body.latest_prerelease.complete':
    'This is the latest prerelease version without any known vulnerabilities.',
  'dependencies.risk.how.fix_body.latest_prerelease.partial':
    'This is the latest prerelease version that fixes this vulnerability, but it has {vulnerabilityIdCount} other {vulnerabilityIdCount, plural, one {vulnerability} other {vulnerabilities}}.',
  'dependencies.risk.how.fix_body.latest_prerelease.default':
    'This is the latest prerelease version but it does not fix this vulnerability{vulnerabilityIdCount, plural, =1 {.} other { and has # other vulnerabilities.}}',

  'dependencies.risk.how.no_guidance':
    'Remediation guidance is not yet available in Sonar for this vulnerability. You will need to manually determine if there is an unaffected release available that you can update to. Please check the “What’s the risk” information for guidance on affected versions.',

  'dependencies.risk.how.malware.body':
    "While each instance of a malicious package is different, here are some general principles to help guide you. <li>Immediately inform your information security team.</li><li>Remove the package from your project by uninstalling it and removing it from your dependency files.</li><li>Rotate all secrets and credentials that may have been exposed, including API keys, passwords, tokens, and certificates. Do this from a different, secure computer.</li><li>Review your system for compromise by checking for unexpected processes, network connections, or file modifications. Consider restoring from a clean backup or reimaging affected systems.</li><li>Update to a safe version if one exists, or find an alternative package. Check the package's repository and security advisories for guidance.</li><li>Scan your codebase for any malicious code that may have been injected into your project files during the package's execution.</li><li>Review your security practices including how you vet dependencies and consider using tools that scan for malicious packages before installation.</li>",

  //------------------------------------------------------------------------------
  //
  // SCA LICENSE PROFILES
  //
  //------------------------------------------------------------------------------

  'sca.licenses.page': 'License Profiles',
  'sca.licenses.page.intro':
    'A license profile is a collection of policies that define which licenses are allowed or prohibited for the dependencies used by your projects. If a dependency with a prohibited license is found during an analysis, it will be identified as a dependency risk. For more details see the documentation for {docsLink}.',
  'sca.licenses.page.no_profiles.title':
    "Dependency licenses won't be analyzed until a license profile is created.",
  'sca.licenses.page.no_profiles.body':
    "In order to analyze a project's licenses, it must be assigned a license profile. You can manually choose which projects to analyze or set a default profile for all projects.",
  'sca.licenses.create_profile': 'Create profile',
  'sca.licenses.details_page.intro':
    'License profiles are used to set policies that define which licenses are allowed or prohibited for the dependencies used by your projects. If a dependency with a prohibited license is found during an analysis, it will be identified as a dependency risk.',
  'sca.licenses.license_override_applied':
    'The default policy for {licenseCategory} licenses is <b>{defaultPolicy}</b>. You have overridden the default policy to <b>{policy}</b>.',
  'sca.licenses.default_policy.body':
    'This is your {defaultBadge} license profile. All projects that are not manually assigned another profile will use this one.',
  'sca.licenses.default_policy.no_default':
    'You have not set a default license profile. If a license profile is set as default, all of your projects will use the profile during analysis, unless they are manually assigned to another one.',
  'sca.licenses.default_policy.nothing_allowed':
    'This license profile is set as default, but no licenses or categories of licenses have been allowed. In this state, analysis will show developers that all licenses are prohibited. If you don’t intend to immediately configure which licenses are allowed, we recommend you wait to set this profile as the default until after configuration.',
  'sca.licenses.policy.nothing_allowed':
    'This license profile has no licenses or categories of licenses which have been allowed. In this state, analysis will show developers that all licenses are prohibited. If you don’t intend to immediately configure which licenses are allowed, we recommend you wait to set this profile as the default until after configuration.',
  'sca.licenses.profile.create_help': 'Create a new license profile to manage your licenses.',
  'sca.licenses.profile.actions.set_default': 'Set as default',
  'sca.licenses.profile.actions.remove_default': 'Remove as default',
  'sca.licenses.profile.actions.edit_configuration': 'Edit configuration',
  'sca.licenses.profile.actions.label': 'Actions',
  'sca.licenses.profile.actions.view_configuration': 'View configuration',
  'sca.licenses.profile.search_licenses': 'Search licenses',
  'sca.licenses.profile.rename_modal.title': 'Rename license profile',
  'sca.licenses.profile.rename_modal.body': 'Enter a new name for the license profile.',
  'sca.licenses.profile.delete_modal.title': 'Delete license profile',
  'sca.licenses.profile.delete_modal.body':
    'Are you sure you want to delete this license profile? Any associated projects will revert to the default license profile or will not have any license profile applied if no default exists.',
  'sca.licenses.profile.properties.name': 'License Profile',
  'sca.licenses.profile.properties.updated_at': 'Updated',
  'sca.licenses.profile.properties.license_count': 'License Count',
  'sca.licenses.profile.properties.license_name': 'License',
  'sca.licenses.profile.properties.license_category': 'Category',
  'sca.licenses.profile.properties.license_policy': 'Policy',
  'sca.licenses.profile.properties.license_policy.allowed': 'Allowed',
  'sca.licenses.profile.properties.license_policy.prohibited': 'Prohibited',
  'sca.licenses.profile.current_default': 'Current default: {defaultPolicy}',
  'sca.licenses.profile.categories.title': 'License category policies',
  'sca.licenses.profile.categories.help':
    'Save configuration time by choosing license categories to allow by default. You can always customize individual license policies even if you allow a category by default.',
  'sca.licenses.profile.projects_using': 'Projects using this profile',
  'sca.licenses.set_category_modal.title': 'Set default license policies',
  'sca.licenses.set_category_modal.body':
    'Sonar has categorized many common open source licenses based on their characteristics to make policy setting easier for you. Setting a default policy by category enables you to quickly allow or prohibit all licenses in that category. Don’t worry, you can always set policies for individual licenses as needed.',

  'sca.licenses.category.copyleft_weak.name': 'Weak copyleft',
  'sca.licenses.category.copyleft_strong.name': 'Strong copyleft',
  'sca.licenses.category.copyleft_network.name': 'Network copyleft',
  'sca.licenses.category.copyleft_maximal.name': 'Maximal copyleft',
  'sca.licenses.category.permissive_standard.name': 'Standard permissive',
  'sca.licenses.category.permissive_amateur.name': 'Non-standard permissive',
  'sca.licenses.category.uncategorized.name': 'Other',
  'sca.licenses.category.filter_by_category': 'All categories',

  'sca.licenses.category.permissive_standard':
    'This category includes the most commonly used permissive licenses. Permissive licenses grant broad permissions to use, and modify, with very minimal obligations (primarily attribution). Licenses in this category have all the essential elements of permissive open source licenses. Example standard permissive licenses include the MIT and Apache software licenses.',
  'sca.licenses.category.permissive_amateur':
    'This category includes permissive licenses that lack one or more essential elements of modern permissive open source licenses, or impose complex or confusing requirements. Many use unclear, jocular, or incomplete language. These licenses can be considered less legally predictable to use. Example amateur permissive licenses include the Artistic 1.0 and the WTFPL software licenses.',
  'sca.licenses.category.copyleft_weak':
    'Weak copyleft licenses require sharing your changes and additions to the licensed software when you give copies to others. Example weak copyleft licenses include the GNU LGPL and the Mozilla Public License software licenses.',
  'sca.licenses.category.copyleft_strong':
    'In addition to the requirements of the weak copyleft licenses, strong copyleft licenses require you to share larger programs that you build with the licensed software when you give copies to others. Example strong copyleft licenses include the GNU GPL license.',
  'sca.licenses.category.copyleft_network':
    'In addition to the requirements of strong copyleft licenses, network copyleft licenses require you to share larger programs that you build with the licensed software not just when you give copies to others, but also when you run the software for others to use over the Internet or another network. Example network copyleft licenses include the GNU AGPL and the Server-Side-Public License software licenses.',
  'sca.licenses.category.copyleft_maximal':
    'Maximal copyleft licenses answer the question “When does the license require you to share?” differently than other families. Maximal copyleft licenses require you to share software you make with others, and to license that software alike when you do. Example maximal copyleft licenses include the Parity and Reciprocal software licenses.',
  'sca.licenses.category.uncategorized':
    'Many detectable licenses do not fall into one of the standard categories, usually because they have non-standard requirements. These non-standard requirements may include limitations on commercial use, morality clauses, requirements of commercial license purchase based on any number of factors, or unusual reporting requirements. Software may also be unlicensed, with the authors reserving all rights. Any license in  the ‘Other’ category needs to be individually reviewed and configured based on the specific license terms and use case.',
  'sca.licenses.category.policy_not_configurable': 'Policies cannot be set for this category.',
  'sca.licenses.project.title': 'License Profile',
  'sca.licenses.project.info':
    'A {licenseProfileDocUrl} is a collection of policies that define which licenses are allowed or prohibited for the dependencies used by your projects. Dependency licenses will only be analyzed if a default license profile is created, or if projects are manually assigned to a license profile. If a dependency with a prohibited license is found during an analysis, it will be identified as a {dependencyRiskDocUrl}.',
  'sca.licenses.project.choose':
    'Choose which license profile to assign to this project or create a new profile from the {licenseProfilesUrl} page.',
  'sca.quality_gates.metric.sca_severity_vulnerability': 'Dependency vulnerability severity',
  'sca.quality_gates.metric.sca_severity_licensing': 'Dependency with prohibited license',
  'sca.quality_gates.metric.sca_severity_malware': 'Dependency with malware',
  'sca.quality_gates.metric.sca_severity_any_issue': 'Dependency risk severity',
  'sca.quality_gates.metric.sca_severity_licensing.description':
    "All prohibited license risks are classified as high severity by Sonar. Therefore, this condition will cause the quality gate to fail if any of a project's dependencies use a license that is prohibited by the project's License Profile.",

  //------------------------------------------------------------------------------
  //
  // SCA REPORT PAGE
  //
  //------------------------------------------------------------------------------
  'sca.sbom.report': 'Software Bill of Materials (SBOM)',
  'sca.risk.report': 'Advanced Security Dependency Risks Report',
  'sca.risk.report.name': 'Dependency Risks Report',

  //------------------------------------------------------------------------------
  //
  // ARCHITECTURE PAGE
  //
  //------------------------------------------------------------------------------
  'architecture.empty_state.title': 'The architecture diagram is not available',
  'architecture.empty_state.body':
    'If your project is compatible with the architecture feature, please run a new scan and the diagram will appear here.',
  'architecture.empty_state.body1': 'Supported Languages: {supported_languages}',
  'architecture.empty_state.body2': 'Active Languages: {active_languages}',
  'architecture.empty_state.get_started.title': 'Get started!',
  'architecture.project_too_big.title': 'project too big to display',
  'architecture.project_too_big.body': "This project is too big and can't be displayed.",
  'architecture.page': 'Architecture',
  'architecture.page.discovery': 'Current architecture',
  'architecture.page.model.visual.title': 'Intended architecture',
  'architecture.page.model.visual.new_group': 'New Group',
  'architecture.page.model.visual.sidebar.title': 'Source Nodes',
  'architecture.page.model.visual.sidebar.description': 'Drag nodes to create groups in the model',
  'architecture.page.model.visual.button.add_component.label': 'Add component',
  'architecture.page.model.visual.button.add_component': 'Component',
  'architecture.page.model': 'Intended architecture',
  'architecture.page.dashboard.model.description_admin':
    'Create an intended architecture with a few top components to detect the first deviations.',
  'architecture.page.dashboard.model.description_view_only':
    'A project administrator should define the intended architecture to detect deviations.',
  'architecture.page.model.saved': 'Saved successfully',
  'architecture.page.model.no_data': 'No model data',
  'architecture.page.model.invalid_json': 'Invalid JSON format',
  'architecture.page.model.label': 'Model',
  'architecture.page.model.invalid_groups':
    'Invalid {groupsCount, plural, one {group} other {groups}}: {groups}',
  'architecture.page.model.visual.compress_nodes': 'Compact view',
  'architecture.page.model.errors.constraint.duplicate':
    'A relationship between "{source}" and "{target}" is already allowed.',
  'architecture.page.model.errors.constraint.same_source_and_target':
    'A relationship between the same source and target is invalid.',
  'architecture.page.model.errors.constraint.source_and_target_are_not_siblings':
    'A component cannot be related to a component that is not a sibling.',
  'architecture.page.model.errors.constraint.direct_cycle': 'Cyclic relationships are not allowed.',
  'architecture.page.model.errors.group.empty_label':
    'A component cannot have an empty name: {groupKey}.',
  'architecture.page.model.errors.group.duplicate_sibling_labels':
    'Two sibling components cannot have the same name: "{groupKey}".',
  'architecture.page.model.errors.invalid_model': 'Unable to change model. {errors}',
  'architecture.page.model.errors.action_needed':
    'Failed to save. You must define relationships first.',
  'architecture.page.model.errors.group.name_cannot_contain_slash':
    'A component name cannot contain a slash.',
  'architecture.page.model.modal.move_component.title': 'Move "{label}"',
  'architecture.page.model.modal.move_component.description':
    'Move the component and its code artifacts.',
  'architecture.page.model.modal.move_component.current_location': 'Current location: ',
  'architecture.page.model.modal.move_component.new_location': 'New location:',
  'architecture.page.model.modal.move_component.warning':
    'When moving the component, all sibling relationships will be lost.',
  'architecture.page.model.modal.move_component_name': 'Component name',
  'architecture.page.model.modal.move_component_name_placeholder': 'Enter component name...',
  'architecture.page.model.modal.move_component.disabled_duplicate':
    'This component has a child with the same name.',
  'architecture.page.model.modal.move_component.disabled_current_location':
    'You cannot move a component to its own location.',
  'architecture.page.model.modal.rename_component.title': 'Rename "{label}"',
  'architecture.page.model.modal.rename_component.new_name': 'New name',
  'architecture.page.model.modal.add_placeholder.title': 'Add placeholder',
  'architecture.page.model.modal.add_placeholder.kind_of_component': 'Kind of component',
  'architecture.page.model.modal.add_placeholder.new_name': 'Name',
  'architecture.page.model.modal.code_artifacts': 'Code Artifacts',
  'architecture.page.model.modal.search_artifacts': 'Search artifacts',
  'architecture.page.model.modal.covered_by': 'covered by {pattern}',
  'architecture.page.model.modal.assigned': 'Assigned',
  'architecture.page.model.modal.unassigned': 'Unassigned',
  'architecture.page.model.subtitle': 'Define your architecture model as code',
  'architecture.page.model.description': 'You can define your architecture model as code below.',
  'architecture.page.model.docs':
    'Review the <link1>expected format</link1> or take a look at the <link2>documentation</link2> to learn more.',
  'architecture.page.model.visual.search.placeholder': 'Search...',
  'architecture.page.model.visual.no_components_available': 'No components can be added',
  'architecture.page.model.relationships.incoming.label': 'Has incoming relationships',
  'architecture.page.model.relationships.outgoing.label': 'Has outgoing relationships',
  'architecture.page.model.relationships.no-siblings':
    'This component has no siblings and cannot have relationships.',
  'architecture.page.model.relationships.all_selected':
    'All components are already part of a relationship.',
  'architecture.page.model.modal.add_component': 'Add Component',
  'architecture.page.model.modal.add_subcomponent': 'Add Sub-Component',
  'architecture.page.model.modal.add_component.title': 'New Component',
  'architecture.page.model.modal.add_component.description':
    'Add a new component to your architecture model.',
  'architecture.page.model.modal.add_subcomponent.title': 'New Sub-Component',
  'architecture.page.model.modal.add_subcomponent.description':
    'Add a new sub-component to {parentName}.',
  'architecture.page.model.modal.for_existing_code': 'For existing code',
  'architecture.page.model.modal.for_future_code': 'For future code',
  'architecture.page.model.modal.choose_existing_component': 'Choose an existing component',
  'architecture.page.model.modal.choose_existing_subcomponent': 'Choose an existing sub-component',
  'architecture.page.model.modal.select_placeholder': 'Select a component...',
  'architecture.page.model.modal.name_in_intended_architecture': 'Name in intended architecture',
  'architecture.page.model.node.action_needed': 'You must define relationships.',
  'architecture.page.oversize': 'Oversized components',
  'architecture.page.oversize_list': 'Oversized components',
  'architecture.page.oversize_list.count':
    '{count, plural, one {<bold>1</bold> oversized component} other {<bold>{count}</bold> oversized components}}',
  'architecture.page.oversize_list.child_count':
    '{count, plural, one {1 child} other {{count} children}}',
  'architecture.page.tangles': 'Tangles',
  'architecture.page.tangle': 'Tangle Details',
  'architecture.page.tangles.count':
    '{count, plural, one {<bold>1</bold> Tangle} other {<bold>{count}</bold> Tangles}}',
  'architecture.page.architecture_deviations': 'Deviations',
  'architecture.page.structural_flaws': 'Flaws',
  'architecture.page.architecture_deviations_description':
    'Shows how much and where the codebase diverges from the intended architecture. Deviations appear in structure, which describes how elements are organized, and in relationships, which describe how elements depend on each other.',
  'architecture.page.structural_flaws_description':
    'Shows problems in the codebase that exist regardless of the intended architecture. A common example is a tangle, where several files or classes form overlapping cyclic dependencies and each can reach the others through dependency links.',
  'architecture.page.disallowed_dependencies': 'Relationships',
  'architecture.page.disallowed_dependencies_full': 'Relationship deviations',
  'architecture.page.disallowed_dependencies.count':
    '{count, plural, one {<bold>1</bold> Relationship dependency} other {<bold>{count}</bold> Relationship dependencies}}',
  'architecture.page.disallowed_dependencies.no_data': 'No relationship deviations',
  'architecture.disallowed_dependencies.table.depth': 'Depth',
  'architecture.disallowed_dependencies.table.weight': 'Code reference',
  'architecture.disallowed_dependencies.description':
    'Dependencies between two code components that are not explicitly allowed in the intended architecture.',
  'architecture.page.misplaced_components': 'Structure',
  'architecture.page.misplaced_components_full': 'Structure deviations',
  'architecture.page.misplaced_components.count':
    '{count, plural, one {<bold>1</bold> Structural deviation} other {<bold>{count}</bold> Structural deviations}}',
  'architecture.page.misplaced_components.no_data': 'No structure deviations',
  'architecture.misplaced_components.description':
    'Components in the intended architecture referencing code artifacts that are located elsewhere in the codebase.',
  'architecture.admin.promotion.message':
    'Try Design & Architecture free Early Access to Visualize your codebase and start formalizing your software architecture. <link>Enable Design & Architecture</link>',
  'architecture.user.promotion.message':
    'You now have Design & Architecture enabled in Early Access, you can start to visualize your codebase, define and verify your architecture. <link>Take me there!</link>',
  'architecture.no_graph_file.message':
    'No data available. Please run an analysis first, or see the analysis logs for more information.',
  'architecture.unsupported_language.message': 'No supported languages found for this project.',
  'architecture.error.message': "Sorry, Currently a project of this size isn't supported.",
  'architecture.nodes.orphans.label': 'Orphans ({orphansCount})',
  'architecture.nodes.orphans.name': 'Orphans',
  'architecture.tangles.description':
    'Groups of code components interconnected in a complex way, making them harder to understand and maintain.',
  'architecture.tangles.title':
    '{containersCount} {containerWord} and {elementsCount} {elementWord}{filename}',
  'architecture.tangles.title.filename': ' inside {filename}',
  'architecture.tangles.subtitle': '{containers} • {elements} • in {container}',
  'architecture.tangle.directive.create.button': 'Request removal',
  'architecture.tangle.directive.remove.button': 'Cancel removal',
  'architecture.tangle.directive.create.description':
    'An issue will be raised every time this dependency is detected in the code so that developers can remove it.',
  'architecture.tangle.directive.remove.description':
    'An issue is raised every time this dependency is detected in the code so that developers can remove it.',
  'architecture.tangle.directive.create.title': 'Request removal?',
  'architecture.tangle.directive.absent.description':
    'No directive exists to remove this dependency.',
  'architecture.tangle.directive.deletion.success': 'Dependency removal cancelled',
  'architecture.tangle.directive.callout.message': 'Select a dependency to manage its removal.',
  'architecture.oversize.description': 'Components containing too many child items.',
  'architecture.discovery.description': 'Discover the structure of your project.',
  'architecture.discovery.spotlight.path.copy': 'Copy: {path}',
  'architecture.discovery.spotlight.incoming_dependencies':
    '{count, plural, one {1 incoming dependency} other {{count} incoming dependencies}}',
  'architecture.discovery.spotlight.outgoing_dependencies':
    '{count, plural, one {1 outgoing dependency} other {{count} outgoing dependencies}}',
  'architecture.discovery.spotlight.direct': 'Direct',
  'architecture.discovery.spotlight.transitive': 'Transitive',
  'architecture.discovery.spotlight.no_incoming_dependencies': 'No incoming dependencies',
  'architecture.discovery.spotlight.no_outgoing_dependencies': 'No outgoing dependencies',
  'architecture.discovery.spotlight.parent_no_dependencies_message':
    'Select a child item on the graph to see its dependencies.',
  'architecture.discovery.spotlight.weight':
    '{weight, plural, one {1 underlying dependency} other {{weight} underlying dependencies}}',
  'architecture.model.no_subcomponents': 'No subcomponents',
  'architecture.model.add_subcomponent': 'Subcomponent',
  'architecture.model.add_subcomponent_label': 'Add subcomponent',
  'architecture.misplaced_components.table.misplaced_component': 'Bad component',
  'architecture.misplaced_components.table.depth': 'Depth',
  'architecture.misplaced_components.table.weight': 'Code artifacts',
  'architecture.directive.creation.success': 'Directive created successfully',
  //------------------------------------------------------------------------------

  //------------------------------------------------------------------------------
  //
  // PROJECTS PAGE
  //
  //------------------------------------------------------------------------------

  'projects.page': 'Projects',
  'projects.add': 'Create Project',
  'projects.create_application': 'Create Application',
  'projects.no_projects.empty_instance': 'There are no visible projects yet.',
  'projects.no_projects.empty_instance.new_project':
    'Once you analyze some projects, they will show up here.',
  'projects.no_projects.empty_instance.how_to_add_projects':
    'Here is how you can analyze new projects',
  'projects.no_favorite_projects': "You don't have any favorite projects yet.",
  'projects.no_favorite_projects.engagement':
    'Discover and mark as favorites projects you are interested in to have a quick access to them.',
  'projects.explore_projects': 'Explore Projects',
  'projects.not_analyzed.TRK': "Project's Main Branch is not analyzed yet.",
  'projects.not_analyzed.APP': "None of the Application's projects have been analyzed.",
  'projects.no_new_code_period.TRK': 'Project has no new code data yet.',
  'projects.no_new_code_period.APP': 'Application has no new code data yet.',
  'projects.new_code_period_x': 'New code: last {0}',
  'projects.configure_analysis': 'Configure analysis',
  'projects.configure_analysis_for_x': 'Configure analysis for project {project}',
  'projects.last_analysis_on_x': 'Last analysis: {date}',
  'projects.search': 'Search by project name or key',
  'projects.perspective': 'Perspective',
  'projects.skip_to_filters': 'Skip to project filters',
  'projects.x_projects_found': '{count} projects found',
  'projects.sort_by': 'Sort by',
  'projects.sort_ascending': 'Result sorted in ascending order',
  'projects.sort_descending': 'Result sorted in descending order',
  'projects.sorting.default': 'default',
  'projects.sorting.name': 'Name',
  'projects.sorting.analysis_date': 'Last analysis date',
  'projects.sorting.creation_date': 'Creation date',
  'projects.sorting.reliability': 'Reliability',
  'projects.sorting.security': 'Security',
  'projects.sorting.security_review': 'Security Review',
  'projects.sorting.maintainability': 'Maintainability',
  'projects.sorting.coverage': 'Coverage',
  'projects.sorting.duplications': 'Duplications',
  'projects.sorting.size': 'Size',
  'projects.sorting.new_reliability': 'Reliability',
  'projects.sorting.new_security': 'Security',
  'projects.sorting.new_security_review': 'Security Review',
  'projects.sorting.new_maintainability': 'Maintainability',
  'projects.sorting.new_coverage': 'Coverage',
  'projects.sorting.new_duplications': 'Duplications',
  'projects.sorting.new_lines': 'New Lines',
  'projects.view.overall': 'Overall Status',
  'projects.view.overall_code': 'Overall Code',
  'projects.view.new_code': 'New Code',
  'projects.worse_of_reliablity_and_security': 'Worse of Reliability and Security',
  'projects.limited_set_of_projects':
    'Displayed project set limited to the top {0} projects based on current sort: {1}.',
  'projects.facets.quality_gate': 'Quality Gate',
  'projects.facets.quality_gate.warning_help':
    'Warning status is deprecated. This filter will disappear when no Warning Quality Gate remains.',
  'projects.facets.rating_x': '{0} rating',
  'projects.facets.rating_option.reliability.legacy.1': '≥ 0 info issues',
  'projects.facets.rating_option.reliability.legacy.2': '≥ 1 minor issue',
  'projects.facets.rating_option.reliability.legacy.3': '≥ 1 major issue',
  'projects.facets.rating_option.reliability.legacy.4': '≥ 1 critical issue',
  'projects.facets.rating_option.reliability.legacy.5': '≥ 1 blocker issue',
  'projects.facets.rating_option.reliability.1': '≥ 0 info issues',
  'projects.facets.rating_option.reliability.2': '≥ 1 low issue',
  'projects.facets.rating_option.reliability.3': '≥ 1 medium issue',
  'projects.facets.rating_option.reliability.4': '≥ 1 high issue',
  'projects.facets.rating_option.reliability.5': '≥ 1 blocker issue',
  'projects.facets.rating_option.security.legacy.1': '≥ 0 info issues',
  'projects.facets.rating_option.security.legacy.2': '≥ 1 minor issue',
  'projects.facets.rating_option.security.legacy.3': '≥ 1 major issue',
  'projects.facets.rating_option.security.legacy.4': '≥ 1 critical issue',
  'projects.facets.rating_option.security.legacy.5': '≥ 1 blocker issue',
  'projects.facets.rating_option.security.1': '≥ 0 info issues',
  'projects.facets.rating_option.security.2': '≥ 1 low issue',
  'projects.facets.rating_option.security.3': '≥ 1 medium issue',
  'projects.facets.rating_option.security.4': '≥ 1 high issue',
  'projects.facets.rating_option.security.5': '≥ 1 blocker issue',
  'projects.facets.rating_option.maintainability.1': '≤ 5% to 0%',
  'projects.facets.rating_option.maintainability.2': '≥ 5% to <10%',
  'projects.facets.rating_option.maintainability.3': '≥ 10% to <20%',
  'projects.facets.rating_option.maintainability.4': '≥ 20% to <50%',
  'projects.facets.rating_option.maintainability.5': '≥ 50%',
  'projects.facets.rating_option.security_review.1': '≥ 80%',
  'projects.facets.rating_option.security_review.2': '≥ 70% to <80%',
  'projects.facets.rating_option.security_review.3': '≥ 50% to <70%',
  'projects.facets.rating_option.security_review.4': '≥ 30% to <50%',
  'projects.facets.rating_option.security_review.5': '< 30%',
  'projects.facets.security_review.description':
    'The percentage of reviewed (fixed or safe) security hotspots',
  'projects.facets.maintainability.description':
    'Ratio of the estimated time needed to fix all outstanding maintainability issues to the size of the project',
  'projects.facets.security.description': 'Vulnerability count',
  'projects.facets.reliability.description': 'Bug count',
  'projects.facets.languages': 'Languages',
  'projects.facets.search.languages': 'Search for languages',
  'projects.facets.new_lines': 'New Lines',
  'projects.facets.tags': 'Tags',
  'projects.facets.search.tags': 'Search for tags',
  'projects.facets.qualifier': 'Type',
  'projects.facets.qualitygate_label_x': 'Click to filter projects with a {0} quality gate.',
  'projects.facets.rating_label_single_x': 'Click to filter projects with a {0} rating of {1}.',
  'projects.facets.rating_label_multi_x':
    'Click to filter projects with a {0} rating of {1} or worse.',
  'projects.facets.label_no_data_x': 'Click to filter projects with no {0} data.',
  'projects.facets.label_text_x': 'Click to filter projects by {0}: {1}',
  'projects.facets.size.label.1': 'Click to filter projects with fewer than 1k lines of code',
  'projects.facets.size.label.2': 'Click to filter projects with 1k lines of code or more',
  'projects.facets.size.label.3': 'Click to filter projects with 10k lines of code or more',
  'projects.facets.size.label.4': 'Click to filter projects with 100k lines of code or more',
  'projects.facets.size.label.5': 'Click to filter projects with more than 500k lines of code',
  'projects.facets.new_lines.label.1': 'Click to filter projects with fewer than 1k new lines',
  'projects.facets.new_lines.label.2': 'Click to filter projects with 1k new lines or more',
  'projects.facets.new_lines.label.3': 'Click to filter projects with 10k new lines or more',
  'projects.facets.new_lines.label.4': 'Click to filter projects with 100k new lines or more',
  'projects.facets.new_lines.label.5': 'Click to filter projects with more than 500k new lines',
  'projects.facets.coverage.label.1': 'Click to filter projects with more than 80% coverage',
  'projects.facets.coverage.label.2': 'Click to filter projects with less than 80% coverage',
  'projects.facets.coverage.label.3': 'Click to filter projects with less than 70% coverage',
  'projects.facets.coverage.label.4': 'Click to filter projects with less than 50% coverage',
  'projects.facets.coverage.label.5': 'Click to filter projects with less than 30% coverage',
  'projects.facets.duplication.label.1': 'Click to filter projects with less than 3% duplication',
  'projects.facets.duplication.label.2': 'Click to filter projects with more than 3% duplication',
  'projects.facets.duplication.label.3': 'Click to filter projects with more than 5% duplication',
  'projects.facets.duplication.label.4': 'Click to filter projects with more than 10% duplication',
  'projects.facets.duplication.label.5': 'Click to filter projects with more than 20% duplication',
  'projects.facets.no_available_filters_clear_others':
    'No available filters. Clear other filters to see options.',
  'projects.sort.disabled':
    'Disabled because sorting cannot affect the displayed result with the current project selection.',
  'projects.sort.analysis_date': 'by last analysis date (oldest first)',
  'projects.sort.-analysis_date': 'by last analysis date (latest first)',
  'projects.sort.name': 'by name',
  'projects.sort.-name': 'by name',
  'projects.sort.reliability': 'by reliability (best first)',
  'projects.sort.-reliability': 'by reliability (worst first)',
  'projects.sort.security': 'by security (best first)',
  'projects.sort.-security': 'by security (worst first)',
  'projects.sort.maintainability': 'by maintainability (best first)',
  'projects.sort.-maintainability': 'by maintainability (worst first)',
  'projects.sort.coverage': 'by coverage (best first)',
  'projects.sort.-coverage': 'by coverage (worst first)',
  'projects.sort.duplications': 'by duplications (best first)',
  'projects.sort.-duplications': 'by duplications (worst first)',
  'projects.sort.size': 'by size (smallest first)',
  'projects.sort.-size': 'by size (biggest first)',
  'projects.show_more': 'Show more projects',
  'projects.security_hotspots_reviewed': 'Hotspots Reviewed',
  'projects.awaiting_scan': 'Change in Calculation',
  'projects.awaiting_scan.title': 'Values might change after the next analysis',
  'projects.awaiting_scan.description.TRK':
    'The calculation methodology for security, reliability, and maintainability ratings has changed, and the values displayed may be updated after the next analysis.',
  'projects.awaiting_scan.description.APP':
    'The calculation methodology for security, reliability, and maintainability ratings has changed, and the values displayed may be updated after analyzing all projects in this application.',
  'projects.awaiting_scan.description.VW':
    'The calculation methodology for security, reliability, and maintainability ratings has changed, and the values displayed may be updated after analyzing all projects in this portfolio.',
  'projects.awaiting_scan.learn_more': 'Learn more in SonarQube documentation',
  'projects.ai_code_assurance_on.description': 'AI Code Assurance is on',
  'projects.ai_code_assurance_off.description': 'AI Code Assurance is off',
  'projects.ai_code_assurance_fail.description': 'AI Code Assurance failed',
  'projects.ai_code_assurance_pass.description': 'AI Code Assurance passed',
  'projects.ai_code_assurance_on.content':
    'This project contains AI-generated code and benefits from Sonar’s AI Code Assurance.',
  'projects.ai_code_assurance.edit_quality_gate': 'Change Quality Gate',
  'projects.ai_code.tooltip.content': 'This project contains AI-generated code.',
  'projects.ai_code_assurance.tooltip.content':
    'This project contains AI-generated code and benefits from Sonar’s AI Code Assurance.',
  'projects.ai_code_detected.title': 'AI code detected',
  'projects.ai_code_detected.description': 'This project may contain AI-generated code.',
  'projects.ai_code_detected.link': 'Review AI-Generated Code setting',
  'projects.ai_code_detected.tooltip.content':
    'Some contributors in this project used GitHub Copilot recently.',
  'projects.branch.info.AI_CODE_ASSURANCE_ON.content':
    'This project benefits from Sonar’s AI Code Assurance.',
  'projects.branch.info.AI_CODE_ASSURANCE_PASS.content':
    'This branch meets your quality standard for AI Code.',
  'projects.branch.info.AI_CODE_ASSURANCE_FAIL.content':
    'This branch does not meet your quality standard for AI Code.',
  'projects.branches.AI_CODE_ASSURANCE_OFF.admin.content':
    'To benefit from AI Code Assurance, select an AI-qualified quality gate. <link>Change quality gate</link>',
  'projects.branches.AI_CODE_ASSURANCE_OFF.content':
    'This project could benefit from AI Code Assurance by using an <link>AI-qualified quality gate</link>.',

  //------------------------------------------------------------------------------
  //
  // DASHBOARD
  //
  //------------------------------------------------------------------------------

  'dashboard.project.not_found': 'The requested project could not be found.',
  'dashboard.project.not_found.2':
    'Either it has never been analyzed successfully or it has been deleted.',
  'dashboard.portfolio.not_found': 'The requested portfolio could not be found.',
  'dashboard.portfolio.not_found.2':
    'Either its parent has not been recomputed or it has been deleted.',

  //------------------------------------------------------------------------------
  //
  // SETTINGS
  //
  //------------------------------------------------------------------------------
  'settings.key_x': 'Key: {0}',
  'settings.default_x': 'Default: {0}',
  'settings.not_set': '(not set)',
  'settings.state.saving': 'Saving...',
  'settings.state.saved': 'Saved!',
  'settings.state.confirmation.title':
    '{value, select, true {Activate} false {Deactivate} other {Save}} "{name}"?',
  'settings.state.validation_failed': 'Validation failed. {0}',
  'settings.state.value_cant_be_empty':
    'Provide a value or use "Reset" to set the value to the default one.',
  'settings.state.value_cant_be_empty_no_default': 'Provide a value.',
  'settings.state.url_not_valid': '{0} is not a valid URL',
  'settings._default': '(default)',
  'settings.boolean.true': 'True',
  'settings.boolean.false': 'False',
  'settings.default.no_value': "'<no value>'",
  'settings.default.complex_value': "'<complex value>'",
  'settings.default.password': "'<password>'",
  'settings.reset_confirm.title': 'Reset Setting',
  'settings.reset_confirm.description': 'Are you sure that you want to reset this setting?',
  'settings.definition.reset': 'Reset "{0}" to default values',
  'settings.definition.delete_value': 'Delete value "{1}" for setting "{0}"',
  'settings.definitions.delete_fields': 'Delete row {1} for setting "{0}"',
  'settings.deprecated_setting_warning':
    'This feature is deprecated and will be removed in a future release',

  'settings.search.placeholder': 'Find in Settings',
  'settings.search.results': 'Search results list',

  'settings.json.format': 'Format JSON',
  'settings.json.format_error': 'Formatting requires valid JSON. Please fix it and retry.',

  'settings.analysis_scope.introduction':
    'Narrow the focus by configure what will be analyzed and how. Learn more about <link>analysis scope</link>.',
  'settings.analysis_scope.wildcards.introduction':
    'You can set analysis parameters by using the following <link>wild card patterns</link>:',
  'settings.analysis_scope.wildcards.link': 'wild card patterns',
  'settings.analysis_scope.wildcards.zero_more_char': 'Match zero or more characters',
  'settings.analysis_scope.wildcards.zero_more_dir': 'Match zero or more directories',
  'settings.analysis_scope.wildcards.single_char': 'Match a single character',
  'settings.analysis_scope.learn_more': 'Read more about analysis scope',

  'settings.new_code_period.category': 'New Code',
  'settings.new_code_period.title': 'New Code',

  'settings.languages.select_a_language_placeholder': 'Select a language',

  'settings.projects.default_visibility_of_new_projects': 'Default visibility of new projects:',
  'settings.projects.change_visibility_form.label': 'Change default visibility of new projects',
  'settings.projects.change_visibility_form.header': 'Set Default Visibility of New Projects',
  'settings.projects.change_visibility_form.warning':
    'This will not change the visibility of already existing projects.',
  'settings.projects.change_visibility_form.warning.github':
    'This will not change the visibility of already existing projects. Additionally, projects bound to GitHub will not be affected by this option and will be ignored.',
  'settings.projects.change_visibility_form.warning.gitlab':
    'This will not change the visibility of already existing projects. Additionally, projects bound to GitLab will not be affected by this option and will be ignored.',
  'settings.projects.change_visibility_form.submit': 'Change Default Visibility',

  'settings.almintegration.title': 'DevOps Platform Integrations',
  'settings.almintegration.description':
    "DevOps Platform integrations allow {productName} to interact with your DevOps Platform. This enables things like authentication, or providing analysis details and a Quality Gate to your Pull Requests directly in your DevOps Platform's interface.",
  'settings.almintegration.empty.server_base_url':
    'You need to set the Server Base URL in General > {serverBaseUrl} to have correct links from the DevOps Platform to your {productName} instance.',
  'settings.almintegration.empty.server_base_url.setting_link': 'Server Base URL',
  'settings.almintegration.tab.github': 'GitHub',
  'settings.almintegration.tab.bitbucket': 'Bitbucket',
  'settings.almintegration.tab.azure': 'Azure DevOps',
  'settings.almintegration.tab.gitlab': 'GitLab',
  'settings.almintegration.github.info':
    'You need to install a GitHub App with specific settings and permissions to enable Pull Request Decoration on your Organization or Repository. {link}',
  'settings.almintegration.github.additional_permission':
    'If Quality Gate status reporting fails on private projects, you might need to add an additional permission to the GitHub App. {link}',
  'settings.almintegration.bitbucketcloud.info':
    '{productName} needs you to create an {oauth} in your Bitbucket Cloud workspace settings to report the Quality Gate status on Pull Requests. It needs to be a private consumer with {permission} permission. An OAuth callback URL is required by Bitbucket Cloud but not used by {productName} so any URL works. {doc_link}',
  'settings.almintegration.bitbucketcloud.oauth': 'OAuth consumer',
  'settings.almintegration.empty.azure':
    'Create your first Azure DevOps configuration to start analyzing your repositories on {productName}.',
  'settings.almintegration.empty.bitbucket':
    'Create your first Bitbucket configuration to start analyzing your repositories on {productName}.',
  'settings.almintegration.empty.bitbucketcloud':
    'Create your first Bitbucket Cloud configuration to start analyzing your repositories on {productName}.',
  'settings.almintegration.empty.github':
    'Create your first GitHub configuration to start analyzing your repositories on {productName}.',
  'settings.almintegration.empty.gitlab':
    'Create your first GitLab configuration to start analyzing your repositories on {productName}.',
  'settings.almintegration.create': 'Create configuration',
  'settings.almintegration.create.tooltip':
    'Upgrade to {link} to integrate with multiple {alm} instances.',
  'settings.almintegration.create.tooltip.link': 'Enterprise Edition',
  'settings.almintegration.check_configuration': 'Check configuration',
  'settings.almintegration.check_configuration_x': 'Check configuration "{0}"',
  'settings.almintegration.edit_configuration': 'Edit configuration "{0}"',
  'settings.almintegration.delete_configuration': 'Delete configuration "{0}"',
  'settings.almintegration.checking_configuration': 'Checking configuration',
  'settings.almintegration.configuration_valid': 'Configuration valid',
  'settings.almintegration.configuration_invalid':
    'You have the following errors in your configuration:',
  'settings.almintegration.could_not_validate': 'Could not validate this configuration.',
  'settings.almintegration.delete.header': 'Delete configuration',
  'settings.almintegration.delete.message':
    'Are you sure you want to delete the {id} configuration?',
  'settings.almintegration.delete.info':
    '{0} projects will no longer get Pull Request Decorations.',
  'settings.almintegration.delete.no_info':
    'An unknown number of projects will no longer get Pull Request Decorations.',
  'settings.almintegration.form.app_id.github.help':
    "The App ID is found on your GitHub App's page on GitHub at Settings > Developer Settings > GitHub Apps",
  'settings.almintegration.form.header.create': 'Create a configuration',
  'settings.almintegration.form.header.edit': 'Edit the configuration',
  'settings.almintegration.form.name.azure': 'Configuration name',
  'settings.almintegration.form.name.azure.help':
    'Give your configuration a clear and succinct name. This name will be used at project level to identify the correct configured Azure instance for a project.',
  'settings.almintegration.form.choose_bitbucket_variant':
    'Select which variant you want to configure',
  'settings.almintegration.form.name.bitbucket': 'Configuration name',
  'settings.almintegration.form.name.bitbucket.help':
    'Give your configuration a clear and succinct name. This name will be used at project level to identify the correct configured Bitbucket instance for a project.',
  'settings.almintegration.form.name.bitbucketcloud': 'Configuration name',
  'settings.almintegration.form.name.bitbucketcloud.help':
    'Give your configuration a clear and succinct name. This name will be used at project level to identify the correct configured Bitbucket Cloud instance for a project.',
  'settings.almintegration.form.name.github': 'Configuration name',
  'settings.almintegration.form.name.github.help':
    'Give your configuration a clear and succinct name. This name will be used at project level to identify the correct configured GitHub App for a project.',
  'settings.almintegration.form.name.gitlab': 'Configuration name',
  'settings.almintegration.form.name.gitlab.help':
    'Give your configuration a clear and succinct name. This name will be used at project level to identify the correct configured GitLab instance for a project.',
  'settings.almintegration.form.workspace.bitbucketcloud': 'Workspace ID',
  'settings.almintegration.form.workspace.bitbucketcloud.error':
    "Workspace ID's can only contain lowercase letters, numbers, dashes, and underscores.",
  'settings.almintegration.form.workspace.bitbucketcloud.help':
    'The workspace ID is part of your bitbucket cloud URL {example}',
  'settings.almintegration.form.oauth_key.bitbucketcloud.help':
    'Bitbucket automatically creates an OAuth key when you create your OAuth consumer. You can find it in your Bitbucket Cloud workspace settings under OAuth consumers.',
  'settings.almintegration.form.oauth_secret.bitbucketcloud.help':
    'Bitbucket automatically creates an OAuth secret when you create your OAuth consumer. You can find it in your Bitbucket Cloud workspace settings under OAuth consumers.',
  'settings.almintegration.form.url.azure': 'Azure DevOps URL',
  'settings.almintegration.form.url.azure.help1':
    'For Azure DevOps Server, provide the full collection URL:',
  'settings.almintegration.form.url.azure.help2':
    'For Azure DevOps Services, provide the full organization URL:',
  'settings.almintegration.form.url.bitbucket': 'Bitbucket Server URL',
  'settings.almintegration.form.url.bitbucket.help':
    'Example: https://bitbucket-server.your-company.com',
  'settings.almintegration.form.url.github': 'GitHub API URL',
  'settings.almintegration.form.url.github.help1': 'Example for GitHub Enterprise:',
  'settings.almintegration.form.url.github.help2': 'If using GitHub.com:',
  'settings.almintegration.form.url.github.private_key_warning':
    'For security reasons, please make sure to provide the GitHub App private key to update the URL.',
  'settings.almintegration.form.url.gitlab': 'GitLab API URL',
  'settings.almintegration.form.url.gitlab.help': 'Provide the GitLab API URL. For example:',
  'settings.almintegration.form.url.pat_warning':
    'For security reasons, please make sure to provide the Personal Access Token to update the URL.',
  'settings.almintegration.form.app_id': 'GitHub App ID',
  'settings.almintegration.form.client_id.github': 'Client ID',
  'settings.almintegration.form.client_id.github.help':
    "The Client ID is found on your GitHub App's page.",
  'settings.almintegration.form.client_secret.github': 'Client Secret',
  'settings.almintegration.form.client_secret.github.help':
    "The Client secret is found on your GitHub App's page.",
  'settings.almintegration.form.client_id.bitbucketcloud': 'OAuth Key',
  'settings.almintegration.form.client_secret.bitbucketcloud': 'OAuth Secret',
  'settings.almintegration.form.private_key': 'Private Key',
  'settings.almintegration.form.private_key.github.help':
    "Your GitHub App's private key. You can generate a .pem file from your GitHub App's page under Private keys. Copy and paste the whole contents of the file here.",
  'settings.almintegration.form.webhook_secret.github': 'Webhook Secret',
  'settings.almintegration.form.webhook_secret.github.help':
    'Leave this field empty unless you are using GitHub Code Scanning Alert feature. See documentation for more details.',
  'settings.almintegration.form.personal_access_token': 'Personal Access Token',
  'settings.almintegration.form.personal_access_token.azure.help':
    '{productName} needs a {pat} to report the Quality Gate status on Pull Requests in Azure DevOps. To create this token, we recommend using a dedicated Azure DevOps account with administration permissions. The token itself needs {permission} permission. {doc_link}',
  'settings.almintegration.form.personal_access_token.azure.help.url': 'Personal Access Token',
  'settings.almintegration.form.personal_access_token.gitlab.help':
    '{productName} needs a {pat} to report the Quality Gate status on Merge Requests in GitLab. To create this token, we recommend using a dedicated GitLab account with {permission} permission to all target projects. The token itself needs the {scope} scope. {doc_link}',
  'settings.almintegration.form.personal_access_token.gitlab.help.url': 'Personal Access Token',
  'settings.almintegration.form.personal_access_token.bitbucket.help':
    '{productName} needs a {pat} to report the Quality Gate status on Pull Requests in Bitbucket Server. To create this token, we recommend using a dedicated Bitbucket Server account with administration permissions. The token itself needs {permission} permission. {doc_link}',
  'settings.almintegration.form.personal_access_token.bitbucket.help.url': 'Personal Access Token',
  'settings.almintegration.form.save': 'Save configuration',
  'settings.almintegration.form.cancel': 'Cancel',
  'settings.almintegration.form.secret.field': 'This field is hidden for security reasons.',
  'settings.almintegration.form.secret.update_field': 'Update field value',
  'settings.almintegration.form.secret.update_field_x': 'Update {0} value',
  'settings.almintegration.form.secret.can_encrypt': 'You can encrypt this value. {learn_more}',
  'settings.almintegration.feature.status_reporting.title': 'Quality Gate status reporting',
  'settings.almintegration.feature.status_reporting.description_pr':
    "Add analysis and a Quality Gate to your Pull Requests directly in your DevOps Platform's interface.",
  'settings.almintegration.feature.status_reporting.description_pr_and_commits':
    "Add the Quality Gate status to your Pull Requests and on analyzed commits directly in your DevOps Platform's interface.",
  'settings.almintegration.feature.status_reporting.description_mr':
    "Add analysis and a Quality Gate to your Merge Requests directly in your DevOps Platform's interface.",
  'settings.almintegration.feature.pr_decoration.disabled': 'Disabled',
  'settings.almintegration.feature.pr_decoration.disabled.no_branches':
    'Upgrade to {link} to enable this feature.',
  'settings.almintegration.feature.pr_decoration.disabled.no_branches.link': 'Developer Edition',
  'settings.almintegration.feature.alm_repo_import.title':
    'Import repositories from your DevOps Platform',
  'settings.almintegration.feature.alm_repo_import.description':
    'Select repositories from your DevOps Platform, and import them into {productName}.',
  'settings.almintegration.feature.alm_repo_import.disabled': 'Disabled',
  'settings.almintegration.feature.alm_repo_import.disabled.no_url':
    'This feature is disabled because your configured instance has no URL.',
  'settings.almintegration.tabs.authentication_moved':
    'You can delegate authentication to this DevOps Platform. The relevant settings are under the {link} section.',

  // Authentication Common
  'settings.authentication.title': 'Authentication',
  'settings.authentication.custom_message_information':
    'You can define a custom log-in message to appear on the log-in page to help your users authenticate. The relevant settings are available under the {link} section.',
  'settings.authentication.custom_message_information.link': 'General',
  'settings.authentication.description':
    'The following settings allow you to delegate authentication via SAML, or any of the following DevOps Platforms: GitHub, GitLab, and Bitbucket.',
  'settings.authentication.help':
    'For details on how to set up authentication, check out the {link}.',
  'settings.authentication.legacy_help.github':
    'Compatibility with GitHub OAuth App is deprecated and will be removed in a future release. Please check out the {link} for information on how to update your configuration.',
  'settings.authentication.help.link': 'documentation',
  'settings.authentication.form.create': 'Create configuration',
  'settings.authentication.form.edit': 'Edit',
  'settings.authentication.form.delete': 'Delete',
  'settings.authentication.form.delete.tooltip':
    'You can only delete a configuration if it is disabled.',
  'settings.authentication.form.loading': 'Loading configuration',
  'settings.authentication.form.enable': 'Enable configuration',
  'settings.authentication.form.disable': 'Disable configuration',
  'settings.authentication.form.disable.tooltip':
    'You can not disable this configuration while using Automatic Provisioning. You must be in Just-in-Time Provisioning mode to disable this configuration.',
  'settings.authentication.form.provisioning': 'Provisioning',
  'settings.authentication.form.provisioning_at_login':
    'Just-in-Time user and group provisioning (default)',
  'settings.authentication.form.other_provisioning_enabled':
    'Already enabled for another provider.  Only one identity provider can have automatic users and groups provisioning enabled.',
  'settings.authentication.form.settings.save_success': 'Settings saved successfully.',
  'settings.authentication.confirm_auto_provisioning.header':
    'Automatic provisioning has been enhanced',
  'settings.authentication.confirm_auto_provisioning.description1':
    'Your current version of automatic provisioning has been suspended and you must confirm a provisioning method.',
  'settings.authentication.confirm_auto_provisioning.description2':
    'Automatic provisioning has now been enhanced with the 10.7 release. For more details, read our {documentation}.',
  'settings.authentication.confirm_auto_provisioning.question': 'Select your provisioning method',
  'settings.authentication.confirm_auto_provisioning.confirm_choice': 'Confirm choice',
  'settings.authentication.confirm_auto_provisioning.auto.label':
    'Enhanced automatic provisioning (recommended)',
  'settings.authentication.confirm_auto_provisioning.auto.help':
    'Now synchronizes users, groups, permissions and project visibility',
  'settings.authentication.confirm_auto_provisioning.jit.label': 'Just-in-Time provisioning',
  'settings.authentication.confirm_auto_provisioning.jit.help':
    'Synchronises users and groups only',

  // GITHUB
  'settings.authentication.github.form.create': 'New GitHub Configuration',
  'settings.authentication.github.form.edit': 'Edit GitHub Configuration',
  'settings.authentication.github.appid_x': 'App ID: {applicationId}',
  'settings.authentication.github.confirm.AUTO_PROVISIONING': 'Switch to automatic provisioning',
  'settings.authentication.github.confirm.JIT': 'Switch to Just-in-Time provisioning',
  'settings.authentication.github.confirm.insecure': 'Potentially insecure configuration',
  'settings.authentication.github.confirm.AUTO_PROVISIONING.description':
    'Once you transition to automatic provisioning, groups, users, group memberships, and permissions on GitHub projects will be inherited from GitHub. You will no longer have the ability to edit them within {productName}. Do you want to proceed with this change?',
  'settings.authentication.github.confirm.JIT.description':
    'Switching to Just-in-Time provisioning removes the automatic synchronization of users, groups, and group memberships. Users are provisioned and group memberships are updated only at user login. Are you sure?',
  'settings.authentication.github.provisioning_change.confirm_changes': 'Confirm change',
  'settings.authentication.github.provisioning_change.insecure_config':
    "Please be aware that your configuration is potentially insecure because you didn't add any organization to the allowlist. If your GitHub App is public, anyone can install it and gain access to your instance.",
  'settings.authentication.github.configuration': 'GitHub Configuration',
  'settings.authentication.github.form.not_configured': 'GitHub App is not configured',
  'settings.authentication.github.form.legacy_configured':
    'Compatibility with GitHub OAuth Apps is deprecated and will be removed in a future release. As such, your current configuration will continue to work but some features will no longer be available. We recommend that you create a new GitHub App configuration. This will automatically replace your current GitHub OAuth App configuration. {documentation}',
  'settings.authentication.github.form.legacy_configured.link':
    'Learn more about how to create a GitHub App configuration',
  'settings.authentication.github.enable_first':
    'Enable your GitHub configuration for more provisioning options.',
  'settings.authentication.github.form.allowedOrganizations.name': 'Organizations',
  'settings.authentication.github.form.allowedOrganizations.description':
    'Only members of these organizations will be able to authenticate to the server. ⚠ if not set, users from any organization where the GitHub App is installed will be able to login to this {productName} instance.',
  'settings.authentication.github.form.apiUrl.name': 'The API url for a GitHub instance.',
  'settings.authentication.github.form.apiUrl.description':
    'The API url for a GitHub instance. https://api.github.com/ for GitHub.com, https://github.company.com/api/v3/ when using GitHub Enterprise',
  'settings.authentication.github.form.applicationId.name': 'App ID',
  'settings.authentication.github.form.applicationId.description':
    "The App ID is found on your GitHub App's page on GitHub at Settings > Developer Settings > GitHub Apps.",
  'settings.authentication.github.form.clientId.name': 'Client ID',
  'settings.authentication.github.form.clientId.description':
    'Client ID provided by GitHub when registering the application.',
  'settings.authentication.github.form.clientSecret.name': 'Client Secret',
  'settings.authentication.github.form.clientSecret.description':
    'Client password provided by GitHub when registering the application.',
  'settings.authentication.github.form.privateKey.name': 'Private Key',
  'settings.authentication.github.form.privateKey.description':
    "Your GitHub App's private key. You can generate a .pem file from your GitHub App's page under Private keys. Copy and paste the whole contents of the file here.",
  'settings.authentication.github.form.synchronizeGroups.name': 'Synchronize teams as groups',
  'settings.authentication.github.form.synchronizeGroups.description':
    'Synchronize GitHub team with {productName} group memberships when users log in to {productName}. For each GitHub team they belong to, users will be associated to a group of the same name if it exists in {productName}.',
  'settings.authentication.github.form.webUrl.name': 'The WEB url for a GitHub instance.',
  'settings.authentication.github.form.webUrl.description':
    'The WEB url for a GitHub instance. https://github.com/ for GitHub.com, https://github.company.com/ when using GitHub Enterprise.',
  'settings.authentication.github.form.private_key.required_for_url_change':
    'Please provide your private key again to update the API URL or the Web URL.',
  'settings.authentication.github.form.provisioning_with_github':
    'Automatic user, group, and permission provisioning',
  'settings.authentication.github.form.provisioning_with_github_short.autoProvisioning':
    'Automatic provisioning',
  'settings.authentication.github.form.provisioning_with_github_short.jit':
    'Just-in-Time provisioning',
  'settings.authentication.github.form.provisioning_with_github.description':
    'Users, groups and permissions are automatically provisioned from your GitHub organizations. Once activated, users and groups can only be created and modified from your GitHub organizations/teams. Existing local users will be kept and can only be deactivated. {documentation}',
  'settings.authentication.github.form.description.doc': 'For more details, see {documentation}.',
  'settings.authentication.github.form.provisioning_at_login.description':
    'Users and groups are synchronized only when users log in to {productName}. {documentation}',
  'settings.authentication.github.form.provisioning.disabled':
    'Your current edition does not support provisioning with GitHub. See the {documentation} for more information.',
  'settings.authentication.github.form.allowUsersToSignUp.name': 'Allow users to sign up',
  'settings.authentication.github.form.allowUsersToSignUp.description':
    'Allow new users to authenticate. When set to disabled, only existing users will be able to authenticate to the server.',
  'settings.authentication.github.form.projectVisibility.name': 'Provision project visibility',
  'settings.authentication.github.form.projectVisibility.description':
    'Change project visibility based on GitHub repository visibility. If disabled, every provisioned project will be private in {productName} and visible only to users with explicit GitHub permissions for the corresponding repository. Changes take effect at the next synchronization.',
  'settings.authentication.github.synchronize_now': 'Synchronize now',
  'settings.authentication.github.synchronization_finish': 'Synchronization is done.',
  'settings.authentication.github.configuration.validation.details': 'View details',
  'settings.authentication.github.configuration.validation.valid.short': 'Configuration is valid.',
  'settings.authentication.github.configuration.validation.valid':
    'Configuration is valid for {0}. {1} organizations will be synced.',
  'settings.authentication.github.configuration.validation.valid_one':
    "Configuration is valid for {0}. Organization '{1}' will be synced.",
  'settings.authentication.github.configuration.validation.invalid':
    'Configuration is invalid. {0}',
  'settings.authentication.github.configuration.validation.invalid_org':
    'Organization "{0}" has the following error: {1}',
  'settings.authentication.github.configuration.validation.details.title': 'Configuration validity',
  'settings.authentication.github.configuration.validation.details.valid_label': 'Valid',
  'settings.authentication.github.configuration.validation.details.invalid_label': 'Invalid',
  'settings.authentication.github.configuration.validation.details.org_not_found':
    '{0} (not found or app not installed)',
  'settings.authentication.github.configuration.roles_mapping.description':
    'When synchronizing users and groups, {productName} assigns permissions based on GitHub user and team roles. You can customize the mapping of permissions. The new mapping will take effect at the next synchronization.',
  'settings.authentication.github.configuration.roles_mapping.save_success':
    'GitHub roles mapping saved successfully.',
  'settings.authentication.github.configuration.roles_mapping.dialog.custom_roles_description':
    'When a custom role name added here matches an existing GitHub custom role in any of your organizations, the mapping applies to all users with this custom role. If an existing GitHub custom role has no exact match in this list, the permissions of its inherited base role are mapped.',
  'settings.authentication.github.configuration.unsaved_changes': 'You have unsaved changes.',

  // GITLAB
  'settings.authentication.gitlab.configuration': 'GitLab Configuration',
  'settings.authentication.gitlab.form.not_configured': 'GitLab App is not configured',
  'settings.authentication.gitlab.form.create': 'New GitLab Configuration',
  'settings.authentication.gitlab.form.edit': 'Edit GitLab Configuration',
  'settings.authentication.gitlab.form.applicationId.name': 'Application ID',
  'settings.authentication.gitlab.form.applicationId.description':
    'Application ID provided by GitLab when registering the application.',
  'settings.authentication.gitlab.form.url.name': 'GitLab URL',
  'settings.authentication.gitlab.form.url.description': 'URL to access GitLab.',
  'settings.authentication.gitlab.form.secret.name': 'Secret',
  'settings.authentication.gitlab.form.secret.description':
    'Secret provided by GitLab when registering the application.',
  'settings.authentication.gitlab.form.secret.required_for_url_change':
    'Please provide your secret again to update the URL.',
  'settings.authentication.gitlab.form.synchronizeGroups.name': 'Synchronize user groups',
  'settings.authentication.gitlab.form.synchronizeGroups.description':
    'For each GitLab group they belong to, the user will be associated to a group with the same name (if it exists) in {productName}. If enabled, the GitLab OAuth 2 application will need to provide the api scope.',
  'settings.authentication.gitlab.form.allowedGroups.name': 'Allowed groups',
  'settings.authentication.gitlab.form.allowedGroups.description.JIT':
    'Only members of these groups (and sub-groups) will be allowed to authenticate. Enter the group slug as it appears in the GitLab URL, for instance `my-gitlab-group`. ⚠︎ When you turn on `Allow users to sign up`, make sure to also turn on group synchronization and provide a list of allowed groups. Otherwise, any GitLab user will be able to log in to this {productName} instance.',
  'settings.authentication.gitlab.form.allowedGroups.description.AUTO_PROVISIONING':
    'Only members of these groups (and sub-groups) will be provisioned. Please enter the group slug as it appears in the GitLab URL, for instance `my-gitlab-group`.',
  'settings.authentication.gitlab.form.allowUsersToSignUp.name': 'Allow users to sign up',
  'settings.authentication.gitlab.form.allowUsersToSignUp.description':
    'Allow new users to authenticate. When set to disabled, only existing users will be able to authenticate to the server.',
  'settings.authentication.gitlab.form.provisioningToken.name': 'Provisioning token',
  'settings.authentication.gitlab.form.provisioningToken.description':
    'Token used for user provisioning. You can either use a group or a personal access token, as long as it has visibility on the groups that need to be imported.',
  'settings.authentication.gitlab.applicationId.name': 'App ID: {0}',
  'settings.authentication.gitlab.enable_first':
    'Enable your GitLab configuration for more provisioning options.',
  'settings.authentication.gitlab.provisioning_at_login':
    'Just-in-Time user provisioning (default)',
  'settings.authentication.gitlab.provisioning_at_login.description':
    'Users are synchronized only when users log in to {productName}. {documentation}',
  'settings.authentication.gitlab.description.JIT.learn_more':
    'Learn more about Just-in-Time provisioning with GitLab',
  'settings.authentication.gitlab.description.AUTO_PROVISIONING.learn_more':
    'Learn more about automatic provisioning with GitLab',
  'settings.authentication.gitlab.confirm.AUTO_PROVISIONING': 'Switch to automatic provisioning',
  'settings.authentication.gitlab.confirm.JIT': 'Switch to Just-in-Time provisioning',
  'settings.authentication.gitlab.confirm.AUTO_PROVISIONING.description':
    'Once you transition to automatic provisioning users, groups and permissions on GitLab projects will be inherited from GitLab. You will no longer have the ability to edit them within {productName}. Do you want to proceed with this change?',
  'settings.authentication.gitlab.confirm.JIT.description':
    'Switching to Just-in-Time provisioning removes the automatic synchronization of users, groups and permissions. Users are provisioned and updated only at user login. Are you sure?',
  'settings.authentication.gitlab.confirm.insecure': 'Potentially insecure configuration',
  'settings.authentication.gitlab.provisioning_change.confirm_changes': 'Confirm change',
  'settings.authentication.gitlab.provisioning_change.insecure_config':
    "Please be aware that your configuration is potentially insecure because you didn't add any groups to the allowlist and you allowed users to sign up. Anyone can install it and gain access to your instance.",
  'settings.authentication.gitlab.form.provisioning_with_gitlab':
    'Automatic user, group, and permission provisioning',
  'settings.authentication.gitlab.form.provisioning_with_gitlab.description':
    'Users, groups and permissions are automatically provisioned from GitLab. Once activated, users and groups can only be created and modified from GitLab. Existing local users will be kept and can only be deactivated. {documentation}',
  'settings.authentication.gitlab.form.provisioning.disabled':
    'Your current edition does not support provisioning with GitLab. See the {documentation} for more information.',
  'settings.authentication.gitlab.configuration.unsaved_changes': 'You have unsaved changes.',
  'settings.authentication.gitlab.configuration.valid.JIT':
    'Configuration is valid for Just-in-Time provisioning.',
  'settings.authentication.gitlab.configuration.valid.AUTO_PROVISIONING':
    'Configuration is valid for Automatic provisioning.',
  'settings.authentication.gitlab.configuration.roles_mapping.description':
    'When synchronizing users and groups, {productName} assigns permissions based on Gitlab user roles. You can customize the mapping of permissions. The new mapping will take effect at the next synchronization.',
  'settings.authentication.gitlab.configuration.roles_mapping.save_success':
    'GitLab roles mapping saved successfully.',
  'settings.authentication.gitlab.configuration.roles_mapping.dialog.custom_roles_description':
    'When a custom role name added here matches an existing GitLab custom role in any of your groups or projects, the mapping applies to all users with this custom role. If an existing GitLab custom role has no exact match in this list, the permissions of its inherited base role are mapped.',

  // BITBUCKET
  'settings.authentication.gitlab.configuration.insecure':
    'BitBucket Authentication allows users to sign up, but no list of allowed workspaces was provided. This is potentially insecure. We recommend entering a list of allowed workspaces. {documentation}',

  // COMMON
  'settings.authentication.configuration.validity_check_loading': 'Checking the configuration',
  'settings.authentication.configuration.test': 'Test configuration',
  'settings.authentication.synchronization_pending': 'Synchronization is pending.',
  'settings.authentication.synchronization_in_progress': 'Synchronization is in progress.',
  'settings.authentication.synchronization_successful.with_warning':
    'Last synchronization was done {date} ago with warnings. {details}',
  'settings.authentication.synchronization_details_link': 'More details',
  'settings.authentication.synchronization_successful': 'Last synchronization was done {0} ago.',
  'settings.authentication.synchronization_failed_short': 'Last synchronization failed. {details}',
  'settings.authentication.synchronization_failed': 'Last synchronization failed {0} ago.',
  'settings.authentication.configuration.roles_mapping.dialog.title': 'Global {0} role mapping',
  'settings.authentication.configuration.roles_mapping.title': 'Role permission mapping',
  'settings.authentication.configuration.roles_mapping.button_label': 'Edit mapping',
  'settings.authentication.configuration.roles_mapping.dialog.roles_column': 'Roles',
  'settings.authentication.configuration.roles_mapping.dialog.delete_custom_role':
    'Delete custom role {0}',
  'settings.authentication.configuration.roles_mapping.dialog.add_custom_role': 'Add custom role:',
  'settings.authentication.configuration.roles_mapping.role_exists': 'Role already exists.',
  'settings.authentication.configuration.roles_mapping.empty_custom_role':
    'Custom roles should have some permissions.',

  // SAML
  'settings.authentication.form.create.saml': 'New SAML configuration',
  'settings.authentication.form.edit.saml': 'Edit SAML configuration',
  'settings.authentication.saml.configuration': 'SAML Configuration',
  'settings.authentication.saml.confirm.scim': 'Switch to automatic provisioning',
  'settings.authentication.saml.confirm.jit': 'Switch to Just-in-Time provisioning',
  'settings.authentication.saml.confirm.scim.description':
    'Once you transition to automatic provisioning, groups, users and group memberships will be managed by your identity provider. You will no longer have the ability to edit them within {productName}. Do you want to proceed with this change?',
  'settings.authentication.saml.confirm.jit.description':
    'Switching to Just-in-Time provisioning removes all information provided while automatic provisioning through SCIM was active. These changes cannot be reverted. Are you sure?',
  'settings.authentication.saml.form.loading': 'Loading SAML configuration',
  'settings.authentication.saml.form.not_configured': 'SAML is not configured',
  'settings.authentication.saml.form.create': 'New SAML configuration',
  'settings.authentication.saml.form.edit': 'Edit SAML configuration',
  'settings.authentication.saml.form.save': 'Save configuration',
  'settings.authentication.saml.form.test': 'Test configuration',
  'settings.authentication.saml.form.test.help.dirty': 'You must save your changes',
  'settings.authentication.saml.form.test.help.incomplete': 'Some mandatory fields are empty',
  'settings.authentication.saml.form.save_success': 'Saved successfully',
  'settings.authentication.saml.form.save_partial': 'Saved partially',
  'settings.authentication.saml.form.provisioning_at_login':
    'Just-in-Time user and group provisioning (default)',
  'settings.authentication.saml.form.provisioning_at_login.sub':
    'Use this option if your identity provider does not support the SCIM protocol.',
  'settings.authentication.saml.form.provisioning_with_scim':
    'Automatic user and group provisioning with SCIM',
  'settings.authentication.saml.form.provisioning_with_scim.sub':
    'Preferred option when using a supported identity provider.',
  'settings.authentication.saml.form.provisioning_with_scim.description':
    'Users and groups are automatically provisioned from your identity provider using the SCIM protocol. Once activated, managed users and groups can only be modified from your identity provider. Existing local users and groups will be kept.',
  'settings.authentication.saml.form.provisioning_with_scim.description.doc':
    'For a list of supported providers and more details on automatic provisioning, see {documentation}.',
  'settings.authentication.saml.form.provisioning.disabled':
    'Your current edition does not support provisioning with SCIM. See the {documentation} for more information.',
  'settings.authentication.saml.enable_first':
    'Enable your SAML configuration to benefit from automatic user provisioning options.',

  'settings.pr_decoration.binding.category': 'DevOps Platform Integration',
  'settings.pr_decoration.binding.no_bindings':
    'A system administrator needs to enable this feature in the global settings.',
  'settings.pr_decoration.binding.no_bindings.admin':
    'Set up a {link} first before you and your team can enable Pull Request Decoration.',
  'settings.pr_decoration.binding.no_bindings.link': 'global configuration',
  'settings.pr_decoration.binding.title': 'DevOps Platform Integration',
  'settings.pr_decoration.binding.description':
    'Display your Quality Gate status directly in your DevOps Platform.',
  'settings.pr_decoration.binding.check_configuration': 'Check configuration',
  'settings.pr_decoration.binding.check_configuration.failure':
    'You have the following errors in your configuration:',
  'settings.pr_decoration.binding.check_configuration.failure.check_global_settings':
    'Please check your {link}.',
  'settings.pr_decoration.binding.check_configuration.failure.check_global_settings.link':
    'global settings',
  'settings.pr_decoration.binding.check_configuration.contact_admin':
    'Please contact your system administrator.',
  'settings.pr_decoration.binding.check_configuration.success': 'Configuration valid.',
  'settings.pr_decoration.binding.form.name': 'Configuration name',
  'settings.pr_decoration.binding.form.name.help':
    'Each DevOps Platform instance must be configured globally first, and given a unique name. Pick the instance your project is hosted on.',
  'settings.pr_decoration.binding.form.monorepo': 'Enable monorepository support',
  'settings.pr_decoration.binding.form.monorepo.help':
    'Enable this setting if your project is part of a monorepository. {doc_link}',
  'settings.pr_decoration.binding.form.monorepo.warning':
    'This setting must be enabled for all {productName} projects that are part of a monorepository.',
  'settings.pr_decoration.binding.form.azure.project': 'Project name',
  'settings.pr_decoration.binding.form.azure.project.help':
    "The name of the Azure DevOps project containing your repository. You can find this name on your project's Overview page.",
  'settings.pr_decoration.binding.form.azure.repository': 'Repository name',
  'settings.pr_decoration.binding.form.azure.repository.help':
    "The name of your Azure DevOps repository. You can find this name on your project's Repos page.",
  'settings.pr_decoration.binding.form.azure.inline_pr_annotations':
    'Enable Inline Pull Request Annotations',
  'settings.pr_decoration.binding.form.azure.inline_pr_annotations.help':
    'When activated, issues within each file are annotated with relevant issue details.',
  'settings.pr_decoration.binding.form.github.repository': 'Repository name',
  'settings.pr_decoration.binding.form.github.repository.help':
    "The full name of your repository, including the organization. You can find this name in your repository's URL. This name is case-sensitive!",
  'settings.pr_decoration.binding.form.github.summary_comment_setting':
    'Enable analysis summary under the GitHub Conversation tab',
  'settings.pr_decoration.binding.form.github.summary_comment_setting.help':
    'When enabled, a summary is displayed under the GitHub Conversation tab. Notifications may be sent by GitHub depending on your settings.',
  'settings.pr_decoration.binding.form.bitbucket.repository': 'Project key',
  'settings.pr_decoration.binding.form.bitbucket.repository.help':
    'The project key is part of your Bitbucket Server repository URL. This is case-sensitive!',
  'settings.pr_decoration.binding.form.bitbucket.slug': 'Repository slug',
  'settings.pr_decoration.binding.form.bitbucket.slug.help':
    'The repository slug is part of your Bitbucket Server repository URL. This slug is case-sensitive!',
  'settings.pr_decoration.binding.form.bitbucketcloud.repository': 'Repository slug',
  'settings.pr_decoration.binding.form.bitbucketcloud.repository.help':
    'The repository slug is part of your Bitbucket Cloud repository URL.',

  'settings.pr_decoration.binding.form.gitlab.repository': 'Project ID',
  'settings.pr_decoration.binding.form.gitlab.repository.help':
    'The Project ID is a numerical unique identifier for your project. You can find it on your Project Overview.',

  'settings.email_notification.category': 'Email Notification',
  'settings.email_notification.header': 'SMTP Configuration',

  // Design and Architecture
  'settings.design_and_architecture.category': 'Design & Architecture',
  'settings.design_and_architecture.header': 'Design & Architecture',
  'settings.design_and_architecture.description.1':
    "This free trial is being offered at Sonar's discretion and may be discontinued in the future. At the end of the trial, Design & Architecture will become a paid feature. Your organization will not incur and changes for using this feature during the trial period.",
  'settings.design_and_architecture.description.2':
    'Activate this option to enable any user in your organization to visualize your codebase directly in SonarQube.',
  'settings.design_and_architecture.description.3':
    'By activating this option, you agree to the <link>Early Access Terms</link>',
  'settings.design_and_architecture.enable': 'Enable Design & Architecture',
  'settings.design_and_architecture.disable': 'Disable Design & Architecture',
  'settings.design_and_architecture.tour.title': 'Enable Design & Architecture',
  'settings.design_and_architecture.tour.content':
    'You can enable Design & Architecture later by going to Administration > Configuration > Design & Architecture.',

  // Mode
  'settings.mode.title': 'Mode',
  'settings.mode.description.line1':
    'There are two options to reflect the health of all the projects in this instance: {mqrLink} and {standardLink}',
  'settings.mode.description.line2':
    'Changing the mode will change how issues are categorized and ranked based on the results of the analysis.',
  'settings.mode.checking_instance': 'Checking your instance...',
  'settings.mode.instance_conditions_from_other_mode':
    'Some of the Quality Gates in this instance are using metrics that belong to the {isStandardMode, select, true {Standard Experience} other {Multi-Quality Rule Mode}}. You will be able to update them once you save the changes.',
  'settings.mode.standard.name': 'Standard Experience',
  'settings.mode.mqr.name': 'Multi-Quality Rule (MQR) Mode',
  'settings.mode.standard.description.line1':
    'Offers the traditional use of the rule types: bugs, code smells, and vulnerabilities, categorized with a single type and severity for each rule.',
  'settings.mode.standard.description.line2':
    'This approach focuses on assigning severity to a rule and its issues based on the single software quality (for example, security, reliability or maintainability) it has the largest impact on. This is the rule categorization used in {productName} 9.9 LTA and earlier.',
  'settings.mode.mqr.description.line1':
    'Aims to more accurately represent the impact software has on all software qualities. Very few issues impact only a single software quality. For instance, most vulnerabilities are also bugs. And vice versa. The MQR mode maps each rule to each of the qualities it impacts, with a separate severity rating for each quality.',
  'settings.mode.mqr.description.line2':
    'This approach focuses on ensuring the impact of an issue on all software qualities is clear, not just the most severe one.',
  'settings.mode.save.warning': 'Save changes to see them reflected in your instance',
  'settings.mode.save':
    'Save the mode. The current mode will be switched to {isStandardMode, select, true {Standard Experience} other {Multi-Quality Rule Mode}}',
  'settings.mode.save.success':
    'This instance is now in {isStandardMode, select, true {Standard Experience} other {Multi-Quality Rule Mode}}.',

  'mode.standard.advertisement':
    'Looking for Security, Reliability, and Maintainability issues? If your team prefers working with software qualities, change it in the <a>settings</a>',
  'mode.mqr.advertisement':
    'Looking for Bugs, Vulnerabilities, or Code Smells? If your team prefers working with these types, change it in the <a>settings</a>',
  'settings.mode.mqr.advertisement':
    'If your team prefers working with Vulnerabilities, Bugs, and Code Smells, change it in the <a>Mode section</a> of General Settings',
  'settings.mode.standard.advertisement':
    'If your team prefers working with Security, Reliability, and Maintainability issues, change it in the <a>Mode section</a> of General Settings',

  // Early access features
  'settings.early_access.title': 'Early Access Features',
  'settings.early_access.description':
    'Features listed below are offered for free in early access trial at Sonar’s discretion. The trial may be discontinued at any time. Your organization will not be charged for using them during the trial. Terms and conditions may apply.',
  'settings.early_access.misra.title': 'MISRA Compliance',
  'settings.early_access.misra.description.line1':
    'Enable this feature to preview additional MISRA C++2023 rules.',
  'settings.early_access.misra.description.line2':
    'At the end of the trial, the MISRA Compliance early access features will be deactivated and all new MISRA C++2023 rules will be removed from the quality profiles. Your organization will not be charged.',
  'settings.early_access.misra.checkbox_label': 'Enable early access MISRA Compliance',
  'settings.early_access.misra.dialog_title':
    'You are about to {enable, select, true {enable} other {disable}} early access trial to MISRA Compliance feature',
  'settings.early_access.misra.dialog_description.enable':
    'A preview of additional MISRA C++2023 rules will be available for this instance. <p>Sonar may stop the trial at any time. When it stops, the MISRA Compliance early access features will be deactivated, all new MISRA C++2023 rules will be removed from the quality profiles, and all related detected issues will be closed.</p> Your organization will not be charged.',
  'settings.early_access.misra.dialog_description.disable':
    'All new MISRA C++2023 rules will be removed from the quality profiles, and all related detected issues will be closed. As long as the early access to this feature is available, you can enable it again. <p>Are you sure you want to continue?</p>',
  'settings.early_access.misra.success':
    'Early access to MISRA Compliance {enabled, select, true {is enabled} other {is disabled}} for this instance',

  // Sandbox issue settings
  'settings.sandbox_issues.title': 'Sandbox specific issue categories after SonarQube update',
  'settings.sandbox_issues.toggle.label': 'Enable the Sandbox feature for specific issue criteria',
  'settings.sandbox_issues.toggle.description':
    'Automatically assigns the "In sandbox" status to issues caused by SonarQube updates or changes to built-in quality profiles. Excludes issues caused by code modifications. <doc>Learn more in documentation</doc>',
  'settings.sandbox_issues.qualities.title.mqr': 'Choose software quality and severity{required}',
  'settings.sandbox_issues.qualities.title.standard': 'Choose issue type and severity{required}',
  'settings.sandbox_issues.qualities.description.instance':
    'This choice will be saved as default for this instance of SonarQube.',
  'settings.sandbox_issues.qualities.description.project':
    'This choice will be saved for this project only, overriding the instance default.',
  'settings.sandbox_issues.qualities.invalid.mqr': 'Choose software quality and severity',
  'settings.sandbox_issues.qualities.invalid.standard': 'Choose issue type and severity',
  'settings.sandbox_issues.qualities.security.warning':
    '<b>Proceed with caution:</b> security issues significantly elevate the risk of a security breach',
  'settings.sandbox_issues.qualities.reliability.warning':
    '<b>Proceed with caution:</b> reliability issues can lead to unpredictable behaviour and degraded performance of your software',
  'settings.sandbox_issues.choose_severities': 'Choose severity...',
  'settings.sandbox_issues.select_severities_for': 'Select severities for {quality}',
  'settings.sandbox_issues.override_admins.title': 'Project overrides',
  'settings.sandbox_issues.override_admins.label.mqr':
    'Allow project admins to customize software quality and severity',
  'settings.sandbox_issues.override_admins.label.standard':
    'Allow project admins to customize issue type and severity',
  'settings.sandbox_issues.override_admins.helpText':
    'If unchecked, the settings above are enforced on all projects',
  'settings.sandbox_issues.override_admins.invalid': 'Define if admins can override your choice',
  'settings.sandbox_issues.default_enablement.title': 'Default project setting',
  'settings.sandbox_issues.default_enablement.yes.description':
    'Active for all existing and future projects. Can be disabled by project admins',
  'settings.sandbox_issues.default_enablement.no.description':
    'Project admins must manually enable this feature',
  'settings.sandbox_issues.default_enablement.invalid': 'Choose default status',
  'settings.sandbox_issues.confirm.title':
    'This action might compromise your code. Are you sure you want to proceed?',
  'settings.sandbox_issues.confirm.description':
    'Automatically moving security and/or reliability issues to the sandbox can significantly elevate the risk of security breach, unpredictable behaviour and degraded performance of your software if the issues are not addressed.',
  'settings.sandbox_issues.confirm.question': 'Are you sure you want to proceed?',
  'settings.sandbox_issues.enable.success': 'Sandbox feature is now enabled',
  'settings.sandbox_issues.edit.success': 'Sandbox setting changes were saved successfully',

  // Integrations settings
  'settings.instance_integrations.title': 'Integrations',
  'settings.instance_integrations.start_setup': 'Start setup',

  'settings.slack.header': 'Slack',
  'settings.slack.badge.configured': 'Configured',
  'settings.slack.badge.not_configured': 'Not configured',
  'settings.slack.description':
    '<link>Set up and configure your Slack app</link> by following our documentation. Once configured and installed, you will receive instant slack notifications when your quality gate changes.',
  'settings.slack.start_setup.no_server_base_url_warning':
    'To continue, set your "Server base URL" in the <link>general settings</link>',
  'settings.slack.start_setup.hint': 'Setup can take 5 to 10 minutes.',
  'settings.slack.app_creation.step_title': 'Create your slack app on your workspace',
  'settings.slack.app_creation.helper':
    'You will be asked to first select your workspace and confirm your details before app creation.',
  'settings.slack.app_creation.hint': 'You must have Slack admin permissions.',
  'settings.slack.app_creation.button_label': 'Create app',
  'settings.slack.app_details.step_title':
    'Copy and paste the following app credentials in the below fields',
  'settings.slack.app_details.submit_button_label': 'Save configuration',
  'settings.slack.configuration.header': 'App configuration details',
  'settings.slack.configuration.client_id': 'Client ID',
  'settings.slack.configuration.client_secret': 'Client Secret',
  'settings.slack.configuration.signing_secret': 'Signing Secret',
  'settings.slack.configuration.secret_placeholder': 'Leave field empty to keep current value',
  'settings.slack.install_app.label': 'Install SonarQube for Slack',
  'settings.slack.install_app.hint':
    'Did you know you can install SonarQube for Slack to multiple workspaces?',
  'settings.slack.update_configuration_modal.title': 'Slack configuration',
  'settings.slack.update_configuration_modal.hint': 'How can I update my secrets?',
  'settings.slack.update_configuration_modal.update_button': 'Update configuration',
  'settings.slack.remove_configuration': 'Remove Slack configuration',
  'settings.slack.remove_configuration_modal.title':
    'Delete Slack configuration for this SonarQube instance?',
  'settings.slack.remove_configuration_modal.description':
    '<p>This action deletes all Slack-related data on SonarQube Server. To completely delete the configuration, you must also delete the app on Slack.</p><p>The Slack-related data includes:</p><ul><li>Configurations</li><li>Workspaces</li><li>Subscriptions to projects</li><li>Connected user accounts</li></ul>',

  // Project setting
  'settings.sandbox_issues.project.on.success': 'Sandbox feature is now enabled',
  'settings.sandbox_issues.project.off.success': 'Sandbox feature is now disabled',
  'settings.sandbox_issues.project.edit.success':
    'Sandbox setting was changed successfully for this project',
  'settings.sandbox_issues.project.reset.success': 'The setting was reset to instance default',
  'settings.sandbox_issues.project.default_settings.mqr':
    'Default permitted software qualities and severities:',
  'settings.sandbox_issues.project.default_settings.standard':
    'Default permitted types and severities:',
  'settings.sandbox_issues.project.default_settings.severities':
    '{severities} {count, plural, one {severity} other {severities}}',
  'settings.sandbox_issues.project.qualities.title.mqr':
    'Software quality and severity of issues that are isolated in the sandbox',
  'settings.sandbox_issues.project.qualities.title.standard':
    'Type and severity of issues that are isolated in the sandbox',
  'settings.sandbox_issues.project.qualities.description':
    'Configured at the instance level. Contact your administrator for modifications.',

  'property.category.announcement': 'Announcement',
  'property.category.general': 'General',
  'property.category.general.email': 'Email',
  'property.category.general.duplications': 'Duplications',
  'property.category.general.differentialViews': 'New Code',
  'property.category.general.localization': 'Localization',
  'property.category.general.databaseCleaner': 'Database Cleaner',
  'property.category.general.looknfeel': 'Look & Feel',
  'property.category.general.issues': 'Issues',
  'property.category.general.qualityGate': 'Quality Gate',
  'property.category.general.qualityProfile': 'Quality Profile',
  'property.category.general.subProjects': 'Sub-projects',
  'property.category.general.subProjectCreation': 'Project Creation',
  'property.category.almintegration': 'DevOps Platform Integrations',
  'property.category.authentication': 'Authentication',
  'property.category.ai_code': 'AI-Generated Code',
  'property.category.organizations': 'Organizations',
  'property.category.security': 'Security',
  'property.category.security.encryption': 'Encryption',
  'property.category.java': 'Java',
  'property.category.differentialViews': 'New Code',
  'property.category.codeCoverage': 'Code Coverage',
  'property.category.duplications': 'Duplications',
  'property.category.localization': 'Localization',
  'property.category.exclusions': 'Analysis Scope',
  'property.category.webhooks': 'Webhooks',
  'property.category.languages': 'Languages',
  'property.category.aicodefix': 'AI CodeFix',
  'property.sonar.autodetect.ai.code.confirmation':
    '{value, select, true {<p1>“Autodetect AI-generated code” will be turned on for all projects.</p1><p>This setting can be turned off by project administrators at the project level to prevent the autodetection of AI-generated code in specific projects.</p>} other {<p1>“Autodetect AI-generated code” will be turned off for all projects.</p1><p>Project administrators will no longer be able to activate this setting at the project level.</p>}}',
  'property.sonar.inclusions.name': 'Source File Inclusions',
  'property.sonar.inclusions.description':
    'Patterns used to include some source files and only these ones in analysis.',
  'property.sonar.test.inclusions.name': 'Test File Inclusions',
  'property.sonar.test.inclusions.description':
    'Patterns used to include some test files and only these ones in analysis.',
  'property.sonar.exclusions.name': 'Source File Exclusions',
  'property.sonar.exclusions.description':
    'Patterns used to exclude some source files from analysis.',
  'property.sonar.test.exclusions.name': 'Test File Exclusions',
  'property.sonar.test.exclusions.description':
    'Patterns used to exclude some test files from analysis.',
  'property.sonar.global.exclusions.name': 'Global Source File Exclusions',
  'property.sonar.global.exclusions.description':
    'Patterns used to exclude some source files from analysis. They apply to every project and cannot be overridden.',
  'property.sonar.global.test.exclusions.name': 'Global Test File Exclusions',
  'property.sonar.global.test.exclusions.description':
    'Patterns used to exclude some test files from analysis. They apply to every project and cannot be overridden.',
  'property.category.exclusions.files': 'A. File Exclusions',
  'property.category.exclusions.files.description':
    'Configure the files that should be completely ignored by the analysis.',
  'property.sonar.skippedModules.name': 'Module Exclusions',
  'property.sonar.skippedModules.description':
    'This property is deprecated since version 4.3 and should not be used anymore.',
  'property.sonar.includedModules.name': 'Module Inclusions',
  'property.sonar.includedModules.description':
    'This property is deprecated since version 4.3 and should not be used anymore.',
  'property.category.exclusions.issues': 'D. Issue Exclusions',
  'property.category.exclusions.issues.description':
    'Configure the conditions under which issues should not be reported.',
  'property.category.exclusions.duplications': 'C. Duplication Exclusions',
  'property.category.exclusions.duplications.description':
    'Configure the files that should be ignored by duplication detection.',
  'property.category.exclusions.coverage': 'B. Code Coverage Exclusions',
  'property.category.exclusions.coverage.description':
    'Configure the files that should be ignored by code coverage calculations.',
  'property.sonar.coverage.exclusions.name': 'Coverage Exclusions',
  'property.sonar.coverage.exclusions.description':
    'Patterns used to exclude some files from coverage report.',
  'property.category.technicalDebt': 'Technical Debt',
  'property.error.notBoolean': 'Valid options are "true" and "false"',
  'property.error.notInteger': 'Only digits are allowed',
  'property.error.notFloat': 'Not a floating point number',
  'property.error.notRegexp': 'Regular expression must be valid',
  'property.error.notInOptions': 'Not a valid option',
  'property.category.scm': 'SCM',
  'property.category.housekeeping': 'Housekeeping',
  'property.category.housekeeping.general': 'General',
  'property.category.housekeeping.branchesAndPullRequests': 'Branches and Pull Requests',
  'property.category.housekeeping.auditLogs': 'Audit Logs',

  'settings.advanced_security.title': 'Advanced Security',
  'settings.advanced_security.description':
    'SonarQube Advanced Security extends your protection to third-party open source code and gives you access to Advanced SAST capabilities.',
  'property.asast.admin.title': 'Advanced SAST (ASAST)',
  'property.asast.admin.description':
    'SonarQube Advanced Security comes with Advanced SAST (ASAST) activated by default for any user to find deeply nested taint vulnerabilities.',
  'property.asast.admin.checkbox.label': 'Enable Advanced SAST (ASAST)',
  'property.sca.admin.title': 'Software Composition Analysis (SCA)',
  'property.sca.admin.description':
    'Activate this option to enable any user to scan their projects for issues in their third-party dependencies, such as vulnerabilities or prohibited licenses, using the Sonar SCA service.',
  'property.sca.admin.description2':
    'By enabling this feature, you agree to the <link>Advanced Security Terms and Conditions</link>',
  'property.sca.admin.checkbox.label': 'Enable Software Composition Analysis (SCA)',
  'property.sca.default.title': 'Analyze all projects',
  'property.sca.confirm.modal.title.enable':
    'You are about to enable Software Composition Analysis (SCA)',
  'property.sca.confirm.modal.description.enable':
    'Software Composition Analysis (SCA) will be available for this instance. Dependency files will be sent to Sonar for analysis as part of every Sonar project analysis.',
  'property.sca.confirm.modal.title.disable':
    'You are about to disable the Software Composition Analysis (SCA) feature',
  'property.sca.confirm.modal.description.disable':
    'Users will not be able to scan their projects for issues in their third-party dependencies any more. Are you sure you want to continue?',
  'property.sca.message.updated': 'Sonar SCA {0}',

  'property.sca.admin.selftest.title': 'Check connection to the SonarQube SCA service',
  'property.sca.admin.selftest.description':
    'An internet connection to SonarQube SCA services is required to retrieve updated package and vulnerability data to perform analysis.',
  'property.sca.admin.selftest.success': 'Connectivity check passed',
  'property.sca.admin.selftest.failure': 'Unable to communicate with SCA service.',
  'property.sca.admin.selftest.failure.offline': 'You are offline.',
  'property.sca.admin.selftest.recheck': 'Recheck connectivity',
  'property.sca.admin.selftest.checking': 'Checking connectivity',
  'property.sca.admin.selftest.show_details': 'Show details',
  'property.sca.admin.selftest.details.title': 'Self Test Results',
  'property.sca.admin.selftest.details.description':
    'The following information may help diagnose issues with your connectivity to the cloud portion of the SCA service.',

  'property.sca.admin.rescan.title': 'Configure branch rescanning',
  'property.sca.admin.rescan.description':
    'Once a branch has been analyzed, it can be periodically rescanned for new vulnerabilities.',

  'property.sca.admin.enabled.message.title':
    'SCA has been enabled for all projects. Run new analyses to see scan results.',
  'property.sca.admin.enabled.message.body':
    'Next time an analysis runs on one of your projects, the scan will check the project’s dependencies for risks. For information on <link>how to ensure your projects are ready for SCA analysis</link> and more, view our complete configuration guide.',
  'property.sca.admin.enabled.message.link': 'View configuration guide',

  'property.sca.admin.disabled.message.title':
    'SCA has been enabled and will run on a project-by-project basis.',
  'property.sca.admin.disabled.message.body':
    'You must enable SCA for each project you want SCA analysis for. Then, the next time an analysis runs on one of your projects, the scan will check the project’s dependencies for risks. For information on <link>how to ensure your projects are ready for SCA analysis</link> and more, view our complete configuration guide.',
  'property.sca.admin.disabled.message.link': 'View configuration guide',

  'property.aicodefix.admin.title': 'Enable AI-generated fix suggestions',
  'property.aicodefix.admin.description':
    'Activate this option to enable users of all or part of the projects to generate an AI-suggested code fix for an issue using the Sonar AI CodeFix service.',
  'property.aicodefix.admin.checkbox.label': 'Enable AI CodeFix',
  'property.aicodefix.admin.acceptTerm.label':
    'By activating this option, you agree to the {terms}',
  'property.aicodefix.admin.acceptTerm.terms': 'AI CodeFix Terms',
  'property.aicodefix.admin.enable.title': 'Choose which projects should have AI CodeFix enabled',
  'property.aicodefix.admin.enable.all.projects.label': 'All projects',
  'property.aicodefix.admin.enable.all.projects.help':
    'Enable AI CodeFix on all existing and future projects',
  'property.aicodefix.admin.enable.some.projects.label': 'Only selected projects',
  'property.aicodefix.admin.enable.some.projects.help':
    'Enable AI CodeFix on selected projects only',
  'property.aicodefix.admin.enable.some.projects.note':
    'AI CodeFix will not be automatically enabled on new projects.',
  'property.aicodefix.admin.early_access.title': 'Free - early access feature',
  'property.aicodefix.admin.early_access.content1':
    "This no-cost trial is offered to you at Sonar's discretion during the early access period.",
  'property.aicodefix.admin.early_access.content2':
    'Sonar may stop the trial at any time. At the end of the trial, the AI CodeFix feature will be deactivated and your organization will not be charged.',
  'property.aicodefix.admin.serviceInfo.learnMore': 'Read more about enabling AI CodeFix',
  'property.aicodefix.admin.serviceInfo.spinner.label':
    'Waiting for AI CodeFix service to respond...',
  'property.aicodefix.admin.serviceInfo.unexpected.response.label':
    'The AI CodeFix service returned an unexpected response. You might need to upgrade your instance.',
  'property.aicodefix.admin.serviceInfo.empty.response.label':
    'The AI CodeFix service returned an empty response. Please report the issue to the maintainers.',
  'property.aicodefix.admin.serviceInfo.result.unresponsive.message':
    'The AI CodeFix service does not respond or is not reachable.',
  'property.aicodefix.admin.serviceInfo.result.unresponsive.causes.title':
    'Here are some possible causes of this error:',
  'property.aicodefix.admin.serviceInfo.result.unresponsive.causes.1':
    'The network may not be properly configured on this SonarQube instance. Please check the firewall and connectivity settings.',
  'property.aicodefix.admin.serviceInfo.result.unresponsive.causes.2':
    'The AI CodeFix service may be down.',
  'property.aicodefix.admin.serviceInfo.result.requestError':
    'Error checking the AI CodeFix service:',
  'property.aicodefix.admin.serviceInfo.result.serviceError':
    'The AI CodeFix service is reachable but returned an error. Check logs for more details.',
  'property.aicodefix.admin.serviceInfo.result.unauthorized':
    'This SonarQube instance is not allowed to use AI CodeFix.',
  'property.aicodefix.admin.serviceInfo.result.unknown':
    'The AI CodeFix service returned an unexpected message:',
  'property.aicodefix.admin.serviceInfo.result.error.title': 'AI CodeFix Error',
  'property.aicodefix.admin.serviceInfo.result.error.retry.message':
    'If the issue persists, try again later or {link}',
  'property.aicodefix.admin.serviceInfo.result.error.retry.get_help': 'get help',
  'property.aicodefix.admin.serviceInfo.result.error.retry.action': 'Retry',
  'property.aicodefix.admin.promotion.title':
    'This SonarQube Server edition doesn’t support this feature',
  'property.aicodefix.admin.promotion.subtitle': 'Unlock AI-generated fix suggestions',
  'property.aicodefix.admin.promotion.content':
    'Enable users to generate AI-suggested code fixes for issues on selected projects or across all projects using the Sonar AI CodeFix service.',
  'property.aicodefix.admin.promotion.content_2':
    'To have access to AI CodeFix, upgrade to Enterprise edition and above.',
  'property.aicodefix.admin.promotion.learn_more': 'Learn more about {link}',
  'property.aicodefix.admin.promotion.more_about_ai_fix_suggestions':
    'More about AI-generated fix suggestions',
  'property.aicodefix.admin.promotion.plan_pricing': 'Plans and pricing',
  'property.aicodefix.admin.promotion.enterprise_only': 'Enterprise only',
  'property.aicodefix.admin.promotion.checkDocumentation': 'Check documentation',
  'property.aicodefix.admin.promotion.link': 'Enable AI Codefix',
  'property.aicodefix.admin.unpaid.promotion.link': 'Explore upgrade options',
  'aicodefix.admin.provider.title': 'Provider',
  'aicodefix.admin.provider.help': 'Choose between our providers or bring your own model',
  'aicodefix.admin.provider.self_hosted': 'Self-hosted (Bring Your Own Model)',
  'aicodefix.admin.provider.sonar': 'Sonar',
  'notification.aicodefix.ga.paid.inactive.admin.message':
    'The Sonar AI CodeFix is now available for this instance. Enable it to receive AI-generated code fix suggestions for some or all of your projects. {link}',
  'notification.aicodefix.ga.unpaid.active.admin.message':
    'The free early access to AI CodeFix has ended. To continue receiving AI-generated code fix suggestions, upgrade your edition. {link}',
  'notification.aicodefix.ga.unpaid.active.user.message':
    'The free early access to AI CodeFix has ended — ask your admin about upgrading to continue receiving AI-generated code fix suggestions.',
  'aicodefix.azure_open_ai.endpoint.label': 'Endpoint',
  'aicodefix.azure_open_ai.endpoint.help': 'Provide Azure OpenAI API endpoint',
  'aicodefix.azure_open_ai.apiKey.label': 'API Key',
  'aicodefix.azure_open_ai.apiKey.help': 'Provide Azure OpenAI API key',
  'aicodefix.azure_open_ai.apiKey.update_placeholder': 'Value is hidden, type a new key to update',
  'aicodefix.updated': 'AI CodeFix settings is {0} on your instance!',
  'aicodefix.update_error': 'Fail to save settings. {0}',
  'aicodefix.cancel.modal.title': 'Are you sure you want to cancel?',
  'aicodefix.cancel.modal.description':
    'You have unsaved changes. All unsaved changes will be lost.',
  'aicodefix.cancel.modal.continue_editing': 'Continue editing',

  //------------------------------------------------------------------------------
  //
  // SEARCH ENGINE FOR RESOURCES
  //
  //------------------------------------------------------------------------------
  'search.shortcut_hint': 'Hint: Press {shortcut} from anywhere to open this search bar.',
  'search.show_more.hint': 'Press {key} to display',
  'search.placeholder': 'Search for projects...',
  'search.search_for_projects': 'Search projects',
  'search.search_for_cves': 'Search by CVE ID...',
  'search.search_for_dependencies': 'Search by dependency name...',
  'search.search_for_members': 'Search for members...',
  'search.search_for_users': 'Search for users...',
  'search.search_for_users_or_groups': 'Search for users or groups...',
  'search.search_by_login_or_name': 'Search by login or name...',
  'search.search_by_name': 'Search by name...',
  'search.search_by_name_or_key': 'Search by name or key...',
  'search.search_for_tags': 'Search for tags...',
  'search.search_for_repositories': 'Search for repositories...',
  'search.search_for_rules': 'Search for rules...',
  'search.search_for_languages': 'Search for languages...',
  'search.search_for_cwe': 'Search for CWEs...',
  'search.search_for_authors': 'Search for authors...',
  'search.search_for_directories': 'Search for directories...',
  'search.search_for_files': 'Search for files...',
  'search.search_for_modules': 'Search for modules...',
  'search.search_for_metrics': 'Search for metrics...',
  'search.search_for_profiles': 'Search for Quality Profiles...',
  'search.tooShort': 'Please enter at least {0} characters',

  'global_search.shortcut_hint': "Hint: Press 'S' from anywhere to open this search bar.",

  //------------------------------------------------------------------------------
  //
  // GLOBAL HELP
  //
  //------------------------------------------------------------------------------
  'help.section.links': 'Links',
  'help.section.shortcuts': 'Shortcuts',
  'help.section.tutorials': 'Tutorials',

  'shortcuts.section.global': 'Global',
  'shortcuts.section.global.search': 'quickly open search bar',
  'shortcuts.section.global.shortcuts': 'open this window',
  'shortcuts.section.global.facets.multiselection': 'Add to selection',

  'shortcuts.section.issues': 'Issues Page',
  'shortcuts.section.issues.navigate_between_issues': 'navigate between issues',
  'shortcuts.section.issues.open_details': 'go from the list of issues to the source code',
  'shortcuts.section.issues.return_to_list': 'return back to the list',

  'shortcuts.section.issue.do_transition': 'do an issue transition',
  'shortcuts.section.issue.assign': 'assign issue',
  'shortcuts.section.issue.assign_to_me': 'assign issue to the current user',
  'shortcuts.section.issue.change_severity': 'change severity of issue',
  'shortcuts.section.issue.comment': 'comment issue',
  'shortcuts.section.issue.submit_comment': 'submit comment',
  'shortcuts.section.issue.change_tags': 'change tags of issue',

  'shortcuts.section.rules': 'Rules Page',
  'shortcuts.section.rules.navigate_between_rules': 'navigate between rules',
  'shortcuts.section.rules.open_details': 'go from the list of rules to the rule details',
  'shortcuts.section.rules.return_to_list': 'return back to the list',
  'shortcuts.section.rules.activate': 'activate selected rule',
  'shortcuts.section.rules.deactivate': 'deactivate selected rule',

  'shortcuts.on_page.intro': 'This page allows you to use the following keyboard shortcuts:',
  'shortcuts.on_page.left_x': 'Left arrow key: {0}',
  'shortcuts.on_page.left_right_x': 'Left and right arrow keys: {0}',
  'shortcuts.on_page.up_down_x': 'Up and down arrow keys: {0}',
  'shortcuts.on_page.meta_x': 'Alt key + arrow keys: {0}',

  'tutorials.onboarding': 'Analyze a new project',
  'tutorials.skip': 'Skip this tutorial',
  'tutorials.finish': 'Finish this tutorial',
  'tutorials.find_tutorial_back_in_help': 'Find this tutorial back anytime in the Help section',
  'tutorials.find_tutorial_back_in_plus': 'Find this tutorial back anytime in the "+" menu',

  //------------------------------------------------------------------------------
  //
  // SELECT2.js
  //
  //------------------------------------------------------------------------------
  'select2.noMatches': 'No matches',
  'select2.searching': 'Searching...',
  'select2.tooShort': 'Please enter at least {0} characters',

  //------------------------------------------------------------------------------
  //
  // Echoes Selects
  //
  //------------------------------------------------------------------------------
  'select.search.tooShort': 'To search, please enter at least {0} characters',
  'select.search.noMatches': 'No matches',

  //------------------------------------------------------------------------------
  //
  // DUPLICATION VIEWER
  //
  //------------------------------------------------------------------------------
  'duplications.dups_found_on_deleted_resource':
    'This file contains duplicated blocks with some deleted resources. This project should be reanalyzed to remove these obsolete duplicated blocks.',

  //------------------------------------------------------------------------------
  //
  // GENERIC CODE VIEWER
  //
  //------------------------------------------------------------------------------
  'code_viewer.no_source_code_displayed_due_to_empty_analysis.TRK':
    'No code files were found for analysis.',
  'code_viewer.no_source_code_displayed_due_to_empty_analysis.APP':
    'No projects in this application.',
  'code_viewer.no_source_code_displayed_due_to_empty_analysis.VW':
    'No projects, applications, or portfolios in this portfolio.',
  'code_viewer.no_source_code_displayed_due_to_empty_analysis.SVW':
    'No projects, applications, or portfolios in this portfolio.',
  'code_viewer.no_source_code_displayed_due_to_security':
    'Due to security settings, no source code can be displayed.',
  'code_viewer.no_source_code_displayed_due_to_source_removed':
    'The file was removed, no source code can be displayed.',
  'code_viewer.not_all_measures_are_shown': 'Not all projects and applications are included',
  'code_viewer.not_all_measures_are_shown.help':
    'You do not have access to all projects and/or applications.',
  'code_viewer.portfolio_code_toggle_disabled.help':
    'New Code and Overall Code measures are not available when searching for projects or applications.',
  'code_viewer.loading': 'Source code is loading',

  //------------------------------------------------------------------------------
  //
  // CUSTOM MEASURES
  //
  //------------------------------------------------------------------------------
  'custom_measures.page': 'Custom Measures',
  'custom_measures.page.description':
    "Update the values of custom metrics for this project. Changes will take effect at the project's next analysis. Custom metrics must be created at the global level.",
  'custom_measures.deprecated': 'Custom measures are deprecated and will be removed soon.',
  'custom_measures.pending': 'Pending',
  'custom_measures.pending_tooltip':
    'The value will be integrated to project during next analysis.',
  'custom_measures.all_metrics_taken':
    'There are already measures on all available custom metrics.',
  'custom_measures.delete_custom_measure': 'Delete Custom Measure',
  'custom_measures.delete_custom_measure.confirmation':
    'Are you sure you want to delete custom measure "{0}"?',
  'custom_measures.create_custom_measure': 'Create Custom Measure',
  'custom_measures.update_custom_measure': 'Update Custom Measure',
  'custom_measures.metric': 'Metric',

  //------------------------------------------------------------------------------
  //
  // COMMON NAVIGATION
  //
  //------------------------------------------------------------------------------
  'navigation.view_all': 'View all',
  'navigation.project.group.analysis': 'Analysis',
  'navigation.project.group.policies': 'Policies',
  'navigation.project.group.project': 'Project',
  'navigation.project.group.reporting': 'Reporting',
  'navigation.project.group.extensions': 'Extensions',

  //------------------------------------------------------------------------------
  //
  // PROJECT NAVIGATION
  //
  //------------------------------------------------------------------------------
  'project_navigation.analysis_status.failed': 'The last analysis has failed.',
  'project_navigation.analysis_status.warnings': 'The last analysis has warnings.',
  'project_navigation.analysis_status.pending': 'New analysis pending',
  'project_navigation.analysis_status.in_progress': 'New analysis in progress',
  'project_navigation.analysis_status.details_link': 'See details',
  'project_navigation.analysis_status.details_link.label': 'See details about the last analysis',
  'project_navigation.binding_status.view_on_x': 'View on {dop}',
  'project_navigation.binding_status.bound_to_x': 'Bound to {dop}',
  'project_navigation.binding_status.not_bound': 'Not bound',
  'project_navigation.binding_status.not_bound.tooltip':
    'To enable automatically configured PR decoration and privacy settings based on your DevOps platform, ask your admin to bind this project',
  'project_navigation.binding_status.bind': 'Bind project',
  'project_navigation.binding_status.bind.tooltip':
    'Enable automatically configured PR decoration and privacy settings based on your DevOps platform by binding your project',

  //------------------------------------------------------------------------------
  //
  // PROJECT BRANCH SELECTOR
  //
  //------------------------------------------------------------------------------

  'project_branch_selector.title': 'Branches and pull requests',
  'project_branch_selector.filters': 'Filter by branches or pull requests',
  'project_branch_selector.search': 'Search branches or pull requests',
  'project_branch_selector.none': 'No results',
  'project_branch_selector.link.all': 'View all',
  'project_branch_selector.link.branches': 'View all branches',
  'project_branch_selector.link.pull_requests': 'View all {pull_requests}',

  //------------------------------------------------------------------------------
  //
  // PROJECT ACTIVITY/HISTORY SERVICE
  //
  //------------------------------------------------------------------------------

  'project_activity.analysis': 'Analysis',
  'project_activity.analysis_build_string_X': 'Build string: {0}',
  'project_activity.add_version': 'Create Version',
  'project_activity.analysis_X_actions': 'Show actions for analysis {0}',
  'project_activity.show_analysis_X_on_graph':
    'Show details on interactive graph for analysis {0}. Note: this data is also available as a table. Click on the button below the graph.',
  'project_activity.remove_version': 'Remove Version',
  'project_activity.remove_version.question': 'Are you sure you want to delete this version?',
  'project_activity.change_version': 'Change Version',
  'project_activity.add_custom_event': 'Create Custom Event',
  'project_activity.change_custom_event': 'Change Event',
  'project_activity.remove_custom_event': 'Delete Event',
  'project_activity.remove_custom_event.question': 'Are you sure you want to delete this event?',
  'project_activity.reset_dates': 'Reset dates',
  'project_activity.delete_analysis': 'Delete Analysis',
  'project_activity.delete_analysis.question':
    'Are you sure you want to delete this analysis from the history?',
  'project_activity.filter_events': 'Events filter',
  'project_activity.filter_events.placeholder': 'Select an event',
  'project_activity.filter_date_range': 'Date range filter',
  'project_activity.events.tooltip.edit': 'Edit this event: {event}',
  'project_activity.events.tooltip.delete': 'Delete this event: {event}',
  'project_activity.new_code_period_start': 'Everything above this line is New Code',
  'project_activity.new_code_period_start.help':
    'The analysis below this mark is the baseline for New Code comparison',

  'project_activity.graphs.choose_type': 'Graph type',
  'project_activity.graphs.explanation_x':
    'This interactive graph shows data for the following project measures over time: {0}',
  'project_activity.graphs.issues': 'Issues',
  'project_activity.graphs.coverage': 'Coverage',
  'project_activity.graphs.duplications': 'Duplications',
  'project_activity.graphs.custom': 'Custom',
  'project_activity.graphs.custom.add': 'Add metric',
  'project_activity.graphs.custom.add_metric': 'Add a metric',
  'project_activity.graphs.custom.select_metric': 'Select metric to display',
  'project_activity.graphs.custom.add_metric_info':
    'Only 3 metrics of the same type can be displayed on one graph. You can have a maximum of two graphs.',
  'project_activity.graphs.custom.remove_metric': 'Remove the {0} metric from the graph',
  'project_activity.graphs.custom.no_history':
    "There isn't enough data to generate an activity graph, please select more metrics.",
  'project_activity.graphs.custom.metric_no_history':
    'This metric has no historical data to display.',
  'project_activity.graphs.custom.search': 'Search for a metric by name',
  'project_activity.graphs.custom.type_x_message':
    'Only "{0}" metrics are available with your current selection.',
  'project_activity.graphs.graph_shown_x': 'Graph shown for {0}.',
  'project_activity.graphs.open_in_table': "Press 'Enter' to show the graph data in a table.",
  'project_activity.graphs.data_table.title': 'Graph data in table format',
  'project_activity.graphs.data_table.max_lines_warning':
    'Only the {0} most recent data entries are shown. If you want to see different data, change the date filters on the main page.',
  'project_activity.graphs.data_table.no_data_warning': 'There is no data for the selected series.',
  'project_activity.graphs.data_table.no_data_warning_check_dates_x':
    'There is no data for the selected date range (everything after {start}). Try modifying the date filters on the main page.',
  'project_activity.graphs.data_table.no_data_warning_check_dates_y':
    'There is no data for the selected date range (everything before {end}). Try modifying the date filters on the main page.',
  'project_activity.graphs.data_table.no_data_warning_check_dates_x_y':
    'There is no data for the selected date range ({start} to {end}). Try modifying the date filters on the main page.',
  'project_activity.graphs.data_table.data_gap':
    'The chart history for issues related to software qualities may contain gaps while information is not available for one or more projects. {learn_more}',

  'project_activity.graphs.rating_split.title': 'Metrics calculation changed',
  'project_activity.graphs.rating_split.description':
    "The way we calculate metrics has changed and it might have affected this metric's values.",
  'project_activity.graphs.rating_split.info_icon': 'Metrics calculation change information',

  'project_activity.custom_metric.covered_lines': 'Covered Lines',

  'project_activity.custom_metric.deprecated.severity':
    'Old severities and the corresponding filters are deprecated.',
  'project_activity.custom_metric.deprecated.quality':
    'Issue types and the corresponding filters are deprecated. You can use filters by Software Quality.',
  'project_activity.custom_metric.deprecated.confirmed':
    'Confirmed issues and the corresponding filter is deprecated.',

  //------------------------------------------------------------------------------
  //
  // PROJECT "UPDATE KEY" PAGE
  //
  //------------------------------------------------------------------------------
  'update_key.old_key': 'Old Key',
  'update_key.new_key': 'New Key',
  'update_key.are_you_sure_to_change_key': 'Are you sure you want to change key of "{0}"?',

  //------------------------------------------------------------------------------
  //
  // PROJECT QUALITY PROFILE PAGE
  //
  //------------------------------------------------------------------------------
  'project_quality_profile.instance_default': 'Instance default:',
  'project_quality_profile.successfully_updated':
    '{0} Quality Profile has been successfully updated.',
  'project_quality_profile.subtitle': 'Manage project Quality Profiles',
  'project_quality_profile.always_use_default': 'Always use the instance default Quality Profile',
  'project_quality_profile.current': 'Current Quality Profile',
  'project_quality_profile.always_use_specific': 'Always use a specific Quality Profile',
  'project_quality_profile.change_lang_X_profile': 'Change {0} Quality Profile',
  'project_quality_profile.requires_new_analysis':
    'Changes will be applied after the next analysis.',
  'project_quality_profile.add_language.title': 'Configure a profile for new language',
  'project_quality_profile.add_language.description':
    'To use a specific, non-default quality profile for a new language, configure and apply it manually, then rerun your analysis.',
  'project_quality_profile.add_language.action': 'Add language',
  'project_quality_profile.add_language_modal.title': 'Add a language',
  'project_quality_profile.add_language_modal.choose_language': 'Choose a language',
  'project_quality_profile.add_language_modal.choose_profile': 'Choose a profile',
  'project_quality_profile.add_language_modal.no_active_rules': 'this profile has no active rules',
  'project_quality_profile.add_language_modal.profile_unavailable_no_active_rules':
    'This profile has no active rules, and cannot be used. Please enable at least 1 rule before using this profile.',
  'project_quality_profile.add_language_modal.go_to_profile': 'Go to Quality Profile',
  'project_quality_profile.change_profile_x': 'Change {x} profile',
  'project_quality_profile.page': 'Quality Profiles',
  'project_quality_profile.page.description':
    'Each language is automatically assigned the default quality profile of this instance. As a project administrator, you can override the default assignment and choose different profiles for languages used in this project.',
  'project_quality_profile.profiles_by_languages': 'Profiles by languages',
  'project_quality_profile.profiles_by_languages.description':
    'For each language, choose the profile associated with this project.',
  'project_quality_profile.contains_ai_code.title': 'This project contains AI-generated code',
  'project_quality_profile.contains_ai_code.description':
    'Sonar way is the recommended quality profile for AI generated code. Although it is not a mandatory step, we suggest you review your quality profiles to ensure protection. <p>Learn why in our documentation</p>',

  //------------------------------------------------------------------------------
  //
  // PROJECT AICA PAGE
  //
  //------------------------------------------------------------------------------
  'ai_generated_code.page': 'AI-Generated Code',
  'ai_generated_code.contains_code.title': 'Contains AI-Generated Code',
  'ai_generated_code.contains_code': 'Contains AI-generated Code',
  'ai_generated_code.description':
    '<p>Select this option if your project contains AI-generated code.</p><p>This is the first step to obtain Sonar’s <link>AI Code Assurance</link>.</p>',
  'ai_generated_code_protected.title': 'Your AI-generated code is protected',
  'ai_generated_code_protected.description':
    'The quality gate used by this project is qualified for AI Code Assurance.',
  'ai_generated_code_not_protected.title':
    'Protect your AI-generated code with ‘AI Code Assurance’',
  'ai_generated_code_not_protected.description':
    'The quality gate used by this project is not qualified for AI Code Assurance.',
  'ai_generated_code.change_quality_gate': 'Change Quality Gate',
  'ai_generated_code.success_message': 'AI-generated Code setting has been successfully updated.',
  'ai_generated_code.autodetect': 'Autodetect AI-Generated Code',
  'ai_generated_code.autodetect.description':
    'Select this option to allow SonarQube Server to <link>autodetect AI-generated code</link> in this project. This feature currently supports organizations using GitHub and GitHub Copilot, and relies on the “GitHub Copilot Business” Organization permission from the GitHub App.',
  'ai_generated_code.autodetect.label': 'Autodetect AI-generated code in this project',
  'ai_generated_code.autodetect.turned_off_globally':
    'This setting is turned off globally for this SonarQube Server instance. It cannot be turned on for this project.',
  'ai_generated_code.autodetect.success_message':
    'Autodetect AI-generated has been successfully updated.',
  'ai_generated_code.autodetect.detected_code':
    'This project may contain AI-generated code. Some contributors in this project used GitHub Copilot recently. We recommend that you activate "Contains AI-generated code" below to benefit from Sonar\'s AI Code Assurance.',
  'ai_generated_code.review_profiles.title': 'Review this project’s quality profiles',
  'ai_generated_code.review_profiles.title.aica_on':
    'AI Code Assurance is on. Consider reviewing this project’s quality profiles.',
  'ai_generated_code.review_profiles.description':
    'Sonar way is the recommended quality profile for AI generated code. Although it is not a mandatory step, we suggest you review your quality profiles to ensure protection.',
  'ai_generated_code.review_profiles.button': 'Review Quality Profiles',
  'ai_generated_code.review_profiles.link': 'Learn why in the documentation',
  //------------------------------------------------------------------------------
  //
  // PROJECT QUALITY GATE PAGE
  //
  //------------------------------------------------------------------------------
  'project_quality_gate.default_qgate': 'Default',
  'project_quality_gate.successfully_updated': 'Quality Gate has been successfully updated.',
  'project_quality_gate.always_use_default': 'Always use the instance default Quality Gate',
  'project_quality_gate.always_use_specific': 'Always use a specific Quality Gate',
  'project_quality_gate.select_specific_qg': 'Select Quality Gate',
  'project_quality_gate.requires_new_analysis': 'Changes will be applied after the next analysis.',
  'project_quality_gate.no_condition':
    'This Quality Gate is empty. To make it usable, add conditions to the {link}.',
  'project_quality_gate.no_condition_on_new_code':
    'This Quality Gate sets conditions on overall code but not on new code. It will not appear on pull requests. To enable it for pull requests, add conditions to the {link}.',
  'project_quality_gate.no_condition.link': 'Quality Gate definition',
  'project_quality_gate.no_condition.reason': 'No conditions',
  'project_quality_gate.ai_assured_quality_gate':
    'This quality gate is qualified for AI Code Assurance',
  'project_quality_gate.not_ai_assured_quality_gate':
    'This quality gate is not qualified for AI Code Assurance',
  'project_quality_gate.ai_generated_code_protected.title': 'Your AI-generated code is protected',
  'project_quality_gate.ai_generated_code_protected.description':
    '<p>This project contains AI-generated code and the selected quality gate is qualified for <link>AI Code Assurance</link>.</p>',
  'project_quality_gate.ai_generated_code_not_protected.title':
    'Protect your AI-generated code with ‘AI Code Assurance’',
  'project_quality_gate.ai_generated_code_not_protected.description':
    '<p>This project contains AI-generated code. We recommend using a qualified quality gate to enable <link>AI Code Assurance</link>.</p><p>You may use <linkSonarWay>Sonar way for AI code</linkSonarWay> or <linkQualifyDoc>qualify your own custom quality gates for AI Code Assurance</linkQualifyDoc>.</p>',

  //------------------------------------------------------------------------------
  //
  // PROJECT (RESOURCE) DELETION PAGE
  //
  //------------------------------------------------------------------------------

  'project_deletion.delete_resource_confirmation': 'Are you sure you want to delete "{name}"?',
  'project_deletion.resource_deleted': 'Project "{name}" has been successfully deleted.',
  'projects_management.delete_resource_confirmation': 'Are you sure you want to delete "{0}"?',
  'projects_management.delete_selected_warning': "You're about to delete {0} selected items.",
  'projects_management.delete_all_warning': "You're about to delete all {0} items.",
  'projects_management.project_has_been_successfully_created':
    'Project {project} has been successfully created.',
  'projects_management.select_project': 'Select project {0}',
  'projects_management.show_actions_for_x': 'Show actions for project {0}',
  'projects_management.filter_by_component': 'Filter by component',
  'projects_management.filter_by_visibility': 'Filter by visibility',

  //------------------------------------------------------------------------------
  //
  // PROJECT INFORMATION DRAWER
  //
  //------------------------------------------------------------------------------

  'project.info.title': 'Project Information',
  'application.info.title': 'Application Information',
  'project.about.title': 'About this Project',
  'application.about.title': 'About this Application',
  'project.info.description': 'Description',
  'project.info.empty_description': 'No description added for this project.',
  'application.info.empty_description': 'No description added for this application.',
  'project.info.quality_gate': 'Quality Gate used',
  'project.info.quality_gate.link_label':
    '{gate} - quality gate used for this project. Click to navigate to the quality gate page.',
  'project.info.to_notifications': 'Set notifications',
  'project.info.notifications': 'Notifications',
  'project.info.main_branch': 'Main branch',
  'project.info.see_more_info_on_x_locs': 'See more information on your {0} lines of code',
  'project.info.make_home.title': 'Use as homepage',
  'project.info.make_home.label': 'Make this project my homepage',
  'application.info.make_home.label': 'Make this application my homepage',
  'project.info.make_home.tooltip':
    "This means you'll be redirected to this project whenever you log in to {productName} or click on the top-left {productName} logo.",
  'application.info.make_home.tooltip':
    "This means you'll be redirected to this application whenever you log in to {productName} or click on the top-left {productName} logo.",
  'overview.project_key.tooltip.TRK':
    'Your project key is a unique identifier for your project. If you are using Maven, make sure the key matches the "groupId:artifactId" format.',
  'overview.project_key.tooltip.APP':
    'Your application key is a unique identifier for your application.',
  'project.info.contain_ai_code.title': 'AI Code',
  'project.info.contain_ai_code.description': 'This project contains AI-generated code.',
  'project.info.detected_ai_code.description': 'This project may contain AI-generated code.',
  'project.info.ai_code_assurance.title': 'AI Code Assurance',
  'project.info.ai_code_assurance.on.description':
    'This project benefits from Sonar’s AI Code Assurance.',
  'project.info.ai_code_assurance.off.description':
    'This project could benefit from AI Code Assurance by using an <link>AI-qualified quality gate</link>.',
  'project.info.ai_code_assurance.off.description_for_admin':
    'To benefit from AI Code Assurance, select an AI-qualified quality gate.',
  'project.info.ai_code_fix.title': 'AI CodeFix',
  'project.info.ai_code_fix.message': 'AI CodeFix is enabled for this project.',

  //------------------------------------------------------------------------------
  //
  // QUALITY PROFILES
  //
  //------------------------------------------------------------------------------

  'quality_profiles.page_title_changelog_x': '{profile} Changelog',
  'quality_profiles.page_title_compare_x': '{profile} Comparison',
  'quality_profiles.new_profile': 'New Quality Profile',

  'quality_profiles.compare_with': 'Compare with',
  'quality_profiles.filter_by': 'Filter by',
  'quality_profiles.filter_by_lang': 'Filter by language',
  'quality_profiles.select_lang': 'Select language',
  'quality_profiles.no_lang_found': 'No languages found',
  'quality_profiles.restore_profile': 'Restore Profile',
  'quality_profiles.restore_profile.success':
    '{ruleSuccesses} rule(s) restored in profile "{profileName}"',
  'quality_profiles.restore_profile.warning':
    '{ruleSuccesses} rule(s) restored, {ruleFailures} rule(s) ignored in profile "{profileName}"',
  'quality_profiles.optional_configuration_file': 'Optional configuration file',
  'quality_profiles.new_name': 'New name',
  'quality_profiles.no_languages_available':
    'There are no languages available. You cannot create a new profile.',
  'quality_profiles.delete_confirm_title': 'Delete Profile',
  'quality_profiles.delete_confirm_description': "You're about to delete a profile.",
  'quality_profiles.are_you_sure_want_delete_profile_x':
    'Are you sure that you want to delete the profile "{profileName}"?',
  'quality_profiles.are_you_sure_want_delete_profile_x_and_descendants':
    'Are you sure that you want to delete the profile "{profileName}" and all its descendants?',
  'quality_profiles.this_profile_has_descendants': 'This profile has descendants.',
  'quality_profiles.profile_inheritance': 'Inheritance',
  'quality_profiles.no_projects_associated_to_profile':
    'No projects are explicitly associated to the profile.',
  'quality_profiles.cannot_associate_projects_no_rules':
    'You must activate at least 1 rule before you can assign projects to this profile.',
  'quality_profiles.cannot_set_default_no_rules':
    'You must activate at least 1 rule before you can make this profile the default profile.',
  'quality_profiles.warning.used_by_projects_no_rules':
    'The current profile is used on several projects, but it has no active rules. Please activate at least 1 rule for this profile.',
  'quality_profiles.warning.is_default_no_rules':
    'The current profile is the default profile, but it has no active rules. Please activate at least 1 rule for this profile.',
  'quality_profiles.parent': 'Parent',
  'quality_profiles.parameter_set_to': 'Parameter {0} set to {1}',
  'quality_profile.summary_additional':
    '{count} additional {count, plural, one {rule} other {rules}}',
  'quality_profile.summary_fewer': '{count} fewer {count, plural, one {rule} other {rules}}',
  'quality_profile.summary_differences1':
    '{profile} has {additional} and {fewer} than {comparedProfile}.',
  'quality_profile.summary_differences2': '{profile} has {difference} than {comparedProfile}',
  'quality_profiles.x_rules_only_in': '{count} rules in {profile}',
  'quality_profiles.x_rules_have_different_configuration':
    '{count} rules have a different configuration',
  'quality_profiles.copy_x_title': 'Copy Profile "{profile}" - {language}',
  'quality_profiles.extend_x_title': 'Extend Profile "{profile}" - {language}',
  'quality_profiles.rename_x_title': 'Rename Profile {profile} - {language}',
  'quality_profiles.deprecated': 'deprecated',
  'quality_profiles.severity_set_to': 'Severity set to',
  'quality_profiles.changelog.ACTIVATED': 'Activated',
  'quality_profiles.changelog.DEACTIVATED': 'Deactivated',
  'quality_profiles.changelog.UPDATED': 'Updated',
  'quality_profiles.changelog.parameter_reset_to_default_value':
    'Parameter {0} reset to default value',
  'quality_profiles.changelog.prioritized_rule_changed': 'Prioritized rule set to {flag}',
  'quality_profiles.changelog.cca_and_category_changed':
    'Code category set to {newCleanCodeAttributeCategory} and attribute set to {newCleanCodeAttribute}, was {oldCleanCodeAttributeCategory} and {oldCleanCodeAttribute}',
  'quality_profiles.changelog.cca_only_changed':
    'Code attribute set to {newCleanCodeAttribute}, was {oldCleanCodeAttribute}',
  'quality_profiles.changelog.impact_changed':
    'Software impact set to {newSoftwareQuality} with severity {newSeverity}, was {oldSoftwareQuality} with severity {oldSeverity}',
  'quality_profiles.changelog.impact_added':
    'Software impact {newSoftwareQuality} with severity {newSeverity} was added',
  'quality_profiles.changelog.impact_removed':
    'Software impact {oldSoftwareQuality} with severity {oldSeverity} was removed',
  'quality_profiles.changelog.sq_upgrade': 'Instance updated to {productName} {sqVersion}',
  'quality_profiles.deleted_profile': "The profile {0} doesn't exist anymore",
  'quality_profiles.projects_for_default':
    'Every project not specifically associated with a quality profile will be associated to this one by default.',
  'quality_profile.x_rules': '{count} rule(s)',
  'quality_profile.lang_deprecated_x_rules': '{name}, {count} deprecated rule(s)',
  'quality_profile.x_active_rules': '{0} active rules',
  'quality_profile.x_inactive_rules': '{0} inactive rules',
  'quality_profile.rules.breakdown': 'Rule breakdown',
  'quality_profile.rules.cct_categories_title': 'Code categories',
  'quality_profile.rules.software_qualities_title': 'Software qualities',
  'quality_profile.rules.see_x_active_x_rules': 'See {0} active {1} rules',
  'quality_profile.rules.see_x_inactive_x_rules': 'See {0} inactive {1} rules',
  'quality_profiles.x_overridden_rules': '{0} overridden rules',
  'quality_profiles.change_parent': 'Change Parent',
  'quality_profiles.change_parent_warning':
    'By changing the parent of this profile, any information on inherited rules that were manually disabled will be lost. This means some previously disabled rules might be re-enabled.',
  'quality_profiles.all_profiles': 'All Profiles',
  'quality_profiles.x_profiles': '{name}, {count} profile(s)',
  'quality_profiles.projects.select_hint':
    'Click to associate this project with the quality profile',
  'quality_profiles.projects.deselect_hint':
    'Click to remove association between this project and the quality profile',
  'quality_profile.empty_comparison': 'The quality profiles are equal.',
  'quality_profiles.activate_more': 'Activate More',
  'quality_profiles.activate_more.help.built_in':
    'This quality profile is built in, and cannot be updated manually. If you want to activate more rules, create a new profile that inherits from this one and add rules there.',
  'quality_profiles.activate_more_rules': 'Activate More Rules',
  'quality_profiles.comparison.activate_rule': 'Activate rule for profile "{profile}"',
  'quality_profiles.comparison.deactivate_rule': 'Dectivate rule for profile "{profile}"',
  'quality_profiles.intro':
    'Quality profiles are collections of rules to apply during an analysis. For each language, there is a default profile. All projects not explicitly assigned to some other profile will be analyzed with the default. Ideally, all projects will use the same profile for a language. <p1>A strict quality profile is needed for projects that contain AI-generated code. We recommend using the Sonar way quality profile.</p1> <p2>Learn more about <link>quality profiles in our documentation</link></p2>',
  'quality_profiles.list.projects': 'Projects',
  'quality_profiles.list.projects.help':
    'Projects assigned to a profile will always be analyzed with it for that language, regardless of which profile is the default. Quality profile administrators may assign projects to a non-default profile, or always make it follow the system default. Project administrators may choose any profile for each language.',
  'quality_profiles.list.rules': 'Rules',
  'quality_profiles.list.updated': 'Updated',
  'quality_profiles.list.used': 'Used',
  'quality_profiles.list.default.help':
    'For each language there is a default profile. All projects not explicitly assigned to some other profile will be analyzed with the default.',
  'quality_profiles.x_updated_on_y': '{name}, updated on {date}',
  'quality_profiles.change_projects': 'Change Projects',
  'quality_profiles.not_found': 'The requested quality profile was not found.',
  'quality_profiles.back_to_list': 'Go back to the list of Quality Profiles',
  'quality_profiles.latest_new_rules': 'Recently Added Rules',
  'quality_profiles.latest_new_rules.activated': '{0}, activated on {1} profile(s)',
  'quality_profiles.latest_new_rules.not_activated': '{0}, not yet activated',
  'quality_profiles.latest_new_rules.see_all_x': 'See all {count} recently added rules',
  'quality_profiles.deprecated_rules': 'Deprecated Rules',
  'quality_profiles.x_deprecated_rules':
    '{linkCount} deprecated {count, plural, one {rule} other {rules}}',
  'quality_profiles.deprecated_rules_description':
    'These deprecated rules will eventually disappear. You should proactively investigate replacing them.',
  'quality_profiles.deprecated_rules_are_still_activated':
    'Deprecated rules are still activated on {count} quality profile(s):',
  'quality_profiles.sonarway_missing_rules': 'Sonar way rules not included',
  'quality_profiles.sonarway_missing_rules_description':
    'Recommended rules are missing from your profile',
  'quality_profiles.x_sonarway_missing_rules':
    '{linkCount} Sonar way {count, plural, one {rule} other {rules}} not included',
  'quality_profiles.sonarway_see_x_missing_rules': 'See {0} missing Sonar way rules',
  'quality_profiles.stagnant_profiles': 'Stagnant Profiles',
  'quality_profiles.not_updated_more_than_year':
    "The following profiles haven't been updated for more than 1 year:",
  'quality_profiles.exporters': 'Exporters',
  'quality_profiles.exporters.deprecated':
    'Exporters are deprecated, and will be removed in a future version.',
  'quality_profiles.updated_': 'Updated:',
  'quality_profiles.used_': 'Used:',
  'quality_profiles.built_in': 'Built-in',
  'quality_profiles.built_in.description':
    'This is a built-in quality profile that might be updated automatically.',
  'quality_profiles.built_in.aica_description':
    'This is a built-in quality profile that might be updated automatically. <aica>We recommend using Sonar way for projects that contain AI-generated code, as a strict standard is needed to ensure safety of such code.</aica> <link>Learn why in our documentation</link>',
  'quality_profiles.extends_built_in':
    'Because this quality profile inherits from a built-in quality profile, it might be updated automatically.',
  'quality_profiles.no_built_in_updates_warning':
    'This quality profile does not inherit from a built-in profile. It will not benefit from automatic updates when new rules are introduced.',
  'quality_profiles.no_built_in_updates_warning_admin':
    'To benefit from automatic updates, set the corresponding built-in profile as the parent of your quality profile.',
  'quality_profiles.no_built_in_updates_warning.new_profile':
    "This new quality profile won't inherit from a built-in profile. It will not benefit from automatic updates when new rules are introduced.",
  'quality_profiles.no_built_in_updates_warning.new_profile.2':
    'If you want to benefit from automatic updates, consider extending a built-in quality profile instead.',
  'quality_profiles.default_permissions':
    'Users with the global "Administer Quality Profiles" permission and those listed below can manage this quality profile.',
  'quality_profiles.grant_permissions_to_more_users': 'Grant permissions to more users',
  'quality_profiles.grant_permissions_to_user_or_group': 'Grant permissions to a user or a group',
  'quality_profiles.additional_user_groups': 'Additional users / groups:',
  'quality_profiles.search_description': 'Search users by login or name, and groups by name:',
  'quality_profiles.permissions.remove.user': 'Remove permission from user',
  'quality_profiles.permissions.remove.user_x': 'Remove permission from user {0}',
  'quality_profiles.permissions.remove.user.confirmation':
    'Are you sure you want to remove permission on this quality profile from user {user}?',
  'quality_profiles.permissions.remove.group': 'Remove permission from group',
  'quality_profiles.permissions.remove.group_x': 'Remove permission for {0}',
  'quality_profiles.permissions.remove.group.confirmation':
    'Are you sure you want to remove permission on this quality profile from group {user}?',
  'quality_profiles.copy_help':
    'Create a new quality profile as a replica of "{profile}".  The two profiles will then evolve independently.',
  'quality_profiles.extend_help':
    'Create a child quality profile inheriting all active rules from "{profile}". Changes to "{profile}" will impact the child profile.',
  'quality_profiles.extend_description': 'This profile extends {link}.',
  'quality_profiles.extend_description_help':
    'Changes to "{0}" or any of its parents may impact this quality profile.',
  'quality_profiles.chose_creation_type': 'What type of profile do you want to create?',
  'quality_profiles.creation_from_extend': 'Extend an existing quality profile',
  'quality_profiles.creation_from_extend_description_1':
    'Create a child quality profile inheriting its parent’s active rules.',
  'quality_profiles.creation_from_extend_description_2':
    'Changes to the parent profile will impact the child profile.',
  'quality_profiles.creation_from_copy': 'Copy an existing quality profile',
  'quality_profiles.creation_from_copy_description_1':
    'Create a new quality profile as a replica of the copied quality profile.',
  'quality_profiles.creation_from_copy_description_2':
    'The two profiles will then evolve independently.',
  'quality_profiles.creation_from_blank': 'Create a blank quality profile',
  'quality_profiles.creation_from_blank_description':
    'Create a new quality profile with no active rules by default.',
  'quality_profiles.creation.choose_parent_quality_profile': 'Profile to extend',
  'quality_profiles.creation.choose_copy_quality_profile': 'Profile to copy',
  'quality_profiles.name_invalid': 'Quality profile name should not be empty',
  'quality_profiles.actions': 'Open {0} {1} quality profile actions',
  'quality_profiles.aica.tooltip.icon': 'This quality profile is recommended for AI-generated code',

  //------------------------------------------------------------------------------
  //
  // QUALITY GATES
  //
  //------------------------------------------------------------------------------

  'quality_gates.create': 'Create Quality Gate',
  'quality_gates.rename': 'Rename Quality Gate',
  'quality_gates.rename_x': 'Rename {name} Quality Gate',
  'quality_gates.delete': 'Delete Quality Gate',
  'quality_gates.delete_x': 'Delete {name} Quality Gate',
  'quality_gates.copy': 'Copy Quality Gate',
  'quality_gates.copy_x': 'Copy {name} Quality Gate',
  'quality_gates.set_as_default_x': 'Set {name} as Default Quality Gate',
  'quality_gates.is_default_no_conditions':
    'This is the default quality gate, but it has no configured conditions. Please configure at least 1 condition for this quality gate.',
  'quality_gates.is_built_in.description': 'Sonar way is recommended for most projects. {link}',
  'quality_gates.is_built_in.tooltip': 'Built-in quality gate reflecting recommended practices',
  'quality_gates.is_built_in.ai.tooltip':
    'Built-in quality gate reflecting recommended practices for AI-generated code',
  'quality_gates.conditions': 'Conditions',
  'quality_gates.conditions.help':
    'Your project will fail the Quality Gate if it crosses any metric thresholds set for New Code or Overall Code.',
  'quality_gates.conditions.update': 'Update conditions on new code',
  'quality_gates.conditions.update_x': 'Update conditions on new code for {name} quality gate',
  'quality_gates.projects': 'Projects',
  'quality_gates.projects.help':
    'The Default gate is applied to all projects not explicitly assigned to a gate. Quality Gate administrators can assign projects to a non-default gate, or always make it follow the system default. Project administrators may choose any gate.',
  'quality_gates.add_condition': 'Add Condition',
  'quality_gates.add_condition_x': 'Add Condition to {name} Quality Gate',
  'quality_gates.add_condition.metric_from_other_mode':
    'This quality gate already has an equivalent condition based on the same concept ("{metric}") that persists from the {isStandardMode, select, true {Standard Experience} other {Multi-Quality Rule Mode}}. Update the metric and you will be able to edit the condition.',
  'quality_gates.condition.edit': 'Edit condition on {metric}',
  'quality_gates.condition.delete': 'Delete condition on {metric}',
  'quality_gates.condition_added': 'Successfully added condition.',
  'quality_gates.update_condition': 'Update Condition',
  'quality_gates.condition_updated': 'Successfully updated condition.',
  'quality_gates.conditions_updated': 'Successfully updated conditions.',
  'quality_gates.conditions_updated_to_the_mode':
    'The metrics of "{qualityGateName}" gate were successfully updated',
  'quality_gates.conditions.error_message.percent': 'Value must be between 0 and 100',
  'quality_gates.conditions.error_message.default': 'Value is invalid',
  'quality_gates.no_conditions': 'No Conditions',
  'quality_gates.health_icons': 'Project health icons represent:',
  'quality_gates.projects_for_default':
    'Every project not specifically associated to a quality gate will be associated to this one by default.',
  'quality_gates.projects.with': 'With',
  'quality_gates.projects.without': 'Without',
  'quality_gates.projects.all': 'All',
  'quality_gates.projects.noResults': 'No Projects',
  'quality_gates.projects.select_hint': 'Click to associate this project with the quality gate',
  'quality_gates.projects.deselect_hint':
    'Click to remove association between this project and the quality gate',
  'quality_gates.projects.cannot_associate_projects_no_conditions':
    'You must configure at least 1 condition before you can assign projects to this quality gate.',
  'quality_gates.projects.ai_assured_message': 'This project contains AI-generated code.',
  'quality_gates.operator.LT': 'is less than',
  'quality_gates.operator.inverted.LT': 'greater than or equal',
  'quality_gates.operator.GT': 'is greater than',
  'quality_gates.operator.inverted.GT': 'less than or equal',
  'quality_gates.operator.EQ': 'equals',
  'quality_gates.operator.NE': 'is not',
  'quality_gates.operator.LT.short': '<',
  'quality_gates.operator.GT.short': '>',
  'quality_gates.operator.EQ.short': '=',
  'quality_gates.operator.NE.short': '\u2260',
  'quality_gates.operator.LT.rating': 'is better than',
  'quality_gates.operator.GT.rating': 'is worse than',
  'quality_gates.operator.EQ.rating': 'is',
  'quality_gates.operator.NE.rating': 'is not',
  'quality_gates.operator.least': 'at least',
  'quality_gates.operator.GTE': 'is greater than or equal to',
  'quality_gates.delete.confirm.message':
    'Are you sure you want to delete the "{qualityGate}" quality gate?',
  'quality_gates.delete_condition': 'Delete Condition',
  'quality_gates.condition_deleted': 'Successfully deleted condition',
  'quality_gates.delete_condition.confirm.message':
    'Are you sure you want to delete the "{metric}" condition?',
  'quality_gates.conditions.fails_when': 'Quality Gate fails when',
  'quality_gates.conditions.metric': 'Metric',
  'quality_gates.conditions.builtin_overall.metric': '{metric} is {operator} {value}',
  'quality_gates.conditions.builtin': 'Conditions on New Code',
  'quality_gates.conditions.description':
    'These conditions apply to the new code of all branches and to pull requests.',
  'quality_gates.conditions.builtin_new_code.metric': '{metric} is {operator} to {value}',
  'quality_gates.conditions.hint':
    'The conditions below must be true for your project to pass the Quality Gate.',
  'quality_gates.conditions.threshold.hint':
    'Sonar recommends this threshold. Create a new Quality Gate to set a different value.',
  'quality_gates.conditions.new_code': 'On New Code',
  'quality_gates.conditions.new_code.long': 'Conditions on New Code',
  'quality_gates.conditions.new_code.description':
    'Conditions on new code apply to all branches and to pull requests.',
  'quality_gates.conditions.new_code_1': '1 condition failed on new code',
  'quality_gates.conditions.new_code_x': '{0} conditions failed on new code',
  'quality_gates.conditions.overall_code': 'On Overall Code',
  'quality_gates.conditions.overall_code.long': 'Conditions on Overall Code',
  'quality_gates.conditions.overall_code.description':
    'Conditions on overall code apply to branches only.',
  'quality_gates.conditions.overall_code_1': '1 condition failed on overall code',
  'quality_gates.conditions.overall_code_x': '{0} conditions failed on overall code',
  'quality_gates.conditions.x_conditions_failed':
    '{conditions} {conditions, plural, one {condition} other {conditions}} failed',
  'quality_gates.conditions.operator': 'Operator',
  'quality_gates.conditions.value': 'Value',
  'quality_gates.conditions.threshold': 'Set condition value',
  'quality_gates.conditions.where': 'Where?',
  'quality_gates.duplicated_conditions': 'This quality gate has duplicated conditions:',
  'quality_gates.intro.1':
    'Quality Gate is the set of conditions the project must meet before it can be released into production.',
  'quality_gates.intro.2':
    'It is possible to set a default Quality Gate, which will be applied to all projects not explicitly assigned to some other gate.',
  'quality_gates.built_in': 'Built-in',
  'quality_gates.built_in.help': 'Built-in, immutable Quality Gate reflecting best practices.',
  'quality_gates.built_in.description.1': 'This quality gate is provided by default.',
  'quality_gates.built_in.description.2':
    'It will automatically be updated with the latest recommendations.',
  'quality_gates.status': 'Quality Gate status',
  'quality_gates.help.title': 'What is a quality gate?',
  'quality_gates.help.desc':
    "It`s a set of measure-based, Boolean conditions. It helps you know immediately whether your projects are production-ready. Ideally, all projects will use the same quality gate. Each project's Quality Gate status is displayed prominently on its homepage.",
  'quality_gates.help.link': 'Learn more about quality gates',
  'quality_gates.permissions': 'Permissions',
  'quality_gates.permissions.help':
    'Users with the global "Administer quality gates" permission and those listed below can manage this quality gate.',
  'quality_gates.permissions.grant': 'Grant permissions to a user or a group',
  'quality_gates.permissions.search': 'Search users by login or name, and groups by name:',
  'quality_gates.permissions.remove.user': 'Remove permission from user',
  'quality_gates.permissions.remove.user.confirmation':
    'Are you sure you want to remove permission on this quality gate from user {user}?',
  'quality_gates.permissions.remove.group': 'Remove permission from group',
  'quality_gates.permissions.remove.group.confirmation':
    'Are you sure you want to remove permission on this quality gate from group {user}?',
  'quality_gates.condition_simplification_list':
    'List of conditions to ensure that any code added follow Sonar practices',

  'quality_gates.banner.builtin.title':
    'This quality gate reflects <link>Sonar recommended practices</link>',
  'quality_gates.banner.builtin.ai.title':
    "This quality gate reflects Sonar's recommended practices for AI-generated code",
  'quality_gates.banner.recommendation_update.title': 'Consider updating conditions on new code',
  'quality_gates.banner.recommendation_update.description':
    'Updating conditions on new code would align this gate with <link>standards recommended by Sonar</link>',
  'quality_gates.banner.info.multiple.title': 'This quality gate:',
  'quality_gates.banner.info.multiple.aica': 'Is qualified for <link>AI Code Assurance</link>',
  'quality_gates.banner.info.multiple.sonar':
    'Has all of conditions <link>recommended by Sonar</link>',
  'quality_gates.info.recommended.title':
    'This quality gate has all of the conditions <link>recommended by Sonar</link>',
  'quality_gates.info.aica.title':
    'This quality gate is qualified for <link>AI Code Assurance</link>',

  'quality_gates.recommendation.new_maintainability_rating.A':
    'Technical debt ratio is less than {0}',
  'quality_gates.recommendation.new_maintainability_rating':
    'Technical debt ratio is greater than {1}',
  'quality_gates.recommendation.new_reliability_rating.A': 'No bugs',
  'quality_gates.recommendation.new_security_rating.A': 'No vulnerabilities',

  'quality_gates.fix_modal.title': 'Update conditions on new code',
  'quality_gates.fix_modal.description':
    'Modify conditions on new code to align this quality gate with <link>standards recommended by Sonar</link>. All conditions on overall code will remain unchanged.',
  'quality_gates.fix_modal.to_add.title.x_conditions':
    '{count} {count, plural, one {condition} other {conditions}} on new code will be added',
  'quality_gates.fix_modal.to_modify.title.x_conditions':
    '{count} {count, plural, one {condition} other {conditions}} on new code will be modified',
  'quality_gates.fix_modal.to_modify.accessible_item':
    '{metric} is changing from "{op} {oldValue}" to "{op} {newValue}"',
  'quality_gates.fix_modal.to_remove.title': 'Some conditions on new code can be removed',
  'quality_gates.fix_modal.to_remove.description':
    'The following conditions are not <link>recommended by Sonar</link>',
  'quality_gates.fix_modal.to_remove.selection.description':
    'All selected conditions will be removed. Deselect conditions you want to retain.',
  'quality_gates.fix_modal.success': 'Conditions on new code were successfully updated',
  'quality_gates.fix_modal.review_update': 'Review and update',
  'quality_gates.fix_modal.review_update_x':
    'Review and update conditions on new code for {name} quality gate',
  'quality_gates.recommended.tooltip.message': 'This  gate has all recommended conditions',
  'quality_gates.ai_generated.tooltip.message':
    'This quality gate is qualified for AI Code Assurance',
  'quality_gates.recommended_and_ai.tooltip':
    'This gate has all recommended conditions and is marked as qualified for AI-generated code',

  'quality_gates.mqr_mode_update.tooltip.message': 'Update the metrics of this quality gate',
  'quality_gates.mqr_mode_update.single_metric.tooltip.message': 'Update {metric} metric to {mode}',
  'quality_gates.update_conditions.update_metrics': 'Update metrics',
  'quality_gates.update_conditions.header': 'Update all metrics of “{qualityGate}” gate',
  'quality_gates.update_conditions.header.single_metric': 'Update this metric',
  'quality_gates.update_conditions.description.line1':
    'The <b>condition(s)</b> listed below will be updated to align with the mode of this instance ({mode}).',
  'quality_gates.update_conditions.description.line2':
    'In some cases, you will see that the name of the conditions does not change between modes. In these cases, the underlying calculation will be changing to something similar but not identical. Your settings for <b>Operator</b> and <b>value</b> will remain unchanged.',
  'quality_gates.update_conditions.description.line3':
    'Note that the update to {mode} might cause your quality gate to fail. {link}',
  'quality_gates.update_conditions.description.link':
    'For more information, refer to the documentation.',
  'quality_gates.update_conditions.standard_mode_header': 'Standard Experience Metric',
  'quality_gates.metric.standard_mode_short': 'Standard Experience',
  'quality_gates.metric.standard_mode_long': 'Standard Experience Metric',
  'quality_gates.metric.mqr_mode_short': 'MQR Mode',
  'quality_gates.metric.mqr_mode_long': 'MQR Mode Metric',
  'quality_gates.update_conditions.operator_and_value_header': 'Operator and Value',
  'quality_gates.update_conditions.removed': 'Condition will be removed',
  'quality_gates.update_conditions.error': 'Failed to update some conditions',
  'quality_gates.mode_banner.title':
    'This quality gate is using conditions with metrics that belong to the {mode}',
  'quality_gates.mode_banner.description':
    'This instance is currently in the {link}. We recommend you update the metrics of your quality gate conditions to ensure accurate categorization and ranking of your issues in this mode. Conditions that use {otherMode} metrics can’t be edited until they are updated.',
  'quality_gates.mode_banner.button': 'Review and update metrics',
  'quality_gates.actions.disqualify_for_ai_code_assurance': 'Disqualify for AI Code Assurance',
  'quality_gates.actions.disqualify_for_ai_code_assurance_x':
    'Disqualify {name} quality gate for AI Code Assurance',
  'quality_gates.actions.qualify_for_ai_code_assurance': 'Qualify for AI Code Assurance',
  'quality_gates.actions.qualify_for_ai_code_assurance_x':
    'Qualify {name} quality gate for AI Code Assurance',
  'quality_gates.disqualify_ai_modal.title':
    'Disqualify this quality gate and disable AI Code Assurance on {count} {count, plural, one {project} other {projects}}?',
  'quality_gates.disqualify_ai_modal_default.title':
    'Some projects may lose their AI Code Assurance',
  'quality_gates.disqualify_ai_modal.content.line1':
    '{count} {count, plural, one {project uses} other {projects use}} this quality gate to benefit from AI Code Assurance. If you disqualify it, {count, plural, one {this project} other {these projects}} will lose {count, plural, one {its} other {their}} AI Code Assurance.',
  'quality_gates.disqualify_ai_modal_default.content.line1':
    'Some projects may rely on the default quality gate to benefit from AI Code Assurance. If you disqualify it, these projects will lose their AI Code Assurance.',
  'quality_gates.disqualify_ai_modal.content.line2': 'Do you want to continue?',
  'quality_gates.disqualify_ai_modal.confirm': 'Disqualify for AI Code Assurance',

  //------------------------------------------------------------------------------
  //
  // RULES DOCUMENTATION PAGE
  //
  //------------------------------------------------------------------------------
  'rules.parameters': 'Parameters',
  'rules.status.beta': 'Beta',
  'rules.status.BETA': 'Beta',
  'rules.status.BETA.help':
    'The rule has been recently implemented and we haven’t gotten enough feedback from users yet, so there may be false positives or false negatives.',
  'rules.status.deprecated': 'Deprecated',
  'rules.status.DEPRECATED': 'Deprecated',
  'rules.status.DEPRECATED.help':
    'The rule that generated this issue has been deprecated and will be removed. Once the rule is removed, this issue will no longer appear.',
  'rules.status.ready': 'Ready',
  'rules.status.READY': 'Ready',
  'rules.status.REMOVED': 'Removed',
  'rules.status.REMOVED.help':
    'The rule that generated this issue has been removed. Starting on the next analysis, this issue will no longer appear.',

  //------------------------------------------------------------------------------
  //
  // CODING RULES
  //
  //------------------------------------------------------------------------------
  'coding_rules.active_in_all_profiles':
    'The rule is already activated on all available Quality Profiles.',
  'coding_rules.severity_deprecated':
    'Changing rule severities is deprecated and will not be possible in the future.',
  'coding_rules.custom_severity.title': 'Rule severity in this quality profile',
  'coding_rules.custom_severity.description.standard':
    'Changing rule severity in a quality profile {link}',
  'coding_rules.custom_severity.description.standard.link':
    'does not change its recommended severity',
  'coding_rules.custom_severity.description.mqr':
    'In the multi-quality mode, severities are directly tied to the software quality impacted. This means that {link}',
  'coding_rules.custom_severity.description.mqr.link':
    'each software quality has its own severity per rule.',
  'coding_rules.custom_severity.not_recommended':
    'This is a custom rule severity, the recommended one is {recommended}',
  'coding_rules.custom_severity.choose_severity': 'Choose severity',
  'coding_rules.custom_severity.severity_with_recommended': '{severity} (recommended)',
  'coding_rules.activate': 'Activate',
  'coding_rules.activate_in': 'Activate In',
  'coding_rules.activate_in_quality_profile': 'Activate In Quality Profile',
  'coding_rules.activation_severity': 'Activation Severity',
  'coding_rules.activation_custom_severity':
    'Custom {count, plural, one {severity} other {severities}}:',
  'coding_rules.available_since': 'Available Since',
  'coding_rules.bulk_change': 'Bulk Change',
  'coding_rules.bulk_change.success': '{2} rule(s) changed in profile {0} - {1}',
  'coding_rules.bulk_change.warning':
    '{2} rule(s) changed, {3} rule(s) ignored in profile {0} - {1}',
  'coding_rules.bulk_change.no_quality_profile': 'No quality profile.',
  'coding_rules.can_not_bulk_change':
    'Bulk change is only available when you have a custom Quality Profile to target. You can create a customizable Quality Profile based on a built-in one by Copying or Extending it in the Quality Profiles list.',
  'coding_rules.can_not_deactivate': 'This rule is inherited and cannot be deactivated.',
  'coding_rules.change_details': 'Change Details of Quality Profile',
  'coding_rules.change_details_x': 'Change Details of Quality Profile {0}',
  'coding_rules.context.others.title': 'How can I fix it in another component or framework?',
  'coding_rules.context.others.description.first':
    'Although the main framework or component you use in your project is not listed above, you may find helpful content in the instructions we provide.',
  'coding_rules.context.others.description.second':
    'Caution: The libraries mentioned in these instructions may not be appropriate for your code.',
  'coding_rules.context.others.description.do':
    'Do use libraries that are compatible with the frameworks you are using.',
  'coding_rules.context.others.description.dont':
    'Don’t blindly copy and paste the fixups into your code.',
  'coding_rules.context.others.title_feedback': 'Help us improve',
  'coding_rules.context.others.feedback_description_1':
    'Let us know if the instructions we provide do not work for you. Tell us which framework you use and why our solution does not work by submitting an idea on the {productName} productboard.',
  'coding_rules.context.others.feedback_description_2':
    'We will do our best to provide you with more relevant instructions in the future.',
  'coding_rules.context.others.feedback_description.link': 'Submit an idea',
  'coding_rules.create': 'Create',
  'coding_rules.create_custom_rule': 'Create Custom Rule',
  'coding_rules.custom_rule': 'Custom Rule',
  'coding_rules.custom_rule.help':
    'Custom rules are created by administrators from templates, and are the only fully-editable rules.',
  'coding_rules.custom_rule.activation_notice':
    'Note: parameters of a custom rule are not customizable on rule activation, only during creation/edit.',
  'coding_rules.custom_rule.software_quality_x': '{quality} software quality',
  'coding_rules.custom_rule.select_software_quality':
    'Please select at least one software quality.',
  'coding_rules.custom_rule.removal':
    'Only custom rules may be deleted. When a custom rule is deleted, it is not removed from the {productName} instance. Instead its status is set to "REMOVED", allowing relevant issues to continue to be displayed properly.',
  'coding_rules.custom_rules': 'Custom Rules',
  'coding_rules.deactivate_in_quality_profile': 'Deactivate In Quality Profile',
  'coding_rules.deactivate_in_quality_profile_x': 'Deactivate In Quality Profile {0}',
  'coding_rules.delete_rule': 'Delete Rule',
  'coding_rules.delete_rule_x': 'Delete Rule {name}',
  'coding_rules.delete.custom.confirm': 'Are you sure you want to delete custom rule "{name}"?',
  'coding_rules.extend_description': 'Extend Description',
  'coding_rules.deactivate_in': 'Deactivate In',
  'coding_rules.deactivate': 'Deactivate',
  'coding_rules.deactivate.confirm':
    'Are you sure you want to deactivate this rule in the profile?',
  'coding_rules.deactivate_in_all_quality_profiles': 'Deactivate In All {0} Profiles',
  'coding_rules.see_actions_for_profile_x': 'See rule actions for profile {x}',
  'coding_rules.inherits': '"{0}" inherits from "{1}"',
  'coding_rules.issues': 'Issues',
  'coding_rules.issues.only_main_branches':
    'Only issues from the main project branches are included.',
  'coding_rules.most_violating_projects': 'Most Violating Projects',
  'coding_rules.most_violating_projects.more_x':
    '{count} more projects contain issues raised from this rule. {link}',
  'coding_rules.most_violating_projects.link': 'See full list of issues',
  'coding_rules.need_extend_or_copy':
    "Rules in built-in Quality Profiles can't be changed. You can create a customizable Quality Profile based on a built-in one by Copying or Extending it in the Quality Profiles list.",
  'coding_rules.no_results': 'No Coding Rules',
  'coding_rules.no_issue_detected_for_projects':
    'No issues were detected for this rule in the main project branches.',
  'coding_rules.no_tags': 'No tags',
  'coding_rules.original': 'Original:',
  'coding_rules.overrides': '"{0}" overrides "{1}"',
  'coding_rules.parameter.empty': '(empty)',
  'coding_rules.parameters': 'Parameters',
  'coding_rules.parameters.default_value': 'Default Value:',
  'coding_rules.quality_profiles': 'Quality Profiles',
  'coding_rules.quality_profiles.description':
    "List of all Quality Profiles where this rule is activated. Built-in profiles can't be changed.",
  'coding_rules.quality_profiles.template_caption':
    'This rule template was activated on the following profiles in previous versions of {instance}. It is not possible anymore to do so. Instead, please create a custom rule.',
  'coding_rules.quality_profile': 'Quality Profile',
  'coding_rules.reactivate': 'Reactivate',
  'coding_rules.reactivate.help':
    'A rule with the same key has been previously deleted. Please reactivate the existing rule or modify the key to create a new rule.',
  'coding_rules.return_to_list': 'Return to list',
  'coding_rules.see_all': 'See all rules',
  'coding_rules.remove_extended_description': 'Remove Extended Description',
  'coding_rules.remove_extended_description.confirm':
    'Are you sure you want to remove the extended description?',
  'coding_rules.repository': 'Rule repo:',
  'coding_rules.revert_to_parent_definition': 'Revert to Parent Definition',
  'coding_rules.revert_to_parent_definition.confirm':
    'This rule will be reverted to the parameters defined in profile {0}. Are you sure?',
  'coding_rules.rule_template': 'Rule Template',
  'coding_rules.rule_template.help':
    'Rule Templates allow users to easily define their own rules. They are like cookie cutters from which you can stamp out new, "custom rules". The rules created from a template are listed on its rule detail page.',
  'coding_rules.rule_template.title':
    'This rule can be used as a template to create custom rules, it cannot be activated on a profile',
  'coding_rules._rules': 'rules',
  'coding_rules.show_template': 'Show Template',
  'coding_rules.skip_to_filters': 'Skip to rules filters',
  'coding_rules.software_qualities.label': 'Software qualities impacted',
  'coding_rules.cct_attribute.label': 'Code attribute',
  'coding_rules.to_select_rules': 'Select rules',
  'coding_rules.to_navigate': 'Navigate to rule',
  'coding_rules.prioritized_rule.title': 'Prioritized rule',
  'coding_rules.impact_severity.tooltip_customized.standard':
    '{type} of {severity} severity. This is a custom severity associated with the quality profile selected. Click for more information.',
  'coding_rules.impact_severity.tooltip_customized.mqr':
    '{severity} severity impact on {quality}. This is a custom severity associated with the quality profile selected. Click for more information.',
  'coding_rules.impact_customized.message': 'Rule severity was customized in this profile',
  'coding_rules.impact_customized.detail':
    '{softwareQuality} changed from {recommended} to {customized}',
  'coding_rules.severity_customized.message':
    'Rule severity was customized from {recommended} to {customized}',
  'coding_rules.prioritized_rule.switch_label':
    'All corresponding issues in the overall code should be fixed',
  'coding_rules.prioritized_rule.note':
    'For the quality gate to fail, you must add a condition that checks whether any issues have been raised from prioritised rules',
  'coding_rules.rule_name.title': 'Rule Name: {name}',
  'coding_rules.quality_profile.title': 'Quality profile: {name}',

  'coding_rules.update_custom_rule': 'Update Custom Rule',

  'coding_rules.filters.activation': 'Activation',
  'coding_rules.filters.activation.active': 'Active',
  'coding_rules.filters.activation.active_rules': 'Active Rules',
  'coding_rules.filters.activation.inactive': 'Inactive',
  'coding_rules.filters.activation.help':
    'Activation criterion is available when a Quality Profile is selected',
  'coding_rules.filters.active_severity': 'Active Severity',
  'coding_rules.filters.active_severity.inactive':
    'Active severity criterion is available when a Quality Profile is selected',
  'coding_rules.filters.availableSince': 'Available Since',
  'coding_rules.filters.characteristic': 'Characteristic',
  'coding_rules.filters.description': 'Description',
  'coding_rules.filters.quality_profile': 'Quality Profile',
  'coding_rules.filters.inheritance': 'Inheritance',
  'coding_rules.filters.inheritance.inactive':
    'Inheritance criterion is available when an inherited Quality Profile is selected',
  'coding_rules.filters.inheritance.none': 'Not Inherited',
  'coding_rules.filters.inheritance.inherited': 'Inherited',
  'coding_rules.filters.inheritance.x_inherited_from_y': '{count} inherited from "{name}"',
  'coding_rules.filters.inheritance.overrides': 'Overridden',
  'coding_rules.filters.key': 'Key',
  'coding_rules.filters.language': 'Language',
  'coding_rules.filters.language.inactive':
    'Language criterion is only available when no Quality Profile is selected',
  'coding_rules.filters.name': 'Name',
  'coding_rules.filters.repository': 'Repository',
  'coding_rules.filters.severity': 'Severity',
  'coding_rules.filters.security_hotspots': 'Security Hotspots',
  'coding_rules.filters.status': 'Status',
  'coding_rules.filters.tag': 'Tag',
  'coding_rules.filters.template': 'Templates',
  'coding_rules.filters.template.is_template': 'Show Templates Only',
  'coding_rules.filters.template.is_not_template': 'Hide Templates',
  'coding_rules.filters.prioritizedRule.disabled':
    'Prioritized Rules criterion is available when Quality Profile is selected',
  'coding_rules.filters.prioritizedRule.true': 'Show Prioritized Only',
  'coding_rules.filters.prioritizedRule.false': 'Hide Prioritized',
  'coding_rules.facet.languages': 'Language',
  'coding_rules.facet.repositories': 'Repository',
  'coding_rules.facet.impactSeverities': 'Severity',
  'coding_rules.facet.active_impactSeverities': 'Severity',
  'coding_rules.facet.cleanCodeAttributeCategories': 'Code attribute',
  'coding_rules.facet.impactSoftwareQualities': 'Software quality',
  'coding_rules.facet.tags': 'Tags',
  'coding_rules.facet.qprofile': 'Quality Profile',
  'coding_rules.facet.qprofile.help.title': 'Quality Profiles',
  'coding_rules.facet.qprofile.help.desc':
    'Quality Profiles are collections of Rules to apply during an analysis.',
  'coding_rules.facet.qprofile.help.extra':
    'When filtering active rules by Quality Profile, any customized rule severity associated with it will be shown.',
  'coding_rules.facet.qprofile.help.learn_more': 'Learn more about quality profiles',
  'coding_rules.facet.qprofile.link': 'See also: Quality Profiles',
  'coding_rules.facet.debt_characteristics': 'Characteristic',
  'coding_rules.facet.severities': 'Severity',
  'coding_rules.facet.active_severities': 'Severity',
  'coding_rules.facet.statuses': 'Status',
  'coding_rules.facet.available_since': 'Available Since',
  'coding_rules.facet.inheritance': 'Inheritance',
  'coding_rules.facet.template': 'Template',
  'coding_rules.facet.rule_key': 'Rule',
  'coding_rules.facet.types': 'Type',
  'coding_rules.facet.prioritizedRule': 'Prioritized Rules',
  'coding_rules.facet.security_hotspots.show_only': 'Show Security Hotspots Only',
  'coding_rules.facets.languages': 'Languages',
  'coding_rules.facets.tags': 'Tags',
  'coding_rules.facets.repositories': 'Repositories',
  'coding_rules.facets.top': 'Top {0}',

  'coding_rules.rule_id': 'Rule ID:',

  'coding_rules.analysis_scope': 'Analysis scope:',

  'coding_rules.scope.MAIN': 'main sources',
  'coding_rules.scope.TEST': 'test sources',
  'coding_rules.scope.ALL': 'all sources',

  'coding_rules.remediation_effort': 'Effort:',
  'coding_rules.remediation_function': 'Remediation function',
  'coding_rules.remediation_function.LINEAR': 'Linear',
  'coding_rules.remediation_function.LINEAR_OFFSET': 'Linear with offset',
  'coding_rules.remediation_function.CONSTANT_ISSUE': 'Constant/issue',
  'coding_rules.remediation_function.coeff': 'Coeff',
  'coding_rules.remediation_function.offset': 'Offset',
  'coding_rules.remediation_function.constant': 'Constant',

  'coding_rules.external_rule.engine_tooltip': 'Rule provided by an external rule engine: {0}',
  'coding_rules.external_rule.engine': 'Engine:',

  'coding_rules.description_section.title.introduction': 'Introduction',
  'coding_rules.description_section.title.root_cause': 'Why is this an issue?',
  'coding_rules.description_section.title.root_cause.SECURITY_HOTSPOT': 'What is the risk?',
  'coding_rules.description_section.title.assess_the_problem': 'Assess the risk',
  'coding_rules.description_section.title.how_to_fix': 'How can I fix it?',
  'coding_rules.description_section.title.code_fix': 'AI CodeFix',
  'coding_rules.description_section.title.more_info': 'More info',
  'coding_rules.description_section.title.activity': 'Activity',

  'coding_rules.description_context.title': 'Which component or framework contains the issue?',
  'coding_rules.description_context.subtitle': 'How can I fix it in {0}?',
  'coding_rules.description_context.default_information':
    '{0} was detected as the most relevant component or framework for this issue.',
  'coding_rules.description_context.other': 'Other',

  'coding_rules.more_info.education_principles.title': 'Code principles',
  'coding_rules.more_info.resources.title': 'Resources',

  'coding_rules.more_info.notification_message':
    "We've added new information about Code principles below to help you improve your code quality and security. Take a moment to read through them.",
  'coding_rules.more_info.scroll_message': 'Scroll down to code quality principles',

  'coding_rules.detail.extend_description.form': "Extend this rule's description",
  'coding_rules.create_tag': 'Create Tag',

  'coding_rules.select_profile': 'Select Profile',
  'coding_rules.selected_profiles': 'Selected Profiles',

  'coding_rules.custom.type.label': 'Type',
  'coding_rules.custom.type.option.ISSUE': 'Issue',
  'coding_rules.custom.type.option.SECURITY_HOTSPOT': 'Security Hotspot',

  'coding_rules.system_tags_tooltip':
    "This tag can't be removed because it has been predefined by our system",

  'rule.impact.severity.tooltip':
    'Issues found for this rule will have a {severity} impact on the {quality} of your software.',

  'rule.clean_code_attribute_category.CONSISTENT': 'Consistency',
  'rule.clean_code_attribute_category.CONSISTENT.title': 'This is a consistency rule.',
  'rule.clean_code_attribute_category.INTENTIONAL': 'Intentionality',
  'rule.clean_code_attribute_category.INTENTIONAL.title': 'This is an intentionality rule.',
  'rule.clean_code_attribute_category.ADAPTABLE': 'Adaptability',
  'rule.clean_code_attribute_category.ADAPTABLE.title': 'This is an adaptability rule.',
  'rule.clean_code_attribute_category.RESPONSIBLE': 'Responsibility',
  'rule.clean_code_attribute_category.RESPONSIBLE.title': 'This is a responsibility rule.',

  'rule.clean_code_attribute.CLEAR': 'Clear',
  'rule.clean_code_attribute.CLEAR.title':
    'This is an intentionality rule, the code should be clear.',
  'rule.clean_code_attribute.COMPLETE': 'Complete',
  'rule.clean_code_attribute.COMPLETE.title':
    'This is a intentionality rule, the code should be complete.',
  'rule.clean_code_attribute.CONVENTIONAL': 'Conventional',
  'rule.clean_code_attribute.CONVENTIONAL.title':
    'This is a consistency rule, the code should be conventional.',
  'rule.clean_code_attribute.DISTINCT': 'Distinct',
  'rule.clean_code_attribute.DISTINCT.title':
    'This is an adaptability rule, the code should be distinct.',
  'rule.clean_code_attribute.EFFICIENT': 'Efficient',
  'rule.clean_code_attribute.EFFICIENT.title':
    'This is an intentionality rule, the code should be efficient.',
  'rule.clean_code_attribute.FOCUSED': 'Focused',
  'rule.clean_code_attribute.FOCUSED.title':
    'This is an adaptability rule, the code should be focused.',
  'rule.clean_code_attribute.FORMATTED': 'Formatted',
  'rule.clean_code_attribute.FORMATTED.title':
    'This is a consistency rule, the code should be formatted.',
  'rule.clean_code_attribute.IDENTIFIABLE': 'Identifiable',
  'rule.clean_code_attribute.IDENTIFIABLE.title':
    'This is a consistency rule, the code should be identifiable.',
  'rule.clean_code_attribute.LAWFUL': 'Lawful',
  'rule.clean_code_attribute.LAWFUL.title':
    'This is a responsibility rule, the code should be lawful.',
  'rule.clean_code_attribute.LOGICAL': 'Logical',
  'rule.clean_code_attribute.LOGICAL.title':
    'This is an intentionality rule, the code should be logical.',
  'rule.clean_code_attribute.MODULAR': 'Modular',
  'rule.clean_code_attribute.MODULAR.title':
    'This is an adaptability rule, the code should be modular.',
  'rule.clean_code_attribute.RESPECTFUL': 'Respectful',
  'rule.clean_code_attribute.RESPECTFUL.title':
    'This is a responsibility rule, the code should be respectful.',
  'rule.clean_code_attribute.TESTED': 'Tested',
  'rule.clean_code_attribute.TESTED.title':
    'This is an adaptability rule, the code should be tested.',
  'rule.clean_code_attribute.TRUSTWORTHY': 'Trustworthy',
  'rule.clean_code_attribute.TRUSTWORTHY.title':
    'This is a responsibility rule, the code should be trustworthy.',

  //------------------------------------------------------------------------------
  //
  // EMAIL NOTIFICATION CONFIGURATION
  //
  //------------------------------------------------------------------------------
  'email_notification.category': 'Email Notification',
  'email_notification.header': 'SMTP Configuration',
  'email_notification.description':
    'Follow the steps below to configure and test your authentication.',
  'email_notification.subheading.1':
    'Select your authentication type and complete the fields below',
  'email_notification.subheading.2': 'Complete the SMTP fields below',
  'email_notification.subheading.3':
    'Input the ‘sender’ information below to identify your email notification',
  'email_notification.form.auth_type': 'Authentication type',
  'email_notification.form.basic_auth.title': 'Basic Authentication',
  'email_notification.form.basic_auth.description': 'Authenticate with a username and password',
  'email_notification.form.username': 'SMTP username',
  'email_notification.form.username.description':
    'Username used to authenticate to the SMTP server.',
  'email_notification.form.basic_password': 'SMTP password',
  'email_notification.form.basic_password.description':
    'Password used to authenticate to the SMTP server.',
  'email_notification.form.oauth_auth.title': 'Modern Authentication',
  'email_notification.form.oauth_auth.description': 'Authenticate with OAuth',
  'email_notification.form.oauth_auth.supported': 'Supported providers: Microsoft',
  'email_notification.form.oauth_auth.recommended_reason': 'for stronger security compliance',
  'email_notification.form.oauth_authentication_host': 'Authentication host',
  'email_notification.form.oauth_authentication_host.description':
    'Host of the Identity Provider issuing access tokens.',
  'email_notification.form.oauth_client_id': 'Client ID',
  'email_notification.form.oauth_client_id.description':
    'Client ID provided by Microsoft Exchange when registering the application.',
  'email_notification.form.oauth_client_secret': 'Client Secret',
  'email_notification.form.oauth_client_secret.description':
    'Client password provided by Microsoft Exchange when registering the application.',
  'email_notification.form.oauth_tenant': 'Tenant',
  'email_notification.form.oauth_tenant.description': 'Microsoft tenant.',
  'email_notification.form.host': 'SMTP host',
  'email_notification.form.host.description': 'URL of your SMTP server.',
  'email_notification.form.port': 'SMTP port',
  'email_notification.form.port.description': 'Port of your SMTP server (usually 25, 587 or 465).',
  'email_notification.form.security_protocol': 'Security protocol',
  'email_notification.form.security_protocol.description':
    'Security protocol used to connect to your SMTP server (SSLTLS is recommended). Valid values: NONE, SSLTLS, STARTTLS.',
  'email_notification.form.from_address': 'From address',
  'email_notification.form.from_address.description': 'Address emails will come from.',
  'email_notification.form.from_name': 'From name',
  'email_notification.form.from_name.description':
    'Name emails will come from (usually "SonarQube").',
  'email_notification.form.subject_prefix': 'Subject prefix',
  'email_notification.form.subject_prefix.description':
    'Prefix added to email so they can be easily recognized (usually "[SonarQube]").',
  'email_notification.form.save_configuration': 'Save configuration',
  'email_notification.form.save_configuration.create_success':
    'Email configuration saved successfully.',
  'email_notification.form.save_configuration.update_success':
    'Email configuration updated successfully.',
  'email_notification.form.delete_configuration': 'Delete configuration',
  'email_notification.overview.heading': 'SMTP configuration settings',
  'email_notification.overview.authentication_type': 'Authentication type',
  'email_notification.overview.private': 'Hidden for security reasons',
  'email_notification.form.private': '**************',
  'email_notification.overview.value': '{0} value',
  'email_notification.test.title': 'Test configuration',
  'email_notification.test.modal_title': 'Test email',
  'email_notification.test.to_address': 'To',
  'email_notification.test.subject': 'Subject',
  'email_notification.test.message': 'Message',
  'email_notification.test.message_text': 'This is a test message from {productName}.',
  'email_notification.test.create_test_email': 'Create test email',
  'email_notification.test.submit': 'Send test email',
  'email_notification.test.success': 'Your email was sent successfully',
  'email_notification.test.failure':
    'Your email could not be sent. Ensure your authentication configuration settings and email recipient are valid.',
  'email_notification.state.value_should_be_valid_email': 'A valid email address is required.',

  //------------------------------------------------------------------------------
  //
  // NOTIFICATIONS
  //
  //------------------------------------------------------------------------------
  'notification.notification': 'Notification',
  'notification.for': 'Notify me for',
  'notification.by': 'by {channel}',
  'notification.channel.EmailNotificationChannel': 'Email',
  'notification.dispatcher.information': 'A notification is never sent to the author of the event.',
  'notification.dispatcher.ChangesOnMyIssue': 'Changes in issues/hotspots assigned to me',
  'notification.dispatcher.NewIssues': 'New issues',
  'notification.dispatcher.NewAlerts': 'Quality gate status changes on all available projects',
  'notification.dispatcher.NewAlerts.project': 'Quality gate status changes',
  'notification.dispatcher.NewFalsePositiveIssue': 'Issues resolved as false positive or accepted',
  'notification.dispatcher.SQ-MyNewIssues': 'My new issues',
  'notification.dispatcher.QualityGateConditionsMismatch':
    'Quality gate metrics mismatch with the mode of the instance',
  'notification.dispatcher.CeReportTaskFailure':
    'Background tasks in failure on my administered projects',
  'notification.dispatcher.CeReportTaskFailure.project': 'Background tasks in failure',
  'notification.dispatcher.description_x': 'Check to receive notification for {project}',
  'notification.dispatcher.group.label': 'Notifications for project {project}',
  'notification.calculation_change.message':
    'The way in which security, reliability, and maintainability counts and ratings are calculated has changed. <link>Learn more in SonarQube documentation</link>',
  'notification.non_production_database.warning':
    "Embedded database should be used for evaluation purposes only. It doesn't support scaling, upgrading to a new SonarQube Server version, or migration to another database engine. {link}",
  'notification.non_production_database.learn_more': 'Learn more',

  //------------------------------------------------------------------------------
  //
  // ALERTS
  //
  //------------------------------------------------------------------------------

  'alerts.operator.<': 'is less than',
  'alerts.operator.>': 'is greater than',
  'alerts.operator.=': 'equals',
  'alerts.operator.!=': 'is not',

  'alert.tooltip.error': 'This is an error message.',
  'alert.tooltip.warning': 'This is a warning message.',
  'alert.tooltip.success': 'This is a success message.',
  'alert.tooltip.info': 'This is an info message.',

  'alert.dismiss': 'Dismiss this message',

  //------------------------------------------------------------------------------
  //
  // USER
  //
  //------------------------------------------------------------------------------
  'user.password_doesnt_match_confirmation': "Password doesn't match confirmation.",
  'user.password.conditions': 'Your password must include at least:',
  'user.password.condition.12_characters': '12 characters',
  'user.password.condition.1_upper_case': '1 upper case letter',
  'user.password.condition.1_lower_case': '1 lower case letter',
  'user.password.condition.1_number': '1 number',
  'user.password.condition.1_special_character': '1 special character',
  'user.password.invalid': 'Your password must meet all the requirements.',
  'user.password.do_not_match': 'Passwords do not match.',
  'user.old_password_incorrect': 'Old password is incorrect',
  'user.new_password_same_as_old': 'New password must be different from old password',
  'user.login_or_email_used_as_scm_account':
    'Login and email are automatically considered as SCM accounts',
  'user.x_deleted': '{0} (deleted)',
  'user.confirm_password.no_match': 'Passwords do not match',

  'login.page': 'Log in',
  'login.login_to_sonarqube': 'Welcome to {productName}',
  'login.login_with_x': 'Log in with {providerName}',
  'login.more_options': 'Log in with credentials',
  'login.unauthorized_access_alert':
    'You are not authorized to access this page. Please log in with more privileges and try again.',
  'login.with_x': 'With {0}',
  'login.or': 'Or',
  'login.authentication_failed': 'Invalid username or password.',
  'login.logout_failed': 'Logout failed',
  'login.username.placeholder': 'Enter your username',
  'login.password.placeholder': 'Enter your password',
  'login.hide_password': 'Hide password',
  'login.show_password': 'Show password',
  'login.marketing.background.alt': 'SonarQube whale logo',
  'login.marketing.logo.alt': 'Sonar logo',
  'login.marketing.title': 'SonarQube Server: Your independent code verification layer',
  'login.marketing.description':
    'SonarQube Server provides deep analysis to ensure all your code, human-written and AI-generated, is secure and high quality.',
  'login.marketing.continuous_verification': 'Continuous Verification: ',
  'login.marketing.continuous_verification.description':
    'Automatically reviews your code in real-time, helping you eliminate security risks, bugs, and technical debt before they reach production.',
  'login.marketing.devsecops_integrated': 'DevSecOps integrated: ',
  'login.marketing.devsecops_integrated.description':
    'Works seamlessly within your existing CI/CD workflow, including integrations with tools like GitHub Actions, GitLab CI/CD, and Jenkins.',
  'login.marketing.empowering_developers': 'Empowering developers: ',
  'login.marketing.empowering_developers.description':
    'SonarQube for IDE in connected mode enables developers to receive real-time, actionable code intelligence and guidance to resolve issues quickly.',

  'unauthorized.page': 'Unauthorized',
  'unauthorized.message':
    "You're not authorized to access this page. Please contact the administrator.",
  'unauthorized.reason': 'Reason:',

  //------------------------------------------------------------------------------
  //
  // MY PROFILE & MY ACCOUNT
  //
  //------------------------------------------------------------------------------
  'my_profile.login': 'Login',
  'my_profile.email': 'Email',
  'my_profile.groups': 'Groups',
  'my_profile.scm_accounts': 'SCM Accounts',
  'my_profile.scm_accounts.tooltip':
    'SCM accounts are used for automatic issue assignment. Login and email are automatically considered as SCM account.',
  'my_profile.password.title': 'Enter a new password',
  'my_profile.password.old': 'Old Password',
  'my_profile.password.changed': 'The password has been changed!',
  'my_profile.notifications.submit': 'Save changes',
  'my_profile.overall_notifications.title': 'General notifications',
  'my_profile.per_project_notifications.title': 'Notifications per project',
  'my_profile.per_project_notifications.add': 'Add a project',
  'my_profile.per_project_notifications.edit': 'Set notifications',
  'my_profile.per_project_notifications.filter': 'Filter projects',
  'my_profile.news_notifications.title': 'SonarQube new features notifications',
  'my_profile.news_notifications.label':
    'Display a notification count in the header when new features are deployed',

  'my_account.page': 'My Account',
  'my_account.notifications': 'Notifications',
  'my_account.no_project_notifications': 'You have not set project notifications yet.',
  'my_account.profile': 'Profile',
  'my_account.security': 'Security',
  'my_account.tokens_description':
    "If you want to enforce security by not providing credentials of a real {instance} user to run your code scan or to invoke web services, you can provide a User Token as a replacement of the user login. This will increase the security of your installation by not letting your analysis user's password going through your network.",
  'my_account.token_type': 'Type',
  'my_account.project_name': 'Project',
  'my_account.tokens_last_usage': 'Last use',
  'my_account.tokens.expiration': 'Expiration',
  'my_account.tokens.expired': 'Token is expired',
  'my_account.projects': 'Projects',
  'my_account.projects.description': 'You have admin privileges over the following projects.',
  'my_account.projects.no_results': 'You have no project admin privileges.',
  'my_account.projects.analyzed_x': 'Analyzed {0}',
  'my_account.projects.never_analyzed': 'Never analyzed',
  'my_account.search_project': 'Search Project',
  'my_account.set_notifications_for': 'Search for a project by name',
  'my_account.set_notifications_for.title': 'Add a project',
  'my_account.set_notifications_for.help': 'Minimum 2 characters',
  'my_account.create_new.TRK': 'Add a project',
  'my_account.add_project': 'Add Project',
  'my_account.add_project.manual': 'Local project',
  'my_account.add_project.azure': 'From Azure DevOps',
  'my_account.add_project.bitbucket': 'From Bitbucket Server',
  'my_account.add_project.bitbucketcloud': 'From Bitbucket Cloud',
  'my_account.add_project.github': 'From GitHub',
  'my_account.add_project.gitlab': 'From GitLab',
  'my_account.add_project.more_others': 'Import from other DevOps Platforms',
  'my_account.add_project.more': 'Import from DevOps Platforms',
  'my_account.reset_password.page': 'Update password',
  'my_account.reset_password': 'Update your password',
  'my_account.reset_password.explain': 'This account should not use the default password.',

  'my_account.create_new_project_portfolio_or_application':
    'Analyze new project / Create new portfolio or application',

  'my_account.preferences': 'Preferences',
  'my_account.preferences.keyboard_shortcuts': 'Enable Keyboard Shortcuts',
  'my_account.preferences.keyboard_shortcuts.description':
    "Some actions can be performed using keyboard shortcuts. If you do not want to use these shortcuts, you can disable them here (this won't disable navigation shortcuts, which include the arrows, escape, and enter keys). For a list of available keyboard shortcuts, use the question mark shortcut (hit {questionMark} on your keyboard).",

  //------------------------------------------------------------------------------
  //
  // PROJECT PROVISIONING
  //
  //------------------------------------------------------------------------------
  'provisioning.no_analysis':
    'No analysis has been performed since creation. The only available section is the configuration.',
  'provisioning.no_analysis.delete': 'Either you should retry analysis or simply {link}.',
  'provisioning.no_analysis.delete_project': 'delete the project',
  'provisioning.no_analysis_on_main_branch': '"{0}" branch has not been analyzed yet.',
  'provisioning.no_analysis_on_main_branch.bad_configuration':
    '"{0}" branch has not been analyzed yet and you have multiple branches already. It looks like it is not your {1}, check your configuration.',
  'provisioning.only_provisioned': 'Only Provisioned',
  'provisioning.only_provisioned.tooltip':
    'Provisioned projects are projects that have been created, but have not been analyzed yet.',
  'provisioning.no_analysis.application':
    'No analysis has been performed since creation. Analyze a project to see information here.',
  'provisioning.permission_synch_in_progress':
    'Project permissions are being synchronized from {0}.',

  //------------------------------------------------------------------------------
  //
  // SEVERITIES
  //
  //------------------------------------------------------------------------------

  'severity.BLOCKER': 'Blocker',
  'severity.BLOCKER.description': 'Must be fixed immediately.',
  'severity.CRITICAL': 'Critical',
  'severity.CRITICAL.description': 'Must be reviewed immediately and fixed soon.',
  'severity.MAJOR': 'Major',
  'severity.MAJOR.description': 'High potential for significant to moderate impact.',
  'severity.MINOR': 'Minor',
  'severity.MINOR.description': 'Potential for moderate to minor impact.',
  'severity.INFO': 'Info',
  'severity.INFO.description': 'Neither a bug nor a quality flaw. Just a finding.',

  // New severities
  'severity_impact.title': '{x} severity of impact',
  'severity_impact.levels': 'Severity levels',
  'severity_impact.BLOCKER': 'Blocker',
  'severity_impact.BLOCKER.description': 'Must be fixed immediately.',
  'severity_impact.HIGH': 'High',
  'severity_impact.HIGH.description': 'Must be reviewed immediately and fixed soon.',
  'severity_impact.MEDIUM': 'Medium',
  'severity_impact.MEDIUM.description': 'High potential for significant to moderate impact.',
  'severity_impact.LOW': 'Low',
  'severity_impact.LOW.description': 'Potential for moderate to minor impact.',
  'severity_impact.INFO': 'Info',
  'severity_impact.INFO.description': 'Neither a bug nor a quality flaw. Just a finding.',
  'severity_impact.help.description':
    '<p1>Severities are now directly tied to the software quality impacted. This means that one software quality impacted has one severity.</p1><p>They can be changed with sufficient permissions.</p>',
  'severity_impact.help.link': 'Learn more about severity and software qualities',

  'severity.icon.label': 'Severity: {severity}',
  //------------------------------------------------------------------------------
  //
  // SOFTWARE QUALITIES
  //
  //------------------------------------------------------------------------------

  software_quality: 'Software Quality',
  'software_quality.SECURITY': 'Security',
  'software_quality.RELIABILITY': 'Reliability',
  'software_quality.MAINTAINABILITY': 'Maintainability',

  'software_impact.button.popover':
    '{severity} severity impact on {quality}. Click for more information.',
  'software_impact.button.change':
    '{severity} severity impact on {quality}. Click to change the severity.',

  //------------------------------------------------------------------------------
  //
  // METRIC DOMAINS
  //
  //------------------------------------------------------------------------------

  'metric_domain.Size': 'Size',
  'metric_domain.Tests': 'Tests',
  'metric_domain.Integration Tests': 'Integration Tests',
  'metric_domain.Complexity': 'Complexity',
  'metric_domain.Documentation': 'Documentation',
  'metric_domain.Rules': 'Rules',
  'metric_domain.General': 'General',
  'metric_domain.Duplication': 'Duplication',
  'metric_domain.Design': 'Design',
  'metric_domain.SCM': 'SCM',
  'metric_domain.Maintainability': 'Maintainability',
  'metric_domain.Releasability': 'Releasability',
  'metric_domain.Reliability': 'Reliability',
  'metric_domain.Security': 'Security',
  'metric_domain.SecurityReview': 'Security Review',
  'metric_domain.Issues': 'Issues',
  'metric_domain.Duplications': 'Duplications',
  'metric_domain.Coverage': 'Coverage',
  'metric_domain.DependencyRisks': 'Dependency Risks',

  //--------------------------------------------------------------------------------------------------------------------
  //
  // METRIC TYPES
  //
  //--------------------------------------------------------------------------------------------------------------------

  'metric.type.INT': 'Integer',
  'metric.type.FLOAT': 'Float',
  'metric.type.PERCENT': 'Percent',
  'metric.type.BOOL': 'Boolean',
  'metric.type.STRING': 'String',
  'metric.type.MILLISEC': 'Milliseconds',
  'metric.type.DATA': 'Data',
  'metric.type.LEVEL': 'Level',
  'metric.type.DISTRIB': 'Distribution',
  'metric.type.RATING': 'Rating',
  'metric.type.SCA_RISK': 'Dependency Risk Severity',
  'metric.type.WORK_DUR': 'Work Duration',

  'metric.level.ERROR': 'Failed',
  'metric.level.WARN': 'Warning',
  'metric.level.OK': 'Passed',
  'metric.level.NONE': 'None',

  //------------------------------------------------------------------------------
  //
  // METRICS
  //
  //------------------------------------------------------------------------------

  'metric.abstractness.description': 'Abstractness',
  'metric.abstractness.name': 'Abstractness',
  'metric.accessors.description': 'Accessors',
  'metric.accessors.name': 'Accessors',
  'metric.alert_status.description': 'The project status with regard to its quality gate.',
  'metric.alert_status.name': 'Quality Gate Status',
  'metric.authors_by_line.description': 'Authors by line',
  'metric.authors_by_line.name': 'Authors by Line',
  'metric.blocker_violations.description': 'Blocker issues',
  'metric.blocker_violations.name': 'Blocker Issues',
  'metric.branch_coverage.description': 'Condition coverage',
  'metric.branch_coverage.name': 'Condition Coverage',
  'metric.bugs.description': 'Bugs',
  'metric.bugs.name': 'Bugs',
  'metric.bugs.short_name': 'Bugs',
  'metric.ca.description': 'Afferent couplings',
  'metric.ca.name': 'Afferent Couplings',
  'metric.ce.description': 'Efferent couplings',
  'metric.ce.name': 'Efferent Couplings',
  'metric.classes.description': 'Classes',
  'metric.classes.name': 'Classes',
  'metric.code_smells.description': 'Code Smells',
  'metric.code_smells.name': 'Code Smells',
  'metric.code_smells.short_name': 'Code Smells',
  'metric.cognitive_complexity.description': 'Cognitive complexity',
  'metric.cognitive_complexity.name': 'Cognitive Complexity',
  'metric.commented_out_code_lines.description': 'Commented lines of code',
  'metric.commented_out_code_lines.name': 'Commented-Out LOC',
  'metric.comment_blank_lines.description': 'Comments that do not contain comments',
  'metric.comment_blank_lines.name': 'Blank Comments',
  'metric.comment_lines.description': 'Number of comment lines',
  'metric.comment_lines.name': 'Comment Lines',
  'metric.comment_lines_density.description': 'Comments balanced by ncloc + comment lines',
  'metric.comment_lines_density.name': 'Comments (%)',
  'metric.comment_lines_density.short_name': 'Comments',
  'metric.complexity.description': 'Cyclomatic complexity',
  'metric.complexity.name': 'Cyclomatic Complexity',
  'metric.conditions_by_line.description': 'Conditions by line',
  'metric.conditions_by_line.name': 'Conditions by Line',
  'metric.conditions_to_cover.description': 'Conditions to cover',
  'metric.conditions_to_cover.name': 'Conditions to Cover',
  'metric.confirmed_issues.description': 'Confirmed issues',
  'metric.confirmed_issues.name': 'Confirmed Issues',
  'metric.coverage.description': 'Coverage by tests',
  'metric.coverage.description.positive': 'Overall code has sufficient test coverage',
  'metric.coverage.name': 'Coverage',
  'metric.coverage_line_hits_data.description': 'Coverage hits by line',
  'metric.coverage_line_hits_data.name': 'Coverage Hits by Line',
  'metric.covered_conditions.description': 'Covered conditions',
  'metric.covered_conditions.name': 'Covered Conditions',
  'metric.covered_conditions_by_line.description': 'Covered conditions by line',
  'metric.covered_conditions_by_line.name': 'Covered Conditions by Line',
  'metric.covered_lines.description': 'Covered lines',
  'metric.covered_lines.name': 'Covered Lines',
  'metric.critical_violations.description': 'Critical issues',
  'metric.critical_violations.name': 'Critical Issues',
  'metric.development_cost.description': 'Development cost',
  'metric.development_cost.name': 'Development Cost',
  'metric.directories.description': 'Directories',
  'metric.directories.name': 'Directories',
  'metric.distance.description': 'Distance',
  'metric.distance.name': 'Distance',
  'metric.dit.description': 'Depth in Inheritance Tree',
  'metric.dit.name': 'Depth in Tree',
  'metric.dsm.description': 'Dependency Matrix',
  'metric.dsm.name': 'Dependency Matrix',
  'metric.duplicated_blocks.description': 'Duplicated blocks',
  'metric.duplicated_blocks.name': 'Duplicated Blocks',
  'metric.duplicated_files.description': 'Duplicated files',
  'metric.duplicated_files.name': 'Duplicated Files',
  'metric.duplicated_lines.description': 'Duplicated lines',
  'metric.duplicated_lines.name': 'Duplicated Lines',
  'metric.duplicated_lines_density.description': 'Duplicated lines balanced by statements',
  'metric.duplicated_lines_density.name': 'Duplicated Lines (%)',
  'metric.duplicated_lines_density.short_name': 'Duplications',
  'metric.duplicated_lines_density.extra_short_name': 'Density',
  'metric.duplications_data.description': 'Duplications details',
  'metric.duplications_data.name': 'Duplication Details',
  'metric.efficiency.description': 'Efficiency',
  'metric.efficiency.name': 'Efficiency',
  'metric.effort_to_reach_maintainability_rating_a.description':
    'Effort to reach maintainability rating A',
  'metric.effort_to_reach_maintainability_rating_a.name':
    'Effort to Reach Maintainability Rating A',
  'metric.effort_to_reach_maintainability_rating_a.extra_short_name': 'Effort to Reach A',
  'metric.effort_to_reach_software_quality_maintainability_rating_a.description':
    'Effort to reach maintainability rating A',
  'metric.effort_to_reach_software_quality_maintainability_rating_a.name':
    'Effort to Reach Maintainability Rating A',
  'metric.effort_to_reach_software_quality_maintainability_rating_a.extra_short_name':
    'Effort to Reach A',
  'metric.false_positive_issues.description': 'False positive issues',
  'metric.false_positive_issues.name': 'False Positive Issues',
  'metric.files.description': 'Number of files',
  'metric.files.name': 'Files',
  'metric.file_cycles.description': 'File cycles',
  'metric.file_cycles.name': 'File Cycles',
  'metric.file_edges_weight.description': 'File edges weight',
  'metric.file_edges_weight.name': 'File Edges Weight',
  'metric.file_feedback_edges.description': 'Suspect file dependencies',
  'metric.file_feedback_edges.name': 'Suspect File Dependencies',
  'metric.file_tangles.description': 'Files tangles',
  'metric.file_tangles.name': 'File Tangles',
  'metric.file_tangle_index.description': 'File tangle index',
  'metric.file_tangle_index.name': 'File Tangle Index',
  'metric.functions.description': 'Functions',
  'metric.functions.name': 'Functions',
  'metric.generated_lines.description': 'Number of generated lines',
  'metric.generated_lines.name.suffix': 'generated lines',
  'metric.generated_lines.name': 'Generated Lines',
  'metric.generated_ncloc.description': 'Generated non Commenting Lines of Code',
  'metric.generated_ncloc.name.suffix': 'generated lines of code',
  'metric.generated_ncloc.name': 'Generated Lines of Code',
  'metric.has_rating_X': 'Has rating: {0}',
  'metric.no_rating': 'Has no rating',
  'metric.info_violations.description': 'Info issues',
  'metric.info_violations.name': 'Info Issues',
  'metric.instability.description': 'Instability',
  'metric.instability.name': 'Instability',
  'metric.it_branch_coverage.description': 'Condition coverage by integration tests',
  'metric.it_branch_coverage.name': 'IT Condition Coverage',
  'metric.it_conditions_by_line.description': 'IT conditions by line',
  'metric.it_conditions_by_line.name': 'IT Conditions by Line',
  'metric.it_conditions_to_cover.description': 'Conditions to cover by integration tests',
  'metric.it_conditions_to_cover.name': 'IT Conditions to Cover',
  'metric.it_coverage.description': 'Integration tests coverage',
  'metric.it_coverage.name': 'IT Coverage',
  'metric.it_coverage_line_hits_data.description': 'Coverage hits by line by integration tests',
  'metric.it_coverage_line_hits_data.name': 'IT Coverage Hits by Line',
  'metric.it_covered_conditions_by_line.description': 'IT covered conditions by line',
  'metric.it_covered_conditions_by_line.name': 'IT Covered Conditions by Line',
  'metric.it_lines_to_cover.description': 'Lines to cover by integration tests',
  'metric.it_lines_to_cover.name': 'IT Lines to Cover',
  'metric.it_line_coverage.description': 'Line coverage by integration tests',
  'metric.it_line_coverage.name': 'IT Line Coverage',
  'metric.it_uncovered_conditions.description': 'Uncovered conditions by integration tests',
  'metric.it_uncovered_conditions.name': 'IT Uncovered Conditions',
  'metric.it_uncovered_lines.description': 'Uncovered lines by integration tests',
  'metric.it_uncovered_lines.name': 'IT Uncovered Lines',
  'metric.last_commit_date.name': 'Date of Last Commit',
  'metric.last_commit_datetimes_by_line.description': 'Last commit dates by line',
  'metric.last_commit_datetimes_by_line.name': 'Last Commit Dates by Line',
  'metric.lcom4.description': 'Lack of Cohesion of Functions',
  'metric.lcom4.name': 'LCOM4',
  'metric.lcom4_blocks.description': 'LCOM4 blocks',
  'metric.lcom4_blocks.name': 'LCOM4 Blocks',
  'metric.lcom4_distribution.description': 'Class distribution /LCOM4',
  'metric.lcom4_distribution.name': 'Class Distribution / LCOM4',
  'metric.lines.description': 'Lines',
  'metric.lines.name': 'Lines',
  'metric.lines_to_cover.description': 'Lines to cover',
  'metric.lines_to_cover.name': 'Lines to Cover',
  'metric.line_coverage.description': 'Line coverage',
  'metric.line_coverage.name': 'Line Coverage',
  'metric.maintainability.description': 'Maintainability',
  'metric.maintainability.name': 'Maintainability',
  'metric.major_violations.description': 'Major issues',
  'metric.major_violations.name': 'Major Issues',
  'metric.minor_violations.description': 'Minor issues',
  'metric.minor_violations.name': 'Minor Issues',
  'metric.ncloc.name': 'Lines of Code',
  'metric.ncloc.description': 'Non commenting lines of code',
  'metric.ncloc_language_distribution.description':
    'Non Commenting Lines of Code Distributed By Language',
  'metric.ncloc_language_distribution.name': 'Lines of Code Per Language',
  'metric.new_blocker_violations.description': 'New Blocker issues',
  'metric.new_blocker_violations.name': 'New Blocker Issues',
  'metric.new_blocker_violations.short_name': 'Blocker Issues',
  'metric.new_branch_coverage.description': 'Condition coverage of new/changed code',
  'metric.new_branch_coverage.name': 'Condition Coverage on New Code',
  'metric.new_branch_coverage.extra_short_name': 'Condition Coverage',
  'metric.new_bugs.description': 'New Bugs',
  'metric.new_bugs.name': 'New Bugs',
  'metric.new_bugs.short_name': 'Bugs',
  'metric.new_code_smells.description': 'New Code Smells',
  'metric.new_code_smells.name': 'New Code Smells',
  'metric.new_code_smells.short_name': 'Code Smells',
  'metric.new_conditions_to_cover.description': 'Conditions to cover on new code',
  'metric.new_conditions_to_cover.name': 'Conditions to Cover on New Code',
  'metric.new_conditions_to_cover.extra_short_name': 'Conditions to Cover',
  'metric.new_coverage.description': 'Coverage of new/changed code',
  'metric.new_coverage.description.positive': 'New code has sufficient test coverage',
  'metric.new_coverage.name': 'Coverage on New Code',
  'metric.new_coverage.short_name': 'Coverage',
  'metric.new_critical_violations.description': 'New Critical issues',
  'metric.new_critical_violations.name': 'New Critical Issues',
  'metric.new_critical_violations.short_name': 'Critical Issues',
  'metric.new_development_cost.description': 'Development cost on new code',
  'metric.new_development_cost.name': 'Development Cost on New Code',
  'metric.new_duplicated_blocks.name': 'Duplicated Blocks on New Code',
  'metric.new_duplicated_blocks.extra_short_name': 'Duplicated Blocks',
  'metric.new_duplicated_blocks.description': 'Duplicated blocks on new code',
  'metric.new_duplicated_lines.name': 'Duplicated Lines on New Code',
  'metric.new_duplicated_lines.extra_short_name': 'Duplicated Lines',
  'metric.new_duplicated_lines.description': 'Duplicated Lines on New Code',
  'metric.new_duplicated_lines_density.description':
    'Duplicated lines (%) on new code balanced by statements',
  'metric.new_duplicated_lines_density.description.positive': 'New code has limited duplications',
  'metric.new_duplicated_lines_density.name': 'Duplicated Lines (%) on New Code',
  'metric.new_duplicated_lines_density.short_name': 'Duplications',
  'metric.new_duplicated_lines_density.extra_short_name': 'Density',
  'metric.new_info_violations.description': 'New Info issues',
  'metric.new_info_violations.name': 'New Info Issues',
  'metric.new_info_violations.short_name': 'Info Issues',
  'metric.new_it_branch_coverage.description':
    'Integration tests condition coverage of new/changed code',
  'metric.new_it_branch_coverage.name': 'Condition Coverage by IT on New Code',
  'metric.new_it_conditions_to_cover.description': 'New conditions to cover by integration tests',
  'metric.new_it_conditions_to_cover.name': 'Conditions to Cover by IT on New Code',
  'metric.new_it_coverage.description': 'Integration tests coverage of new/changed code',
  'metric.new_it_coverage.name': 'Coverage by IT on New Code',
  'metric.new_it_lines_to_cover.description': 'Lines to cover on new code by integration tests',
  'metric.new_it_lines_to_cover.name': 'Lines to Cover by IT on New Code',
  'metric.new_it_line_coverage.description':
    'Integration tests line coverage of added/changed code',
  'metric.new_it_line_coverage.name': 'Line Coverage by IT on New Code',
  'metric.new_it_uncovered_conditions.description':
    'New conditions that are not covered by integration tests',
  'metric.new_it_uncovered_conditions.name': 'Uncovered Conditions by IT on New Code',
  'metric.new_it_uncovered_lines.description':
    'New lines that are not covered by integration tests',
  'metric.new_it_uncovered_lines.name': 'Uncovered Lines by IT on New Code',
  'metric.new_lines_to_cover.description': 'Lines to cover on new code',
  'metric.new_lines_to_cover.name': 'Lines to Cover on New Code',
  'metric.new_lines_to_cover.extra_short_name': 'Lines to Cover',
  'metric.new_line_coverage.description': 'Line coverage of added/changed code',
  'metric.new_line_coverage.name': 'Line Coverage on New Code',
  'metric.new_line_coverage.extra_short_name': 'Line Coverage',
  'metric.new_maintainability_rating.description': 'Maintainability rating on new code',
  'metric.new_maintainability_rating.name': 'Maintainability Rating on New Code',
  'metric.new_maintainability_rating.extra_short_name': 'Rating',
  'metric.new_software_quality_maintainability_rating.description':
    'Maintainability rating on new code',
  'metric.new_software_quality_maintainability_rating.name': 'Maintainability Rating on New Code',
  'metric.new_software_quality_maintainability_rating.extra_short_name': 'Rating',
  'metric.new_major_violations.description': 'New Major issues',
  'metric.new_major_violations.name': 'New Major Issues',
  'metric.new_major_violations.short_name': 'Major Issues',
  'metric.new_minor_violations.description': 'New Minor issues',
  'metric.new_minor_violations.name': 'New Minor Issues',
  'metric.new_minor_violations.short_name': 'Minor Issues',
  'metric.new_lines.name': 'New Lines',
  'metric.new_lines.description': 'New lines',
  'metric.new_lines.short_name': 'Lines',
  'metric.new_overall_branch_coverage.description':
    'Condition coverage of new/changed code by all tests',
  'metric.new_overall_branch_coverage.name': 'Overall Condition Coverage on New Code',
  'metric.new_overall_conditions_to_cover.description': 'New conditions to cover by all tests',
  'metric.new_overall_conditions_to_cover.name': 'Overall Conditions to Cover on New Code',
  'metric.new_overall_coverage.description': 'Overall coverage of new/changed code',
  'metric.new_overall_coverage.name': 'Overall Coverage on New Code',
  'metric.new_overall_lines_to_cover.description': 'New lines to cover by all tests',
  'metric.new_overall_lines_to_cover.name': 'Overall Lines to Cover on New Code',
  'metric.new_overall_line_coverage.description':
    'Line coverage of added/changed code by all tests',
  'metric.new_overall_line_coverage.name': 'Overall Line Coverage on New Code',
  'metric.new_overall_uncovered_conditions.description':
    'New conditions that are not covered by any test',
  'metric.new_overall_uncovered_conditions.name': 'Overall Uncovered Conditions on New Code',
  'metric.new_overall_uncovered_lines.description': 'New lines that are not covered by any tests',
  'metric.new_overall_uncovered_lines.name': 'Overall Uncovered Lines on New Code',
  'metric.new_reliability_rating.description': 'Reliability rating on new code',
  'metric.new_reliability_rating.name': 'Reliability Rating on New Code',
  'metric.new_reliability_rating.extra_short_name': 'Rating',
  'metric.new_software_quality_reliability_rating.description': 'Reliability rating on new code',
  'metric.new_software_quality_reliability_rating.name': 'Reliability Rating on New Code',
  'metric.new_software_quality_reliability_rating.extra_short_name': 'Rating',
  'metric.new_reliability_remediation_effort.description':
    'Reliability remediation effort on new code',
  'metric.new_reliability_remediation_effort.name': 'Reliability Remediation Effort on New Code',
  'metric.new_reliability_remediation_effort.extra_short_name': 'Remediation Effort',
  'metric.new_sca_count_any_issue.description': 'Number of dependencies with any risk',
  'metric.new_sca_count_any_issue.name': 'Dependency risks',
  'metric.new_sca_count_vulnerabilities.description': 'Number of dependencies with vulnerabilities',
  'metric.new_sca_count_vulnerabilities.name': 'Vulnerable dependency risks',
  'metric.new_sca_count_licensing.description': 'Number of dependencies with prohibited licenses',
  'metric.new_sca_count_licensing.name': 'Prohibited license dependency risks',
  'metric.new_sca_count_malware.description': 'Malware dependency risks',
  'metric.new_sca_count_malware.name': 'New malware dependency risks',
  'metric.new_software_quality_reliability_remediation_effort.description':
    'Reliability remediation effort on new code',
  'metric.new_software_quality_reliability_remediation_effort.name':
    'Reliability Remediation Effort on New Code',
  'metric.new_software_quality_reliability_remediation_effort.extra_short_name':
    'Remediation Effort',
  'metric.new_security_hotspots.description': 'New Security Hotspots',
  'metric.new_security_hotspots.name': 'New Security Hotspots',
  'metric.new_security_hotspots.short_name': 'Security Hotspots',
  'metric.new_security_hotspots_reviewed.description':
    'Percentage of Security Hotspots Reviewed on New Code',
  'metric.new_security_hotspots_reviewed.description.positive':
    'All new security hotspots are reviewed',
  'metric.new_security_hotspots_reviewed.name': 'Security Hotspots Reviewed on New Code',
  'metric.new_security_hotspots_reviewed.short_name': 'Security Hotspots Reviewed',
  'metric.new_security_hotspots_reviewed_status.description':
    'Security Review Reviewed Status on New Code',
  'metric.new_security_hotspots_reviewed_status.name':
    'Security Review Reviewed Status on New Code',
  'metric.new_security_hotspots_to_review_status.description':
    'Security Review To Review Status on New Code',
  'metric.new_security_hotspots_to_review_status.name':
    'Security Review To Review Status on New Code',
  'metric.new_security_rating.description': 'Security rating on new code',
  'metric.new_security_rating.name': 'Security Rating on New Code',
  'metric.new_security_rating.extra_short_name': 'Rating',
  'metric.new_software_quality_security_rating.description': 'Security rating on new code',
  'metric.new_software_quality_security_rating.name': 'Security Rating on New Code',
  'metric.new_software_quality_security_rating.extra_short_name': 'Rating',
  'metric.new_security_remediation_effort.description': 'Security remediation effort on new code',
  'metric.new_security_remediation_effort.name': 'Security Remediation Effort on New Code',
  'metric.new_security_remediation_effort.extra_short_name': 'Remediation Effort',
  'metric.new_software_quality_security_remediation_effort.description':
    'Security remediation effort on new code',
  'metric.new_software_quality_security_remediation_effort.name':
    'Security Remediation Effort on New Code',
  'metric.new_software_quality_security_remediation_effort.extra_short_name': 'Remediation Effort',
  'metric.new_security_review_rating.description': 'Security Review Rating on New Code',
  'metric.new_security_review_rating.name': 'Security Review Rating on New Code',
  'metric.new_security_review_rating.extra_short_name': 'Rating',
  'metric.new_sqale_debt_ratio.description': 'Technical Debt Ratio of new/changed code.',
  'metric.new_sqale_debt_ratio.name': 'Technical Debt Ratio on New Code',
  'metric.new_sqale_debt_ratio.short_name': 'Debt Ratio on new code',
  'metric.new_sqale_debt_ratio.extra_short_name': 'Debt Ratio',
  'metric.new_software_quality_maintainability_debt_ratio.description':
    'Technical Debt Ratio of new/changed code.',
  'metric.new_software_quality_maintainability_debt_ratio.name': 'Technical Debt Ratio on New Code',
  'metric.new_software_quality_maintainability_debt_ratio.short_name': 'Debt Ratio on new code',
  'metric.new_software_quality_maintainability_debt_ratio.extra_short_name': 'Debt Ratio',
  'metric.new_technical_debt.description': 'Added technical debt',
  'metric.new_technical_debt.name': 'Added Technical Debt',
  'metric.new_technical_debt.short_name': 'Added Debt',
  'metric.new_technical_debt.extra_short_name': 'Debt',
  'metric.new_software_quality_maintainability_remediation_effort.description':
    'Added technical debt',
  'metric.new_software_quality_maintainability_remediation_effort.name': 'Added Technical Debt',
  'metric.new_software_quality_maintainability_remediation_effort.short_name': 'Added Debt',
  'metric.new_software_quality_maintainability_remediation_effort.extra_short_name': 'Debt',
  'metric.new_uncovered_conditions.description': 'Uncovered conditions on new code',
  'metric.new_uncovered_conditions.name': 'Uncovered Conditions on New Code',
  'metric.new_uncovered_conditions.extra_short_name': 'Uncovered Conditions',
  'metric.new_uncovered_lines.description': 'Uncovered lines on new code',
  'metric.new_uncovered_lines.name': 'Uncovered Lines on New Code',
  'metric.new_uncovered_lines.extra_short_name': 'Uncovered Lines',
  'metric.new_violations.description': 'New issues',
  'metric.new_violations.description.positive': 'New code has 0 issues',
  'metric.new_violations.name': 'New Issues',
  'metric.new_vulnerabilities.description': 'New Vulnerabilities',
  'metric.new_vulnerabilities.name': 'New Vulnerabilities',
  'metric.new_vulnerabilities.short_name': 'Vulnerabilities',
  'metric.noc.description': 'Number of Children',
  'metric.noc.name': 'Number of Children',
  'metric.open_issues.description': 'Open issues',
  'metric.open_issues.name': 'Open Issues',
  'metric.overall_branch_coverage.description': 'Condition coverage by all tests',
  'metric.overall_branch_coverage.name': 'Overall Condition Coverage',
  'metric.overall_conditions_by_line.description': 'Overall conditions by all tests and by line',
  'metric.overall_conditions_by_line.name': 'Overall Conditions by Line',
  'metric.overall_conditions_to_cover.description': 'Conditions to cover by all tests',
  'metric.overall_conditions_to_cover.name': 'Overall Conditions to Cover',
  'metric.overall_coverage.description': 'Overall test coverage',
  'metric.overall_coverage.name': 'Overall Coverage',
  'metric.overall_coverage_line_hits_data.description': 'Coverage hits by all tests and by line',
  'metric.overall_coverage_line_hits_data.name': 'Overall Coverage Hits by Line',
  'metric.overall_covered_conditions_by_line.description':
    'Overall covered conditions by all tests and by line',
  'metric.overall_covered_conditions_by_line.name': 'Overall Covered Conditions by Line',
  'metric.overall_lines_to_cover.description': 'Lines to cover by all tests',
  'metric.overall_lines_to_cover.name': 'Overall Lines to Cover',
  'metric.overall_line_coverage.description': 'Line coverage by all tests',
  'metric.overall_line_coverage.name': 'Overall Line Coverage',
  'metric.overall_uncovered_conditions.description': 'Uncovered conditions by all tests',
  'metric.overall_uncovered_conditions.name': 'Overall Uncovered Conditions',
  'metric.overall_uncovered_lines.description': 'Uncovered lines by all tests',
  'metric.overall_uncovered_lines.name': 'Overall Uncovered Lines',
  'metric.packages.description': 'Packages',
  'metric.packages.name': 'Packages',
  'metric.package_cycles.description': 'Package cycles',
  'metric.package_cycles.name': 'Package Cycles',
  'metric.package_edges_weight.description': 'Package edges weight',
  'metric.package_edges_weight.name': 'Package Edges Weight',
  'metric.package_feedback_edges.description': 'Package dependencies to cut',
  'metric.package_feedback_edges.name': 'Package Dependencies to Cut',
  'metric.package_tangles.description': 'File dependencies to cut',
  'metric.package_tangles.name': 'File Dependencies to Cut',
  'metric.package_tangle_index.description': 'Package tangle index',
  'metric.package_tangle_index.name': 'Package Tangle Index',
  'metric.portability.description': 'Portability',
  'metric.portability.name': 'Portability',
  'metric.prioritized_rule_issues.name': 'Issues from prioritized rules',
  'metric.prioritized_rule_issues.description': 'Issues from prioritized rules',
  'metric.profile.description': 'Selected Quality Profile',
  'metric.profile.name': 'Profile',
  'metric.profile_version.description': 'Selected Quality Profile version',
  'metric.profile_version.name': 'Profile Version',
  'metric.projects.description': 'Number of project branches',
  'metric.projects.name': 'Project branches',
  'metric.public_api.description': 'Public API',
  'metric.public_api.name': 'Public API',
  'metric.public_documented_api_density.description':
    'Public documented classes and functions balanced by ncloc',
  'metric.public_documented_api_density.name': 'Public Documented API (%)',
  'metric.public_undocumented_api.description':
    'Public undocumented classes, functions and variables',
  'metric.public_undocumented_api.name': 'Public Undocumented API',
  'metric.quality_gate_details.description':
    'The project detailed status with regard to its quality gate',
  'metric.quality_gate_details.name': 'Quality Gate Details',
  'metric.quality_profiles.description': 'Details of Quality Profiles used during analysis',
  'metric.quality_profiles.name': 'Profiles',
  'metric.reliability.description': 'Reliability',
  'metric.reliability.name': 'Reliability',
  'metric.reliability_rating.description': 'Reliability rating',
  'metric.reliability_rating.description.positive': 'Overall code has no critical bugs',
  'metric.reliability_rating.name': 'Reliability Rating',
  'metric.reliability_rating.extra_short_name': 'Rating',
  'metric.reliability_rating.tooltip.A': 'Reliability rating is A when there are no bugs.',
  'metric.reliability_rating.tooltip.B':
    'Reliability rating is B when there is at least one minor bug.',
  'metric.reliability_rating.tooltip.C':
    'Reliability rating is C when there is at least one major bug.',
  'metric.reliability_rating.tooltip.D':
    'Reliability rating is D when there is at least one critical bug.',
  'metric.reliability_rating.tooltip.E':
    'Reliability rating is E when there is at least one blocker bug.',
  'metric.releasability_rating.description': 'Releasability Rating',
  'metric.releasability_rating.name': 'Releasability Rating',
  'metric.sca_count_any_issue.description': 'Number of dependencies with any risk',
  'metric.sca_count_any_issue.name': 'Dependency risks',
  'metric.sca_count_vulnerabilities.description': 'Number of dependencies with vulnerabilities',
  'metric.sca_count_vulnerabilities.name': 'Vulnerable dependency risks',
  'metric.sca_count_licensing.description': 'Number of dependencies with prohibited licenses',
  'metric.sca_count_licensing.name': 'Prohibited license dependency risks',
  'metric.sca_count_malware.description': 'Malware dependency risks',
  'metric.sca_count_malware.name': 'Malware dependency risks',
  'metric.software_quality_releasability_rating.description': 'Releasability Rating',
  'metric.software_quality_releasability_rating.name': 'Releasability Rating',
  'metric.software_quality_reliability_rating.description': 'Reliability rating',
  'metric.software_quality_reliability_rating.description.positive':
    'Overall code has no critical reliability issues',
  'metric.software_quality_reliability_rating.name': 'Reliability Rating',
  'metric.software_quality_reliability_rating.extra_short_name': 'Rating',
  'metric.software_quality_reliability_rating.tooltip.A':
    'Reliability rating is A when there are no reliability issues above info severity.',
  'metric.software_quality_reliability_rating.tooltip.B':
    'Reliability rating is B when there is at least one low reliability issue.',
  'metric.software_quality_reliability_rating.tooltip.C':
    'Reliability rating is C when there is at least one medium reliability issue.',
  'metric.software_quality_reliability_rating.tooltip.D':
    'Reliability rating is D when there is at least one high reliability issue.',
  'metric.software_quality_reliability_rating.tooltip.E':
    'Reliability rating is E when there is at least one blocker reliability issue.',
  'metric.reliability_remediation_effort.description': 'Reliability Remediation Effort',
  'metric.reliability_remediation_effort.name': 'Reliability Remediation Effort',
  'metric.reliability_remediation_effort.extra_short_name': 'Remediation Effort',
  'metric.software_quality_reliability_remediation_effort.description':
    'Reliability Remediation Effort',
  'metric.software_quality_reliability_remediation_effort.name': 'Reliability Remediation Effort',
  'metric.software_quality_reliability_remediation_effort.extra_short_name': 'Remediation Effort',
  'metric.reopened_issues.description': 'Reopened issues',
  'metric.reopened_issues.name': 'Reopened Issues',
  'metric.revisions_by_line.description': 'Revisions by line',
  'metric.revisions_by_line.name': 'Revisions by Line',
  'metric.rfc.description': 'Response for Class',
  'metric.rfc.name': 'Response for Class',
  'metric.rfc_distribution.description': 'Class distribution /RFC',
  'metric.rfc_distribution.name': 'Class Distribution / RFC',
  'metric.sca_rating.tooltip.A':
    'Dependency Risk rating is A when there are no dependency risks, or when there are only risks with Info severity.',
  'metric.sca_rating.tooltip.B':
    'Dependency Risk rating is B when there is at least one dependency risk with Low severity.',
  'metric.sca_rating.tooltip.C':
    'Dependency Risk rating is C when there is at least one dependency risk with Medium severity.',
  'metric.sca_rating.tooltip.D':
    'Dependency Risk rating is D when there is at least one dependency risk with High severity.',
  'metric.sca_rating.tooltip.E':
    'Dependency Risk rating is E when there is at least one dependency risk with Blocker severity.',
  'metric.security_hotspots.description': 'Security Hotspots',
  'metric.security_hotspots.full_description':
    'Security-sensitive code that requires manual review to assess whether or not a vulnerability exists.',
  'metric.security_hotspots.name': 'Security Hotspots',
  'metric.security_hotspots_reviewed.description': 'Percentage of Security Hotspots Reviewed',
  'metric.security_hotspots_reviewed.description.positive': 'All security hotspots are reviewed',
  'metric.security_hotspots_reviewed.name': 'Security Hotspots Reviewed',
  'metric.security_hotspots_reviewed_status.description': 'Security Review Reviewed Status',
  'metric.security_hotspots_reviewed_status.name': 'Security Review Reviewed Status',
  'metric.security_hotspots_to_review_status.description': 'Security Review To Review Status',
  'metric.security_hotspots_to_review_status.name': 'Security Review To Review Status',
  'metric.security_rating.description': 'Security rating',
  'metric.security_rating.description.positive': 'Overall code has no vulnerabilities',
  'metric.security_rating.name': 'Security Rating',
  'metric.security_rating.extra_short_name': 'Rating',
  'metric.security_rating.tooltip.A': 'Security rating is A when there are no vulnerabilities.',
  'metric.security_rating.tooltip.B':
    'Security rating is B when there is at least one minor vulnerability.',
  'metric.security_rating.tooltip.C':
    'Security rating is C when there is at least one major vulnerability.',
  'metric.security_rating.tooltip.D':
    'Security rating is D when there is at least one critical vulnerability.',
  'metric.security_rating.tooltip.E':
    'Security rating is E when there is at least one blocker vulnerability.',
  'metric.software_quality_security_rating.description': 'Security rating',
  'metric.software_quality_security_rating.description.positive':
    'Overall code has no security issues',
  'metric.software_quality_security_rating.name': 'Security Rating',
  'metric.software_quality_security_rating.extra_short_name': 'Rating',
  'metric.software_quality_security_rating.tooltip.A':
    'Security rating is A when there are no security issues above info severity.',
  'metric.software_quality_security_rating.tooltip.B':
    'Security rating is B when there is at least one low security issue.',
  'metric.software_quality_security_rating.tooltip.C':
    'Security rating is C when there is at least one medium security issue.',
  'metric.software_quality_security_rating.tooltip.D':
    'Security rating is D when there is at least one high security issue.',
  'metric.software_quality_security_rating.tooltip.E':
    'Security rating is E when there is at least one blocker security issue.',
  'metric.security_remediation_effort.description': 'Security remediation effort',
  'metric.security_remediation_effort.name': 'Security Remediation Effort',
  'metric.security_remediation_effort.extra_short_name': 'Remediation Effort',
  'metric.software_quality_security_remediation_effort.description': 'Security remediation effort',
  'metric.software_quality_security_remediation_effort.name': 'Security Remediation Effort',
  'metric.software_quality_security_remediation_effort.extra_short_name': 'Remediation Effort',
  'metric.security_review_rating.description': 'Security Review Rating',
  'metric.security_review_rating.name': 'Security Review Rating',
  'metric.security_review_rating.extra_short_name': 'Rating',
  'metric.security_review_rating.tooltip.A':
    'Security Review rating is A when at least 80% of Security Hotspots are reviewed.',
  'metric.security_review_rating.tooltip.B':
    'Security Review rating is B when less than 80% of Security Hotspots are reviewed.',
  'metric.security_review_rating.tooltip.C':
    'Security Review rating is C when less than 70% of Security Hotspots are reviewed.',
  'metric.security_review_rating.tooltip.D':
    'Security Review rating is D when less than 50% of Security Hotspots are reviewed.',
  'metric.security_review_rating.tooltip.E':
    'Security Review rating is E when less than 30% of Security Hotspots are reviewed.',
  'metric.skipped_tests.description': 'Number of skipped unit tests',
  'metric.skipped_tests.name': 'Skipped Unit Tests',
  'metric.skipped_tests.short_name': 'Skipped',
  'metric.sqale_debt_ratio.description':
    'Ratio of the actual technical debt compared to the estimated cost to develop the whole source code from scratch',
  'metric.sqale_debt_ratio.name': 'Technical Debt Ratio',
  'metric.sqale_debt_ratio.short_name': 'Debt Ratio',
  'metric.software_quality_maintainability_debt_ratio.description':
    'Ratio of the actual technical debt compared to the estimated cost to develop the whole source code from scratch',
  'metric.software_quality_maintainability_debt_ratio.name': 'Technical Debt Ratio',
  'metric.software_quality_maintainability_debt_ratio.short_name': 'Debt Ratio',
  'metric.sqale_index.description':
    'Total effort (in minutes) to fix all the issues on the component and therefore to comply to all the requirements.',
  'metric.sqale_index.name': 'Technical Debt',
  'metric.sqale_index.short_name': 'Debt',
  'metric.software_quality_maintainability_remediation_effort.description':
    'Total effort (in minutes) to fix all the issues on the component and therefore to comply to all the requirements.',
  'metric.software_quality_maintainability_remediation_effort.name': 'Technical Debt',
  'metric.software_quality_maintainability_remediation_effort.short_name': 'Debt',
  'metric.sqale_rating.description': 'A-to-E rating based on the technical debt ratio',
  'metric.sqale_rating.name': 'Maintainability Rating',
  'metric.sqale_rating.extra_short_name': 'Rating',
  'metric.sqale_rating.tooltip':
    'Maintainability rating is {0} when the technical debt ratio is greater than {1}',
  'metric.sqale_rating.tooltip.A':
    'Maintainability rating is A when the technical debt ratio is less than {0}',
  'metric.software_quality_maintainability_rating.description':
    'A-to-E rating based on the technical debt ratio',
  'metric.software_quality_maintainability_rating.name': 'Maintainability Rating',
  'metric.software_quality_maintainability_rating.extra_short_name': 'Rating',
  'metric.software_quality_maintainability_rating.tooltip':
    'Maintainability rating is {0} when the technical debt ratio is greater than {1}',
  'metric.software_quality_maintainability_rating.tooltip.A':
    'Maintainability rating is A when the technical debt ratio is less than {0}',
  'metric.statements.description': 'Number of statements',
  'metric.statements.name': 'Statements',
  'metric.suspect_lcom4_density.description': 'Density of classes having LCOM4>1',
  'metric.suspect_lcom4_density.name': 'Suspect LCOM4 Density',
  'metric.tests.description': 'Number of unit tests',
  'metric.tests.name': 'Unit Tests',
  'metric.test_data.description': 'Unit tests details',
  'metric.test_data.name': 'Unit Test Details',
  'metric.test_errors.description': 'Number of unit test errors',
  'metric.test_errors.name': 'Unit Test Errors',
  'metric.test_errors.short_name': 'Errors',
  'metric.test_execution_time.description': 'Execution duration of unit tests',
  'metric.test_execution_time.name': 'Unit Test Duration',
  'metric.test_execution_time.short_name': 'Duration',
  'metric.test_failures.description': 'Number of unit test failures',
  'metric.test_failures.name': 'Unit Test Failures',
  'metric.test_failures.short_name': 'Failures',
  'metric.test_success_density.description': 'Density of successful unit tests',
  'metric.test_success_density.name': 'Unit Test Success (%)',
  'metric.test_success_density.short_name': 'Success',
  'metric.uncovered_conditions.description': 'Uncovered conditions',
  'metric.uncovered_conditions.name': 'Uncovered Conditions',
  'metric.uncovered_lines.description': 'Uncovered lines',
  'metric.uncovered_lines.name': 'Uncovered Lines',
  'metric.usability.description': 'Usability',
  'metric.usability.name': 'Usability',
  'metric.violations.description': 'Issues',
  'metric.violations.name': 'Issues',
  'metric.violations.short_name': 'Issues',
  'metric.vulnerabilities.description': 'Vulnerabilities',
  'metric.vulnerabilities.name': 'Vulnerabilities',
  'metric.vulnerabilities.short_name': 'Vulnerabilities',
  'metric.wont_fix_issues.description': "Won't fix issues",
  'metric.wont_fix_issues.name': "Won't Fix Issues",
  'metric.accepted_issues.description': 'Accepted issues',
  'metric.accepted_issues.name': 'Accepted Issues',
  'metric.pull_request_fixed_issues.name': 'Pull request fixed issues',
  'metric.pull_request_fixed_issues.description':
    'Count of issues that would be fixed by the pull request.',
  'metric.new_accepted_issues.name': 'New Accepted Issues',
  'metric.new_accepted_issues.description': 'New accepted issues',
  'metric.high_impact_accepted_issues.name': 'Blocker and High Severity Accepted Issues',
  'metric.high_impact_accepted_issues.description': 'Accepted issues with blocker or high impact',
  'metric.maintainability_issues.name': 'Maintainability Issues',
  'metric.maintainability_issues.description': 'Maintainability issues',
  'metric.maintainability_issues.short_name': 'Maintainability',
  'metric.reliability_issues.name': 'Reliability Issues',
  'metric.reliability_issues.description': 'Reliability issues',
  'metric.reliability_issues.short_name': 'Reliability',
  'metric.security_issues.name': 'Security Issues',
  'metric.security_issues.description': 'Security issues',
  'metric.security_issues.short_name': 'Security',
  'metric.new_maintainability_issues.name': 'New Maintainability Issues',
  'metric.new_maintainability_issues.description': 'New maintainability issues',
  'metric.new_maintainability_issues.short_name': 'New Maintainability',
  'metric.new_reliability_issues.name': 'New Reliability Issues',
  'metric.new_reliability_issues.description': 'New reliability issues',
  'metric.new_reliability_issues.short_name': 'New Reliability',
  'metric.new_security_issues.name': 'New Security Issues',
  'metric.new_security_issues.description': 'New security issues',
  'metric.new_security_issues.short_name': 'New Security',
  'metric.software_quality_blocker_issues.description': 'Blocker Severity issues',
  'metric.software_quality_blocker_issues.name': 'Blocker Severity Issues',
  'metric.software_quality_high_issues.description': 'High Severity issues',
  'metric.software_quality_high_issues.name': 'High Severity Issues',
  'metric.software_quality_info_issues.description': 'Info Severity issues',
  'metric.software_quality_info_issues.name': 'Info Severity Issues',
  'metric.software_quality_medium_issues.description': 'Medium Severity issues',
  'metric.software_quality_medium_issues.name': 'Medium Severity Issues',
  'metric.software_quality_low_issues.description': 'Low Severity issues',
  'metric.software_quality_low_issues.name': 'Low Severity Issues',
  'metric.new_software_quality_blocker_issues.description': 'New Blocker Severity issues',
  'metric.new_software_quality_blocker_issues.name': 'New Blocker Severity Issues',
  'metric.new_software_quality_high_issues.description': 'New High Severity issues',
  'metric.new_software_quality_high_issues.name': 'New High Severity Issues',
  'metric.new_software_quality_info_issues.description': 'New Info Severity issues',
  'metric.new_software_quality_info_issues.name': 'New Info Severity Issues',
  'metric.new_software_quality_medium_issues.description': 'New Medium Severity issues',
  'metric.new_software_quality_medium_issues.name': 'New Medium Severity Issues',
  'metric.new_software_quality_low_issues.description': 'New Low Severity issues',
  'metric.new_software_quality_low_issues.name': 'New Low Severity Issues',
  'metric.software_quality_maintainability_issues.name': 'Maintainability Issues',
  'metric.software_quality_maintainability_issues.short_name': 'Maintainability',
  'metric.software_quality_maintainability_issues.description': 'Maintainability issues',
  'metric.software_quality_reliability_issues.name': 'Reliability Issues',
  'metric.software_quality_reliability_issues.short_name': 'Reliability',
  'metric.software_quality_reliability_issues.description': 'Reliability issues',
  'metric.software_quality_security_issues.name': 'Security Issues',
  'metric.software_quality_security_issues.short_name': 'Security',
  'metric.software_quality_security_issues.description': 'Security issues',
  'metric.new_software_quality_maintainability_issues.name': 'New Maintainability Issues',
  'metric.new_software_quality_maintainability_issues.description': 'New maintainability issues',
  'metric.new_software_quality_reliability_issues.name': 'New Reliability Issues',
  'metric.new_software_quality_reliability_issues.description': 'New reliability issues',
  'metric.new_software_quality_security_issues.name': 'New Security Issues',
  'metric.new_software_quality_security_issues.description': 'New security issues',
  'metric.issues_in_sandbox.name': 'Issues in sandbox',
  'metric.issues_in_sandbox.short_name': 'Issue sandbox',
  'metric.issues_in_sandbox.description':
    'Issue detection is always improving. When SonarQube finds new issues due to an update, they are held here for review before they can affect the quality gate.',
  'metric.new_issues_in_sandbox.name': 'New issues in sandbox',
  'metric.new_issues_in_sandbox.short_name': 'Issue sandbox',
  'metric.new_issues_in_sandbox.description':
    'Issue detection is always improving. When SonarQube finds new issues due to an update, they are held here for review before they can affect the quality gate.',

  //------------------------------------------------------------------------------
  //
  // PERMISSIONS
  //
  //------------------------------------------------------------------------------
  'permission.assign_x_to_y': 'Assign permission {0} to {1}',

  'permissions.holder': 'Permission holder',
  'permissions.toggletip.more_information': 'Click for more on the "{permission}" permission',
  'permissions.filter.label': 'Filter by permission',

  //------------------------------------------------------------------------------
  //
  // GLOBAL PERMISSIONS
  //
  //------------------------------------------------------------------------------
  'global_permissions.permission': 'Permission',
  'global_permissions.users': 'Users',
  'global_permissions.groups': 'Groups',
  'global_permissions.administer': 'Administer',
  'global_permissions.creator': 'Create',
  'global_permissions.admin': 'Administer System',
  'global_permissions.admin.desc':
    'Ability to perform all administration functions for the instance.',
  'global_permissions.profileadmin': 'Quality Profiles',
  'global_permissions.profileadmin.desc': 'Ability to perform any action on Quality Profiles.',
  'global_permissions.gateadmin': 'Quality Gates',
  'global_permissions.gateadmin.desc': 'Ability to perform any action on quality gates.',
  'global_permissions.scan': 'Execute Analysis',
  'global_permissions.scan.desc':
    'Ability to get all settings required to perform an analysis (including the secured settings like passwords) and to push analysis results to the {instance} server.',
  'global_permissions.provisioning': 'Projects',
  'global_permissions.provisioning.desc':
    'Ability to initialize a project so its settings can be configured before the first analysis.',
  'global_permissions.filter_by_x_permission': 'Filter by "{0}" permission',
  'global_permissions.restore_access': 'Restore Access',
  'global_permissions.restore_access.message':
    'You will receive {browse} and {administer} permissions on the project. Do you want to continue?',
  'global_permissions.applicationcreator': 'Applications',
  'global_permissions.applicationcreator.desc': 'Ability to create an application.',
  'global_permissions.portfoliocreator': 'Portfolios',
  'global_permissions.portfoliocreator.desc': 'Ability to create a portfolio.',
  'global_permissions.no_actions_available': 'No actions available',

  //------------------------------------------------------------------------------
  //
  // PROJECTS PERMISSIONS
  //
  //------------------------------------------------------------------------------
  'projects_role.criteria.name': 'Name contains',
  'projects_role.criteria.key': 'Key contains',
  'projects_role.role': 'Role Membership For New',
  'projects_role.groups': 'Groups',
  'projects_role.template_name': 'Template Name',
  'projects_role.admin': 'Administer',
  'projects_role.admin.desc':
    'Access project settings and perform administration tasks (for private projects, users also need the "Browse" permission)',
  'projects_role.issueadmin': 'Administer Issues',
  'projects_role.issueadmin.desc':
    'Resolve issues as being "fixed", "accepted" or "false positive", as well as change issue severity. For private projects, users also need the "Browse" permission.',
  'projects_role.securityhotspotadmin': 'Administer Security Hotspots',
  'projects_role.securityhotspotadmin.desc':
    'Resolve a Security Hotspot as reviewed (fixed or safe), reset it as to review (for private projects, users also need the "Browse" permission).',
  'projects_role.user': 'Browse',
  'projects_role.user.desc':
    'Access a project, browse its measures and issues, confirm issues, change the assignee, comment on issues and change tags.',
  'projects_role.codeviewer': 'See Source Code',
  'projects_role.codeviewer.desc':
    'View the project\'s source code (for private projects, users also need the "Browse" permission)',
  'projects_role.scan': 'Execute Analysis',
  'projects_role.scan.desc':
    'Ability to get all settings required to perform an analysis (including the secured settings like passwords) and to push analysis results to the server.',
  'projects_role.bulk_change': 'Bulk Change',
  'projects_role.apply_template': 'Apply Permission Template',
  'projects_role.apply_template_to_x': 'Apply Permission Template To "{0}"',
  'projects_role.apply_template.success': 'Permission template was successfully applied.',
  'projects_role.no_projects':
    'There are currently no results to apply the permission template to.',
  'projects_role.turn_x_to_public': 'Turn "{0}" to Public',
  'projects_role.turn_project_to_public.TRK': 'Turn Project to Public',
  'projects_role.turn_project_to_public.VW': 'Turn Portfolio to Public',
  'projects_role.turn_project_to_public.APP': 'Turn Application to Public',
  'projects_role.are_you_sure_to_turn_project_to_public.TRK':
    'Are you sure you want to turn your project to public?',
  'projects_role.are_you_sure_to_turn_project_to_public.warning.TRK':
    'Everybody will be able to browse and see the source code of your project.',
  'projects_role.are_you_sure_to_turn_project_to_public.VW':
    'Are you sure you want to turn your portfolio to public?',
  'projects_role.are_you_sure_to_turn_project_to_public.warning.VW':
    'Everybody will be able to browse it.',
  'projects_role.are_you_sure_to_turn_project_to_public.APP':
    'Are you sure you want to turn your application to public?',
  'projects_role.are_you_sure_to_turn_project_to_public.warning.APP':
    'Everybody will be able to browse it.',
  'projects_role.public_projects_warning':
    'For public projects, this permission is granted to everyone (including anonymous users) by default. Selections here apply to private projects only.',
  'projects_role.applicationcreator': 'Create Applications',
  'projects_role.applicationcreator.desc':
    'Allow to create applications for non system administrator.',
  'projects_role.portfoliocreator': 'Create Portfolios',
  'projects_role.portfoliocreator.desc': 'Allow to create portfolios for non system administrator.',

  //------------------------------------------------------------------------------
  //
  // PERMISSION TEMPLATES
  //
  //------------------------------------------------------------------------------
  permission_templates: 'Permission Templates',
  'permission_templates.page': 'Permission Templates',
  'permission_templates.page.description':
    '<link>Manage templates</link> of project permission sets. The default template will be applied to all new projects.',
  'permission_templates.search_placeholder': 'Search for templates...',
  'permission_templates.search_aria_label': 'Search permission templates',
  'permission_templates.no_results': 'No permission templates found matching "{query}"',
  'permission_templates.no_templates': 'No permission templates have been created yet.',
  'permission_templates.set_default': 'Set Default',
  'permission_templates.set_default_for': 'Set Default For',
  'permission_templates.provisioning_warning':
    'Please note that permission templates will only affect non-{0} projects due to the enabled automatic provisioning via {0}.',
  'permission_template.new_template': 'Create Permission Template',
  'permission_template.delete_confirm_title': 'Delete Permission Template',
  'permission_template.do_you_want_to_delete_template_xxx':
    'Are you sure that you want to delete permission template "{0}"?',
  'permission_template.edit_template': 'Edit Permission Template',
  'permission_template.edit_permissions': 'Edit Permissions: {0}',
  'permission_template.key_pattern': 'Project key pattern',
  'permission_template.key_pattern.description': 'Should be a valid regular expression',
  'permission_template.default_for': 'Default for {qualifiers}',
  'permission_templates.project_creators': 'Creators',
  'permission_templates.project_creators.explanation':
    'When a new project, portfolio or application is created, the user who creates it will receive these permissions.',
  'permission_templates.bulk_apply_permission_template': 'Bulk Apply Permission Template',
  'permission_templates.bulk_apply_permission_template.apply_to_selected':
    "You're about to apply the selected permission template to {0} selected item(s).",
  'permission_templates.bulk_apply_permission_template.apply_to_all':
    "You're about to apply the selected permission template to {0} item(s).",
  'permission_templates.bulk_apply_permission_template.apply_to_managed_projects':
    "You can't apply the selected permission template to the {0} {1} project(s).",
  'permission_templates.bulk_apply_permission_template.apply_to_only_managed_projects':
    "You can't apply permission templates to {0} projects.",
  'permission_templates.select_to_delete': 'You must select at least one item',
  'permission_templates.delete_selected': 'Delete all selected items',
  'permission_templates.show_actions_for_x': 'Show actions for template {0}',

  //------------------------------------------------------------------------------
  //
  // Promotion
  //
  //------------------------------------------------------------------------------

  'promotion.sonarlint.title': 'Get the most out of {productName}!',
  'promotion.sonarlint.content':
    'Take advantage of the whole ecosystem by using SonarQube for IDE, a free IDE plugin that helps you find and fix issues earlier in your workflow. Connect SonarQube for IDE to {productName} to sync rule sets and issue states.',

  //------------------------------------------------------------------------------
  //
  // Sonarlint
  //
  //------------------------------------------------------------------------------

  'sonarlint-connection.request.title': 'Allow SonarQube for IDE connection?',
  'sonarlint-connection.request.description':
    'SonarQube for IDE for {ideName} is requesting access to {productName}.',
  'sonarlint-connection.request.description2':
    'Do you allow SonarQube for IDE to connect? This will create a token and share it with SonarQube for IDE.',
  'sonarlint-connection.request.action': 'Allow connection',

  'sonarlint-connection.token-error.title': 'Token generation failed',
  'sonarlint-connection.token-error.description': '{productName} was not able to generate a token.',
  'sonarlint-connection.token-error.description2':
    'Go back to your IDE and start again, or go to the {link} of your {productName} account to create a new user token manually.',
  'sonarlint-connection.token-error.description2.link': 'Security section',

  'sonarlint-connection.connection-error.title': 'Token created',
  'sonarlint-connection.connection-error.description': 'The following token was created:',
  'sonarlint-connection.connection-error.token-name': 'Token name',
  'sonarlint-connection.connection-error.token-value': 'Token value',
  'sonarlint-connection.connection-error.next-steps': 'Next steps',
  'sonarlint-connection.connection-error.step1': 'Copy the above token.',
  'sonarlint-connection.connection-error.step2':
    'Go back to your IDE and paste the token in SonarQube for IDE.',

  'sonarlint-connection.success.title': 'SonarQube for IDE connection is almost ready!',
  'sonarlint-connection.success.description':
    "A new '{0}' token was created and sent to SonarQube for IDE in your IDE.",
  'sonarlint-connection.success.last-step': 'Last step',
  'sonarlint-connection.success.step': 'Go back to your IDE to complete the setup.',

  'sonarlint-connection.unspecified-ide': 'an unspecified IDE',

  'sonarlint-connected-mode-doc': 'documentation about SonarQube for IDE Connected Mode',
  //------------------------------------------------------------------------------
  //
  // HELP
  //
  //------------------------------------------------------------------------------
  'formatting.page': 'Formatting',
  'formatting.helplink': 'Formatting Help',
  'formatting.example.link': 'For a hyperlink, write: {example}',
  'formatting.example.link.example': '[link label](https://www.domain.com)',

  //------------------------------------------------------------------------------
  //
  // KEYBOARD SHORTCUTS
  //
  //------------------------------------------------------------------------------
  'keyboard_shortcuts_modal.title': 'Keyboard Shortcuts',
  'keyboard_shortcuts_modal.disable_link': 'Disable shortcuts',
  'keyboard_shortcuts_modal.global': ' Global',
  'keyboard_shortcuts_modal.global.open_search_bar': ' Open search bar',
  'keyboard_shortcuts_modal.global.open_keyboard_shortcuts_modal': ' Open keyboard shortcuts modal',
  'keyboard_shortcuts_modal.global.focus_toasts_messages': ' Focus toast messages',
  'keyboard_shortcuts_modal.navigate_between_issues': ' Navigate between issues',
  'keyboard_shortcuts_modal.open_issue': ' Open issue',
  'keyboard_shortcuts_modal.return_back_to_the_list': ' Return back to the list',
  'keyboard_shortcuts_modal.do_issue_transition': ' Do an issue transition',
  'keyboard_shortcuts_modal.assign_issue': ' Assign issue',
  'keyboard_shortcuts_modal.assign_issue_to_me': ' Assign issue to me',
  'keyboard_shortcuts_modal.change_tags_of_issue': ' Change tags of issue',
  'keyboard_shortcuts_modal.select_an_issue': ' Select an issue',
  'keyboard_shortcuts_modal.issues_page': ' Issues page',
  'keyboard_shortcuts_modal.issue_details_page.navigate_issue_locations':
    ' To navigate issue locations',
  'keyboard_shortcuts_modal.issue_details_page.switch_flows': ' To switch flows',
  'keyboard_shortcuts_modal.issue_details_page.comment_an_issue': ' Comment an issue',
  'keyboard_shortcuts_modal.issue_details_page.submit_comment': ' Submit comment',
  'keyboard_shortcuts_modal.code_page': ' Code page',
  'keyboard_shortcuts_modal.code_page.select_files': ' Select files',
  'keyboard_shortcuts_modal.code_page.open_file': ' Open file',
  'keyboard_shortcuts_modal.measures_page': ' Measures page',
  'keyboard_shortcuts_modal.rules_page': ' Rules page',
  'keyboard_shortcuts_modal.rules_page.navigate_between_rule': ' Navigate between rules',
  'keyboard_shortcuts_modal.rules_page.open_rule': ' Open rule',

  //------------------------------------------------------------------------------
  //
  // DURATION
  //
  //------------------------------------------------------------------------------
  'duration.seconds': 'less than a minute',
  'duration.minute': 'about a minute',
  'duration.minutes': '{0} minutes',
  'duration.hour': 'about an hour',
  'duration.hours': '{0} hours',
  'duration.day': 'a day',
  'duration.days': '{0} days',
  'duration.month': 'about a month',
  'duration.months': '{0} months',
  'duration.year': 'about a year',
  'duration.years': '{0} years',

  //------------------------------------------------------------------------------
  //
  // COMPONENT VIEWER
  //
  //------------------------------------------------------------------------------
  'component_viewer.measure_section.unit_tests': 'Tests',

  'component_viewer.transition.covers': 'Covers',
  'component_viewer.transition.duplication': 'Duplicated By',

  'component_viewer.tests.ordered_by': 'ordered by',
  'component_viewer.tests.duration': 'duration',
  'component_viewer.tests.test_name': 'name',
  'component_viewer.tests.status': 'status',

  'component_viewer.x_lines_are_covered': '{0} lines are covered',
  'component_viewer.details': 'Details',
  'component_viewer.show_raw_source': 'Show Raw Source',
  'component_viewer.more_actions': 'More Actions',
  'component_viewer.new_window': 'Open in New Window',
  'component_viewer.open_in_workspace': 'Pin This File',
  'component_viewer.open_in_workspace_X': 'Pin {0} File',
  'component_viewer.copy_permalink': 'Click to copy permalink to clipboard',
  'component_viewer.covered_lines': 'Covered Lines',
  'component_viewer.show_details': 'Show Measures',
  'component_viewer.file_measures': 'File measures',
  'component_viewer.show_all_measures': 'Show all measures',
  'component_viewer.no_component': 'The component has been removed or never existed.',
  'component_viewer.copy_path_to_clipboard': 'Copy the file path to the clipboard',
  'component_viewer.action_menu': 'File actions menu',

  'source_viewer.view_all_issues': 'See all issues in this file',
  'source_viewer.expand_all_lines': 'Show all lines of code',
  'source_viewer.covered': 'Covered by the following tests',
  'source_viewer.not_covered': 'Not covered by tests',
  'source_viewer.conditions': 'conditions',
  'source_viewer.line_X': 'Line: {0}',
  'source_viewer.click_for_scm_info': 'Click to see SCM information for line {0}',
  'source_viewer.author_X': 'Author: {0}',
  'source_viewer.click_to_copy_filepath': 'Click to copy the filepath to clipboard',
  'source_viewer.issue_link_x': '{count} {quality} {count, plural, one {issue} other {issues}}',
  'source_viewer.jupyter.output.image': 'Output',
  'source_viewer.jupyter.preview.error':
    'Error while loading the Jupyter notebook. Use the Code tab to view raw.',

  'source_viewer.tooltip.duplicated_line':
    'This line is duplicated. Click to see duplicated blocks.',
  'source_viewer.tooltip.duplicated_block': 'Duplicated block. Click for details.',
  'source_viewer.tooltip.covered': 'Fully covered by tests.',
  'source_viewer.tooltip.covered.conditions': 'Fully covered by tests ({0} conditions).',
  'source_viewer.tooltip.partially-covered': 'Partially covered by tests.',
  'source_viewer.tooltip.partially-covered.conditions':
    'Partially covered by tests ({0} of {1} conditions).',
  'source_viewer.tooltip.uncovered': 'Not covered by tests.',
  'source_viewer.tooltip.uncovered.conditions': 'Not covered by tests ({0} conditions).',
  'source_viewer.tooltip.no_information_about_tests':
    'There is no extra information about test files.',
  'source_viewer.tooltip.scm.commited_on': 'Committed on',
  'source_viewer.tooltip.scm.revision': 'Revision',

  'source_viewer.issues_on_line.multiple_issues':
    '{show, select, true {Show} other {Hide}} multiple issues on this line',
  'source_viewer.issues_on_line.multiple_issues_same_category':
    '{show, select, true {Show} other {Hide}} {count} {category} {count, plural, one {issue} other {issues}} on this line',
  'source_viewer.issues_on_line.multiple_issues_same_category.legacy':
    '{show, select, true {Show} other {Hide}} {count} {issueType} on this line',

  'source_viewer.load_more_code': 'Load More Code',
  'source_viewer.loading_more_code': 'Loading More Code...',

  'source_viewer.expand_above': 'Show previous few lines of code',
  'source_viewer.expand_below': 'Show next few lines of code',
  'source_viewer.copy_permalink': 'Copy Permalink',
  'source_viewer.copy_line': 'Copy Line',
  'source_viewer.copied_to_clipboard': 'Copied to Clipboard',
  'source_viewer.new_code': 'New Code',
  'source_viewer.coverage.covered': 'Covered code',
  'source_viewer.coverage.uncovered': 'Uncovered code',
  'source_viewer.coverage.partially-covered': 'Partially covered code',
  //------------------------------------------------------------------------------
  //
  // WORKSPACE
  //
  //------------------------------------------------------------------------------
  'workspace.minimize': 'Minimize',
  'workspace.full_window': 'Expand to full window',
  'workspace.normal_size': 'Collapse to normal size',
  'workspace.close': 'Remove from the list of pinned files',
  'workspace.no_rule': 'The rule has been removed or never existed.',

  //------------------------------------------------------------------------------
  //
  // MARKETPLACE
  //
  //------------------------------------------------------------------------------
  'marketplace.page': 'Marketplace',
  'marketplace.page.description':
    'Discover the additional benefits offered in SonarQube Server Commercial Editions',
  'marketplace.page.description_best_edition':
    'This edition includes access to all the SonarQube Server-SonarQube for IDE Ecosystem features!',
  'marketplace.page.you_are_running.community': 'You are currently running a Community Build.',
  'marketplace.page.you_are_running.developer': 'You are currently running a Developer Edition.',
  'marketplace.page.you_are_running.enterprise': 'You are currently running an Enterprise Edition.',
  'marketplace.page.you_are_running.datacenter': 'You are currently running a Data Center Edition.',
  'marketplace.page.plugins': 'Plugins',
  'marketplace.page.plugins.description':
    'Plugins available in the Marketplace are not provided or supported by SonarSource. Please reach out directly to their maintainers for support.',
  'marketplace.page.plugins.description2':
    'Installing a plugin is a manual operation. Please refer to the {link}.',
  'marketplace.page.plugins.description2.link': 'documentation',
  'marketplace.plugin_list.no_plugins.all': 'No installed plugins or updates available',
  'marketplace.plugin_list.no_plugins.installed': 'No installed plugins',
  'marketplace.plugin_list.no_plugins.updates': 'No plugin updates available',
  'marketplace.instance_needs_to_be_restarted_to': '{instance} needs to be restarted in order to',
  'marketplace.install_x_plugins': 'install {nb} plugins',
  'marketplace.update_x_plugins': 'update {nb} plugins',
  'marketplace.uninstall_x_plugins': 'uninstall {nb} plugins',
  'marketplace.not_activated': 'Update Center is not activated.',
  'marketplace.all': 'All',
  'marketplace.installed': 'Installed',
  'marketplace.updates_only': 'Updates Only',
  'marketplace.restart': 'Restart',
  'marketplace.revert': 'Revert',
  'marketplace.install': 'Install',
  'marketplace.upgrade_to_x': 'Upgrade to {0}',
  'marketplace.downgrade_to_x': 'Downgrade to {0}',
  'marketplace.installing': 'Installing...',
  'marketplace.upgrade': 'Upgrade',
  'marketplace.downgrade': 'Downgrade',
  'marketplace.checking_license': 'Checking your license...',
  'marketplace._installed': 'installed',
  'marketplace.available_under_commercial_license': 'Available under our commercial editions',
  'marketplace.learn_more': 'Learn more',
  'marketplace.request_free_trial': 'Request a free trial',
  'marketplace.homepage': 'Homepage',
  'marketplace.issue_tracker': 'Issue Tracker',
  'marketplace.licensed_under_x': 'Licensed under {license}',
  'marketplace.developed_by_x': 'Developed by {organization}',
  'marketplace.install_pending': 'Install Pending',
  'marketplace.update_pending': 'Update Pending',
  'marketplace.uninstall_pending': 'Uninstall Pending',
  'marketplace.requires_restart': 'This requires a restart',
  'marketplace.updates': 'Updates',
  'marketplace.update_status.COMPATIBLE': 'Compatible',
  'marketplace.update_status.INCOMPATIBLE': 'Incompatible',
  'marketplace.update_status.REQUIRES_SYSTEM_UPGRADE': 'Requires system update',
  'marketplace.update_status.DEPS_REQUIRE_SYSTEM_UPGRADE':
    'Some of dependencies requires system update',
  'marketplace.installing_this_plugin_will_also_install_x':
    'Installing this plugin will also install: {0}',
  'marketplace.show_plugin_changelog': 'See {0} {1} changelog',
  'marketplace.update_to_x': 'Update to {0}',
  'marketplace.uninstall': 'Uninstall',
  'marketplace.i_accept_the': 'I accept the',
  'marketplace.terms_and_conditions': 'Terms and Conditions',
  'marketplace.release_notes': 'Release Notes',
  'marketplace.how_to_setup_cluster_url':
    'Further configuration is required to set up a cluster. See {url} documentation.',
  'marketplace.search': 'Search by features, tags, or categories...',

  'marketplace.risk_consent.title': 'Installation of plugins',
  'marketplace.risk_consent.description':
    'Plugins are not provided by SonarSource and are therefore installed at your own risk. SonarSource disclaims all liability for installing and using such plugins.',
  'marketplace.risk_consent.installation':
    'You can install plugins directly from the list below after you acknowledge the risk.',
  'marketplace.risk_consent.action': 'I understand the risk',

  'plugin_risk_consent.page': 'Plugin risk consent',
  'plugin_risk_consent.title': 'Installation of plugins',
  'plugin_risk_consent.description': 'A plugin has been detected.',
  'plugin_risk_consent.description2':
    'Plugins are not provided by SonarSource and are therefore installed at your own risk. SonarSource disclaims all liability for installing and using such plugins.',
  'plugin_risk_consent.action': 'I understand the risk',

  //------------------------------------------------------------------------------
  //
  // BACKGROUND TASKS
  //
  //------------------------------------------------------------------------------
  'component_navigation.status.failed': 'The last background task has failed.',
  'component_navigation.status.failed_X': 'The {type} has failed.',
  'component_navigation.status.failed.admin.link':
    'The last background task has failed. More details available on the {url} page.',
  'component_navigation.status.failed_X.admin.link':
    'The {type} has failed. More details available on the {url} page.',
  'component_navigation.status.failed.admin.help':
    'The last background task has failed. You can find more details below by clicking on the cog menu, and then "{stacktrace}".',
  'component_navigation.status.failed_X.admin.help':
    'The {type} has failed. You can find more details below by clicking on the cog menu, and then "{stacktrace}".',
  'component_navigation.status.failed_branch':
    'The last analysis on this project ({branch}) failed.',
  'component_navigation.status.failed_branch_X':
    'The last {type} on this project ({branch}) failed.',
  'component_navigation.status.failed_branch.admin.link':
    'The last analysis on this project ({branch}) failed. More details available on the {url} page.',
  'component_navigation.status.failed_branch_X.admin.link':
    'The last {type} on this project ({branch}) failed. More details available on the {url} page.',
  'component_navigation.status.failed_branch.admin.help':
    'The last analysis on this project ({branch}) failed. You can find more details below by clicking on the cog menu, and then "{stacktrace}".',
  'component_navigation.status.failed_branch_X.admin.help':
    'The last {type} on this project ({branch}) failed. You can find more details below by clicking on the cog menu, and then "{stacktrace}".',
  'component_navigation.status.pending': 'There is a pending background task.',
  'component_navigation.status.pending_X': 'There is a pending {type}.',
  'component_navigation.status.pending.admin.link':
    'There is a pending background task. More details available on the {url} page.',
  'component_navigation.status.pending_X.admin.link':
    'There is a pending {type}. More details available on the {url} page.',
  'component_navigation.status.pending.admin.help': 'There is a pending background task.',
  'component_navigation.status.pending_X.admin.help': 'There is a pending {type}.',
  'component_navigation.status.in_progress': 'A background task is in progress.',
  'component_navigation.status.in_progress_X': 'The {type} is in progress.',
  'component_navigation.status.in_progress.admin.link':
    'A background task is in progress. More details available on the {url} page.',
  'component_navigation.status.in_progress_X.admin.link':
    'The {type} is in progress. More details available on the {url} page.',
  'component_navigation.status.in_progress.admin.help': 'A background task is in progress.',
  'component_navigation.status.in_progress_X.admin.help': 'The {type} is in progress.',
  'component_navigation.status.last_blocked_due_to_bad_license_X':
    'Last analysis blocked due to an invalid license, which has since been corrected. Please reanalyze this {0}.',

  'component_navigation.pr_deco.error_detected_X':
    "We've detected an issue with your configuration. Your {productName} instance won't be able to perform any pull request decoration. {action}",
  'component_navigation.pr_deco.action.check_project_settings':
    'Please check your project settings.',
  'component_navigation.pr_deco.action.contact_project_admin':
    'Please contact your project administrator.',

  'background_task.status.ALL': 'All',
  'background_task.status.PENDING': 'Pending',
  'background_task.status.IN_PROGRESS': 'In Progress',
  'background_task.status.SUCCESS': 'Success',
  'background_task.status.FAILED': 'Failed',
  'background_task.status.CANCELED': 'Canceled',
  'background_task.status.ALL_EXCEPT_PENDING': 'All Except Pending',

  'background_task.type.ALL': 'All',
  'background_task.type.REPORT': 'Project Analysis',
  'background_task.type.DEV_REFRESH': 'Developer Analysis',
  'background_task.type.DEV_PURGE': 'Developer Cleaning',
  'background_task.type.ISSUE_SYNC': 'Project Data Reload',
  'background_task.type.APP_REFRESH': 'Application Recomputation',
  'background_task.type.PROJECT_EXPORT': 'Project Export',
  'background_task.type.PROJECT_IMPORT': 'Project Import',
  'background_task.type.AUDIT_PURGE': 'Audit Log Purge',
  'background_task.type.REPORT_SUBMIT': 'Report Email Submit',
  'background_task.type.GITHUB_AUTH_PROVISIONING': 'GitHub Provisioning',
  'background_task.type.GITHUB_PROJECT_PERMISSIONS_PROVISIONING': 'GitHub Project Permission Sync',
  'background_task.type.GITLAB_AUTH_PROVISIONING': 'GitLab Provisioning',
  'background_task.type.GITLAB_PROJECT_PERMISSIONS_PROVISIONING': 'Gitlab Project Permission Sync',
  'background_task.type.SCA_RESCAN_BRANCH': 'SCA Scan Branch',

  'background_tasks.page': 'Background Tasks',
  'background_tasks.page.description':
    'This page allows monitoring of the queue of tasks running asynchronously on the server. It also gives access to the history of finished tasks and their status. Analysis report processing is the most common kind of background task. Learn more about <link>Background Tasks</link>.',

  'background_tasks.currents_filter.ONLY_CURRENTS': 'Only Latest Analysis',

  'background_tasks.date_filter': 'Date',
  'background_tasks.date_filter.ALL': 'Any Date',
  'background_tasks.date_filter.TODAY': 'Today',
  'background_tasks.date_filter.CUSTOM': 'Custom',

  'background_tasks.table.status': 'Status',
  'background_tasks.table.task': 'Task',
  'background_tasks.table.id': 'ID',
  'background_tasks.table.submitted': 'Submitted',
  'background_tasks.table.submitter': 'Submitter',
  'background_tasks.table.started': 'Started',
  'background_tasks.table.finished': 'Finished',
  'background_tasks.table.duration': 'Duration',
  'background_tasks.table.nodeName': 'Node',

  'background_tasks.filter_by_component_x': 'Filter by Component "{component}"',
  'background_tasks.cancel_task': 'Cancel Task',
  'background_tasks.cancel_task.text': 'Are you sure you want to cancel this pending task?',
  'background_tasks.cancel_all_tasks': 'Cancel All Pending Tasks',
  'background_tasks.cancel_all_tasks.text': 'Are you sure you want to cancel all pending tasks?',
  'background_tasks.cancel_all_tasks.submit': 'Cancel All',
  'background_tasks.scanner_context': 'Scanner Context',
  'background_tasks.show_scanner_context': 'Show Scanner Context',
  'background_tasks.show_actions_for_task_x_in_list': 'Show actions for task in row {0}',
  'background_tasks.show_stacktrace': 'Show Error Details',
  'background_tasks.show_warnings': 'Show Warnings',
  'background_tasks.error_message': 'Error Message',
  'background_tasks.error_stacktrace.title': 'Error Details: {project} [{type}]',
  'background_tasks.error_stacktrace': 'Error Details',
  'background_tasks.pending': 'pending',
  'background_tasks.pending_time': 'pending time',
  'background_tasks.pending_time.description':
    'Pending time of the oldest background task waiting to be processed.',
  'background_tasks.failures': 'still failing',
  'background_tasks.date_and_time': '{date} - {time}',
  'background_tasks.submitted_by_x': 'By {submitter}',

  'background_tasks.number_of_workers': 'Number of Workers:',
  'background_tasks.number_of_workers.warning':
    'Configuring additional workers without first vertically scaling your server could have negative performance impacts.',
  'background_tasks.change_number_of_workers': 'Edit CE Workers',
  'background_tasks.change_number_of_workers.hint':
    'If your queue backs up behind the analysis reports from large projects, increasing the number of Compute Engine workers will allow you to take full advantage of having configured increased Compute Engine memory on a multi-core server (vertical scaling).',
  'background_tasks.add_more_workers': 'Speed up analysis with parallel processing',
  'background_tasks.add_more_workers.text':
    'Configure multiple workers for parallel processing of analysis reports in Enterprise Edition.',
  'background_tasks.search_by_task_or_component': 'Search by Task or Component',
  'background_tasks.failing_count':
    'Count of projects where processing of most recent analysis report failed',
  'background_tasks.retry_failed_tasks':
    'Some projects data reload failed. Refer to the <link>documentation</link> for steps to retry.',

  //------------------------------------------------------------------------------
  //
  // Project Dump
  //
  //------------------------------------------------------------------------------
  'project_dump.page': 'Import / Export',
  'project_dump.page.description1':
    'Moving a project from one {productName} instance to another is a 3 step operation:',
  'project_dump.page.description2':
    'Export the project, copy the generated dump on the target server, and finally import that dump from this page on the target {productName} instance.',
  'project_dump.page.description_without_import1':
    'Export project issues, measures and measure history for import into an Enterprise Edition or higher instance of the same version and similar configuration. The export file will be generated to the file system. It must then be copied to the target file system for import.',
  'project_dump.page.description_without_import2':
    'The export file will be generated to the file system. It must then be copied to the target file system for import.',
  'project_dump.refresh': 'Refresh',
  'project_dump.see_details': 'See Details',
  'project_dump.export': 'Export',
  'project_dump.do_export': 'Export Project',
  'project_dump.can_not_export':
    'This project cannot be exported as no analysis has been run so far.',
  'project_dump.pending_export': 'Export was scheduled on {0}, waiting to be processed.',
  'project_dump.in_progress_export': 'Export is in progress, started {0}.',
  'project_dump.failed_export': 'The last export failed. Please try once again.',
  'project_dump.latest_export_available':
    'Latest project dump was generated on {0}. It can be found on the server, in the following directory:',
  'project_dump.export_available':
    'Project dump was generated. It can be found on the server, in the following directory:',
  'project_dump.export_form_description':
    'Export the project to the file system. The export file will need to be manually copied to the target filesystem.',
  'project_dump.import': 'Import',
  'project_dump.do_import': 'Import Project',
  'project_dump.import_success': 'The project has been successfully imported on {0}.',
  'project_dump.can_not_import':
    'This project can not be imported because it already contains some data.',
  'project_dump.no_file_to_import':
    'This project can not be imported because the dump file is not found.',
  'project_dump.pending_import': 'Import was scheduled on {0}, waiting to be processed.',
  'project_dump.in_progress_import': 'Import is in progress, started {0}.',
  'project_dump.failed_import': 'The last import has failed. Please try once again.',
  'project_dump.import_form_description':
    'A dump has been found on the file system for this project. You can import it by clicking on the button below.',
  'project_dump.import_form_description_disabled':
    'Projects cannot be imported. This feature is only available starting from Enterprise Edition.',

  //------------------------------------------------------------------------------
  //
  // SYSTEM
  //
  //------------------------------------------------------------------------------
  'system.application_nodes_title': 'Application Nodes',
  'system.are_you_sure_to_restart':
    'Are you sure you want to restart the server? The restart will first wait for ongoing background tasks to complete.',
  'system.cluster_log_level.info':
    'Your selection affect all Application nodes but not the Search nodes.',
  'system.copy_id_info': 'Copy ID information',
  'system.current_health_of_x': 'Current health status of {0}',
  'system.current_health.green': 'Status is up',
  'system.current_health.yellow': 'Status is starting',
  'system.current_health.red': 'Status is down',
  'system.download_logs': 'Download Logs',
  'system.download_system_info': 'Download System Info',
  'system.download_x': 'Download {0}',
  'system.forcing_shutdown_not_recommended':
    'Forcing the shutdown is not recommended and can interrupt the processing of analysis reports.',
  'system.hide_intermediate_versions': 'Hide intermediate versions',
  'system.how_to_upgrade': 'How to upgrade?',
  'system.latest_version': 'Latest Version',
  'system.latest_patch': 'Patch Release',
  'system.lta_version': 'Latest LTA Version',
  'system.log_level.warning':
    'This level has performance impacts, please make sure to get back to INFO level once your investigation is done. Please note that when the server is restarted, logging will revert to the level configured in sonar.properties.',
  'system.log_level.warning.short':
    'Current logs level has performance impacts, get back to INFO level.',
  'system.log_level.info': 'Your selection does not affect the Search Engine.',
  'system.logs_level': 'Logs level',
  'system.logs_level.change': 'Change logs level',
  'system.new_version_available': 'A new version of {productName} is available.',
  'system.restart_does_not_reload_sonar_properties':
    'Also note that a restart will not reload the sonar.properties file.',
  'system.see_whats_new': "See what's new!",
  'system.release_notes': 'Release Notes',
  'system.released_x': 'Released {0}',
  'system.restart_in_progress': 'Restart in progress',
  'system.restart_server': 'Restart Server',
  'system.instance_restarting': '{instance} restart is in progress. Ongoing {link} are completing.',
  'system.search_nodes_title': 'Search Nodes',
  'system.see_sonarqube_downloads': 'See All {productName} Downloads',
  'system.not_production_database_warning':
    'This server ID is valid only for the embedded database, which should be considered disposable. Consider configuring an external database for long-term use prior to requesting your license.',
  'system.server_id': 'Server ID',
  'system.set_log_level': 'Set logs level',
  'system.show_intermediate_versions': 'Show intermediate versions',
  'system.system_upgrade': 'New update available',
  'system.version': 'Version',
  'system.version_is_availble': '{version} is available',

  //------------------------------------------------------------------------------
  //
  // OVERVIEW
  //
  //------------------------------------------------------------------------------
  'overview.X_conditions_failed':
    '{conditions} {conditions, plural, one {failed condition} other {failed conditions}}',
  'overview.failed_condition.x_rating_required': '{rating} is {value}. Required {threshold}',
  'overview.failed_condition.x_required': '{metric}. Required {threshold}',
  'overview.fix_failed_conditions_with_sonarlint':
    'Fix issues before they fail your Quality Gate with {link}. Power up with connected mode!',
  'overview.new_issues': 'New issues',
  'overview.pull_request.fixed_issues': 'Fixed issues',
  'overview.pull_request.fixed_issues.help': 'Estimation of issues fixed by this PR',
  'overview.pull_request.fixed_issues.disclaimer':
    'Only issues fixed on the files modified by the pull request are taken into account. Issues incidentally fixed on unmodified files are not counted.',
  'overview.pull_request.fixed_issues.disclaimer.2':
    'When the pull request and the target branch are not synchronized, issues introduced on the target branch may be incorrectly considered fixed by the pull request. Rebasing the pull request would give an updated value.',
  'overview.accepted_issues.help': 'Valid issues that were not fixed',
  'overview.quality_gate': 'Quality Gate',
  'overview.quality_gate_x': 'Quality Gate: {status}',
  'overview.quality_gate.help':
    "A Quality Gate is a set of measure-based Boolean conditions. It helps you know immediately whether your project is production-ready. If your current status is not Passed, you'll see which measures caused the problem and the values required to pass.",
  'overview.quality_gate_failed_with_x': 'with {0} errors',
  'overview.quality_gate_code_clean': 'Your code is clean!',
  'overview.you_should_define_quality_gate': 'You should define a quality gate on this project.',
  'overview.quality_gate.ignored_conditions':
    'Some Quality Gate conditions on New Code were ignored because of the small number of New Lines',
  'overview.quality_gate.ignored_conditions.tooltip':
    "At the start of a new code period, if very few lines have been added or modified, it might be difficult to reach the desired level of code coverage or duplications. To prevent Quality Gate failure when there's little that can be done about it, Quality Gate conditions about duplications in new code and coverage on new code are ignored until the number of new lines is at least 20. An administrator can disable this in the general settings.",
  'overview.quality_gate.conditions_on_new_code':
    'Only conditions on new code that are defined in the Quality Gate are checked. See the {link} associated to the project for details.',
  'overview.quality_gates.conditions.condition_simplification_tour.title':
    'One condition, zero issues',
  'overview.quality_gates.conditions.condition_simplification_tour.content':
    '<p>One single condition in <link>{qualityGateName} quality gate</link> ensures that new code has no issues.</p><p>Every issue in new code must be resolved for a project to pass this quality gate.</p>',
  'overview.quality_gate.show_project_conditions_x': 'Show failed conditions for project {0}',
  'overview.quality_gate.hide_project_conditions_x': 'Hide failed conditions for project {0}',
  'overview.quality_gate.coverage': 'Coverage',
  'overview.quality_gate.duplications': 'Duplications',
  'overview.new_coverage.on_x_new_lines': 'On {link} New Lines to cover.',
  'overview.coverage.on_x_new_lines': 'On {link} lines to cover.',
  'overview.new_duplicated_lines_density.on_x_new_lines': 'On {link} New Lines.',
  'overview.duplicated_lines_density.on_x_new_lines': 'On {link} lines.',
  'overview.quality_gate.require_fixing': '{count, plural, one {requires} other {require}} fixing',
  'overview.quality_gate.require_reviewing':
    '{count, plural, one {requires} other {require}} reviewing',
  'overview.quality_gate.required_x': 'Required {operator} {requirement}',
  'overview.quality_gate.required_x_reviewed': 'Required review: {requirement}',
  'overview.quality_profiles': 'Quality Profiles used',
  'overview.new_code_period_x': 'New Code: {0}',
  'overview.max_new_code_period_from_x': 'Max New Code from: {0}',
  'overview.started_x': 'Started {0}',
  'overview.set_as_homepage': 'Set as homepage',
  'overview.new_code': 'New Code',
  'overview.overall_code': 'Overall Code',
  'overview.last_analysis_x': 'Last analysis {date}',
  'overview.previous_analysis_x': 'Previous analysis was {0}',
  'overview.started_on_x': 'Started on {0}',
  'overview.previous_analysis_on_x': 'Previous analysis on {0}',
  'overview.on_new_code': 'On New Code',
  'overview.on_new_code_long': 'Conditions on New Code',
  'overview.see_list_of_x_y_issues': 'See the list of {0} {1}',
  'overview.see_more_details_on_x_of_y': 'See more details on {0} of {1}',
  'overview.see_more_details_on_x_y': 'See more details on {0} {1}',
  'overview.metric_not_computed': 'Not computed',
  'overview.coverage.not_computed':
    'Not computed. <doc>Check language support and import guides</doc>',
  'overview.about_this_portfolio': 'About This Portfolio',
  'overview.about_this_project.APP': 'About This Application',
  'overview.about_this_project.TRK': 'About This Project',
  'overview.project_activity.APP': 'Application Activity',
  'overview.project_activity.TRK': 'Project Activity',
  'overview.project_activity.click_to_see': 'Click to see project activity',
  'overview.external_links': 'External Links',
  'overview.project_key.APP': 'Application Key',
  'overview.project_key.TRK': 'Project Key',
  'overview.project_key.click_to_copy': 'Click to copy the key to your clipboard',
  'overview.activity': 'Activity',
  'overview.activity.graph_shows_data_for_x':
    'This graph shows historical data for {0}. Click on the "Activity" link below to see more information.',
  'overview.recent_activity': 'Recent Activity',
  'overview.accepted_issues': 'Accepted issues',
  'overview.accepted_issues.description':
    'Issues that are valid, but were not fixed and represent accepted technical debt.',
  'overview.accepted_issues.total': 'Total accepted issues',
  'overview.high_impact_accepted_issues': 'Blocker and High Severity Accepted Issues',
  'overview.measures.empty_explanation':
    'Measures on New Code will appear after the second analysis of this branch.',
  'overview.measures.same_reference.explanation':
    'This branch is configured to use itself as a reference branch. It will never have New Code.',
  'overview.measures.bad_reference.explanation':
    'This branch could not be compared to its reference branch. See the SCM or analysis report for more details.',
  'overview.measures.bad_setting.link': 'This can be fixed in the {setting_link} setting.',
  'overview.measures.security_hotspots_reviewed': 'Reviewed',
  'overview.measures.software_impact.total_open_issues': 'Open issues',
  'overview.measures.software_impact.count_tooltip':
    'Issues in code can impact multiple Software Qualities, so the sum of impacts tends to be greater than the total amount of issues.',
  'overview.measures.software_impact.see_list_of_x_open_issues':
    'See the list of {count} open {softwareQuality} issues',
  'overview.measures.software_impact.severity.see_x_open_issues':
    'See {count} open {softwareQuality} issues with {severity} severity',
  'overview.measures.software_impact.severity.HIGH': 'H',
  'overview.measures.software_impact.severity.HIGH.tooltip': 'High Impact',
  'overview.measures.software_impact.severity.HIGH.improve_tooltip': 'high',
  'overview.measures.software_impact.severity.MEDIUM': 'M',
  'overview.measures.software_impact.severity.MEDIUM.tooltip': 'Medium Impact',
  'overview.measures.software_impact.severity.MEDIUM.improve_tooltip': 'medium',
  'overview.measures.software_impact.severity.LOW': 'L',
  'overview.measures.software_impact.severity.LOW.tooltip': 'Low Impact',
  'overview.measures.software_impact.severity.LOW.improve_tooltip': 'low',
  'overview.measures.software_impact.improve_rating_tooltip':
    'The {softwareQuality} rating is {ratingLabel} when there is at least one issue with {severity} impact on the {_softwareQuality} of your software.',
  'overview.measures.software_impact.improve_rating_tooltip.A':
    'The {softwareQuality} rating is {ratingLabel} when there are no issues above info severity with impact on the {_softwareQuality} of your software.',
  'overview.measures.software_impact.improve_rating_tooltip.MAINTAINABILITY':
    'The Maintainability rating is {ratingLabel} if the code has a relatively higher level of technical debt when compared to the size of the codebase.',
  'overview.measures.software_impact.improve_rating_tooltip.MAINTAINABILITY.A':
    'The Maintainability rating is A if the code has a relatively lower level of technical debt when compared to the size of the codebase.',

  'overview.project.no_lines_of_code': 'This project has no lines of code.',
  'overview.project.empty': 'This project is empty.',
  'overview.project.branch_X_no_lines_of_code': 'The "{0}" branch has no lines of code.',
  'overview.project.branch_X_empty': 'The "{0}" branch of this project is empty.',
  'overview.project.main_branch_no_lines_of_code': 'The main branch has no lines of code.',
  'overview.project.main_branch_empty': 'The main branch of this project is empty.',
  'overview.project.branch_needs_new_analysis':
    'The branch data is incomplete. Run a new analysis to update it.',
  'overview.project.last_analysis.date_time': 'Last analysis started on {0}',
  'overview.project.next_steps.set_up_pr_deco_and_ci.admin':
    "To benefit from more of {productName}'s features, {link_ci} and set up DevOps platform integration in your {link_project_settings}.",
  'overview.project.next_steps.set_up_pr_deco_and_ci':
    "To benefit from more of {productName}'s features, {link_ci} and ask a project administrator to set up DevOps platform integration.",
  'overview.project.next_steps.set_up_pr_deco.admin':
    "To benefit from more of {productName}'s features, set up DevOps platform integration in your {link_project_settings}.",
  'overview.project.next_steps.set_up_pr_deco':
    "To benefit from more of {productName}'s features, ask a project administrator to set up DevOps platform integration.",
  'overview.project.next_steps.set_up_ci':
    "To benefit from more of {productName}'s features, {link}.",
  'overview.project.next_steps.links.project_settings': 'project settings',
  'overview.project.next_steps.links.set_up_ci': 'set up analysis in your favorite CI',
  'overview.project.software_impact.has_rating':
    'Software Quality {softwareQuality} has rating {rating}',
  'overview.run_analysis_to_compute.TRK': 'Run new analysis to compute the missing data.',
  'overview.run_analysis_to_compute.APP': 'Analyse all projects to compute the missing data.',
  'overview.missing_project_data':
    'The calculation of counts and ratings for security, reliability, and maintainability has changed, which may impact this {qualifier, select, VW {portfolio after all projects are analyzed} APP {application after all projects are analyzed} other {project after the next analysis}}.  <link>Learn more in SonarQube documentation</link>',

  'overview.coverage_on': 'Coverage on',
  'overview.coverage_on_X_lines': 'Coverage on {count} Lines to cover',
  'overview.coverage_on_X_new_lines': 'Coverage on {count} New Lines to cover',
  'overview.duplications_on': 'Duplications on',
  'overview.duplications_on_X_lines': 'Duplications on {count} Lines',
  'overview.duplications_on_X_new_lines': 'Duplications on {count} New Lines',

  'overview.period.previous_version': 'Since {0}',

  // Old periods, necessary to display project that haven't been analyzed with new setting (MMF-1579)
  'overview.period.previous_version_only_date': 'Since previous version',
  'overview.period.previous_analysis': 'Since previous analysis',
  'overview.period.days': 'Last {0} days',
  'overview.period.version': 'Since {0}',
  'overview.period.date': 'After {0}',
  'overview.period.manual_baseline': 'Since {0}',

  // New periods (MMF-1579)
  'overview.period.number_of_days': 'From last {0} days',
  'overview.period.specific_analysis': 'Since {0}',
  'overview.period.reference_branch': 'Compared to {0}',

  'overview.failed.badge': '{counter} failed',
  'overview.gate.ERROR': 'Failed',
  'overview.gate.WARN': 'Warning',
  'overview.gate.OK': 'Passed',
  'overview.gate.view.no_alert': 'The view has passed the quality gate.',
  'overview.gate.view.warnings':
    'The view has warnings on the following quality gate conditions: {0}.',
  'overview.gate.view.errors': 'The view failed the quality gate on the following conditions: {0}.',

  'overview.measurement_type.DUPLICATION': 'Duplications',
  'overview.measurement_type.COVERAGE': 'Coverage',

  'overview.measures.failed_badge': 'Failed',

  'overview.complexity_tooltip.function': '{0} functions have complexity around {1}',
  'overview.complexity_tooltip.file': '{0} files have complexity around {1}',

  'overview.deprecated_profile':
    'This Quality Profile uses {0} deprecated rules and should be updated.',
  'overview.deleted_profile': '{0} has been deleted since the last analysis.',
  'overview.link_to_x_profile_y': 'Go to {0} profile "{1}"',

  'overview.sonarlint_ad.header':
    'Catch issues before they fail your Quality Gate with our IDE extension, SonarQube for IDE',
  'overview.sonarlint_ad.details_1': 'The power of Sonar analyzers directly as you type',
  'overview.sonarlint_ad.details_2': 'No need to wait for your PR to pass all checks',
  'overview.sonarlint_ad.details_3': 'Repair flagged issues in real-time with quick fixes',
  'overview.sonarlint_ad.details_4':
    '12 major IDEs supported (including key JetBrains and Microsoft IDEs)',
  'overview.sonarlint_ad.details_5': 'Free forever',
  'overview.sonarlint_ad.learn_more': 'Learn more about SonarQube for IDE',
  'overview.sonarlint_ad.close_promotion': 'Close SonarQube for IDE promotion',

  'overview.badges.get_badge': 'Badges',
  'overview.badges.title': 'Get project badges',
  'overview.badges.description.TRK':
    'Show the status of your project metrics on your README or website.',
  'overview.badges.description.VW':
    'Show the status of your portfolio metrics on your README or website.',
  'overview.badges.description.APP':
    'Show the status of your application metrics on your README or website.',
  'overview.badges.type': 'Badge type',
  'overview.badges.metric': 'Customize badge',
  'overview.badges.format': 'Code format',
  'overview.badges.options.colors.white': 'White',
  'overview.badges.options.colors.black': 'Black',
  'overview.badges.options.colors.orange': 'Orange',
  'overview.badges.options.formats.md': 'Markdown',
  'overview.badges.options.formats.url': 'Image URL only',
  'overview.badges.measure': 'Metric',
  'overview.badges.measure.alt':
    'This is an image of a standard badge that displays the current status of {metric} of your project.',
  'overview.badges.measure.description.TRK':
    'Displays the current status of one metric of your project.',
  'overview.badges.measure.description.VW':
    'Displays the current status of one metric of your portfolio.',
  'overview.badges.measure.description.APP':
    'Displays the current status of one metric of your application.',
  'overview.badges.quality_gate': 'Quality Gate',
  'overview.badges.quality_gate.alt':
    'This is an image of a quality gate badge that displays the current quality gate status of your project.',
  'overview.badges.quality_gate.description':
    'Displays the current quality gate status of your project.',
  'overview.badges.quality_gate.description.APP':
    'Displays the current quality gate status of your application.',
  'overview.badges.quality_gate.description.TRK':
    'Displays the current quality gate status of your project.',
  'overview.badges.quality_gate.description.VW':
    'Displays the current quality gate status of your portfolio.',
  'overview.badges.ai_code_assurance': 'AI Code Assurance',
  'overview.badges.ai_code_assurance.alt':
    "This is an image of an AI Code Assurance badge that displays the current status of Sonar's AI Code Assurance.",
  'overview.badges.ai_code_assurance.description':
    "Displays the current status of Sonar's AI Code Assurance.",
  'overview.badges.ai_code_assurance.description.TRK':
    "Displays the current status of Sonar's AI Code Assurance of your project.",
  'overview.badges.leak_warning':
    'Project badges can expose your security rating and other measures. Only use project badges in trusted environments.',
  'overview.badges.renew': 'Renew Token',
  'overview.badges.renew.description':
    'If your project badge security token has leaked to an unsafe environment, you can renew it:',
  'overview.badges.copy_snippet': 'Copy the snippet for your selected badge',

  'overview.quality_profiles_update_after_sq_upgrade.message':
    'Update to {productName} {sqVersion} has updated your Quality Profiles. Issues on your project may have been affected. {link}',
  'overview.quality_profiles_update_after_sq_upgrade.link': 'See more details',

  'overview.activity.variations.new_analysis': 'New analysis:',
  'overview.activity.variations.first_analysis': 'First analysis:',

  'overview.ai_assurance.unsolved_overall.title': 'Unresolved findings in overall code',
  'overview.ai_assurance.unsolved_overall.description':
    'Some unresolved findings in this branch’s overall code may represent a risk. We recommend reviewing these findings before releasing the branch.',
  'overview.ai_assurance.unsolved_overall.dismiss': 'Dismiss unresolved overall code findings',
  'overview.issues.issue_from_update': '{count} from SonarQube update',
  'overview.issues.issue_from_update.tooltip': 'Issues appearing as a result of SonarQube updates',

  //------------------------------------------------------------------------------
  //
  // WS API
  //
  //------------------------------------------------------------------------------
  'api_documentation.domain_nav': 'Web API domains navigation',
  'api_documentation.internal_tooltip':
    'Use at your own risk; internal services are subject to change or removal without notice.',
  'api_documentation.page': 'Web API',
  'api_documentation.page.v2': 'Web API v2',
  'api_documentation.show_deprecated': 'Show Deprecated API',
  'api_documentation.show_deprecated.learn_more': 'Learn more about Web API deprecation',
  'api_documentation.show_internal': 'Show Internal API',
  'api_documentation.show_internal_v2': 'Show Internal',
  'api_documentation.possible_values': 'Possible values',
  'api_documentation.default_values': 'Default value',
  'api_documentation.example_values': 'Example value',
  'api_documentation.max_values': 'Maximum allowed values',
  'api_documentation.min_value': 'Minimum value',
  'api_documentation.max_value': 'Maximum value',
  'api_documentation.min_length': 'Minimum length',
  'api_documentation.max_length': 'Maximum length',
  'api_documentation.internal': 'internal',
  'api_documentation.deprecated': 'deprecated',
  'api_documentation.deprecated_since_x': 'deprecated since {since}',
  'api_documentation.parameters': 'Parameters',
  'api_documentation.response_example': 'Response Example',
  'api_documentation.changelog': 'Changelog',
  'api_documentation.search': 'Search by name...',
  'api_documentation.v2.search': 'Search API...',
  'api_documentation.v2.parameter_header': 'Request',
  'api_documentation.v2.response_header': 'Response',
  'api_documentation.v2.request_subheader.query': 'Query Parameters',
  'api_documentation.v2.request_subheader.path': 'Path Parameters',
  'api_documentation.v2.request_subheader.header': 'Headers',
  'api_documentation.v2.request_subheader.request_body': 'Request Body',
  'api_documentation.v2.request_subheader.request_content_type': 'Content-Type:',
  'api_documentation.v2.enum_description': 'Valid values: {values}',

  //------------------------------------------------------------------------------
  //
  // CODE
  //
  //------------------------------------------------------------------------------
  'code.ai_badge_tooltip.application':
    'This application contains project(s) with AI-generated code.',
  'code.ai_badge_tooltip.project': 'This project contains AI-generated code.',
  'code.ai_badge_tooltip.sub_portfolio':
    'This nested portfolio contains project(s) with AI-generated code.',
  'code.aica_disabled_projects': 'Projects without AI Code Assurance enabled',
  'code.aica_disabled_projects.tooltip':
    "Projects in this portfolio that do not use Sonar's AI Code Assurance feature.",
  'code.aica_enabled_projects': 'AI Code Assurance enabled projects',
  'code.aica_enabled_projects.tooltip':
    "Projects in this portfolio that contain AI-generated code and benefit from Sonar's AI Code Assurance.",
  'code.open_component_page': "Open Component's Page",
  'code.search_placeholder': 'Search for files...',
  'code.search_placeholder.application': 'Search for projects...',
  'code.search_placeholder.portfolio': 'Search for projects and sub-portfolios...',
  'code.parent_folder': 'Parent folder',
  'code.last_analysis_date': 'Last analysis',
  'code.name': 'Name',
  'code.pin': 'Pin file',

  //------------------------------------------------------------------------------
  //
  // PROMOTION
  //
  //------------------------------------------------------------------------------

  'promotion.security_dev_edition.title': 'Did you know...',
  'promotion.security_dev_edition.text':
    'SonarQube Developer Edition can detect <b>260+ additional</b> distinct types of security issues across the languages of your projects.',
  'promotion.security_dev_edition.action': 'Compare benefits',

  //------------------------------------------------------------------------------
  //
  // COMPONENT MEASURES
  //
  //------------------------------------------------------------------------------
  'component_measures.details_are_not_available':
    'Details are not available for estimated measures.',
  'component_measures.domain_x_overview': '{0} Overview',
  'component_measures.domain_overview': 'Overview',
  'component_measures.items': 'items',
  'component_measures.tab.tree': 'Tree',
  'component_measures.tab.list': 'List',
  'component_measures.show_metric_history': 'Show history of this metric',
  'component_measures.tab.treemap': 'Treemap',
  'component_measures.view_as': 'View as',
  'component_measures.legend.color': 'Color:',
  'component_measures.legend.size': 'Size:',
  'component_measures.legend.worse_of_x_y': 'Worse of {0} and {1}',
  'component_measures.legend.help_x': 'Click to toggle visibility for data with rating {0}.',
  'component_measures.legend.only_first_500_files': 'Only showing data for the first 500 files',
  'component_measures.no_history': "There isn't enough data to generate an activity graph.",
  'component_measures.not_found': 'The requested measure was not found.',
  'component_measures.empty': 'No measures.',
  'component_measures.select_files': 'Select files',
  'component_measures.navigate': 'Navigate',
  'component_measures.to_select_files': 'to select files',
  'component_measures.to_navigate': 'to navigate',
  'component_measures.to_navigate_files': 'to next/previous file',
  'component_measures.hidden_best_score_metrics':
    'There are {0} hidden components with a score of {1}.',
  'component_measures.hidden_best_score_metrics_show_label': 'Show hidden components',
  'component_measures.navigation': 'Measures navigation',
  'component_measures.skip_to_navigation': 'Skip to measure navigation',
  'component_measures.see_metric_history': 'See history',
  'component_measures.leak_legend.new_code': 'New Code:',
  'component_measures.awaiting_analysis.name': 'Issues',
  'component_measures.leak_awaiting_analysis.name': 'Issues',

  'component_measures.overview.project_overview.subnavigation': 'Project Overview',
  'component_measures.overview.project_overview.title': 'Risk',
  'component_measures.overview.project_overview.description':
    'Get quick insights into the operational risks. For users relying on their keyboard, elements are sorted by the number of lines of code for each file. Any color but green indicates immediate risks: Bugs or Vulnerabilities that should be examined. A position at the top or right of the graph means that the longer-term health may be at risk. Green bubbles at the bottom-left are best.',
  'component_measures.overview.Reliability.description':
    "See bugs' operational risks. For users relying on their keyboard, elements are sorted by volume of bugs per file. The closer a bubble's color is to red, the more severe the worst bugs are. Bubble size indicates bug volume, and each bubble's vertical position reflects the estimated time to address the bugs. Small green bubbles on the bottom edge are best.",
  'component_measures.overview.Security.description':
    "See vulnerabilities' operational risks. For users relying on their keyboard, elements are sorted by volume of vulnerabilities per file. The closer a bubble's color is to red, the more severe the worst vulnerabilities are. Bubble size indicates vulnerability volume, and each bubble's vertical position reflects the estimated time to address the vulnerabilities. Small green bubbles on the bottom edge are best.",
  'component_measures.overview.Maintainability.description':
    "See code smells' long-term risks. For users relying on their keyboard, elements are sorted by the volume of code smells for each file. The closer a bubble's color is to red, the higher the ratio of technical debt is. Bubble size indicates code smell volume, and each bubble's vertical position reflects the estimated time to address the code smells. Small green bubbles on the bottom edge are best.",
  'component_measures.overview.Coverage.description':
    "See missing test coverage's long-term risks. For users relying on their keyboard, elements are sorted by volume of uncovered lines per file. Bubble size indicates the volume of uncovered lines, and each bubble's vertical position reflects the volume of missing coverage. Small bubbles on the bottom edge are best.",
  'component_measures.overview.Duplications.description':
    "See duplications' long-term risks. For users relying on their keyboard, elements are sorted by the number of duplicated blocks per file. Bubble size indicates the volume of duplicated blocks, and each bubble's vertical position reflects the volume of lines in those blocks. Small bubbles on the bottom edge are best.",
  'component_measures.overview.see_data_as_list': 'See the data presented on this chart as a list',

  'component_measures.domain_subnavigation.Reliability.help':
    'Issues in this domain mark code where you will get behavior other than what was expected.',
  'component_measures.domain_subnavigation.Maintainability.help':
    'Issues in this domain mark code that will be more difficult to update competently than it should.',
  'component_measures.domain_subnavigation.Security.help':
    'Issues in this domain mark potential weaknesses to hackers.',
  'component_measures.domain_subnavigation.SecurityReview.help':
    'This domain represents potential security risks in the form of hotspots and their review status.',
  'component_measures.domain_subnavigation.Complexity.help':
    'How simple or complicated the control flow of the application is. Cyclomatic Complexity measures the minimum number of test cases required for full test coverage. Cognitive Complexity is a measure of how difficult the application is to understand',

  'component_measures.subnavigation_category.new_code_category': 'New Code',
  'component_measures.subnavigation_category.overall_category': 'Overall Code',
  'component_measures.subnavigation_category.tests_category': 'Tests',

  'component_measures.facet_category.overall_category.estimated': 'Estimated after merge',
  'component_measures.bubble_chart.zoom_level':
    'Current zoom level. Scroll on the chart to zoom or unzoom, click here to reset.',
  'component_measures.not_all_measures_are_shown': 'Not all projects and applications are included',
  'component_measures.not_all_measures_are_shown.help':
    'You do not have access to all projects and/or applications. Measures are still computed based on all projects and applications.',

  'component_measures.metric.new_security_issues.name': 'Issues',
  'component_measures.metric.new_software_quality_security_issues.name': 'Issues',
  'component_measures.metric.new_security_issues.detailed_name': 'New Issues',
  'component_measures.metric.new_software_quality_security_issues.detailed_name': 'New Issues',
  'component_measures.metric.new_vulnerabilities.name': 'Vulnerabilities',
  'component_measures.metric.new_vulnerabilities.detailed_name': 'New Vulnerabilities',
  'component_measures.metric.new_reliability_issues.name': 'Issues',
  'component_measures.metric.new_software_quality_reliability_issues.name': 'Issues',
  'component_measures.metric.new_reliability_issues.detailed_name': 'New Issues',
  'component_measures.metric.new_software_quality_reliability_issues.detailed_name': 'New Issues',
  'component_measures.metric.new_maintainability_issues.name': 'Issues',
  'component_measures.metric.new_software_quality_maintainability_issues.name': 'Issues',
  'component_measures.metric.new_maintainability_issues.detailed_name': 'New Issues',
  'component_measures.metric.new_software_quality_maintainability_issues.detailed_name':
    'New Issues',
  'component_measures.metric.new_code_smells.name': 'Code Smells',
  'component_measures.metric.new_code_smells.detailed_name': 'New Code Smells',
  'component_measures.metric.new_violations.name': 'Open Issues',
  'component_measures.metric.new_violations.detailed_name': 'New Open Issues',
  'component_measures.metric.new_accepted_issues.name': 'Accepted Issues',
  'component_measures.metric.new_accepted_issues.detailed_name': 'New Accepted Issues',
  'component_measures.metric.new_bugs.name': 'Bugs',
  'component_measures.metric.new_bugs.detailed_name': 'New Bugs',
  'component_measures.metric.security_issues.name': 'Issues',
  'component_measures.metric.software_quality_security_issues.name': 'Issues',
  'component_measures.metric.vulnerabilities.name': 'Vulnerabilities',
  'component_measures.metric.reliability_issues.name': 'Issues',
  'component_measures.metric.software_quality_reliability_issues.name': 'Issues',
  'component_measures.metric.bugs.name': 'Bugs',
  'component_measures.metric.maintainability_issues.name': 'Issues',
  'component_measures.metric.software_quality_maintainability_issues.name': 'Issues',
  'component_measures.metric.code_smells.name': 'Code Smells',
  'component_measures.metric.violations.name': 'Open Issues',
  'component_measures.metric.accepted_issues.name': 'Accepted Issues',
  'component_measures.metric.confirmed_issues.name': 'Confirmed Issues',
  'component_measures.metric.false_positive_issues.name': 'False Positive Issues',
  //------------------------------------------------------------------------------
  //
  // DOCS
  //
  //------------------------------------------------------------------------------
  'docs.documentation': 'Documentation',
  'docs.get_help': 'Get Help',
  'docs.roadmap': 'Product Roadmap',
  'docs.news': 'Product News',
  'docs.stay_connected': 'Stay Connected',
  'docs.suggestion': 'Suggestions For This Page',

  //------------------------------------------------------------------------------
  //
  // GLOBAL FOOTER
  //
  //------------------------------------------------------------------------------
  'footer.community': 'Community',
  'footer.contact_us': 'Contact us',
  'footer.documentation': 'Documentation',
  'footer.help': 'Help',
  'footer.license.lgplv3': 'LGPL v3',
  'footer.license.sqs': 'Terms & Conditions',
  'footer.news': 'News',
  'footer.plugins': 'Plugins',
  'footer.pricing': 'Pricing',
  'footer.privacy': 'Privacy',
  'footer.security': 'Security',
  'footer.status': 'Status',
  'footer.terms': 'Terms',
  'footer.version.full': 'v{version}{status}',
  'footer.version.short': 'v{version}',
  'footer.version.status': '{status}',
  'footer.version.status.active': 'ACTIVE',
  'footer.version.status.inactive': 'NO LONGER ACTIVE',
  'footer.web_api': 'Web API',
  'footer.mode.STANDARD': 'Standard Experience',
  'footer.mode.MQR': 'MQR Mode',

  //------------------------------------------------------------------------------
  //
  // NEW CODE DEFINITION
  //
  //------------------------------------------------------------------------------
  'new_code_definition.question': 'Instance default new code definition:',
  'new_code_definition.specific_setting': 'Define a specific setting for this project',
  'new_code_definition.previous_version': 'Previous version',
  'new_code_definition.previous_version.usecase':
    'Recommended for <b>projects following regular versions or releases.</b>',
  'new_code_definition.previous_version.description':
    'Any code that has changed since the previous version is considered new code.',

  'new_code_definition.number_days': 'Number of days',
  'new_code_definition.number_days.specify_days': 'Specify a number of days',
  'new_code_definition.number_days.usecase':
    'Recommended for <b>projects following continuous delivery.</b>',
  'new_code_definition.number_days.description':
    'Any code that has changed in the last x days is considered new code. If no action is taken on a new issue after x days, this issue will become part of the overall code.',

  'new_code_definition.reference_branch': 'Reference branch',
  'new_code_definition.reference_branch.notice':
    'The main branch will be set as the reference branch when the project is created. You will be able to choose another branch as the reference branch when your project will have more branches.',

  'new_code_definition.auto_update.branch.message':
    'The new code definition of the following branch(es) was automatically changed on {date}, following a {productName} update, as it was exceeding the maximum value: {branchesList} {link}',
  'new_code_definition.auto_update.branch.list_item':
    '{branchName}: Number of days was changed from {previousDays} to {days}.',
  'new_code_definition.auto_update.global.message':
    'The global new code definition was automatically changed from {previousDays} to {days} days on {date}, following a {productName} update, as it was exceeding the maximum value. {link}',
  'new_code_definition.auto_update.ncd_page.message':
    'The number of days was automatically changed from {previousDays} to {days} on {date}, following a {productName} update, as it was exceeding the maximum value. {link}',
  'new_code_definition.auto_update.project.message':
    "This project's new code definition was automatically changed from {previousDays} to {days} days on {date}, following a {productName} update, as it was exceeding the maximum value. {link}",
  'new_code_definition.auto_update.review_link': 'Review new code definition',
  'new_code_definition.change_notice': 'Changes will take effect after the next analysis.',
  'new_code_definition.page.title': 'New Code',

  'new_code_definition.specific_setting.previous_version.label': 'Previous version',
  'new_code_definition.specific_setting.previous_version.description':
    'Any code that has changed since the previous version is considered new code. Recommended for <b>projects following regular versions or releases.</b>',
  'new_code_definition.specific_setting.number_of_days.label': 'Number of days',
  'new_code_definition.specific_setting.number_of_days.description':
    'Any code that has changed in the last x days is considered new code. If no action is taken on a new issue after x days, this issue will become part of the overall code. Recommended for <b>projects following continuous delivery.</b>',
  'new_code_definition.specific_setting.number_of_days.input.label': 'Define the number of days',
  'new_code_definition.specific_setting.number_of_days.input.error':
    'Please provide a whole number between {min} and {max}.',

  'new_code_definition.specific_setting.reference_branch.label': 'Reference branch',
  'new_code_definition.specific_setting.reference_branch.description':
    'Choose a reference branch as the baseline for the new code. Recommended for <b>projects using feature branches.</b>',
  'new_code_definition.specific_setting.reference_branch.input.label': 'Choose branch',
  'new_code_definition.specific_setting.reference_branch.input.help.main':
    'The branch you selected will need its own new code definition to prevent it from using itself as a reference',

  'new_code_definition.specific_setting.specific_analysis.label': 'Specific analysis',
  'new_code_definition.specific_setting.specific_analysis.description':
    'Choose an analysis as the baseline for the new code.',
  'new_code_definition.specific_setting.specific_analysis.warning.label':
    'This option has been deprecated but remains available through the Web API',
  'new_code_definition.specific_setting.specific_analysis.warning.description':
    'Choosing the "Specific analysis" option from the {productName} UI is not recommended by Sonar.',

  //------------------------------------------------------------------------------
  //
  // ONBOARDING
  //
  //------------------------------------------------------------------------------
  'onboarding.alm.azure': 'Azure DevOps',
  'onboarding.alm.bitbucket': 'Bitbucket Server',
  'onboarding.alm.bitbucketcloud': 'Bitbucket Cloud',
  'onboarding.alm.gitlab': 'GitLab',

  'onboarding.project_analysis.menu_entry': 'Project onboarding',
  'onboarding.project_analysis.header': 'Analyze your project',
  'onboarding.project_analysis.description':
    "We initialized your project on {productName}, now it's up to you to launch analyses!",
  'onboarding.project_analysis.guide_to_integrate_pipelines':
    'follow the guide to integrating with Pipelines',

  'onboarding.create_project.manual.step1': '1 of 2',
  'onboarding.create_project.manual.step2': '2 of 2',
  'onboarding.create_project.manual.title': 'Create a local project',
  'onboarding.create_project.select_method': 'How do you want to create your project?',
  'onboarding.create_project.select_method.manually':
    'Are you just testing or have an advanced use-case?',
  'onboarding.create_project.select_method.devops_platform':
    "Do you want to benefit from all of {productName}'s features (like repository import and Pull Request decoration)?",
  'onboarding.create_project.select_method.devops_platform_second':
    'Create your project from your favorite DevOps platform.',

  'onboarding.create_project.select_method.no_alm_yet.admin':
    'First, you need to set up a DevOps platform configuration.',
  'onboarding.create_project.select_method.manual': 'Local project',
  'onboarding.create_project.select_method.azure': 'From Azure DevOps',
  'onboarding.create_project.select_method.bitbucket': 'From Bitbucket Server',
  'onboarding.create_project.select_method.bitbucketcloud': 'From Bitbucket Cloud',
  'onboarding.create_project.select_method.github': 'From GitHub',
  'onboarding.create_project.select_method.gitlab': 'From GitLab',
  'onboarding.create_project.import_select_method.manual': 'Create a local project',
  'onboarding.create_project.import_select_method.azure': 'Import from Azure DevOps',
  'onboarding.create_project.import_select_method.bitbucket': 'Import from Bitbucket Server',
  'onboarding.create_project.import_select_method.bitbucketcloud': 'Import from Bitbucket Cloud',
  'onboarding.create_project.import_select_method.github': 'Import from GitHub',
  'onboarding.create_project.import_select_method.gitlab': 'Import from GitLab',
  'onboarding.create_project.alm_not_configured':
    'Contact your admin to set up the global configuration allowing you to import project from this DevOps Platform',
  'onboarding.create_project.check_alm_supported': 'Checking if available',
  'onboarding.create_project.project_key': 'Project key',
  'onboarding.create_project.project_key.duplicate_key': 'The project key name is already taken.',
  'onboarding.create_project.project_key.wrong_format':
    "The provided value doesn't match the expected format.",
  'onboarding.create_project.project_key.description':
    "The project key is a unique identifier for your project. It may contain up to 400 characters. Allowed characters are alphanumeric, '-' (dash), '_' (underscore), '.' (period) and ':' (colon), with at least one non-digit.",
  'onboarding.create_project.project_key.valid': 'The provided key can be used',
  'onboarding.create_project.project_key.error.empty': 'You must provide at least one character.',
  'onboarding.create_project.project_key.error.too_long': 'The provided key is too long.',
  'onboarding.create_project.project_key.error.invalid_char':
    'The provided key contains invalid characters.',
  'onboarding.create_project.project_key.error.only_digits':
    'The provided key contains only digits.',
  'onboarding.create_project.display_name': 'Project display name',
  'onboarding.create_project.display_name.description':
    'Up to 255 characters. Some scanners might override the value you provide.',

  'onboarding.create_project.main_branch_name': 'Main branch name',
  'onboarding.create_project.main_branch_name.error.empty': 'Please provide a main branch name.',
  'onboarding.create_project.main_branch_name.description':
    'The name of your project’s default branch { learn_more }',

  'onboarding.create_project.pr_decoration.information':
    'Local projects won’t benefit from the features associated with DevOps Platforms integration unless you configure them in the project settings.',
  'onboarding.create_project.repository_imported': 'Already imported',
  'onboarding.create_project.import': 'Import',
  'onboarding.create_project.see_project': 'See the project',
  'onboarding.create_project.search_projects_by_name': 'Search for project name starting with...',
  'onboarding.create_project.search_repositories_by_name':
    'Search for repository name starting with...',
  'onboarding.create_project.search_mode': 'Search for',
  'onboarding.create_project.search_mode.project': 'Project',
  'onboarding.create_project.search_mode.repository': 'Repository',
  'onboarding.create_project.search_projects_repositories': 'Search for projects and repositories',
  'onboarding.create_project.search_repositories': 'Search for a repository',
  'onboarding.create_project.select_repositories': 'Select repositories',
  'onboarding.create_project.select_all_repositories': 'Select currently visible repositories',

  'onboarding.create_application.key.description':
    'If specified, this value is used as the key instead of generating it from the name of the Application. Only letters, digits, dashes and underscores can be used.',
  'onboarding.create_project.pat_form.title': 'Grant access to your repositories',
  'onboarding.create_project.pat_form.help.azure':
    '{productName} needs a personal access token to access and list your repositories from Azure DevOps.',
  'onboarding.create_project.pat_form.help.bitbucket':
    '{productName} needs a personal access token to access and list your repositories from Bitbucket Server.',
  'onboarding.create_project.pat_form.help.bitbucket_cloud':
    '{productName} needs an API token to access and list your repositories from Bitbucket Cloud.',
  'onboarding.create_project.pat_form.help.gitlab':
    '{productName} needs a personal access token to access and list your projects from GitLab.',
  'onboarding.create_project.pat_form.pat_required': 'Please enter a personal access token',
  'onboarding.create_project.wrong_binding_count':
    'You must have at least 1 {alm} instance configured in order to use this method, but none were found. Either create a local project, or contact your system administrator.',
  'onboarding.create_project.wrong_binding_count.admin':
    'You must have at least 1 {alm} instance configured in order to use this method. You can configure instances under {url}.',
  'onboarding.create_project.azure.no_url.admin':
    'Your Azure DevOps instance configuration is missing a URL. We cannot import projects in the current state. You can configure instances under {url}.',
  'onboarding.create_project.azure.no_url':
    'Your Azure DevOps instance configuration is missing a URL. We cannot import projects in the current state. Please contact your system administrator.',
  'onboarding.create_project.enter_pat': 'Personal Access Token',
  'onboarding.create_project.bitbucket_cloud.enter_password': 'API token',
  'onboarding.create_project.bitbucket_cloud.enter_username': 'Atlassian account email address',
  'onboarding.create_project.pat_incorrect.azure': "Your personal access couldn't be validated.",
  'onboarding.create_project.pat_incorrect.bitbucket':
    "Your personal access couldn't be validated.",
  'onboarding.create_project.pat_incorrect.bitbucket_cloud':
    "Your API token couldn't be validated.",
  'onboarding.create_project.pat_incorrect.gitlab':
    "Your personal access couldn't be validated. Please make sure it has the right scope and that it is not expired.",
  'onboarding.create_project.pat.expired.info_message':
    'You have to do this again as your token may have expired or has been revoked. If this does not fix the issue, please contact your system administrator.',

  'onboarding.create_project.pat_help.instructions.azure':
    'To create a Personal Access Token on Azure, {link} and make sure to select the “Code (Read)” scope.',
  'onboarding.create_project.pat_help.instructions.link.azure': 'generate a token',

  'onboarding.create_project.pat_help.instructions.gitlab':
    'To create a Personal Access Token on GitLab, {link} by setting a name, for example “{productName}” and selecting the “read_api” scope.',
  'onboarding.create_project.pat_help.instructions.gitlab.link': 'generate a token',

  'onboarding.enter_username.instructions.bitbucket_cloud':
    'Find your email address in your {link}',
  'onboarding.enter_username.instructions.bitbucket_cloud.link': 'Atlassian settings',

  'onboarding.create_project.enter_password.instructions.bitbucket_cloud':
    'To get an API token, {link}',
  'onboarding.create_project.enter_password.instructions.bitbucket_cloud.link':
    'view our "API token with scopes" guide',

  'onboarding.create_project.pat_help.instructions.bitbucket_server':
    'To create a Personal Access Token on BitBucket Server, go to {link} and click on “Create token”. Set a name, for example “{productName}” and select the following permissions “Projects: Read” “Repositories: Read”.',
  'onboarding.create_project.pat_help.instructions.bitbucket_server.link': 'HTTP access tokens',

  'onboarding.create_project.pat_help.instructions2.bitbucket':
    'Set a name, for example "{productName}", and select the following permissions:',
  'onboarding.create_project.pat_help.instructions2.bitbucketcloud':
    'Set a name, for example "{productName}", and select the following permissions:',

  'onboarding.create_project.pat_help.instructions2.gitlab':
    'Set a name, for example "{productName}", and select the following scope:',
  'onboarding.create_project.pat_help.gitlab.read_api_permission': 'read_api',

  'onboarding.create_project.no_bbs_projects':
    'No projects could be fetched from Bitbucket Server. Contact your system administrator, or {link}.',
  'onboarding.create_project.no_bbs_repos':
    'No repositories were found for this project. Contact your system administrator, or {link}.',
  'onboarding.create_project.update_your_token': 'update your personal access token',
  'onboarding.create_project.no_bbs_repos.filter': 'No repositories match your filter.',
  'onboarding.create_project.only_showing_X_first_repos':
    "We're only displaying the first {0} repositories. If you're looking for a repository that's not in this list, use the search above.",
  'onboarding.create_project.see_on': 'See on {almName}',

  'onboarding.create_project.search_prompt': 'Search for projects',
  'onboarding.create_project.set_up': 'Set up',
  'onboarding.create_project.subtitle_monorepo_setup_link': 'set up a monorepo',
  'onboarding.create_project.azure.title': 'Azure project onboarding',
  'onboarding.create_project.azure.subtitle': 'Import projects from one of your Azure projects',
  'onboarding.create_project.azure.subtitle.reset_pat':
    'Reset your Azure DevOps personal access token',
  'onboarding.create_project.azure.subtitle.with_monorepo':
    'Import projects from one of your Azure projects or {monorepoSetupLink}.',
  'onboarding.create_project.azure.no_projects':
    'No projects could be fetched from Azure DevOps. Contact your system administrator, or {link}.',
  'onboarding.create_project.azure.search_results_for_project_X': 'Search results for "{0}"',
  'onboarding.create_project.azure.no_repositories':
    'Could not fetch repositories for this project. Contact your system administrator, or {link}.',
  'onboarding.create_project.azure.no_results': 'No repositories match your search query.',
  'onboarding.create_project.bitbucketcloud.title': 'Bitbucket Cloud project onboarding',
  'onboarding.create_project.bitbucketcloud.subtitle.reset_pat':
    'Reset your Bitbucket Cloud API token',
  'onboarding.create_project.bitbucketcloud.subtitle':
    'Import projects from one of your Bitbucket Cloud workspaces',
  'onboarding.create_project.bitbucketcloud.subtitle.with_monorepo':
    'Import projects from one of your Bitbucket Cloud workspaces or {monorepoSetupLink}.',
  'onboarding.create_project.bitbucketcloud.no_projects':
    'No projects could be fetched from Bitbucket. Contact your system administrator, or {link}.',
  'onboarding.create_project.bitbucketcloud.link': 'See on Bitbucket',
  'onboarding.create_project.github.title': 'GitHub project onboarding',
  'onboarding.create_project.github.subtitle':
    'Import repositories from one of your GitHub organizations.',
  'onboarding.create_project.github.subtitle.with_monorepo':
    'Import repositories from one of your GitHub organizations or {monorepoSetupLink}.',
  'onboarding.create_project.github.choose_organization': 'Choose an organization',
  'onboarding.create_project.github.choose_repository': 'Choose the repository',
  'onboarding.create_project.github.warning.message':
    'Could not connect to GitHub. Please contact an administrator to configure GitHub integration.',
  'onboarding.create_project.github.warning.message_admin':
    'Could not connect to GitHub. Please make sure the GitHub instance is correctly configured in the {link} to create a new project from a repository.',
  'onboarding.create_project.github.warning.message_admin.link':
    'DevOps Platform integration settings',
  'onboarding.create_project.github.no_orgs':
    "We couldn't load any organizations with your key. Contact an administrator.",
  'onboarding.create_project.github.no_orgs_admin':
    "We couldn't load any organizations. Make sure the GitHub App is installed in at least one organization and check the GitHub instance configuration in the {link}.",
  'onboarding.create_project.github.no_projects':
    'No projects could be fetched from GitHub. Contact your system administrator.',
  'onboarding.create_project.gitlab.title': 'GitLab project onboarding',
  'onboarding.create_project.gitlab.subtitle': 'Import projects from one of your GitLab groups',
  'onboarding.create_project.gitlab.subtitle.reset_pat': 'Reset your GitLab personal access token',
  'onboarding.create_project.gitlab.subtitle.with_monorepo':
    'Import projects from one of your GitLab groups or {monorepoSetupLink}.',
  'onboarding.create_project.gitlab.no_projects':
    'No projects could be fetched from GitLab. Contact your system administrator, or {link}.',
  'onboarding.create_project.gitlab.link': 'See on GitLab',
  'onboarding.create_project.bitbucket.title': 'Bitbucket Server project onboarding',
  'onboarding.create_project.bitbucket.subtitle.reset_pat':
    'Reset your Bitbucket Server personal access token',
  'onboarding.create_project.bitbucket.subtitle':
    'Import projects from one of your Bitbucket server workspaces',
  'onboarding.create_project.bitbucket.subtitle.with_monorepo':
    'Import projects from one of your Bitbucket server workspaces or {monorepoSetupLink}.',
  'onboarding.create_project.x_repositories_selected':
    '{count} {count, plural, one {repository} other {repositories}} selected',
  'onboarding.create_project.x_repository_created':
    '{count} {count, plural, one {repository} other {repositories}} will be created as {count, plural, one {a project} other {projects}} in {productName}',
  'onboarding.create_project.please_dont_leave':
    'If you leave the page the import could fail. Are you sure you want to leave?',
  'onboarding.create_project.import_in_progress':
    '{count} of {total} projects imported. Please do not close this page until the import is complete.',

  'onboarding.create_project.monorepo.title': '{almName} monorepo project onboarding',
  'onboarding.create_project.monorepo.subtitle':
    'Create multiple {productName} projects corresponding to the same monorepo and bound to the same repository.',
  'onboarding.create_project.monorepo.doc_link': 'Learn more and get help setting up your monorepo',
  'onboarding.create_project.monorepo.choose_organization_and_repository':
    'Choose the organization and the repository',
  'onboarding.create_project.monorepo.choose_dop_setting': 'Choose the {almKey} configuration',
  'onboarding.create_project.monorepo.choose_organization': 'Choose the organization',
  'onboarding.create_project.monorepo.choose_organization.placeholder': 'List of organizations',
  'onboarding.create_project.monorepo.choose_repository': 'Choose the repository',
  'onboarding.create_project.monorepo.choose_repository.placeholder': 'List of repositories',
  'onboarding.create_project.monorepo.choose_repository.no_already_bound_projects':
    'This repository has no imported projects in {productName}',
  'onboarding.create_project.monorepo.choose_repository.existing_already_bound_projects':
    "This repository has already been imported, and it's linked to these projects in {productName}:",
  'onboarding.create_project.monorepo.no_orgs':
    "We couldn't load any organizations with your key. Contact an administrator.",
  'onboarding.create_project.monorepo.no_orgs_admin':
    "We couldn't load any organizations. Make sure the {almKey} App is installed in at least one organization and check the {almKey} instance configuration in the {link}.",
  'onboarding.create_project.monorepo.no_projects':
    'No projects could be fetched from {almKey}. Contact your system administrator.',
  'onboarding.create_project.monorepo.project_title': 'Create new projects',
  'onboarding.create_project.monorepo.add_project': 'Add new project',
  'onboarding.create_project.monorepo.remove_project': 'Remove project',
  'onboarding.create_project.monorepo.warning.message':
    'Could not connect to {almKey}. Please contact an administrator to configure {almKey} integration.',
  'onboarding.create_project.monorepo.warning.message_admin':
    'Could not connect to {almKey}. Please make sure the {almKey} instance is correctly configured in the {link} to create a new project from a repository.',
  'onboarding.create_project.monorepo.warning.message_admin.link':
    'DevOps Platform integration settings',

  'onboarding.create_project.new_code_definition.title': 'Set up new code for project',
  'onboarding.create_x_project.new_code_definition.title':
    'Set up new code for {count, plural, one {project} other {# projects}}',
  'onboarding.create_project.new_code_definition.create_x_projects':
    'Create {count, plural, one {project} other {# projects}}',
  'onboarding.create_projects.new_code_definition.change_info':
    'You can change this setting for each project individually at any time in the project administration settings.',
  'onboarding.create_project.success':
    'Your {count, plural, one {project has} other {# projects have}} been created.',
  'onboarding.create_project.monorepo.success':
    'Your monorepo has been set up successfully. {count, plural, one {1 new project was} other {# new projects were}} created',
  'onboarding.create_project.success.admin':
    'Project {project_link} has been successfully created.',
  'onboarding.create_project.failure':
    'Import of {count, plural, one {# project} other {# projects}} failed.',

  'onboarding.token.header': 'Provide a token',
  'onboarding.token.text':
    'The token is used to identify you when an analysis is performed. If it has been compromised, you can revoke it at any point in time in your {link}.',
  'onboarding.token.text.PROJECT_ANALYSIS_TOKEN':
    'The project token is used to identify you when an analysis is performed. If it has been compromised, you can revoke it at any point in time in your {link}.',
  'onboarding.token.text.GLOBAL_ANALYSIS_TOKEN':
    'The global token is used to identify you when an analysis is performed. If it has been compromised, you can revoke it at any point in time in your {link}.',
  'onboarding.token.text.user_account': 'user account',
  'onboarding.token.generate': 'Generate',
  'onboarding.token.generate.long': 'Generate a token',
  'onboarding.token.generate.PROJECT_ANALYSIS_TOKEN': 'Generate a project token',
  'onboarding.token.generate.GLOBAL_ANALYSIS_TOKEN': 'Generate a global token',
  'onboarding.token.use_existing_token': 'Use existing token',
  'onboarding.token.use_existing_token.label': 'Existing token value',
  'onboarding.token.use_existing_token.help': 'Paste an existing token value into the input field.',
  'onboarding.token.warning_project_token_scope':
    'Please note that this token will only allow you to analyze the current project. If you want to use the same token to analyze multiple projects, you need to generate a global token in your {link}. See the {doc_link} for more information.',
  'onboarding.token.name.label': 'Token name',
  'onboarding.token.name.placeholder': 'Enter a name for your token',
  'onboarding.token.name.help': 'Enter a name for your project token',
  'onboarding.token.invalid_format': 'The token you have entered has invalid format.',
  'onboarding.token.delete': 'Delete the token',

  'onboarding.tutorial.env_variables': 'In the {field} field, enter {value} {extra}',
  'onboarding.tutorial.env_variables.field': 'Value',
  'onboarding.tutorial.env_variables.token_generator.value':
    'an existing token, or a newly generated one:',

  'onboarding.analysis.header': 'Run analysis on your project',
  'onboarding.analysis.auto_refresh_after_analysis.done': 'Is my analysis done?',
  'onboarding.analysis.auto_refresh_after_analysis.auto_refresh':
    'If your analysis is successful, this page will automatically refresh in a few moments.',
  'onboarding.analysis.auto_refresh_after_analysis.check_these_links':
    "While you're waiting, check out these links to learn how to configure Branch Analysis and Pull Request Analysis:",
  'onboarding.analysis.auto_refresh_after_analysis.check_these_links.pr_analysis':
    'Pull Request Analysis',
  'onboarding.analysis.auto_refresh_after_analysis.check_these_links.branches': 'Branch Analysis',
  'onboarding.analysis.auto_refresh_after_analysis.community.check_these_links':
    "While you're waiting, why not consider upgrading to our {edition}?  It offers additional features such as {branches} and {pull_requests}.",
  'onboarding.analysis.auto_refresh_after_analysis.community.check_these_links.edition':
    'Developer Edition',

  'onboarding.build': 'What option best describes your project?',
  'onboarding.build.maven': 'Maven',
  'onboarding.build.gradle': 'Gradle',
  'onboarding.build.make': 'Make',
  'onboarding.build.dotnet': '.NET',
  'onboarding.build.dotnet.win_core': 'Windows + .NET Core',
  'onboarding.build.dotnet.win_msbuild': 'Windows + .NET Framework',
  'onboarding.build.dotnet.linux_core': 'Linux + .NET Core',
  'onboarding.build.cpp': 'C or C++',
  'onboarding.build.objectivec': 'Objective-C',
  'onboarding.build.dart': 'Flutter or Dart',
  'onboarding.build.other': 'Other (for Go, PHP, ...)',

  'onboarding.build.jsts': 'JS/TS & Web',
  'onboarding.analysis.jsts.install.header': 'Install the Scanner for npm projects',
  'onboarding.analysis.jsts.links.documentation':
    'official documentation of the Scanner for npm projects',
  'onboarding.analysis.jsts.execute.header': 'Execute the Scanner',
  'onboarding.analysis.jsts.execute.text': `Running a SonarQube analysis with the Scanner for npm projects is straightforward. You just need to run the following command in your project's folder.`,
  'onboarding.analysis.jsts.step.footer': `Please visit the {link} for more details.`,

  'onboarding.build.python': 'Python',
  'onboarding.analysis.python.install.header': 'Install the Scanner for Python projects',
  'onboarding.analysis.python.links.documentation':
    'official documentation of the Scanner for Python projects',
  'onboarding.analysis.python.execute.header': 'Execute the Scanner',
  'onboarding.analysis.python.execute.text': `Running a SonarQube analysis with the Scanner for Python projects is straightforward. You just need to run the following command in your project's folder.`,
  'onboarding.analysis.python.step.footer': `Please visit the {link} for more details.`,

  'onboarding.build.dotnet.variant': 'Which framework do you use?',
  'onboarding.build.dotnet.variant.dotnet_core': '.NET Core',
  'onboarding.build.dotnet.variant.dotnet_framework': '.NET Framework',

  'onboarding.build.other.os': 'What is your OS?',
  'onboarding.build.other.os.linux': 'Linux',
  'onboarding.build.other.os.win': 'Windows',
  'onboarding.build.other.os.mac': 'macOS',

  'onboarding.build.other.architecture': 'What is your architecture?',
  'onboarding.build.other.architecture.x86_64': 'x86_64',
  'onboarding.build.other.architecture.arm64': 'ARM64',

  'onboarding.build.cpp.autoconfig':
    'Do you want to use automatic configuration or manual configuration?',
  'onboarding.build.cpp.autoconfig.automatic': 'Automatic',
  'onboarding.build.cpp.autoconfig.automatic.description':
    'Automatic Configuration allows the onboarding of most projects. Getting started does not require any specific knowledge about the project or the language.',
  'onboarding.build.cpp.autoconfig.manual': 'Manual',
  'onboarding.build.cpp.autoconfig.manual.description':
    "Manual Configuration provides enhanced control over the setup, making it more suitable for certain specific use-cases. However, it may not support all scenarios and requires a certain level of understanding about the project's build process.",

  'onboarding.analysis.docs': 'Please visit the {link} for more details.',
  'onboarding.analysis.build_wrapper.header.linux':
    'Download and unzip the Build Wrapper for Linux',
  'onboarding.analysis.build_wrapper.header.win':
    'Download and unzip the Build Wrapper for Windows',
  'onboarding.analysis.build_wrapper.header.mac': 'Download and unzip the Build Wrapper for macOS',
  'onboarding.analysis.build_wrapper.text':
    "And add the executable's directory to the {env_var} environment variable",
  'onboarding.analysis.build_wrapper.execute':
    'Execute the Build Wrapper as a prefix to your build command',
  'onboarding.analysis.build_wrapper.execute_text':
    "Run the following command in your project's folder.",
  'onboarding.analysis.build_wrapper.execute_build_command': '<your clean build command>',
  'onboarding.analysis.build_wrapper.docs':
    'Please visit the {link} of the Build Wrapper for more details.',
  'onboarding.analysis.build_wrapper.docs_link': 'official documentation',

  'onboarding.analysis.java.maven.header': 'Execute the Scanner for Maven',
  'onboarding.analysis.java.maven.text':
    "Running a {instance} analysis with Maven is straightforward. You just need to run the following command in your project's folder.",
  'onboarding.analysis.java.maven.docs_link': 'official documentation of the Scanner for Maven',
  'onboarding.analysis.java.maven.text.custom':
    "Run the following command in your project's folder.",

  'onboarding.analysis.java.gradle.header': 'Execute the Scanner for Gradle',
  'onboarding.analysis.java.gradle.text.1':
    'Running an analysis with Gradle is straightforward. You just need to declare the {plugin_code} plugin in your {groovy} or {kotlin} file:',
  'onboarding.analysis.java.gradle.text.2': 'and run the following command:',
  'onboarding.analysis.java.gradle.latest_version':
    'You can find the latest version of the Gradle plugin {link}.',
  'onboarding.analysis.java.gradle.docs_link': 'official documentation of the Scanner for Gradle',

  'onboarding.analysis.msbuild.header': 'Download and unzip the SonarScanner for .NET',
  'onboarding.analysis.msbuild.text':
    'Visit the {link} to download the latest version for .NET framework. Make sure to add the directory containing {code} to the {path} environment variable.',
  'onboarding.analysis.msbuild.execute': 'Execute the SonarScanner for .NET',
  'onboarding.analysis.msbuild.execute.text':
    'Running a {instance} analysis is straightforward. You just need to execute the following commands at the root of your solution.',
  'onboarding.analysis.msbuild.docs_link': 'documentation of the SonarScanner for .NET',

  'onboarding.analysis.sq_scanner.header.linux': 'Download and unzip the Scanner for Linux',
  'onboarding.analysis.sq_scanner.header.win': 'Download and unzip the Scanner for Windows',
  'onboarding.analysis.sq_scanner.header.mac': 'Download and unzip the Scanner for macOS',
  'onboarding.analysis.sq_scanner.text':
    'Visit the {link} to download the latest version, and add the {dir} directory to the {env_var} environment variable',
  'onboarding.analysis.sq_scanner.prepare': 'Prepare the Scanner',
  'onboarding.analysis.sq_scanner.prepare.flutter':
    'Before performing the analysis, we highly recommend:',
  'onboarding.analysis.sq_scanner.prepare.flutter.pub_get':
    'retrieving all project dependencies declared in <snippet>pubspec.yaml</snippet>, for example, by running <snippet>flutter pub get</snippet> for Flutter projects, <snippet>dart pub get</snippet> for Dart projects, etc.',
  'onboarding.analysis.sq_scanner.prepare.flutter.build':
    'performing a full and successful build of your Flutter or Dart project',
  'onboarding.analysis.sq_scanner.prepare.flutter.tip':
    'Otherwise, you might get incomplete and potentially incorrect analysis results. Retrieving project dependencies alone may not be enough to produce a correct analysis, for example, when you analyze generated code.',
  'onboarding.analysis.sq_scanner.execute': 'Execute the Scanner',
  'onboarding.analysis.sq_scanner.execute.text':
    "Running a {instance} analysis is straightforward. You just need to execute the following commands in your project's folder.",
  'onboarding.analysis.sq_scanner.execute.text.custom':
    "Run the following commands in your project's folder.",
  'onboarding.analysis.sq_scanner.docs': 'Please visit the {link} for more details.',
  'onboarding.analysis.sq_scanner.docs_use_case':
    'Please visit the {link} for more details, and the {useCaseLink} to know more about this use case.',
  'onboarding.analysis.sq_scanner.docs_link': 'official documentation of the Scanner',
  'onboarding.analysis.sq_scanner.sonar_token_env.header':
    'Configure a SONAR_TOKEN environment variable in your CI settings',
  'onboarding.analysis.sq_scanner.sonar_token_env.var_name': 'Add an environment variable called',
  'onboarding.analysis.sq_scanner.sonar_token_env.var_value': 'Give it the following value',
  'onboarding.analysis.sqscanner.docs.gradle.title':
    'official documentation of the Scanner for Gradle',
  'onboarding.analysis.sqscanner.docs.gradle.example_project.title':
    'live Gradle-based example project',

  'onboarding.analysis.dotnetcore.global': 'Install the SonarScanner .NET Core Global Tool',
  'onboarding.analysis.dotnetcore.global.text':
    'As a prerequisite you need to have the sonarscanner tool installed globally using the following command:',
  'onboarding.analysis.dotnetcore.global.text.path':
    'Make sure dotnet tools folder is in your path. See dotnet global tools documentation for more information.',

  'onboarding.tutorial.return_to_list': 'Choose another option',
  'onboarding.tutorial.ci_outro.all_set.title': "You're all set!",
  'onboarding.tutorial.ci_outro.done': 'And you are done!',
  'onboarding.tutorial.ci_outro.refresh_text':
    "If everything is running successfully, once the analysis is complete you'll be redirected to the Overview page of your project where the new analysis results will be displayed. This can take a few minutes.",
  'onboarding.tutorial.ci_outro.commit': 'Commit and push your code to start the analysis.',
  'onboarding.tutorial.ci_outro.commit.why.gitlab':
    'Each new push you make on your branches or merge requests will trigger a new analysis in {productName}. We will decorate merge requests directly on GitLab for you.',
  'onboarding.tutorial.ci_outro.commit.why.github':
    'Each new push you make on your branches or pull requests will trigger a new analysis in {productName}. We will decorate pull requests directly on GitHub for you.',
  'onboarding.tutorial.ci_outro.commit.why.bitbucket':
    'Each new push you make on your branches or pull requests will trigger a new analysis in {productName}. We will decorate pull requests directly on Bitbucket for you.',
  'onboarding.tutorial.ci_outro.commit.why.bitbucketcloud':
    'Each new push you make on your branches or pull requests will trigger a new analysis in {productName}. We will decorate pull requests directly on Bitbucket for you.',
  'onboarding.tutorial.ci_outro.commit.why.azure':
    'Each new push you make on your branches or pull requests will trigger a new analysis in {productName}. We will decorate pull requests directly on Azure for you.',
  'onboarding.tutorial.ci_outro.commit.why.no_branches':
    'Each new push you make on your main branch will trigger a new analysis in {productName}.',
  'onboarding.tutorial.ci_outro.refresh': 'This page will then refresh with your analysis results.',
  'onboarding.tutorial.ci_outro.refresh.why':
    "If the page doesn't refresh after a while, please double-check the analysis configuration, and check your logs.",
  'onboarding.tutorial.other.project_key.sentence':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.other.project_key.monorepo.sentence':
    'Create a {file} file at the root of your project and paste the following code:',
  'onboarding.tutorial.other.project_key.monorepo.info':
    'Repeat this step for all the projects in your monorepo',
  'onboarding.tutorial.cfamilly.compilation_database_info':
    'If you have trouble using the Build Wrapper, you can try one of the alternative methods to {link}.',
  'onboarding.tutorial.cfamilly.compilation_database_info.link': 'generate a compilation database',
  'onboarding.tutorial.cfamily.examples_repositories_description':
    'Check out our C and C++ sample projects with {productName} analysis configured',

  'onboarding.tutorial.page.title': 'Analysis Method',
  'onboarding.tutorial.page.description':
    'Use this page to manage and set-up the way your analyses are performed.',
  'onboarding.tutorial.choose_method': 'How do you want to analyze your repository?',
  'onboarding.tutorial.choose_method.devops_platform.description':
    'Do you want to integrate with your favorite CI? Choose one of the following tutorials.',
  'onboarding.tutorial.choose_method.local.description':
    'Are you just testing or have an advanced use-case? Analyze your project locally.',
  'onboarding.tutorial.choose_method.local': 'Locally',
  'onboarding.tutorial.choose_method.other-ci': 'Other CI',
  'onboarding.tutorial.choose_method.jenkins': 'With Jenkins',
  'onboarding.tutorial.choose_method.github-actions': 'With GitHub Actions',
  'onboarding.tutorial.choose_method.gitlab-ci': 'With GitLab CI',
  'onboarding.tutorial.choose_method.azure-pipelines': 'With Azure Pipelines',
  'onboarding.tutorial.choose_method.bitbucket-pipelines': 'With Bitbucket Pipelines',
  'onboarding.tutorial.breadcrumbs.home': 'Analysis Method',
  'onboarding.tutorial.breadcrumbs.local': 'Locally',
  'onboarding.tutorial.breadcrumbs.other-ci': 'Other CI',
  'onboarding.tutorial.breadcrumbs.jenkins': 'Jenkins',
  'onboarding.tutorial.breadcrumbs.github-actions': 'GitHub Actions',
  'onboarding.tutorial.breadcrumbs.gitlab-ci': 'GitLab CI',
  'onboarding.tutorial.breadcrumbs.azure-pipelines': 'Azure Pipelines',
  'onboarding.tutorial.breadcrumbs.bitbucket-pipelines': 'Bitbucket Pipelines',
  'onboarding.mode.help.manual':
    'Use this for testing or advanced use-case. Other modes are recommended to help you set up your CI environment.',
  'onboarding.mode.help.otherci':
    "{productName} integrates with your workflow no matter which CI tool you're using.",

  'onboarding.tutorial.with.yaml.gradle':
    'Update your {groovy} or {kotlin} file with the {sq} plugin and its configuration:',

  'onboarding.tutorial.with.bitbucket_ci.title': 'Analyze your project with Bitbucket CI',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.title': 'Create repository variables',
  'onboarding.tutorial.with.bitbucket_pipelines.yaml.title':
    'Create your pipelines builds configuration',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.intro':
    'In your Bitbucket repository, go to {repository_variables} and create two new variables:',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.intro.link':
    'Repository settings > Repository variables',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.name.sentence':
    'In the {name} field, enter',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.name.sentence.name': 'Name',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.add.sentence': 'Click on {add}.',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.add.sentence.add': 'Add',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.secured.sentence':
    'Make sure {secured} is check.',
  'onboarding.tutorial.with.bitbucket_pipelines.variables.secured.sentence.secured': 'Secured',

  'onboarding.tutorial.with.github_ci.title': 'Analyze your project with GitHub CI',
  'onboarding.tutorial.with.github_action.create_secret.title': 'Create GitHub Secrets',
  'onboarding.tutorial.with.github_action.create_secret.monorepo_project_level_token_info':
    'If you use project-level tokens, {link} for each project in your monorepo and create the associated secrets as per previous steps (secrets names need to be unique per project e.g. SONAR_TOKEN_1, SONAR_TOKEN_2...)',
  'onboarding.tutorial.with.github_action.create_secret.monorepo_project_level_token_info.link':
    'generate a token',
  'onboarding.tutorial.with.github_action.create_secret.monorepo_global_token_info':
    'If you use global tokens, request a global token from your admin and follow previous steps.',
  'onboarding.tutorial.with.github_action.monorepo.see_yaml_instructions':
    'Create or update your .github/workflows/build.yml YAML file at the root of your monorepository with this content',
  'onboarding.tutorial.with.github_action.secret.intro':
    'In your GitHub repository, go to {settings_secret} and create the following new secrets:',
  'onboarding.tutorial.with.github_action.secret.intro.link':
    'Settings > Secrets and variables > Actions',
  'onboarding.tutorial.with.github_action.secret.name.sentence': 'In the {name} field, enter',
  'onboarding.tutorial.with.github_action.secret.name.sentence.name': 'Name',
  'onboarding.tutorial.with.github_action.secret.new.sentence': 'Click on {new_secret}.',
  'onboarding.tutorial.with.github_action.secret.new.sentence.new_secret': 'New repository secret',
  'onboarding.tutorial.with.github_action.secret.add.sentence': 'Click on {add_secret}.',
  'onboarding.tutorial.with.github_action.secret.add.sentence.add_secret': 'Add secret',
  'onboarding.tutorial.with.github_action.yaml.title': 'Create Workflow YAML File',
  'onboarding.tutorial.with.github_action.yaml.create_yml':
    'Create or update your {file} YAML file with the following content:',
  'onboarding.tutorial.with.github_action.dart':
    'Add the following steps to your GitHub Actions Workflow after build of your Flutter or Dart project:',

  'onboarding.tutorial.with.gitlab_ci.title': 'Analyze your project with GitLab CI',
  'onboarding.tutorial.with.gitlab_ci.project_key.title': 'Set your project key',
  'onboarding.tutorial.with.gitlab_ci.project_key.maven.step2':
    'Add the following to your {file} file:',
  'onboarding.tutorial.with.gitlab_ci.project_key.gradle.step2':
    'Add the following to your {file} or {file2} file:',
  'onboarding.tutorial.with.gitlab_ci.project_key.jsts.step2':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.with.gitlab_ci.project_key.python.step2':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.with.gitlab_ci.project_key.other.step2':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.with.gitlab_ci.project_key.dart.step2':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.with.gitlab_ci.project_key.dotnet.step2':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.with.gitlab_ci.project_key.cpp.step2':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.with.gitlab_ci.project_key.objectivec.step2':
    'Create a {file} file in your repository and paste the following code:',

  'onboarding.tutorial.with.gitlab_ci.variables.title': 'Add environment variables',
  'onboarding.tutorial.with.gitlab_ci.variables.description.link': 'Settings > CI/CD > Variables',
  'onboarding.tutorial.with.gitlab_ci.variables.section.title':
    'Define the {productName} Token environment variable.',
  'onboarding.tutorial.with.gitlab_ci.variables.section.description':
    'In GitLab, go to {link} to add the following variable and make sure it is available for your project:',
  'onboarding.tutorial.with.gitlab_ci.variables.edit.token.tooltip':
    'Use an existing token or generate a new one.',
  'onboarding.tutorial.with.gitlab_ci.variables.step1': 'Key {value} {extra}',

  'onboarding.tutorial.with.gitlab_ci.variables.step3': 'Uncheck the {value} checkbox.',
  'onboarding.tutorial.with.gitlab_ci.variables.step3.value': 'Protect Variable',
  'onboarding.tutorial.with.gitlab_ci.variables.section.step4': 'Check the {value} checkbox.',
  'onboarding.tutorial.with.gitlab_ci.variables.section.step4.value': 'Mask Variable',
  'onboarding.tutorial.with.gitlab_ci.variables.section2.title':
    'Define the {productName} URL environment variable.',
  'onboarding.tutorial.with.gitlab_ci.variables.section2.description':
    'Still in {link} add a new variable and make sure it is available for your project:',
  'onboarding.tutorial.with.gitlab_ci.variables.section2.step4':
    'Leave the {value} checkbox unchecked.',
  'onboarding.tutorial.with.gitlab_ci.yaml.title': 'Create or update the configuration file',
  'onboarding.tutorial.with.gitlab_ci.yaml.description':
    'Create or update your {filename} file with the following content.',
  'onboarding.tutorial.with.gitlab_ci.yaml.filename': '.gitlab-ci.yml',
  'onboarding.tutorial.with.gitlab_ci.yaml.baseconfig':
    'Note that this is a minimal base configuration to run a {productName} analysis on your main branch and merge requests, and fetch the vulnerability report (if applicable).',
  'onboarding.tutorial.with.gitlab_ci.yaml.existing':
    'If you already have a pipeline configured and running, you might want to add the example above to your existing yml file.',
  'onboarding.tutorial.with.gitlab_ci.yaml.premium':
    'GitLab vulnerability report is only available with GitLab Ultimate. You may safely remove the sonarqube-vulnerability-report stage if you have not subscribed to this service.',

  'onboarding.tutorial.with.jenkins.title': 'Analyze your project with Jenkins',
  'onboarding.tutorial.with.jenkins.alm_selection.title': 'Select your DevOps platform',
  'onboarding.tutorial.with.jenkins.prereqs.title': 'Prerequisites',
  'onboarding.tutorial.with.jenkins.prereqs.intro.sentence':
    'To run your project analyses with Jenkins, the following plugins must be {installed} and {configured}.',
  'onboarding.tutorial.with.jenkins.prereqs.intro.sentence.installed': 'installed',
  'onboarding.tutorial.with.jenkins.prereqs.intro.sentence.configured': 'configured',
  'onboarding.tutorial.with.jenkins.prereqs.plugins.branch_source.bitbucket':
    'Bitbucket Branch Source plugin for Jenkins - version 2.7 or later',
  'onboarding.tutorial.with.jenkins.prereqs.plugins.branch_source.bitbucketcloud':
    'Bitbucket Branch Source plugin for Jenkins - version 2.7 or later',
  'onboarding.tutorial.with.jenkins.prereqs.plugins.branch_source.github':
    'GitHub Branch Source plugin for Jenkins - version 2.7.1 or later',
  'onboarding.tutorial.with.jenkins.prereqs.plugins.branch_source.gitlab':
    'GitLab Branch Source plugin for Jenkins - version 1.5.3 or later',
  'onboarding.tutorial.with.jenkins.prereqs.plugins.gitlab_plugin':
    'GitLab plugin for Jenkins - version 1.5.13 or later',
  'onboarding.tutorial.with.jenkins.prereqs.plugins.sonar_scanner':
    '{productName} Scanner plugin for Jenkins - version 2.11 or later',
  'onboarding.tutorial.with.jenkins.prereqs.step_by_step_guide':
    'For a step by step guide on installing and configuring those plugins in Jenkins, visit the {link} documentation page.',
  'onboarding.tutorial.with.jenkins.prereqs.step_by_step_guide.link': 'Analysis Prerequisites',
  'onboarding.tutorial.with.jenkins.prereqs.following_are_recommendations':
    'We recommend using the configuration in the following steps for the best results, but you can customize it as needed.',
  'onboarding.tutorial.with.jenkins.prereqs.done': 'Configure Analysis',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.title':
    'Create a Multibranch Pipeline Job',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.intro':
    'Create a Multibranch Pipeline in order to automatically analyze all your branches and pull requests.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step1.sentence':
    "From Jenkins' dashboard, click {new_item} and create a {type}.",
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step1.sentence.new_item': 'New Item',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step1.sentence.type':
    'Multibranch Pipeline Job',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.sentence':
    'Under {tab}, add a {source} source and enter the following information:',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.sentence.tab':
    'Branch Sources',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.sentence.source':
    'Bitbucket',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.server.label': 'Server',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.server.action':
    'select the instance hosting the repository you want to analyze.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.creds.label':
    'Credentials',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.creds.action':
    'select the Bitbucket Server credentials.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.owner.label': 'Owner',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.owner.action':
    'enter your project key.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.repo.label': 'Repository',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucket.repo.action':
    'select the repository you want to analyze.',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.sentence':
    'Under {tab}, add a {source} source and enter the following information:',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.sentence.tab':
    'Branch Sources',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.sentence.source':
    'Bitbucket',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.server.label':
    'Server',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.server.action':
    'Make sure that Bitbucket Cloud is selected.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.creds.label':
    'Credentials',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.creds.action':
    'select the Bitbucket Cloud credentials.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.owner.label':
    'Owner',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.owner.action':
    'enter your workspace ID.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.repo.label':
    'Repository',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.bitbucketcloud.repo.action':
    'select the repository you want to analyze.',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.github.sentence':
    'Under {tab}, add a {source} source and enter the following information:',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.github.sentence.tab':
    'Branch Sources',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.github.sentence.source': 'GitHub',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.github.creds.label': 'Credentials',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.github.creds.action':
    'select or add your GitHub credentials.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.github.repo_url.label':
    'Repository HTTPS URL',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.github.repo_url.action':
    'enter your repository URL.',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.sentence':
    'Under {tab}, add a {source} source and enter the following information:',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.sentence.tab':
    'Branch Sources',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.sentence.source':
    'GitLab Project',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.creds.label':
    'Checkout Credentials',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.creds.action':
    'select or add your GitLab credentials.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.owner.label': 'Owner',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.owner.action':
    'enter the name of your user or your group.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.repo.label': 'Projects',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.gitlab.repo.action':
    'select your project.',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.label': 'Behaviors',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.branches_prs.action':
    'Exclude branches that are also filed as PRs.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.branches_prs.label':
    'Discover branches',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.branches_mrs.action':
    'Exclude branches that are also filed as MRs.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.branches_mrs.label':
    'Discover branches',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.discover_prs.action':
    'The current pull request revision.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.discover_prs.label':
    'Discover pull requests from origin',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.discover_mrs.action':
    'The current merge request revision.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.discover_mrs.label':
    'Discover merge requests from origin',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.label':
    'Specify ref specs',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.add_behaviour.sentence':
    'By default, this behavior is not active. If you do not see it, click on {add} to see the list of available behaviors, and select {ref_spec}.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.add_behaviour.sentence.add':
    'Add',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.add_behaviour.sentence.ref_spec':
    'Specify ref specs',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.set_pr_ref_specs.sentence':
    'In order to correctly compute new code for Pull Requests, the scanner will need the refs of the target branch. Make sure the {ref_spec} value will include any target branches (the default value should be enough). Example:',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.set_pr_ref_specs.sentence.ref_spec':
    'Ref Spec',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.set_mr_ref_specs.sentence':
    'In order to correctly compute new code for Merge Requests, the scanner will need the refs of the target branch. Make sure the {ref_spec} value will include any target branches (the default value should be enough). Example:',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.behaviors.ref_specs.set_mr_ref_specs.sentence.ref_spec':
    'Ref Spec',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step2.leave_defaults':
    'You can leave the other Branch Source settings at the defaults.',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step3.sentence':
    'Jump to the {tab} section and make sure the parameters are set as follows:',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step3.sentence.tab':
    'Build Configuration',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step3.mode.label': 'Mode',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step3.mode.action': 'by Jenkinsfile',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step3.script_path.label': 'Script Path',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step3.script_path.action': 'Jenkinsfile',

  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step4.sentence': 'Click {save}.',
  'onboarding.tutorial.with.jenkins.multi_branch_pipeline.step4.sentence.save': 'Save',

  'onboarding.tutorial.with.jenkins.pipeline.title': 'Create a Pipeline Job',
  'onboarding.tutorial.with.jenkins.pipeline.intro':
    'Create a Pipeline in order to automatically analyze your project.',
  'onboarding.tutorial.with.jenkins.pipeline.step1.sentence':
    "From Jenkins' dashboard, click {new_item} and create a {type}.",
  'onboarding.tutorial.with.jenkins.pipeline.step1.sentence.new_item': 'New Item',
  'onboarding.tutorial.with.jenkins.pipeline.step1.sentence.type': 'Pipeline Job',

  'onboarding.tutorial.with.jenkins.pipeline.step2.sentence':
    'Under {tab}, choose {option}. You must set a unique, secret token for this field.',
  'onboarding.tutorial.with.jenkins.pipeline.step2.sentence.tab': 'Build Triggers',
  'onboarding.tutorial.with.jenkins.pipeline.step2.sentence.option': 'Trigger builds remotely',

  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.trigger.sentence':
    'Under {tab}, choose {option}. Write down the webhook URL provided. You will need it when configuring the webhook in GitLab.',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.trigger.sentence.tab': 'Build Triggers',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.trigger.sentence.option':
    'Build when a change is pushed to GitLab',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.pick_triggers.sentence':
    'Under {triggers}, only select {push_events}.',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.pick_triggers.sentence.triggers':
    'Enabled GitLab triggers',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.pick_triggers.sentence.push_events':
    'Push events',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.click_advanced.sentence':
    'Click on {advanced}',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.click_advanced.sentence.advanced':
    'Advanced...',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.secret_token.sentence':
    'Find the {secret_token} text field, and click on {generate}. Write down the secret token. You will need it when configuring the webhook in GitLab.',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.secret_token.sentence.secret_token':
    'Secret token',
  'onboarding.tutorial.with.jenkins.pipeline.gitlab.step2.secret_token.sentence.generate':
    'Generate',

  'onboarding.tutorial.with.jenkins.pipeline.step3.sentence':
    'Under {tab}, make sure the parameters are set as follows:',
  'onboarding.tutorial.with.jenkins.pipeline.step3.sentence.tab': 'Pipeline',
  'onboarding.tutorial.with.jenkins.pipeline.step3.definition.label': 'Definition',
  'onboarding.tutorial.with.jenkins.pipeline.step3.definition.action': 'Pipeline script from SCM',
  'onboarding.tutorial.with.jenkins.pipeline.step3.scm.sentence':
    '{label} Configure your SCM. Make sure to only build your main branch. For example, if your main branch is called "main", put "*/main" under {branches_to_build}.',
  'onboarding.tutorial.with.jenkins.pipeline.step3.scm.sentence.label': 'SCM:',
  'onboarding.tutorial.with.jenkins.pipeline.step3.scm.sentence.branches_to_build':
    'Branches to build',
  'onboarding.tutorial.with.jenkins.pipeline.step3.script_path.label': 'Script Path',
  'onboarding.tutorial.with.jenkins.pipeline.step3.script_path.action': 'Jenkinsfile',

  'onboarding.tutorial.with.jenkins.pipeline.step4.sentence': 'Click {save}.',
  'onboarding.tutorial.with.jenkins.pipeline.step4.sentence.save': 'Save',

  'onboarding.tutorial.with.jenkins.webhook.bitbucket.title': 'Create a Bitbucket Server Webhook',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.title':
    'Create a Bitbucket Cloud Webhook',
  'onboarding.tutorial.with.jenkins.webhook.github.title': 'Create a GitHub Webhook',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.title': 'Create a GitLab Webhook',
  'onboarding.tutorial.with.jenkins.webhook.intro.sentence':
    'Create a Webhook in your repository to trigger the Jenkins job on push. You may skip this step if you already have a Webhook configured.',
  'onboarding.tutorial.with.jenkins.webhook.step1.sentence':
    'Go to the {link} and enter the following information:',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step1.link':
    'Bitbucket Server Webhook creation page for your repository',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step1.link':
    'Bitbucket Cloud Webhook creation page for your repository',
  'onboarding.tutorial.with.jenkins.webhook.github.step1.link':
    'GitHub Webhook creation page for your repository',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step1.link':
    'GitLab Webhook creation page for your repository',
  'onboarding.tutorial.with.jenkins.webhook.step1.name.label': 'Name',
  'onboarding.tutorial.with.jenkins.webhook.step1.name.action': 'give a unique name.',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step1.url.label': 'URL',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step1.url.action':
    'Enter the following URL, replacing the values between *** as needed:',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step1.url.warning':
    'The Bitbucket Server URL must be identical to the one in your Jenkins configuration. Watch out for any missing or extra "/" at the end.',
  'onboarding.tutorial.with.jenkins.webhook.github.step1.url.label': 'URL',
  'onboarding.tutorial.with.jenkins.webhook.github.step1.url.action':
    'Enter the following URL, replacing the values between *** as needed:',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step1.url_with_branches.label': 'URL',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step1.url_with_branches.action':
    'Enter the following URL, replacing the values between *** as needed:',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step1.url_no_branches.label': 'URL',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step1.url_no_branches.action':
    'Enter the URL you wrote down in the previous step.',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step1.secret_token.label': 'Secret Token',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step1.secret_token.action':
    'Enter the generated token you wrote down in the previous step.',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step2.sentence':
    'Under {events}, make sure the following options are checked:',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step2.sentence.events': 'Events',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step2.sentence':
    'Under {triggers}, select {option} and make sure the following options are checked:',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step2.sentence.triggers': 'Triggers',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step2.sentence.option':
    'Choose from a full list of triggers',
  'onboarding.tutorial.with.jenkins.webhook.github.step2.sentence':
    'Under {events} select {option} and check the following:',
  'onboarding.tutorial.with.jenkins.webhook.github.step2.sentence.events':
    'Which events would you like to trigger this webhook?',
  'onboarding.tutorial.with.jenkins.webhook.github.step2.sentence.option':
    'Let me select individual events',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step2.sentence':
    'Under {trigger} check the following:',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step2.sentence.trigger': 'Trigger',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step2.repo.label': 'Repository',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step2.repo.action': 'Push',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step2.pr.label': 'Pull Request',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step2.pr.action': 'Opened',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step2.repo.label': 'Repository',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step2.repo.action': 'Push',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step2.pr.label': 'Pull Request',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step2.pr.action': 'Created',
  'onboarding.tutorial.with.jenkins.webhook.github.step2.repo': 'Pushes',
  'onboarding.tutorial.with.jenkins.webhook.github.step2.pr': 'Pull Requests',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step2.repo': 'Push events',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step2.mr': 'Merge request events',
  'onboarding.tutorial.with.jenkins.webhook.github.step3.sentence': 'Click {add_webhook}.',
  'onboarding.tutorial.with.jenkins.webhook.github.step3.sentence.add_webhook': 'Add webhook',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step3.sentence': 'Click {save}.',
  'onboarding.tutorial.with.jenkins.webhook.bitbucketcloud.step3.sentence.save': 'Save',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step3.sentence': 'Click {create}.',
  'onboarding.tutorial.with.jenkins.webhook.bitbucket.step3.sentence.create': 'Create',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step3.sentence': 'Click {add_webhook}.',
  'onboarding.tutorial.with.jenkins.webhook.gitlab.step3.sentence.add_webhook': 'Add webhook',
  'onboarding.tutorial.with.jenkins.jenkinsfile.title': 'Create a Jenkinsfile',
  'onboarding.tutorial.with.jenkins.jenkinsfile.jenkinsfile_step.sentence':
    'Create a {file} file in your repository and paste the following code:',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.replace.sentence':
    'Make sure to replace {default} with the name you gave to your Maven tool {in_jenkins}.',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.replace.sentence.default':
    'Default Maven',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.replace.sentence.in_jenkins':
    'in Jenkins',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.help1.sentence':
    'To get the name of your Maven tool in Jenkins, navigate to {path}.',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.help1.sentence.path':
    'Manage Jenkins > Global Tool Configuration',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.help2.sentence':
    'The name is located under the {path} section, in the {name} field.',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.help2.sentence.path':
    'Maven > Maven installations',
  'onboarding.tutorial.with.jenkins.jenkinsfile.maven.step3.help2.sentence.name': 'Name',
  'onboarding.tutorial.with.jenkins.jenkinsfile.gradle.step2.sentence':
    'Add the following to your {groovy} or {kotlin} file:',
  'onboarding.tutorial.with.jenkins.jenkinsfile.dotnet.build_agent': 'Choose your build agent.',

  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.title.sentence':
    'Prerequisite: Add a {default_msbuild} tool.',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.title.sentence.default_msbuild':
    'MSBuild',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.info':
    'This step need to be done only once per jenkins instance.',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step1.sentence':
    'In Jenkins, make sure to have the {msbuild} installed.',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step1.sentence.msbuild':
    'MSBuild Plugin',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step2.sentence': 'Navigate to {path}.',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step2.sentence.path':
    'Manage Jenkins > Global Tool Configuration',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step3.sentence':
    'Under {msbuild} click on {add_msbuild} and give a {name} that will be used in the last step. Refer to the {msbuild_plugin} documentation on how to install the tool:',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step3.sentence.msbuild': 'MSBuild',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step3.sentence.msbuild_plugin':
    'MSBuild Plugin',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step3.sentence.add_msbuild':
    'Add MSBuild',
  'onboarding.tutorial.with.jenkins.dotnet.msbuild.prereqs.step3.sentence.name': 'Name',

  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.title.sentence':
    'Prerequisite: Add a {default_scanner} tool.',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.title.sentence.default_scanner':
    'SonarScanner for .NET',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.info':
    'This step needs to be done only once per jenkins instance or if you need different scanner versions.',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step1.sentence':
    'In Jenkins, navigate to {path}.',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step1.sentence.path':
    'Manage Jenkins > Global Tool Configuration',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step2.sentence':
    'Under {default_scanner} click on {add_scanner_for_msbuild}.',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step2.sentence.default_scanner':
    'SonarScanner for .NET',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step2.sentence.add_scanner_for_msbuild':
    'Add SonarScanner for .NET',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step3.sentence':
    'Choose a {name} that will be used in the last step:',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step3.sentence.name': 'Name',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step4.sentence': 'Check {install_auto}',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step4.sentence.install_auto':
    'Install automatically',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step5.sentence':
    'Under {install_from} select the corresponding .NET Core scanner required for you project.',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step5.sentence.install_from':
    'Install from GitHub',
  'onboarding.tutorial.with.jenkins.dotnet.scanner.prereqs.step5.sentence.install_auto':
    'Install automatically',

  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.replace.sentence':
    'Make sure to replace {default} with the name you gave to your {productName} Scanner tool {in_jenkins}.',
  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.replace.sentence.default':
    'SonarScanner',
  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.replace.sentence.in_jenkins':
    'in Jenkins',
  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.help1.sentence':
    'To get the name of your {productName} Scanner tool in Jenkins, navigate to {path}.',
  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.help1.sentence.path':
    'Manage Jenkins > Global Tool Configuration',
  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.help2.sentence':
    'The name is located under the {path} section, in the {name} field.',
  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.help2.sentence.path':
    '{productName} Scanner > {productName} Scanner installations',
  'onboarding.tutorial.with.jenkins.jenkinsfile.other.step3.help2.sentence.name': 'Name',
  'onboarding.tutorial.with.jenkins.jenkinsfile.cfamilly.agent_setup':
    'We assume the Jenkins agent has the necessary tools to build your project.',

  'onboarding.tutorial.with.azure_pipelines.os': 'What is your agent host?',
  'onboarding.tutorial.with.azure_pipelines.architecture': 'What is your agent architecture?',
  'onboarding.tutorial.with.azure_pipelines.title':
    'Analyze your project with Azure DevOps Pipelines',
  'onboarding.tutorial.with.azure_pipelines.ExtensionInstallation.title':
    'Install {productName} extension for Azure DevOps',
  'onboarding.tutorial.with.azure_pipelines.ExtensionInstallation.sentence':
    'From your Azure DevOps instance, navigate to the Visual Studio Marketplace and install the {link} by clicking the {button} button.',
  'onboarding.tutorial.with.azure_pipelines.ExtensionInstallation.sentence.link':
    '{productName} extension',
  'onboarding.tutorial.with.azure_pipelines.ExtensionInstallation.sentence.button': 'Get it free',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.title':
    'Add a new {productName} Service Endpoint in your project',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step1.sentence':
    'In Azure DevOps, go to {menu}.',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step1.sentence.menu':
    'Project settings > Service connections',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step2.sentence':
    'Add a new service connection of type {type}.',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step2.sentence.type': '{productName}',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step3.sentence':
    'Enter your {productName} server url: {url} {button}',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step4.sentence':
    'Enter an existing token, or a newly generated one',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step5.sentence':
    'Enter a memorable connection name.',
  'onboarding.tutorial.with.azure_pipelines.ServiceEndpoint.step6.sentence':
    'Create the service connection.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.title': 'Configure analysis',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.info':
    'The following steps assume you are using the Azure Pipelines classic editor. Check out our {doc_link} for the YAML counterpart.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.info.doc_link':
    'Azure DevOps integration page',

  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_wrapper.ccpp.sentence':
    'In Azure DevOps, create or edit a build {pipeline} to make Build Wrapper available on the build agent.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_wrapper.ccpp.script.sentence':
    'Add a {task} task, select {inline} mode and add the following script to download and decompress the Build Wrapper on the build agent.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_wrapper.ccpp.win.sentence.task':
    'PowerShell script',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_wrapper.ccpp.nix.sentence.task':
    'Bash script',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_wrapper.ccpp.win.sentence.inline':
    'inline',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_wrapper.ccpp.nix.sentence.inline':
    'inline',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.ccpp.sentence':
    'Add a new {task} task {before} your build task.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare_additional.ccpp':
    'In {additional} in the {advanced} section, add a new property: {property} {button}',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare_additional.ccpp.additional':
    'Additional Properties',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare_additional.ccpp.advanced':
    'Advanced',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build.ccpp.sentence':
    'Add or modify your build {task} task. For the analysis to happen, your build has to be run through a command line so that it can be wrapped-up by the build-wrapper.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build.ccpp.sentence.task':
    'Command Line',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_script.ccpp.sentence':
    'Run {build_wrapper} executable. Pass in as the arguments (1) the output directory configured in the previous task and (2) the command that runs a clean build of your project (not an incremental build). Example:',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.build_script.ccpp.sentence.build_wrapper':
    'Build Wrapper',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.run.ccpp.sentence':
    'Add a new {task} task {after} your build task. Consider running this task right after the previous one as the build environment should not be significantly altered before running the analysis.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.sentence':
    'In Azure DevOps, create or edit a build {pipeline} and add a new {task} task {before} your build task:',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.sentence.pipeline': 'Pipeline',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.sentence.task':
    'Prepare Analysis Configuration',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.sentence.before': 'before',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.endpoint.sentence':
    'Select the {endpoint} you created in Step 2.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.endpoint.sentence.endpoint':
    '{productName} server endpoint',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis':
    'Under {section}, select {run_analysis_value}.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis.section':
    'Choose the way to run the analysis',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis.values.dotnet':
    'Integrate with MSBuild',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis.values.maven':
    'Integrate with Maven or Gradle',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis.values.gradle':
    'Integrate with Maven or Gradle',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis.values.cpp':
    'Use standalone scanner',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis.values.objectivec':
    'Use standalone scanner',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.prepare.run_analysis.values.other':
    'Use standalone scanner',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.manual.sentence':
    'Select the {mode} mode.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.manual.sentence.mode':
    'Manually provide configuration',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.run.sentence':
    'Add a new {task} task {after} your build task.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.run.sentence.task': 'Run Code Analysis',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.run.sentence.after': 'after',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.run.key.sentence':
    'In the {project_key} field, enter {key} {button}',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.run.key.sentence.project_key':
    'Project Key',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.advanced_properties.sentence':
    'Expand the {section} and replace the {properties} with the following snippet',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.advanced_properties.sentence.section':
    'Advanced section',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.advanced_properties.sentence.properties':
    'Additional Properties',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java_installer.title':
    'Add a new Java tool installer task:',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java_installer.sentence':
    'Under {field}, select {value}',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java_installer.java_version':
    'JDK version',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java_installer.or_higher': '(or higher)',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java_installer.java_architecture':
    'JDK architecture',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java_installer.java_source':
    'JDK source',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java_installer.pre-installed':
    'Pre-installed',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java': 'Edit or add a new {0} task:',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java.settings.sentence':
    'Under {section}, check {option}',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java.settings.sentence.section':
    'Code Analysis',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.java.settings.sentence.option':
    'Run {productName} Analysis',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.publish_qg.sentence':
    "Add a new {task} task to publish {productName}'s Quality Gate results on your build pipeline summary.",
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.publish_qg.info.sentence1':
    'This task may increase your build time as your pipeline will have to wait for {productName} to process the analysis report. It is highly recommended but optional.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.publish_qg.sentence.task':
    'Publish Quality Gate Result',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.continous_integration.sentence':
    'Under the {tab} tab of your pipeline, check {continuous_integration} and select all the branches for which you want the {productName} analysis to run automatically.',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.continous_integration.sentence.tab':
    'Triggers',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.continous_integration.sentence.continuous_integration':
    'Enable continuous integration',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.continous_integration.no_branches.sentence':
    'Under the {tab} tab of your pipeline, check {continuous_integration} and select the main branch',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.continous_integration.no_branches.sentence.tab':
    'Triggers',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.continous_integration.no_branches.sentence.continuous_integration':
    'Enable continuous integration',
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.branch_protection':
    "To make sure your Pull Requests are analyzed automatically and aren't merged when they're failing their quality gate, check out the {link}.",
  'onboarding.tutorial.with.azure_pipelines.BranchAnalysis.branch_protection.link': 'documentation',

  'onboarding.tutorial.no_scan_rights':
    'You do not have permission to analyze this project. Please contact the project administrator.',

  //------------------------------------------------------------------------------
  //
  // BRANCHES
  //
  //------------------------------------------------------------------------------
  'branches.branch': 'Branch',
  'branches.main_branch': 'Main Branch',
  'branches.pr': 'PR',
  'branches.see_the_pr': 'See the PR',
  'branches.see_the_pr_on_x': 'See the PR on {dop}',

  //------------------------------------------------------------------------------
  //
  // BRANCH-LIKE NAVIGATION
  //
  //------------------------------------------------------------------------------
  'branch_like_navigation.manage': 'Manage branches and Pull Requests',
  'branch_like_navigation.search_for_branch_like': 'Search for branches or Pull Requests...',
  'branch_like_navigation.list': 'Branches and Pull Requests',
  'branch_like_navigation.pull_requests': 'Pull Requests',
  'branch_like_navigation.pull_requests_targeting': 'Pull Requests targeting "{branch}"',
  'branch_like_navigation.orphan_pull_requests': 'Orphan Pull Requests',
  'branch_like_navigation.orphan_pull_requests.tooltip':
    'When the base of a Pull Request is deleted, this Pull Request becomes orphan.',
  'branch_like_navigation.for_merge_into_x_from_y': 'for merge into {target} from {branch}',
  'branch_like_navigation.for_merge_into_x_from_y.title': 'for merge into {target} from {branch}',
  'branch_like_navigation.no_branch_support.title':
    'Get the most out of SonarQube Server with branch and PR/MR analysis',
  'branch_like_navigation.no_branch_support.title.pr':
    'Get the most out of SonarQube Server with branch and PR analysis',
  'branch_like_navigation.no_branch_support.title.mr':
    'Get the most out of SonarQube Server with branch and MR analysis',
  'branch_like_navigation.no_branch_support.content':
    'With Developer Edition you can analyze every pull/merge request. You can also watch the quality of your release branches by analyzing each one individually in SonarQube Server.',
  'branch_like_navigation.no_branch_support.content_x.pr':
    'With Developer Edition you can analyze every pull request and get the results in {alm}. You can also watch the quality of your release branches by analyzing each one individually in SonarQube Server.',
  'branch_like_navigation.no_branch_support.content_x.mr':
    'With Developer Edition you can analyze every merge request and get the results in {alm}. You can also watch the quality of your release branches by analyzing each one individually in SonarQube Server.',
  'branch_like_navigation.only_one_branch.title':
    'Learn how to analyze branches in SonarQube Server',
  'branch_like_navigation.only_one_branch.content':
    'Quickly set up branch analysis and get separate insights for each of your branches and Pull Requests.',
  'branch_like_navigation.only_one_branch.documentation': 'Branches documentation',
  'branch_like_navigation.only_one_branch.pr_analysis': 'Pull Request analysis',
  'branch_like_navigation.tutorial_for_ci': 'Show me how to set up my CI',

  //------------------------------------------------------------------------------
  //
  // APPLICATIONS
  //
  //------------------------------------------------------------------------------
  'application.cannot_access_all_child_projects1':
    'You must have access to all the projects within this Application in order to browse it.',
  'application.cannot_access_all_child_projects2': 'Please contact your project administrator.',

  //------------------------------------------------------------------------------
  //
  // PORTFOLIOS
  //
  //------------------------------------------------------------------------------
  'portfolio.has_always_been_x': 'has always been {rating}',
  'portfolio.was_x_y': 'was {rating} {date}',
  'portfolio.x_in_y': '{project_branches} in {rating}',
  'portfolio.project_branch': 'project branch',
  'portfolio.project_branches': 'project branches',
  'portfolio.has_qg_status': 'Has Quality Gate Status',
  'portfolio.have_qg_status': 'Have Quality Gate Status',
  'portfolio.empty': 'This portfolio is empty.',
  'portfolio.no_lines_of_code': 'All projects in this portfolio are empty',
  'portfolio.not_computed': 'This portfolio is not yet computed.',
  'portfolio.app.empty': 'This application is empty.',
  'portfolio.app.no_lines_of_code': 'All projects in this application are empty',
  'portfolio.metric_trend': 'Metric trend',
  'portfolio.lowest_rated_project_branches': 'Lowest rated project branches',
  'portfolio.health_factors': 'Portfolio health factors',
  'portfolio.activity_link': 'See full history of analyses',
  'portfolio.measures_link': 'Measures',
  'portfolio.language_breakdown_link': 'Language breakdown',
  'portfolio.breakdown': 'Portfolio breakdown',
  'portfolio.number_of_projects': 'Number of project branches',
  'portfolio.number_of_lines': 'Number of lines of code',
  'portfolio.details': 'Portfolio Details',
  'portfolio.details.breakdown': 'Breakdown by projects, applications, and nested portfolios',

  'portfolio.metric_domain.security': 'Security',
  'portfolio.metric_domain.security_review': 'Security Review',

  //------------------------------------------------------------------------------
  //
  // METRIC DOMAINS HELP TEXT
  //
  //------------------------------------------------------------------------------

  'portfolio.metric_domain.releasability.help':
    'Ratio of projects in the Portfolio that have passed the Quality Gate.',
  'portfolio.metric_domain.reliability.help':
    'Average Reliability rating for all projects in the portfolio.',
  'portfolio.metric_domain.vulnerabilities.help':
    'Average security rating for all projects in the portfolio.',
  'portfolio.metric_domain.security_hotspots.help':
    'Average security review rating for all projects in the portfolio.',
  'portfolio.metric_domain.maintainability.help':
    'Average maintainability rating for all projects in the portfolio.',

  //------------------------------------------------------------------------------
  //
  // ENCRYPTION
  //
  //------------------------------------------------------------------------------
  'encryption.form_intro':
    'Secret key is registered. You can encrypt any property value with the following form:',
  'encryption.form_note':
    'Note that the secret key can be changed, but all the encrypted properties will have to be updated. {moreInformationLink}',
  'encryption.encrypted_value': 'Encrypted Value:',
  'encryption.generate_secret_key': 'Generate Secret Key',
  'encryption.generate_new_secret_key': 'Generate New Secret Key',
  'encryption.encrypt': 'Encrypt',
  'encryption.secret_key_description':
    'Secret key is required to be able to encrypt properties. {moreInformationLink}',
  'encryption.secret_key': 'Secret Key',
  'encryption.how_to_use': 'How To Use',
  'encryption.how_to_use.content1':
    'Store the secret key in the file {secret_file} of the server. This file can be relocated by defining the property {property} in {propreties_file}',
  'encryption.how_to_use.content2':
    'Restrict access to this file by making it readable and by owner only',
  'encryption.how_to_use.content3':
    'Restart the server if the property {property} has been set or changed.',
  'encryption.how_to_use.content4':
    'For each property that you want to encrypt, generate the encrypted value and replace the original value wherever it is stored (configuration files, command lines).',

  //------------------------------------------------------------------------------
  //
  // USERS
  //
  //------------------------------------------------------------------------------
  'users.page': 'Users',
  'users.page.description': 'Create and administer individual users.',
  'users.page.managed_description':
    'Your instance is managed by {provider}. No modification is allowed except for tokens and SCM account information.',
  'users.page.managed_description.recommendation':
    'We recommend that you delete local users to ensure all operations are done on your identity provider. Read more about {link}.',
  'users.page.managing_users': 'managing users',
  'users.info': 'User',
  'users.deactivate': 'Deactivate',
  'users.deactivate_user': 'Deactivate User',
  'users.deactivate_user.confirmation': 'Are you sure you want to deactivate "{0} ({1})"?',
  'users.delete_user': "Delete user's personal information",
  'users.delete_user.help':
    'A user account cannot be reactivated once their personal information is deleted. {link}',
  'users.delete_user.help.link': 'Learn more',
  'users.delete_user.documentation': 'Authentication',
  'users.create_user': 'Create User',
  'users.create_user.scm_account_new': 'New SCM account',
  'users.create_user.scm_account_x': 'SCM account "{0}"',
  'users.update': 'Update users',
  'users.list': 'Users list',
  'users.update_user': 'Update User',
  'users.cannot_update_delegated_user':
    'You cannot update the name and email of this user, as it is controlled by an external identity provider.',
  'users.minimum_x_characters': 'Minimum {0} characters',
  'users.login_already_used': 'This login is already in use. Please choose another one.',
  'users.login_invalid_characters': 'Login should contain only letters, numbers, and .-_@',
  'users.login_start_with_letter_or_number': 'Login should start with _ or alphanumeric.',
  'users.email': 'Email',
  'users.email.invalid': 'Invalid email',
  'users.last_connection': 'Last connection',
  'users.last_sonarlint_connection': 'Last SonarQube for IDE connection',
  'users.last_sonarlint_connection.help_text':
    'The time of the last connection from SonarQube for IDE indicates that the user used SonarQube for IDE in connected mode.',
  'users.update_users_groups': "Update {0}'s group membership",
  'users.view_users_groups': "View {0}'s group membership",
  'users.update_groups': 'Update Groups',
  'users.update_groups.saml_enabled':
    "Updating a group's membership when SAML is enabled will be temporary. The group membership will be updated the next time the user logs in.",
  'users.view_groups': 'View Groups',
  'users.manage_user': 'Update {0}',
  'users.update_tokens': 'Update tokens',
  'users.update_tokens_for_x': 'Update tokens for user {0}',
  'users.user_name': 'Name',
  'users.add': 'Add user',
  'users.remove': 'Remove user',
  'users.search_description': 'Search users by login or name',
  'users.activity_filter.label': 'Filter users by activity',
  'users.activity_filter.placeholder': 'All users',
  'users.activity_filter.helptext.sonarqube':
    'Users are considered active if they connected to {productName} at least once in the past 30 days.',
  'users.activity_filter.helptext.sonarlint':
    'Users are considered active with SonarQube for IDE if they used SonarQube for IDE in connected mode at least once in the past 30 days.',
  'users.activity_filter.all_users': 'All users',
  'users.activity_filter.active_sonarlint_users': 'Active users with SonarQube for IDE',
  'users.activity_filter.active_sonarqube_users': 'Active users without SonarQube for IDE',
  'users.activity_filter.inactive_users': 'Inactive users',
  'users.tokens': 'Tokens',
  'users.user_X_tokens': 'Tokens of {user}',
  'users.tokens.sure': 'Sure?',
  'users.tokens.sure_X': 'Are you sure you want to revoke token {token}?',
  'users.tokens.revoke': 'Revoke',
  'users.tokens.revoke_label': 'Revoke token {0}',
  'users.tokens.remove_label': 'Remove expired token {0}',
  'users.no_tokens': 'No tokens',
  'users.generate': 'Generate',
  'users.tokens.PROJECT_ANALYSIS_TOKEN': 'Project Analysis Token',
  'users.tokens.PROJECT_ANALYSIS_TOKEN.short': 'Project',
  'users.tokens.GLOBAL_ANALYSIS_TOKEN': 'Global Analysis Token',
  'users.tokens.GLOBAL_ANALYSIS_TOKEN.short': 'Global',
  'users.tokens.USER_TOKEN': 'User Token',
  'users.tokens.USER_TOKEN.short': 'User',
  'users.tokens.generate': 'Generate Tokens',
  'users.tokens.name': 'Name',
  'users.tokens.enter_name': 'Enter Token Name',
  'users.tokens.type': 'Type',
  'users.tokens.select_type': 'Select Token Type',
  'users.tokens.project': 'Project',
  'users.tokens.select_project': 'Select Project',
  'users.tokens.expires_in': 'Expires in',
  'users.tokens.expiration.30': '30 days',
  'users.tokens.expiration.90': '90 days',
  'users.tokens.expiration.365': '1 year',
  'users.tokens.expiration.0': 'No expiration',
  'users.tokens.new_token_created':
    'New token "{0}" has been created. Make sure you copy it now, you won\'t be able to see it again!',
  'users.generate_new_token': 'Generate New Token',
  'users.new_token': 'New token value',
  'users.change_admin_password.page': 'Change password',
  'users.change_admin_password.instance_is_at_risk': 'Secure your {productName} instance',
  'users.change_admin_password.header': 'Default Administrator credentials are still used',
  'users.change_admin_password.description':
    "Your {productName} instance is still using default administrator credentials. You must change the password for the 'admin' account to secure your {productName} instance.",
  'users.change_admin_password.form.header': "Change the password for user 'admin'",
  'users.change_admin_password.form.success': "The admin user's password was successfully changed.",
  'users.change_admin_password.form.continue_to_app': 'Continue to {productName}',
  'users.filter.by': 'Filter by',

  //------------------------------------------------------------------------------
  //
  // GROUPS
  //
  //------------------------------------------------------------------------------
  'user_groups.page': 'Groups',
  'user_groups.page.description': 'Create and administer groups of users.',
  'user_groups.page.group_header': 'Name',
  'user_groups.page.managed_description':
    'Your instance is managed by {provider}. No modification is allowed.',
  'user_groups.page.managed_description.recommendation':
    'We recommend you delete local groups. All other operations should be done on your identity provider. Read more about {link}.',
  'user_groups.page.managing_groups': 'managing groups',
  'user_groups.anyone.description':
    'Anybody who browses the application belongs to this group. If authentication is not enforced, assigned permissions also apply to non-authenticated users.',
  'groups.delete_group': 'Delete Group',
  'groups.delete_group.confirmation': 'Are you sure you want to delete "{0}"?',
  'groups.create_group': 'Create Group',
  'groups.update_group': 'Update Group',
  'groups.users.edit': 'Change {0} members',
  'groups.users.view': 'View {0} members',
  'groups.edit': 'Edit {0}',
  'group_membership.remove_user.error': 'User {0} is not a member of group {1}',

  //------------------------------------------------------------------------------
  //
  // MAINTENANCE
  //
  //------------------------------------------------------------------------------
  'maintenance.page': 'Maintenance',
  'maintenance.upgrade_failed': 'Update Failed',
  'maintenance.upgrade_failed.text':
    'Database connection cannot be established. Please check database status and JDBC settings.',
  'maintenance.migration_not_supported': 'Migration not supported',
  'maintenance.migration_not_supported.text': 'Migration is not supported on embedded databases.',
  'maintenance.back_up_database': 'Back up your database',
  'maintenance.back_up_database.1':
    'When upgrading commences, you will no longer be able to back up your database or recover any lost data.',
  'maintenance.back_up_database.2': 'Continue only after you have backed up your database.',
  'maintenance.upgrade_database': 'Update database',
  'maintenance.upgrade_database.1': 'Upgrading your database can take several minutes.',
  'maintenance.upgrade_database.2': 'For guidance, view the {link}',
  'maintenance.upgrade_database.2.link': 'SonarQube Server update guide',
  'maintenance.upgrade': 'Start update',
  'maintenance.database_migration': 'Database Migration',
  'maintenance.database_is_up_to_date': 'Database is up-to-date',
  'maintenance.is_down': '{instance} is down',
  'maintenance.sonarqube_is_down.text':
    'Something went wrong. Please contact your system administrator.',
  'maintenance.try_again': 'Try Again',
  'maintenance.is_under_maintenance': '{instance} is under maintenance',
  'maintenance.sonarqube_is_under_maintenance.1': 'While waiting, install {link} in your IDE!',
  'maintenance.sonarqube_is_under_maintenance_link.1': 'SonarQube for IDE',
  'maintenance.sonarqube_is_under_maintenance.2':
    'If you are an administrator and have no idea why this message is being shown, you should read the {link}.',
  'maintenance.sonarqube_is_under_maintenance_link.2': 'update guide',
  'maintenance.is_starting': '{instance} is starting',
  'maintenance.is_up': '{instance} is up',
  'maintenance.all_systems_opetational': 'All systems operational.',
  'maintenance.is_offline': '{instance} is offline',
  'maintenance.sonarqube_is_offline.text':
    'The connection to {productName} is lost. Please contact your system administrator.',
  'maintenance.running.progress': '{completed} migrations completed out of {total}',
  'maintenance.running.estimate': 'Estimated completion time: {date}',

  //------------------------------------------------------------------------------
  //
  // INDEXING
  //
  //------------------------------------------------------------------------------
  'indexation.in_progress': 'Reindexing in progress.',
  'indexation.details_unavailable': 'Details are unavailable until this process is complete.',
  'indexation.features_partly_available':
    'Most features are available. Some details only show upon completion. {link}',
  'indexation.features_partly_available.link': 'More info',
  'indexation.progression': '{count} out of {total} projects reindexed.',
  'indexation.progression_with_error':
    '{count} out of {total} projects reindexed with some {link}.',
  'indexation.progression_with_error.link': 'tasks failing',
  'indexation.completed': 'All project data has been reloaded.',
  'indexation.completed_with_error':
    '{productName} completed the reload of project data. Some {link} causing some projects to remain unavailable.',
  'indexation.completed_with_error.link': 'tasks failed or canceled',
  'indexation.admin_link': 'See {link} for more information.',
  'indexation.page_unavailable.title.issues': 'Issues page is temporarily unavailable',
  'indexation.page_unavailable.title.portfolios': 'Portfolios page is temporarily unavailable',
  'indexation.page_unavailable.title':
    '{componentQualifier} {componentName} is temporarily unavailable',
  'indexation.page_unavailable.description': '{productName} is reindexing project data.',
  'indexation.page_unavailable.description.additional_information':
    'This page is unavailable until this process is complete. {link}',
  'indexation.filter_unavailable.description':
    'This filter is unavailable until this process is complete.',
  'indexation.learn_more': 'Learn more:',
  'indexation.reindexing': 'Reindexing',
  'indexation.filters_unavailable':
    'Some filters are unavailable until this process is complete. {link}',
  'indexation.upgrade_survey_link':
    'Help us improve the update experience. <link>Click here to share your thoughts.</link>',

  //------------------------------------------------------------------------------
  //
  // HOMEPAGE
  //
  //------------------------------------------------------------------------------
  'homepage.current':
    'This page is your homepage. Click to revert to the default homepage. Click on the top-left logo to find it anytime.',
  'homepage.current.is_default':
    'This page is your homepage. Click on the top-left logo to find it anytime.',
  'homepage.check': 'Click to make the current page your homepage.',

  //------------------------------------------------------------------------------
  //
  // FAVORITE
  //
  //------------------------------------------------------------------------------
  'favorite.action.TRK.add': 'Add this project to favorites',
  'favorite.action.TRK.remove': 'Remove this project from favorites',
  'favorite.action.VW.add': 'Add this portfolio to favorites',
  'favorite.action.VW.remove': 'Remove this portfolio from favorites',
  'favorite.action.SVW.add': 'Add this sub-portfolio to favorites',
  'favorite.action.SVW.remove': 'Remove this sub-portfolio from favorites',
  'favorite.action.APP.add': 'Add this application to favorites',
  'favorite.action.APP.remove': 'Remove this application from favorites',
  'favorite.action.TRK.add_x': 'Add project {component} to favorites',
  'favorite.action.TRK.remove_x': 'Remove project {component} from favorites',
  'favorite.action.VW.add_x': 'Add portfolio {component} to favorites',
  'favorite.action.VW.remove_x': 'Remove portfolio {component} from favorites',
  'favorite.action.SVW.add_x': 'Add sub-portfolio {component} to favorites',
  'favorite.action.SVW.remove_x': 'Remove sub-portfolio {component} from favorites',
  'favorite.action.APP.add_x': 'Add application {component} to favorites',
  'favorite.action.APP.remove_x': 'Remove application {component} from favorites',

  //------------------------------------------------------------------------------
  //
  // WEBHOOKS
  //
  //------------------------------------------------------------------------------
  'webhooks.page': 'Webhooks',
  'webhooks.create': 'Create Webhook',
  'webhooks.delete': 'Delete Webhook',
  'webhooks.delete.confirm': 'Are you sure you want to delete the webhook "{0}"?',
  'webhooks.description0':
    'Webhooks are used to notify external services when a project analysis is done.',
  'webhooks.description1':
    'An HTTP POST request including a JSON payload is sent to each of the provided URLs. Learn more in the {url}.',
  'webhooks.deliveries.show': 'Show recent deliveries',
  'webhooks.show_actions': 'Show actions for webhook {0}',
  'webhooks.deliveries_for_x': 'Recent deliveries of {0}',
  'webhooks.delivery.duration_x': 'Duration: {0}',
  'webhooks.delivery.payload': 'Payload:',
  'webhooks.delivery.response_x': 'Response: {0}',
  'webhooks.delivery.server_unreachable': 'Server Unreachable',
  'webhooks.documentation_link': 'Webhooks documentation',
  'webhooks.last_execution': 'Last delivery',
  'webhooks.last_execution.none': 'Never',
  'webhooks.last_execution.open_for_x': 'Open last delivery of {0}',
  'webhooks.latest_delivery_for_x': 'Last delivery of {0}',
  'webhooks.maximum_reached':
    'You reached your maximum number of {0} webhooks. You can still update or delete an existing one.',
  'webhooks.name': 'Name',
  'webhooks.name.required': 'Name is required.',
  'webhooks.no_result': 'No webhook defined.',
  'webhooks.update': 'Update Webhook',
  'webhooks.secret': 'Secret',
  'webhooks.secret_header': 'Has secret?',
  'webhooks.secret.bad_format': 'Secret length must be between 16 and 200 characters.',
  'webhooks.secret.description':
    "If provided, secret will be used as the key to generate the HMAC hex (lowercase) digest value in the 'X-Sonar-Webhook-HMAC-SHA256' header.",
  'webhooks.secret.description.update':
    'If blank, any secret previously configured will be removed. If not set, the secret will remain unchanged.',
  'webhooks.secret.field_mask.description': 'Hidden for security reasons: {link}.',
  'webhooks.secret.field_mask.link': ' edit secret',
  'webhooks.url': 'URL',
  'webhooks.url.bad_format': 'Bad format of URL.',
  'webhooks.url.bad_protocol': 'URL must start with "http://" or "https://".',
  'webhooks.url.description':
    'Server endpoint that will receive the webhook payload, for example: "http://my_server/foo". If HTTP Basic authentication is used, HTTPS is recommended to avoid man in the middle attacks. Example: "https://myLogin:myPassword@my_server/foo"',
  'webhooks.url.required': 'URL is required.',

  //------------------------------------------------------------------------------
  //
  // COMPONENT REPORT
  //
  //------------------------------------------------------------------------------
  'component_report.report': '{0} report',
  'component_report.download': 'Download {0} report (PDF)',
  'component_report.download.help_text': 'Key metrics for new code and quality gate status',
  'component_report.no_email_to_subscribe': 'Email subscription requires an email address.',
  'component_report.subscribe_x': 'Subscribe to {0} report',
  'component_report.unsubscribe_x': 'Unsubscribe from {0} report',
  'component_report.unsubscribe': 'Unsubscribe from report',
  'component_report.unsubscribe.description':
    'If you no longer wish to receive these reports via email, you can unsubscribe by clicking on the button below.',
  'component_report.subscribe_x_success':
    'Subscription successful. You will receive a {frequency} report for this {qualifier} by email.',
  'component_report.subscribe_x_success_no_frequency':
    'Subscription successful. You will start receiving a report for this {qualifier} by email',
  'component_report.unsubscribe_x_success':
    'You have successfully unsubscribed from receiving {frequency} PDF report about this {qualifier}',
  'component_report.unsubscribe_x_success_no_frequency':
    'You have successfully unsubscribed from receiving PDF report about this {qualifier}',
  'component_report.unsubscribe_success':
    "Subscription successfully canceled. You won't receive these reports by email anymore.",
  'component_report.unsubscribe.page_title': 'Unsubscribe from report',
  'component_report.toggletip.permanent_branches.description':
    "Reports are only available for permanent branches. A permanent branch is one that has been marked as 'Keep when inactive'.",
  'component_report.toggletip.permanent_branches.documentation_link':
    "Visit documentation on how to enable 'Keep when inactive' setting",

  //------------------------------------------------------------------------------
  //
  // COMPONENT REGULATORY REPORT
  //
  //------------------------------------------------------------------------------
  'component_regulatory_report.report': 'Regulatory report',
  'component_regulatory_report.download': 'Download Regulatory report (.zip)',
  'component_regulatory_report.download.help_text':
    'Detailed metrics, issue lists, and project configurations',
  'component_regulatory_report.dropdown': 'Downloadable reports',

  //------------------------------------------------------------------------------
  //
  // GUIDING
  //
  //------------------------------------------------------------------------------
  'guiding.step_x_of_y': '{0} of {1}',

  //------------------------------------------------------------------------------
  //
  // Sandboxed issues intro
  //
  //------------------------------------------------------------------------------
  'sandboxed_issues_intro.title': 'Update without breaking your Quality Gate ',
  'sandboxed_issues_intro.img_alt':
    'Image showing an example of sandbox issues on summary page that do not impact quality gate. Additionally, new issue status "In sandbox" is shown for an issue in issue list.',
  'sandboxed_issues_intro.description_1':
    'Say goodbye to unexpected pipeline failures. We’re introducing the Issue Sandbox to make platform updates stress-free. New issues flagged by updated analyzers are placed in a "sandbox" — visible to you, but excluded from Quality Gate calculations.',
  'sandboxed_issues_intro.description_2':
    '<b>Enable this setting before your first project analysis</b> following the SonarQube update to keep your pipelines green and give your teams time to triage at their own pace.',

  'sandboxed_issues_intro.footer_link': 'How does issue sandbox works?',
  'sandboxed_issues_intro.turn_on': 'Turn it on',
  'sandboxed_issues_intro.no_thanks': 'No thanks',

  //------------------------------------------------------------------------------
  //
  // Developer Server Extension
  //
  //------------------------------------------------------------------------------

  'application_console.edit': 'Edit Application',
  'application_console.project_inaccessible': 'You do not have access to this project',
  'application_console.branches': 'Application Branches',
  'application_console.branches.action_x': 'Open application branch {0} actions',
  'application_console.branches.edit_x': 'Edit application branch {0}',
  'application_console.branches.enable_x': 'Check to enable project {0} in this branch',
  'application_console.branches.delete_x': 'Delete application branch {0}',
  'application_console.branches.cannot_access_all_child_projects':
    'You must have access to all projects in this Application in order to administer branches.',
  'application_console.branches.cancel': 'Cancel',
  'application_console.branches.configuration': 'Branch configuration',
  'application_console.branches.create': 'Create branch',
  'application_console.branches.create.verb': 'Create',
  'application_console.branches.create.help':
    "For each project of your Application, choose a project branch that will be displayed inside the Application's branch.",
  'application_console.branches.delete': 'Delete branch',
  'application_console.branches.delete.warning_x': 'Are you sure you want to delete "{0}" ?',
  'application_console.branches.help':
    "Track branches other than the main branch of this application's projects.",
  'application_console.branches.main_branch': 'Main Branch',
  'application_console.branches.update': 'Update branch',
  'application_console.branches.update.verb': 'Update',
  'application_console.branches.rename': 'Rename branch',
  'application_console.branches.no_branches':
    'No branches yet. You can create branches once projects are selected for this Application.',
  'application_console.page': 'Edit Definition',
  'application_console.delete_application': 'Delete Application',
  'application_console.recompute': 'Recompute',
  'application_console.refresh_started': 'Your application will be recomputed soon',
  'application_console.do_you_want_to_delete': 'Are you sure that you want to delete "{0}"?',

  //------------------------------------------------------------------------------
  //
  // OAuth Callback
  //
  //------------------------------------------------------------------------------

  'oauth.slack_binding.success.title': "You're ready to start!",
  'oauth.slack_binding.success.toast.title': 'Binding successful',
  'oauth.slack_binding.success.toast.description':
    "You've linked your SonarQube Server and Slack accounts",
  'oauth.slack_binding.success.get_started.1':
    '<b>Invite</b> your SonarQube Server app to a channel <cmd>/invite @SonarQube Server</cmd>',
  'oauth.slack_binding.success.get_started.2':
    "<b>Subscribe</b> to a project <cmd>/sonarqube-server subscribe '<project-key>'</cmd>",
  'oauth.slack_binding.success.get_started.3':
    "To <b>unsubscribe</b>, use <cmd>/sonarqube-server unsubscribe '<project-key>'</cmd>",
  'oauth.slack_binding.success.documentation': 'For a step-by-step guide, view our {docLink}',
  'oauth.slack_binding.success.documentation.link_label': 'Slack setup documentation',
  'oauth.slack_binding.success.name': 'Logged in as {name}',
  'oauth.slack_binding.error.title': 'Could not bind your accounts',
  'oauth.slack_binding.error.description':
    'Please try again on Slack. If you continue to experience this error, visit our documentation.',
  'oauth.slack_binding.error.toast.title': 'Binding failed',
  'oauth.slack_binding.error.toast.description':
    'You were unable to link your SonarQube Instance and Slack accounts',
  'oauth.slack_binding.documentation_link': 'View documentation',
  'oauth.slack_binding.get_started_button': 'Get started',

  //------------------------------------------------------------------------------
  //
  // Enterprise Server Extension
  //
  //------------------------------------------------------------------------------

  'views.add': 'Add',
  'views.all': 'All',
  'views.apply': 'Apply',
  'views.by_default': 'All remaining projects not associated to "{0}"',
  'views.by_language': 'All projects whose language is',
  'views.by_manual_measure': 'All projects whose manual measure',
  'views.by_manual_measure.none_available':
    'No metrics available. Please create a manual metric with type "Text" on the "Manual Metrics" page.',
  'views.is': 'is',
  'views.by_none': 'Following manually selected projects:',
  'views.by_regexp': 'All projects matching regular expression',
  'views.cannot_delete_referred_view':
    'Portfolio "{0}" must be removed from the following portfolio(s) before it is deleted:',
  'views.collapse': 'collapse',
  'views.refresh': 'Refresh',
  'views.recompute': 'Recompute',
  'views.recompute_all': 'Recompute All',
  'views.create': 'Create',
  'views.create_new': 'Create Portfolio',
  'views.create_success': 'Portfolio was successfully created',
  'views.criteria': 'Criteria',
  'views.deleted_metric': '<deleted manual metric>',
  'views.deleted_project': 'Deleted project',
  'views.deleted_server': 'Server has been removed',
  'views.deleted_view':
    'The definition of this portfolio has probably been deleted and this portfolio will not appear anymore once the portfolios have all been rebuilt.',
  'views.delete_success': 'Portfolio definition "{0}" has been successfully deleted',
  'views.delete_view': 'delete',
  'views.delete.project': 'Remove Project',
  'views.delete.subview': 'Delete Portfolio',
  'views.delete.view': 'Delete Portfolio',
  'views.remove_x': 'Remove {0}',
  'view.refresh.started': 'All portfolios will be recomputed soon',
  'view.refresh.started.one': 'Your portfolio will be recomputed soon',
  'views.do_you_want_to_change_selection_mode':
    'This action will replace any existing project selection on portfolio "{0}". Do you want to continue?',
  'views.is_referenced_by': 'This will automatically delete "{0}" from all its parent portfolios',
  'views.do_you_want_to_delete_x': 'Are you sure that you want to delete "{0}"?',
  'views.do_you_want_to_remove_x': 'Are you sure that you want to remove "{0}"?',
  'views.do_you_want_to_delete_subview': 'Are you sure that you want to delete portfolio "{0}"?',
  'views.do_you_want_to_delete_project_from_view':
    'Are you sure that you want to remove project "{0}" from portfolio "{1}"?',
  'views.do_you_want_to_delete_project_from_subview':
    'Are you sure that you want to remove project "{0}" from portfolio "{1}"?',
  'views.duplicate_key': 'A portfolio with the key "{0}" already exists',
  'views.edit': 'Edit',
  'views.edit_subview': 'Edit "{0}"',
  'views.edit_view': 'Edit "{0}"',
  'views.filter_projects': 'Filter',
  'views.associate.view.explain': 'Associate projects with one of the following options:',
  'views.associate.subview.explain': 'Associate projects with one of the following options:',
  'views.empty.language': "can't be blank",
  'views.empty.regexp': "can't be blank",
  'views.empty': 'empty',
  'views.expand': 'expand',
  'views.hierarchy': 'hierarchy',
  'views.invalid.criteria': 'Only one criteria can be used (regexp, language or manual measure)',
  'views.invalid.key':
    '"{0}" is invalid. Only letters, digits, dashes and underscores are supported.',
  'views.invalid.regexp': 'is not a valid java regular expression, for example [a-zA-Z]*-[0-9]+',
  'views.invalid.tag_key': "can't be blank",
  'views.invalid.tag_value': "can't be blank if a value is specified",
  'views.language.desc': 'Filter on a language',
  'views.language': 'Language',
  'views.list': 'Portfolios',
  'views.mode.standard': 'Standard',
  'views.mode.local': 'Reference',
  'views.move': 'Move',
  'views.move.project': 'Move "{0}" into',
  'views.move.select.new.parent.view': 'Select destination',
  'views.move.subview': 'Move "{0}" into',
  'views.application.branches': 'Select branches to compute',
  'views.new_portfolio': 'Add Portfolio',
  'views.new_application': 'Add Application',
  'views.new_child_to': 'Add Portfolio to "{0}"',
  'views.new_application_to': 'Add Application to "{0}"',
  'views.none': 'No portfolios',
  'views.no_project': 'No project',
  'views.no_server': 'No server',
  'views.no_server_available': 'No server available',
  'views.open_dashbard': 'Open Dashboard',
  'views.projects_distribution': 'Projects distribution',
  'views.projects_distribution.in': '{count} in {rating}',
  'views.projects_distribution.quality_gate': '{rating}: {count}',
  'views.projects.add': 'Add Projects',
  'views.projects.associate': 'Associate Projects to "{0}"',
  'views.projects.associated': 'Associated Projects',
  'views.referenced_x': 'Referenced {0}',

  'views.structure.nav': 'Portfolio structure navigation menu',

  //
  // When updating the line below, please also update com.sonar.views.batch.ViewFilters.languageFilter(View)
  //
  'views.projects.by_regexp': 'All projects matching regular expression "{0}"',
  'views.projects.by_tag': 'All projects whose {0} is {1}',
  'views.projects.selection_mode': 'Projects and branches selection mode',
  'views.projects.selection_mode.NONE': 'None',
  'views.projects.selection_mode.NONE.description':
    'No project branches are associated to this portfolio.',
  'views.projects.selection_mode.MANUAL': 'Manual',
  'views.projects.selection_mode.MANUAL.root': 'Manual',
  'views.projects.selection_mode.MANUAL.description':
    'This portfolio contains only manually selected project branches.',
  'views.projects.selection_mode.MANUAL.branches_selection': 'Edit selected branches',
  'views.projects.selection_mode.MANUAL.branches_selection.description':
    'Only branches excluded from purge are available for selection',
  'views.projects.selection_mode.REGEXP': 'By regular expression',
  'views.projects.selection_mode.REGEXP.root': 'By regular expression',
  'views.projects.selection_mode.REGEXP.description':
    'This portfolio contains the {branch} branch of every project matching {regexp}.',
  'views.projects.selection_mode.REST': 'All Remaining Projects',
  'views.projects.selection_mode.REST.root': 'All Projects',
  'views.projects.selection_mode.REST.description':
    'This portfolio contains the {branch} branch of every project that does not belong to any other sub-portfolio, referenced portfolio, or referenced application, within this hierarchy.',
  'views.projects.selection_mode.TAGS': 'By tags',
  'views.projects.selection_mode.TAGS.root': 'By tags',
  'views.projects.selection_mode.TAGS.description':
    'This portfolio contains the {branch} branch of every project marked by the following tags: {tags}.',
  'views.projects.selection_mode.main_branch': 'main',
  'views.already_selected_in': '"{0}" is already selected in "{1}"',
  'views.projects.select_language': 'Language',
  'views.projects.set': 'Associate Projects',
  'views.projects': 'Projects',
  'views.regexp.desc':
    'A valid regular expression, eg. ".*Business" to match project names or keys that end with "Business".',
  'views.regexp': 'Regexp',
  'views.remove_project': 'Remove',
  'views.search': 'Search',
  'views.set_criteria': 'Set criteria',
  'views.server': 'Server',
  'views.structure.name': 'Structure of the portfolio',
  'views.tag.desc': 'Manual measure',
  'views.tag': 'Manual measure',
  'views.update': 'Update',
  'views.update_success': 'Portfolio was successfully updated',
  'views.view': 'Portfolio',
  'views.advanced_settings': 'Advanced Settings',
  'views.key.description':
    'If specified, this value is used as the key instead of generating it from the name of the Portfolio.',
  'views.key.valid_characters':
    'Only letters, digits, dashes, dots, colons and underscores can be used, with at least one non-digit.',
  'views.project_already_selected_in_x': 'Already manually selected in "{0}"',
  'views.project_already_selected.help':
    'Ensure that each project/branch is included only once in the portfolio hierarchy. The portfolio computation will fail otherwise. Please note that projects may still be selected multiple times, if a dynamic selection mode is used (by tag or by regular expression).',
  'views.app_x_already_selected': 'Application "{0}" was already manually added to this hierarchy.',
  'views.app_already_selected.help':
    'Ensure that each application/branch is included only once in the portfolio hierarchy. The portfolio computation will fail otherwise.',

  'portfolio.edit_selection_mode': 'Edit selection mode',
  'portfolio.selection_mode': 'Project selection mode',
  'portfolio.regexp': 'Regexp',
  'portfolio.regexp.description':
    'A valid regular expression, eg. ".*Business" to match project names or keys that end with "Business".',
  'portfolio.tags': 'Tag selection',
  'portfolio.branch': 'Branch selection',
  'portfolio.branch.description':
    'The branch name that will be selected for every project if it exists. Leave empty to select the main branch.',
  'portfolio.custom_measure': 'Custom Measure',
  'portfolio.deprecated_custom_measure_mode':
    '"By Custom Measure" selection mode is deprecated. Please use "By Tags" instead.',

  'portfolio_console.project_inaccessible': 'You do not have access to this project',

  // background task
  'background_task.type.VIEW_REFRESH': 'Portfolio Recomputation',

  // Governance Page
  'governance.x_portfolios': '{count} portfolios',
  'governance.section.releasability': 'Releasability',
  'governance.section.reliability': 'Reliability',
  'governance.section.review': 'Security Review',
  'governance.section.security': 'Security',
  'governance.section.maintainability': 'Maintainability',
  'governance.section.application.reliability': 'Bugs',
  'governance.section.application.security': 'Vulnerabilities',
  'governance.section.application.security_hotspots_reviewed': 'Hotspots Reviewed',
  'governance.section.application.maintainability': 'Code Smells',
  'governance.section.sca': 'Dependency Risks',
  'governance.projects': 'Projects',
  'governance.x_projects_failed': '{0} project(s) failed',
  'governance.x_projects_in_y': '{projectCount} project(s) in {rating}',
  'governance.and': 'and',
  'governance.has_always_been_x': 'has always been {rating}',
  'governance.was': 'was',
  'governance.not_computed.VW': 'This portfolio is not yet computed.',
  'governance.not_computed.APP': 'This application is not yet computed.',
  'governance.no_projects.VW': 'This portfolio is empty.',
  'governance.no_projects.APP': 'This application is empty.',
  'governance.no_ncloc.VW': 'This portfolio contains only empty projects.',
  'governance.no_ncloc.APP': 'This application contains only empty projects.',
  'governance.show_all': 'Show All',
  'governance.no_security_review_rating': 'Not yet computed',

  // Metrics
  'metric.releasability_effort.name': 'Total Number of Projects not Production Ready',
  'metric.releasability_effort.description': 'Total number of projects not production ready',

  // Report
  'report.page': 'Executive Report',
  'report.cant_download': "You don't have right permissions to see the report.",
  'report.can_download': 'You can print the main information from this page into a PDF file.',
  'report.configured_globally_note': '(configured globally)',
  'report.configuration': 'Advanced Configuration',
  'report.frequency': 'Frequency',
  'report.frequency.admin': 'Customize the frequency used to send PDF reports for that portfolio.',
  'report.frequency.default': 'Default',
  'report.frequency.default.description': 'Globally configured value is used.',
  'report.frequency.daily': 'Daily',
  'report.frequency.daily.description':
    'Report is sent during the first portfolio calculation of the day (if any).',
  'report.frequency.daily.effective': 'every day',
  'report.frequency.weekly': 'Weekly',
  'report.frequency.weekly.description':
    'Report is sent during the first portfolio calculation of the week (if any), starting from Midnight on Monday.',
  'report.frequency.weekly.effective': 'every week',
  'report.frequency.monthly': 'Monthly',
  'report.frequency.monthly.description':
    'Report is sent during the first portfolio calculation of the month (if any), starting from the first day of the current month.',
  'report.frequency.monthly.effective': 'every month',
  'report.recipients': 'Other Recipients',
  'report.recipients.admin':
    'Add email addresses of people who do not have an account on SonarQube Server but still want to get PDF reports for that portfolio.',
  'report.work_duration.x_days': '{0} days',
  'report.work_duration.one_day': '1 day',
  'report.work_duration.x_hours': '{0} hours',
  'report.work_duration.one_hour': '1 hour',
  'report.work_duration.x_minutes': '{0} minutes',
  'report.work_duration.one_minute': '1 minute',
  'report.work_duration.about': '~ {0}',
  'report.delete_recipient': 'Delete recipient {0}',

  'application_settings.page': 'Application Settings',
  'application_settings.report': 'Application Report Settings',
  'application_settings.report.frequency': 'Application Reports Frequency',

  'portfolios.search': 'Search for portfolios...',
  'portfolios.search_in_structure': 'Search in structure...',
  'portfolios.explore_portfolios': 'Explore Portfolios',
  'portfolios.search_all_portfolios': 'Search all Portfolios',
  'portfolios.create_portfolio': 'Create Portfolio',
  'portfolios.edit_portfolio': 'Edit Portfolio',

  'portfolios.empty.title.filtered.favorite':
    "We couldn't find any results matching selected criteria in your favorites.",
  'portfolios.empty.title.filtered.all': "We couldn't find any results matching selected criteria.",
  'portfolios.empty.title.unfiltered.favorite': "You don't have any favorite portfolios yet.",
  'portfolios.empty.title.unfiltered.all': 'There are no portfolios yet.',

  'portfolios.empty.description.filtered.favorite':
    'Would you like to search among all portfolios?',
  'portfolios.empty.description.filtered.all':
    'Try changing your search query to get some results.',
  'portfolios.empty.description.unfiltered.favorite':
    'To easily access portfolios your are interested in, mark them as favorite.',
  'portfolios.empty.description.unfiltered.all':
    'Portfolios offer an overview of the quality of all projects within each of them.',

  'portfolio_overview.title': 'Overview',
  'portfolio_overview.desciption':
    'A summary of information from the project branches that was chosen for this portfolio. To learn more about how portfolio ratings are calculated, see {link}.',
  'portfolio_overview.desciption.link': 'managing portfolios documentation',

  'portfolio_overview.breakdown': 'Portfolio Breakdown',
  'portfolio_overview.intro':
    'A detailed list of ratings for this portfolio and the projects, applications, and nested portfolios contained within it that you are allowed to browse. Switch between new code and overall code to see the ratings. Learn more about <link>portfolio breakdowns</link>.',

  'portfolio_overview.empty': 'This portfolio is empty.',
  'portfolio_overview.empty.description':
    'Add projects and applications to your portfolio definition to compute quality metrics.',
  'portfolio_overview.no_lines_of_code': 'All projects in this portfolio are empty',
  'portfolio_overview.not_computed': 'This portfolio is not yet computed.',
  'portfolio_overview.need_recompute':
    'Measures on new code have been added. Recompute the portfolio to see the new measures.',

  'portfolio_overview.risk.no_measure': 'Not yet computed',

  'portfolio_overview.projects_distribution': 'Projects distribution',
  'portfolio_overview.projects_x': '{0} Projects',
  'portfolio_overview.lines_of_code_x': '{count} Lines of code',
  'portfolio_overview.activity': 'Activity',
  'portfolio_overview.measures': 'Measures',
  'portfolio_overview.language_breakdown': 'Language Breakdown',
  'portfolio_overview.metric_trend': 'Metric trend',
  'portfolio_overview.risk': 'Risk',
  'portfolio_overview.overall_code': 'Overall Code',
  'portfolio_overview.new_code': 'New Code',
  'portfolio_overview.project_branches_x': '{0} selected project branches',
  'portfolio_overview.project_branches_all': 'All selected project branches',
  'portfolio_overview.project_branches_rating': '{link} in {rating}',
  'portfolio_overview.see_all': 'See All',
  'portfolio_overview.cannot_see_all': 'Some projects are inaccessible',
  'portfolio_overview.cannot_see_all.help':
    'You do not have access to all projects in this portfolio',

  'portfolio_overview.new_code_definition':
    'The metrics below show ratings on both New Code (code that has been added or changed according to your New Code definition) and Overall Code. Focusing on the new code ensures the code you write today is clean and safe. {link}.',
  'portfolio_overview.new_code_definition.link': 'Learn more about New vs Overall Code',

  'portfolio_overview.releasability.title': 'Releasability',
  'portfolio_overview.releasability.description':
    'Ratio of passing Quality Gates over failing ones. The Quality Gate of a project can have conditions both on New Code and Overall Code.',
  'portfolio_overview.releasability.help':
    "This rating is based on the ratio of passing Quality Gates over failing ones for all projects in your Portfolio. Projects' Quality Gates have conditions on both New Code and Overall Code.",
  'portfolio_overview.releasability.rating.help':
    'This rating is based on the ratio of passing Quality Gates over failing ones. The Quality Gate of a project can have conditions both on New Code and Overall Code.',
  'portfolio_overview.releasability.portfolio_health': 'Portfolio health',
  'portfolio_overview.releasability.pagination': '{0} of {1}',
  'portfolio_overview.releasability.no_failing_projects':
    'None of the projects have a failing Quality Gate.',
  'portfolio_overview.releasability.project_inaccessible':
    'You do not have access to any of the failing project branches.',

  'portfolio_overview.reliability_rating.title': 'Reliability',
  'portfolio_overview.reliability_rating.description':
    'Average reliability rating. Issues in this domain mark code where you will get behavior other than what was expected.',

  'portfolio_overview.security_rating.title': 'Security',
  'portfolio_overview.security_rating.description':
    'Average security rating. Issues in this domain mark potential weaknesses to hackers.',

  'portfolio_overview.security_review_rating.title': 'Security Review',
  'portfolio_overview.security_review_rating.description':
    'Average security review rating. This domain represents potential security risks in the form of hotspots and their review status.',

  'portfolio_overview.sqale_rating.title': 'Maintainability',
  'portfolio_overview.sqale_rating.description':
    'Average maintainability rating. Issues in this domain mark code that will be more difficult to update competently than it should.',

  //------------------------------------------------------------------------------
  //
  // License page
  //
  //------------------------------------------------------------------------------

  'license.activate_offline': 'Activate offline',
  'license.activate_your_license_offline': 'Activate your license offline',
  'license.activation_method.legacy': 'License key based on server ID',
  'license.activation_method.offline': 'Offline',
  'license.activation_method.online': 'Online',
  'license.activation_method': 'Activation method',
  'license.add_license': 'Add license',
  'license.callout.activated.suggestion':
    'Your SonarQube license is active. You have full access to all the features and capabilities included in your edition.',
  'license.callout.activated.title': 'License successfully activated',
  'license.callout.expired.suggestion.grace_period':
    "We've granted you a {days}-day grace period so you can continue using all your features without interruption. To maintain full access, please set a new license or refresh your current one",
  'license.callout.expired.suggestion':
    'Set a new license or refresh your current one after renewal',
  'license.callout.expired.title': 'Your license has expired',
  'license.callout.loc.suggestion':
    'In order to continue using the product, decrease the number of lines of code, or contact sales to add more',
  'license.callout.loc.title': "You've exceeded the limit on lines of code",
  'license.callout.non-official.link-text': 'an official SonarQube Server distribution',
  'license.callout.non-official.suggestion':
    'Installing a Commercial Edition on top of a non-official distribution of SonarQube Server is not supported. As a consequence, all analyses are suspended. Please download and install {link} provided by SonarSource.',
  'license.callout.non-official.title': "You're using a non-official SQS distribution",
  'license.cant_connect_to_license_server': "SonarQube can't connect to the license server",
  'license.disabled_by_sonar.popover': 'The license was disabled by Sonar.',
  'license.disabled_by_sonar': 'Disabled by Sonar',
  'license.enter_your_license_key_for_x': 'Enter your license key for {0}',
  'license.enter_your_license_key': 'Enter your license key',
  'license.exceeded_loc.popover': "You've exceeded the limit of LOC (lines of code).",
  'license.exceeded_loc': 'Exceeded LOC',
  'license.expiration_date': 'Expiration date',
  'license.expired.popover': 'Set a new license or refresh your current one after renewal',
  'license.expired': 'Expired',
  'license.expires_soon.popover': 'Your license expires on {date}',
  'license.expires_soon': 'Expires soon',
  'license.feature_name': 'License Manager',
  'license.features.availability.available': 'Available',
  'license.features.availability.not_available': 'Not available',
  'license.features.availability': 'Availability',
  'license.features.enablement.activable': 'Enable feature',
  'license.features.enablement.enabled': 'Enabled',
  'license.features.enablement.try_now': 'Try now',
  'license.features.enablement': 'Enablement',
  'license.features.feature_name': 'Name',
  'license.features.feature.sqas': 'SonarQube Advanced Security',
  'license.features': 'Features',
  'license.how_to_fix_it': 'How to fix it',
  'license.i_accept_the_terms_and_conditions_with_link': 'I accept the {link}',
  'license.i_accept_the_terms_and_conditions': 'I accept the SonarQube Terms and Conditions',
  'license.invalid': 'Invalid',
  'license.is_supported': 'Support included',
  'license.last_refresh': 'Last refresh: ',
  'license.learn_more_or_activate_offline':
    'Learn more about this issue and how to fix it, or activate the license in the offline mode',
  'license.license_administration': 'license administration',
  'license.license_information': 'License information',
  'license.license_key': 'License key',
  'license.license_usage': 'License usage',
  'license.ncloc_lines_analyzed': '{ncloc} lines currently analyzed',
  'license.no_license.not_added': "It seems like you haven't added any license yet.",
  'license.no_license.reach_out':
    "If you've purchased a license but need a new key, reach out to {emailLink}",
  'license.no_license': "You don't have any license",
  'license.not_production_database_warning':
    'This license key is valid only for the embedded database, which should be considered disposable. Consider configuring an external database for long-term use and requesting a new license key.',
  'license.notification_threshold': 'Notification threshold:',
  'license.notification_threshold.lines_of_code': '{ncloc} remaining lines of code',
  'license.offline.obtain_req_file.button': 'Download .req file',
  'license.offline.obtain_req_file.helptext':
    'Click to download your .req request file from SonarQube Server',
  'license.offline.obtain_req_file': 'Download your .req request file from SonarQube Server',
  'license.offline.upload_lic_file.button': 'Upload .lic file',
  'license.offline.upload_lic_file.helptext':
    'Click to upload your .lic file into SonarQube Server and activate your license',
  'license.offline.upload_lic_file': 'Upload your .lic file into SonarQube Server',
  'license.offline.upload_req_file.button': 'Upload .req file',
  'license.offline.upload_req_file.helptext':
    'Click to open the offline license portal. Upload your .req file into it and donwload your .lic file in return. Then come back to this wizard',
  'license.offline.upload_req_file':
    'Upload your .req request file, download your .lic license file',
  'license.prompt.description':
    '{title}You must set a license to be able to perform new analyses. {url}.',
  'license.prompt.link': 'Go to License page',
  'license.prompt.title': 'License needed:',
  'license.refresh_license': 'Refresh license',
  'license.refresh_limit_hit': 'Daily refresh limit of 10 reached',
  'license.refresh_your_license_offline': 'Refresh your license offline',
  'license.replace_license': 'Set a new license',
  'license.request_trial_license': 'Request trial license',
  'license.serverId': 'Server ID',
  'license.set_license': 'Set license',
  'license.set_or_update': 'Set or update your SonarQube Server license.',
  'license.set_up_a_license': 'Set up a license',
  'license.start_date': 'Start date',
  'license.support': 'For support, view the {docLink} documentation or email us at {emailLink}.',
  'license.support_page.browse_resources': 'Browse online resources:',
  'license.support_page.create_ticket':
    "Create a ticket of the appropriate type (don't forget to attach your {file})",
  'license.support_page.connect_to_portal': 'Connect to the {link}',
  'license.support_page.download': 'Download',
  'license.support_page.get_support_info_file': 'Get your {file}',
  'license.support_page.need_help': 'Need help with your SonarQube ecosystem?',
  'license.support_page.not_finding_help': 'Not finding the help you need?',
  'license.support_page.not_supported':
    'This instance is not supported. Please contact SonarSource to get support.',
  'license.support_page.sonarqube_documentation': 'SonarQube documentation',
  'license.support_page.sonarsource_products': 'SonarSource products',
  'license.support_page.support_info_file': '<b>Support Information File</b>',
  'license.support_page.support_page_link': 'Support page',
  'license.support_page.support_page_read':
    'After you read it, feel free to create a ticket to report your problem, ask a question or suggest a change:',
  'license.support_page.support_page_text':
    'On our {link} you can find all the information you need concerning the SonarSource service desk, including how to create tickets.',
  'license.support_page.support_portal': 'SonarSource Support Portal',
  'license.support_page.supported':
    'This SonarQube server is covered by your SonarSource support subscription.',
  'license.support_page.title': 'Support',
  'license.terms_and_conditions': 'terms and conditions',
  'license.threshold.edit': 'Edit notification threshold',
  'license.threshold.explanation':
    'Once you reach this point, you will receive an email to inform you that you are approaching your limit of authorized lines of code for analysis.',
  'license.threshold.tooltip': 'This is your notification threshold',
  'license.threshold.warning_threshold.description':
    'Send an email notification when there are less lines of code remaining for analysis than the notification threshold.',
  'license.threshold.warning_threshold.name': 'Threshold',
  'license.title': 'SonarQube Server license',
  'license.type': 'Type',
  'license.unset_license.confirm.1': 'You are about to unset your SonarQube Server license.',
  'license.unset_license.confirm.2':
    'This action cannot be undone, and will immediately remove paid features from your instance until you set a valid license again.',
  'license.unset_license.confirm.3': 'Are you sure you wish to proceed?',
  'license.unset_license.success': 'License successfully unset',
  'license.unset_license': 'Unset license',
  'license.up_to_ncloc': 'Up to {ncloc}',
  'license.usage.description.subdued':
    'In order to determine how much each project contributes, the license takes into account the number of lines of code on the largest branch of that project. Lines of test code do not count towards your license usage.',
  'license.valid': 'Valid',
  'license.warning_threshold.success': 'Warning threshold saved successfully.',

  // New Code Definition - Additional keys for shared component
  'new_code.page.description':
    "The new code definition sets the criteria for what's considered new code, allowing you to focus on the most recent changes in your project.<br></br><br></br>This setting establishes the instance’s default new code definition, that will be applied to all new and existing projects, and can be further customized at the project level.<br></br>{url}",
  'new_code.page.description.documentation_link': 'Learn more in documentation',
  'new_code.changes_affect_new_projects_only': 'Changes will only affect new projects',
  'new_code.page.notification.success': 'New code definition updated successfully',

  // Toggle Tips
  'toggle_tip.aria_label.quality_gate': 'More information about quality gate',
  'toggle_tip.aria_label.unbound_project': 'More information about PR decoration',
  'toggle_tip.aria_label.alm_not_configured': 'More information about ALM integration',
  'toggle_tip.aria_label.threshold': 'More information about threshold',
  'toggle_tip.aria_label.security_hotspots': 'More information about security hotspots',
  'toggle_tip.aria_label.reports': 'More information about reports',
  'toggle_tip.aria_label.onboarding': 'More information about onboarding',

  // Beamer
  'beamer.panel.title': "What's new on SonarQube",
  'beamer.category.new': 'New',
  'beamer.news.error': 'Failed to load news',
  'beamer.news.community_post': 'Community post',
  'beamer.news.no_news': 'No news available',

  // ----------------------------------------------------------------------------
  //
  // Jira integration
  //
  // ----------------------------------------------------------------------------

  'jira_binding.server_error': 'Internal server error. Please try again later.',

  'organization.jira.binding.header': 'Jira',
  'organization.jira.binding.badge.connected': 'Connected',
  'organization.jira.binding.badge.not_connected': 'Not Connected',
  'organization.jira.binding.instance_details_title': 'Jira instance details',
  'organization.jira.binding.not_connected.intro':
    '<p>Setup and connect to your Jira application to push issues into Jira as work items. You will need to provide a Client ID and Secret to connect. To obtain them, <setupGuideDocLink>follow our setup guide</setupGuideDocLink></p>',
  'organization.jira.binding.start_setup.hint': 'Setup can take 15 minutes.',
  'organization.jira.binding.connected.intro':
    "<p>To push issues, ensure you've <projectBindingDocLink>connected your projects</projectBindingDocLink> in your project settings.</p><p>If reauthorizing, always ensure you select the same instance in the app page to avoid potential errors. If an error occurs, please read and follow our <troubleshootingDocLink>troubleshooting steps.</troubleshootingDocLink></p>",
  'organization.jira.binding.connected.callout.title':
    'Want project admins to be able to set up Jira at the project level?',
  'organization.jira.binding.connected.callout.text':
    'By default, only instance admins have browse, bind and edit permissions to Jira projects. If you want project admins to be able to set up Jira at the project level, turn ‘on’ the setting below.',
  'organization.jira.binding.connected.callout.documentation_link_text':
    'How to connect projects to Jira',
  'organization.jira.binding.connected.grant_project_permissions.label':
    'Grant project administrators binding permissions',
  'organization.jira.binding.connected.grant_project_permissions.description':
    'If you want project admins to be able to bind to Jira at the project level, turn ‘on’ this setting.',
  'organization.jira.binding.connected.grant_project_permissions.description_2':
    'By default, only instance admins have browse, bind and edit permissions to Jira projects.',
  'organization.jira.binding.connected.grant_project_permissions.toast_granted.title':
    'Permissions granted',
  'organization.jira.binding.connected.grant_project_permissions.toast_granted.description':
    'Project admins now have browse, bind and edit permissions to Jira projects.',
  'organization.jira.binding.connected.grant_project_permissions.toast_revoked.title':
    'Permissions revoked',
  'organization.jira.binding.connected.grant_project_permissions.toast_revoked.description':
    'Only instance administrator now have browse, bind and edit permissions to Jira projects.',
  'organization.jira.binding.connected.reauthorize': 'Reauthorize',
  'organization.jira.binding.bind_success':
    "You've successfully connected your Jira instance to this SonarQube Server instance",
  'organization.jira.binding.unbind_success': "You've successfully deleted your Jira connection",
  'organization.jira.binding.instance_url.label': 'Instance URL',
  'organization.jira.binding.connected_by_on_label': 'Connected by',
  'organization.jira.binding.connected_by_on_value': '{createdBy} on {createdAt}',
  'organization.jira.binding.app_configuration.title': 'Client ID and Secret',
  'organization.jira.binding.app_configuration.edit_modal.title': 'Edit Client ID and Secret',
  'organization.jira.binding.app_configuration.helper_intro':
    'Follow the steps in our guide to <link>edit your Client ID and Secret</link>',
  'organization.jira.binding.app_configuration.callback_url.label': 'Callback URL',
  'organization.jira.binding.app_configuration.callback_url.copy': 'Copy callback URL to clipboard',
  'organization.jira.binding.app_configuration.client_id.label': 'Client ID',
  'organization.jira.binding.app_configuration.client_secret.label': 'Secret',
  'organization.jira.binding.app_configuration.submit_note':
    'Updating will redirect you to Atlassian to confirm your workspace.',
  'organization.jira.binding.modal.confirmation.description':
    "You've previously authorised multiple Jira instances to this SonarQube Server instance. Please confirm the Jira instance that you want to connect to:",
  'organization.jira.binding.modal.confirmation.title': 'Confirm your Jira instance',
  'organization.jira.binding.disconnect.label': 'Disconnect Jira instance',
  'organization.jira.binding.disconnect.modal.title':
    'Delete Jira connection for this SonarQube instance?',
  'organization.jira.binding.disconnect.modal.description.line1':
    "<p>This action deletes all data (except Client ID & Secret) on SonarQube Server.</p><p>Revoke token permissions on Atlassian's connected apps page to completely delete the connection.</p>",
  'organization.jira.binding.disconnect.modal.description.line2': 'By deleting, you will:',
  'organization.jira.binding.disconnect.modal.description.bullet1':
    'Lose access to all Jira features in this SonarQube Server instance',
  'organization.jira.binding.disconnect.modal.description.bullet2':
    "Delete this instance's project ↔ Jira project connections",
  'organization.jira.binding.disconnect.modal.description.bullet3':
    'Disconnect all SonarQube Server issues from Jira work items',
  'organization.jira.binding.disconnect.modal.description.warning':
    'You will not be able to restore or relink connections or issues even if you reconnect to the same Jira instance in the future',
  'organization.jira.binding.disconnect.modal.link': 'Atlassian connected apps page',

  'project_settings.category.jira_binding': 'Jira',
  'project_settings.jira_binding.header': 'Jira',
  'project_settings.jira_binding.bound': 'Connected',
  'project_settings.jira_binding.not_bound': 'Not connected',
  'project_settings.jira_binding.description.bound':
    '<p>You can now push SonarQube issues directly to Jira, display relevant release-related Jira information within SonarQube. For any errors, follow our <link>troubleshooting steps</link>.</p>',
  'project_settings.jira_binding.description.not_bound':
    '<p>Enable seamless issue management and workflow visibility.</p>  <p>Push SonarQube issues directly to Jira and display relevant release-related Jira information within SonarQube <link>by setting up your connection</link></p>',
  'project_settings.jira_binding.key': 'Project key:',
  'project_settings.jira_binding.remove_binding': 'Remove jira connection for project: {name}',
  'project_settings.jira_binding.disconnect': 'Disconnect',
  'project_settings.jira_binding.create_binding.title': 'Select a Jira project',
  'project_settings.jira_binding.create_binding.description':
    'By default, you will be able to push all possible issue types',
  'project_settings.jira_binding.edit_binding.title': 'Change Jira project binding?',
  'project_settings.jira_binding.edit_binding.description':
    'Issues previously pushed to "{name}" and earlier will be preserved, but all new issues will be pushed to your new Jira project.',
  'project_settings.jira_binding.organization_not_bound':
    'Cannot connect until you bind your instance to Jira in <link>Administration -> Integrations</link>',
  'project_settings.jira_binding.no_permissions':
    'To bind to a Jira project, your instance admin must grant binding permissions to project admins',
  'project_settings.jira_binding.bound.no_permissions':
    'To edit or delete this binding, your instance admin must grant binding permissions to project admins in the instance settings.',
  'project_settings.jira_binding.no_summary':
    'To see issues for this release, configure Jira releases and versions. See <link>instructions in our documentation</link>',
  'project_settings.jira.binding.bind_success': '"{sqProject}" has been connected to Jira',
  'project_settings.jira.binding.update_bind_success':
    'You have successfully changed your Jira connection to "{name}"',
  'project_settings.jira.binding.unbind_success': '"{sqProject}" has been disconnected from Jira',
  'project_settings.jira_binding.work_types.at_least_one_required':
    'At least one work type must be selected',
  'project_settings.jira_binding.work_types.mandatory_custom_fields':
    'Mandatory custom fields: {fields}',
  'project_settings.jira_binding.work_types.mandatory_fields_warning.title':
    'Some work item types can’t be pushed from SonarQube',
  'project_settings.jira_binding.work_types.mandatory_fields_warning.text':
    'SonarQube can’t create Jira work items with mandatory custom fields because it can’t automatically assign values to them. Remove the mandatory settings for those custom fields in Jira first.',
  'project_settings.jira.binding.work_types.save_failed':
    'Failed to save permitted Jira work types. Please try again later.',
  'project_settings.jira.binding.work_types.saved_successfully':
    'Permitted Jira work types were updated.',
  'project_settings.jira_binding.work_types.title':
    'Choose work types that can be pushed from SonarQube to Jira',
  'project_settings.jira_binding.unbind_confirm.title':
    'Do you want to disconnect this Jira project?',
  'project_settings.jira_binding.unbind_confirm.description':
    '{count} SonarQube {count, plural, one {issue} other {issues}} and corresponding Jira work items will no longer be synchronized. However, existing Jira work items will not be deleted.',
  'project_settings.jira_binding.unbind_confirm.alert':
    'Previous connections cannot be restored. Rebinding or creating a new project binding with Jira can lead to duplicate Jira work items.',

  'issue.jira.work_item_deletion_error': 'Failed removing link to Jira issue {0}',
  'issue.jira.work_item_deletion_link': 'Remove link',
  'issue.jira.work_item_deletion_tooltip': 'Remove link to Jira issue',
  'issue.jira.work_item_deletion_modal_description':
    'This action cannot be undone. Deleting this connection only removes the link between SonarQube and Jira; it will not delete any work items in Jira itself.',
  'issue.jira.work_item_deletion_modal_title': 'Are you sure you want to remove the Jira link?',
  'issue.jira.work_item_deletion_success': 'Link to Jira issue {0} has been removed',
  'issue.jira.work_item_creation': 'Push to Jira',
  'issue.jira.work_item_creation.in_progress': 'Pushing to Jira',
  'issue.jira.work_item_creation.count':
    'Push {count} {count, plural, one {issue} other {issues}} to Jira',
  'issue.jira.work_item_creation_success': 'Work item {0} created in Jira',
  'issue.jira.work_type_dropdown': 'Choose Jira work type',
  'issue.jira.view_work_item': 'View work item',
  'issue.jira.work_items_creation_failure':
    "An error occurred. Please make sure you don't try to push the same issue twice to Jira.",
  'issue.jira.work_items_creation.success':
    'Jira work {count, plural, one {item} other {items}} <link>{jiraWorkItemKey}</link> has been successfully created and linked to {count} SonarQube {count, plural, one {issue} other {issues}}',
};
